<template>
  <!-- #58 · la ruta es `keepAlive`: salir de aquí no destruye la pantalla, así que lo que el
       detalle de un día de vacaciones tuviera pedido se invalida al salir (`salirDeLaPantalla`). -->
  <f7-page :page-content="false" @page:beforeout="salirDeLaPantalla">

    <v-app class="full-height" :class="{'mobile-css': target == 'cordova'}">
      <v-sheet 
        height="64"
        class="d-flex sheetPadre"
      >
        <v-toolbar flat class="barraTareas">
          <v-btn
            outlined
            class="ma-2"
            @click="value = ''"
            width="30px"
          >
            Hoy
          </v-btn>
          <v-btn
            outlined
            @click="popupSelectDateOpened = true"
            class="btn-calendar"
          >
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
          <v-btn
            icon
            class="ma-2"
            @click="$refs.calendar.prev()"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            icon
            class="ma-2"
            @click="$refs.calendar.next()"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            <template v-if="type == 'month'">
              {{ $refs.calendar.title }}
            </template>
            <template v-else>
              S {{moment($refs.calendar.lastStart.date, 'YYYY-MM-DD', 'es').week()}} - {{ $refs.calendar.title }}
            </template>
          </v-toolbar-title>
          <!-- #174 · aviso discreto y no bloqueante: `bloqueo-generico` no ha contestado, así que
               se está usando el valor restrictivo. Va aquí, pegado al título, y no entre las
               métricas de `badges-totales`, porque esas no se pintan en cordova y el aviso tiene
               que verse siempre. No lleva botón de reintentar a propósito: el interruptor viaja
               como prop fija y no puede cambiar sin volver a resolver la ruta, así que lo que lo
               quita es una recarga de la pantalla. -->
          <span
            v-if="avisoBloqueoVacaciones"
            class="aviso-bloqueo-vacaciones"
            v-tooltip="'No se ha podido comprobar la configuración de vacaciones.<br/>Mientras tanto no se pueden editar las vacaciones ni los festivos generados. El resto del calendario funciona con normalidad: vuelve a abrir la pantalla para intentarlo otra vez.'"
          >
            <v-icon small color="orange darken-3">mdi-alert-outline</v-icon>
            <span class="texto">Edición de vacaciones no disponible</span>
          </span>
          <v-spacer></v-spacer>
          <div class="badges-totales" v-if="target != 'cordova'">
            <r-badge v-if="horasFichajeDia() != '0h 0m'" :color="colorBadgeFichaje()" :text="horasFichajeDia()" v-tooltip="'Horas imputadas: ' + horasFichajeDia()"></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="getTotalOeaDia('total')"
              color="lime" 
              :text="'<small>OEA: </small> ' + getTotalOeaDia('total')"
              v-tooltip="'Total contratado: ' + getTotalOeaDia('total') + '<br/>' + getPedidosDiaHtml('total')"
              @click="mostrarPedidos('total')"
            ></r-badge>
            <r-badge 
              class="importeTotal"
              v-if="totalTotal" 
              color="teal"
              :text="'<small>' + totalTotal + '</small>'"
              v-tooltip="'Importe total: ' + totalTotal"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalRealizado" 
              color="green" 
              :text="'<small>OEB R: ' + totalRealizado + '</small>'"
              v-tooltip="'Importe total Realizado: ' + totalRealizado"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalPlanif" 
              color="blue" 
              :text="'<small>OEB P: ' + totalPlanif + '</small>'"
              v-tooltip="'Importe total Planificado: ' + totalPlanif"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalPPend" 
              color="yellow" 
              :text="'<small style=\'color:blue;\'>OEB PPEND: ' + totalPPend + '</small>'"
              v-tooltip="'Importe total Planificado Pendiente: ' + totalPPend"
            ></r-badge>
            <r-badge 
              class="importeTotal"
              v-if="tiempoTotal" 
              color="black"
              :text="'<small>' + tiempoTotal + '</small>'"
              v-tooltip="'Tiempo total: ' + tiempoTotal"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTotalKm" 
              color="purple" 
              :text="'<small>' + totalTotalKm + '</small>'"
              v-tooltip="'Km totales: ' + totalTotalKm"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTiempoDesplazamiento" 
              color="purple" 
              :text="'<small>TD: ' + totalTiempoDesplazamiento + '</small>'"
              v-tooltip="'Tiempo desplazamiento: ' + totalTiempoDesplazamiento"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTotalConsumo" 
              color="deeppurple" 
              :text="'<small>Cons: ' + totalTotalConsumo + ' L</small>'"
              v-tooltip="'Consumo: ' + totalTotalConsumo + ' L'"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTotalKmParticular"
              color="purple" 
              borderColor="red"
              :text="'<small>Part: ' + totalTotalKmParticular + '</small>'"
              v-tooltip="'Km totales (particular): ' + totalTotalKmParticular"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTotalConsumoParticular" 
              color="deeppurple" 
              borderColor="red"
              :text="'<small>Cons P: ' + totalTotalConsumoParticular + ' L</small>'"
              v-tooltip="'Consumo: ' + totalTotalConsumoParticular + ' L'"
            ></r-badge>
            <!-- <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTiempoDesplazamientoParticular" 
              color="purple" 
              borderColor="black"
              :text="'<small>TDP: ' + totalTiempoDesplazamientoParticular + '</small>'"
              v-tooltip="'Tiempo desplazamiento  (particular): ' + totalTiempoDesplazamientoParticular"
            ></r-badge> -->
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTiempoTPC" 
              color="orange" 
              :text="'<small>TPC: ' + totalTiempoTPC + '</small>'"
              v-tooltip="'Tiempo TPC: ' + totalTiempoTPC"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTiempoTPIR" 
              borderColor="teal"
              color="lime" 
              :text="'<small>TPIR: ' + totalTiempoTPIR + '</small>'"
              v-tooltip="'Tiempo TPIR: ' + totalTiempoTPIR"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalTiempoTPIP" 
              borderColor="blue"
              color="lime" 
              :text="'<small>TPIP: ' + totalTiempoTPIP + '</small>'"
              v-tooltip="'Tiempo TPIP: ' + totalTiempoTPIP"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalImporteTPIR" 
              borderColor="lime"
              color="teal" 
              :text="'<small>TPIR€: ' + totalImporteTPIR + '</small>'"
              v-tooltip="'Importe TPIR: ' + totalImporteTPIR"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalImporteTPIP" 
              borderColor="blue"
              color="teal" 
              :text="'<small>TPIP€: ' + totalImporteTPIP + '</small>'"
              v-tooltip="'Importe TPIP: ' + totalImporteTPIP"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="totalImporteInformesPendientes"
              color="red" 
              :text="'<small>Importe Inf. Pdtes: </small> ' + formatoImporte(totalImporteInformesPendientes)"
              v-tooltip="'Importe Inf. Pdtes: ' + formatoImporte(totalImporteInformesPendientes)"
            ></r-badge>
            <r-badge 
              class="importeTotal kmTotal"
              v-if="fechaPrimerInformePdte"
              color="red" 
              :text="'<small>F. 1er. Inf. Pdte: </small> ' + fechaPrimerInformePdte"
              v-tooltip="'F. 1er. Inf. Pdte: ' + fechaPrimerInformePdte"
            ></r-badge>
          </div>
          <v-spacer></v-spacer>
          <!-- #1133 · `con-acel-planificacion` ensancha la barra justo lo que ocupa ese botón (ver la
               hoja): sin ella, sus 48 px salían de «Empleado» y «Tipo», que se reparten el resto. -->
          <div class="selectoresCalendario" :class="{ 'con-acel-planificacion': puedeAbrirAcelPlanificacion }">
            <!-- #58 · entrada a «Mis vacaciones» desde la barra del calendario, junto a los
                 indicadores OEA/OEB.

                 **Icono solo**, igual que el Proponer y el de informes pendientes de esta misma
                 barra: con texto, el `width: 100%` que `vuetify.css` fuerza en los `button` lo
                 estiraba a toda la toolbar y tapaba lo demás —está escrito tres botones más abajo,
                 y aquí volvió a pasar: dirección lo vio el 10/10/2026—. Lo que dice qué es, es su
                 `title`.

                 **Y se pinta solo si la pantalla es alcanzable** (§9): un botón que lleva a un 403
                 es peor que no tener botón, porque hace creer que le han quitado permisos. Quién
                 llega lo decide el menú efectivo del usuario, no su rol, y la pregunta es la misma
                 que resuelve la ruta (`PermisosVacaciones.abrirMisVacaciones`).

                 Lleva a la ruta en lugar de abrir un diálogo aquí dentro: el calendario ya es el
                 fichero más grande del front y la ventana tiene que poder abrirse también desde el
                 menú. -->
            <v-btn
              v-if="puedeAbrirVacaciones"
              text
              icon
              color="#d98324"
              :title="$t('misVacaciones.titulo')"
              @click="irAVacaciones()"
            >
              <v-icon>mdi-palm-tree</v-icon>
            </v-btn>
            <!-- #1133 · entrada a ACEL PLANIFICACIÓN, junto a la de vacaciones y con la misma forma:
                 icono solo, con el nombre en el `title`, y otro icono para que no se confundan.

                 Se pinta si y solo si la ruta está en el menú efectivo del usuario
                 (`puedeAbrirControlPlanificacion`, la misma pregunta que la tarjeta de OEB
                 Producción), nunca por el rol: a un ADMIN sin la entrada en su menú la ruta le
                 responde 403, y un botón que lleva a un 403 es peor que no tener botón (§9). -->
            <v-btn
              v-if="puedeAbrirAcelPlanificacion"
              text
              icon
              color="#1F6F8B"
              :title="$t('main_menu.controlplanificacion')"
              @click="irAAcelPlanificacion()"
            >
              <v-icon>mdi-playlist-check</v-icon>
            </v-btn>
            <v-dialog
              v-model="dialogFilter"
              width="600"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="Object.keys(filterData).length ? '#23355b' : '#23355b77'"
                  v-bind="attrs"
                  v-on="on"
                  text
                  icon
                >
                  <v-icon>mdi-filter-variant</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar
                  dark
                  color="#23355bdd"
                >
                  <!-- <v-btn
                    icon
                    dark
                    @click="dialogFilter = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn> -->
                  <v-btn
                    dark
                    @click="filterData = {}"
                    color="red"
                    width="150px"
                  >
                    Limpiar filtro
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>Filtro</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn
                      dark
                      text
                      color="green"
                      @click="dialogFilter = false; getPlanificaciones();"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-list
                  three-line
                  subheader
                >
                  <v-list-item>
                    <v-list-item-content>
                      <v-select
                        v-model="filterData.tipo"
                        :items="filterOptions.tipos"
                        item-text="text"
                        item-value="value"
                        dense
                        outlined
                        hide-details
                        multiple
                        label="Tipo"
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="filterData.tipo && filterData.tipo.indexOf('TAREA') > -1">
                    <v-list-item-content>
                      <v-select
                        v-model="filterData.tipoTarea"
                        :items="filterOptions.tiposTareas"
                        item-text="text"
                        item-value="value"
                        dense
                        outlined
                        hide-details
                        multiple
                        label="Tipo Tarea"
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
              </v-card>
            </v-dialog>
            <v-text-field
              v-if="Utils.getUser() && (Utils.getUser().roles.indexOf('ADMIN') > -1 || Utils.getUser().roles.indexOf('DTYCAL') > -1 || Utils.getUser().roles.indexOf('FVYFP') > -1 || Utils.getUser().roles.indexOf('DIRECTOR') > -1 || Utils.getUser().roles.indexOf('PLANIFICADOR') > -1 || Utils.getUser().roles.indexOf('TRAMITACION') > -1)"
              dense
              outlined
              hide-details
              label="Empleado"
              v-model="inspectorFiltro"
              :rules="rules"
              @change="cambiarEmpleado()"
            ></v-text-field>
            <!-- #59 · El mismo campo «Empleado» para quien no tiene ninguno de esos seis roles
                 pero SÍ aprueba a alguien: un jefe de delegación con rol PRODUCCION o INSPECTOR.
                 Va como DESPLEGABLE y no como texto libre a propósito: el servidor solo le deja
                 ver el calendario de su gente, así que escribir otro nombre acabaría en una
                 rejilla en blanco sin decir por qué. Las opciones son exactamente las que el
                 servidor permite —salen del mismo sitio—, él incluido.
                 No se enseña si no aprueba a nadie: ahí no hay nada que elegir y el calendario
                 sigue siendo solo el suyo, como hoy.

                 El cambio va por `cambiarEmpleado()`, igual que el campo de arriba, y no por
                 `getPlanificaciones()`: elegir a otra persona cambia TAMBIÉN sus festivos, y en
                 Cordova esta pantalla no navega (ver `cambiarEmpleado`). -->
            <v-select
              v-else-if="opcionesEmpleado.length > 1"
              dense
              outlined
              hide-details
              label="Empleado"
              v-model="inspectorFiltro"
              :items="opcionesEmpleado"
              item-text="texto"
              item-value="username"
              @change="cambiarEmpleado()"
            ></v-select>
            <!-- #59 · Y si la consulta del equipo falló, en el sitio del campo «Empleado» va su
                 reintento: sin equipo el desplegable no se enseña —solo estaría él— y en el
                 calendario propio no queda ninguna otra acción que vuelva a pedirlo, así que el
                 campo se perdía hasta salir y volver a entrar (ver `reintentarMiEquipo`). -->
            <v-btn
              v-else-if="falloMiEquipo"
              outlined
              small
              color="#c0392b"
              :title="$t('bandejaVacaciones.reintentarEquipoAyuda')"
              @click="reintentarMiEquipo()"
            >
              <v-icon small left>mdi-refresh</v-icon>
              {{ $t('bandejaVacaciones.reintentarEquipo') }}
            </v-btn>
            <!-- C4: proponer planificación con el solver (capa provisional; no escribe hasta aceptar) -->
            <v-menu
              v-if="Utils.getUser() && (Utils.getUser().roles.indexOf('ADMIN') > -1 || Utils.getUser().roles.indexOf('DTYCAL') > -1 || Utils.getUser().roles.indexOf('DIRECTOR') > -1 || Utils.getUser().roles.indexOf('PLANIFICADOR') > -1)"
              offset-y
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#9c27b0"
                  v-bind="attrs"
                  v-on="on"
                  text
                  icon
                  title="Proponer planificación (solver)"
                >
                  <v-icon>mdi-auto-fix</v-icon>
                </v-btn>
              </template>
              <v-card class="pa-3" width="320">
                <!-- SPEC-PARAMETRIZACION-PROPONER: los parámetros de la corrida viven en el DRAWER (con
                     preview ligero); este menú conserva las ACCIONES sobre la propuesta ya en pantalla. -->
                <v-btn block color="#9c27b0" dark @click="abrirDrawerProponer()">
                  {{ $t('proponerDrawer.abrir') }}
                </v-btn>
                <!-- ENCARGO-023 §2: si /resultado devolvió 410 y estamos en vista reducida
                     (audit-log), Aceptar queda DESHABILITADO — no aceptamos lo que no vemos
                     entero. El texto del tooltip repite el motivo del backend para que quede
                     documentado en el propio botón. -->
                <v-btn v-if="propuestas.length" block color="#2e9e5b" dark class="mt-2"
                       :disabled="pasadaAsyncModoReducido"
                       :title="pasadaAsyncModoReducido ? pasadaAsyncModoReducidoMotivo : ''"
                       @click="aceptarPlanificacion()">
                  Aceptar planificación ({{ propuestas.length }})
                </v-btn>
                <!-- #460 · quitarPropuestas, no limpiarPropuestas: esto es un descarte a mano y se
                     anota en el registro de la corrida. Ver quitarPropuestas(). -->
                <v-btn v-if="propuestas.length" block text color="red" class="mt-1" @click="quitarPropuestas()">
                  Quitar propuestas ({{ propuestas.length }})
                </v-btn>
                <!-- #460 · sin propuesta en pantalla el Aceptar no se dibuja (CLAUDE.md §9: un punto de
                     entrada que no lleva a ningún sitio no se pinta), pero el pie de este mismo menú
                     sigue explicando «Aceptar → queda PENDIENTE», así que el menú se contradecía: quien
                     lo lee busca un botón que no está. El probador de la #460 perdió una ronda entera
                     ahí (13/10/2026). La nota dice las tres cosas que §9 pide y JUNTO al control: por
                     qué no está, quién lo desbloquea (uno mismo, proponiendo) y dónde se pulsa después.
                     El motivo de fondo: la capa provisional vive en memoria de esta pantalla —no se
                     persiste en ningún sitio— y la vista principal va con `preloadPreviousPage: false`
                     y la ruta con `keepAlive: false`, así que salir del calendario la destruye. -->
                <div v-if="!propuestas.length" class="c4-sin-propuesta">
                  <b>No hay propuesta en pantalla que aceptar.</b>
                  La propuesta es provisional y vive solo aquí: al abrir el informe, cambiar de pantalla
                  o recargar se pierde y hay que volver a proponerla.
                  Lánzala con «{{ $t('proponerDrawer.abrir') }}» y acéptala <b>sin salir del
                  calendario</b>: con el botón verde «Aceptar planificación» de este menú, o pulsando un
                  bloque violeta del día y «Aceptar propuesta».
                </div>
                <!-- C4-EXPLICABILIDAD: panel con el motivo de colocación por visita (solver v0.17) -->
                <v-btn v-if="explicaciones.length" block text color="#9c27b0" class="mt-1" @click="panelPorQueAbierto = !panelPorQueAbierto">
                  ¿Por qué esta propuesta? ({{ propuestasConMotivo().length }})
                </v-btn>
                <!-- INTEGRIDAD PR-2: CONFIRMAR las pendientes (amarillas) — aquí ocurren los cambios
                     canónicos diferidos por el aceptar-aditivo: expedientes (segundas incluidas), estado
                     de línea/pedido y notificación SAP. Preview con soloListar + diálogo explícito. -->
                <v-btn v-if="contarPendientesPersistidas() > 0" block color="#2e7d32" dark class="mt-1"
                       title="Materializa las pendientes: crea expedientes y notifica (SAP)"
                       @click="confirmarPendientesReal()">
                  Confirmar pendientes ({{ contarPendientesPersistidas() }})
                </v-btn>
                <!-- C4: limpia las pendientes de confirmar PERSISTIDAS (aceptadas) + sus desplazamientos.
                     Solo por botón, con confirm. Nunca REALIZADA ni confirmada. Visible SIEMPRE con
                     inspector: el residuo puede vivir FUERA de la ventana (semanas pasadas) y antes el
                     botón ni aparecía; el diálogo ofrece limpiar la ventana o todo el horizonte. -->
                <v-btn v-if="inspectorFiltro" block text color="#c0392b" class="mt-1"
                       title="Elimina las pendientes y devuelve cada línea a su estado original"
                       @click="limpiarPendientesConfirmar()">
                  Limpiar pendientes{{ contarPendientesPersistidas() > 0 ? ' (' + contarPendientesPersistidas() + ')' : '' }}
                </v-btn>
                <!-- Los tres caminos, claros en la UI (SPEC-INTEGRIDAD-REVERT-PROPUESTAS) -->
                <div class="c4-caminos">
                  <b>Aceptar</b> → queda PENDIENTE (amarillo, reversible al 100%) ·
                  <b>Confirmar</b> → real: crea expedientes y notifica ·
                  <b>Limpiar</b> → elimina y restaura el original
                </div>
                <!-- SPEC-REGISTRO-PROPUESTAS: audit-log de corridas (quién, cuándo, parámetros,
                     restricciones congeladas, proceso deductivo y resolución). Solo lectura. -->
                <v-btn v-if="inspectorFiltro" block text color="#455a64" class="mt-1"
                       title="Historial de propuestas: quién pidió cada corrida, con qué parámetros y cómo se resolvió"
                       @click="abrirRegistroPropuestas()">
                  Registro de propuestas
                </v-btn>
              </v-card>
            </v-menu>
            <!-- Panel de informes pendientes (TPI) por inspector, al lado del Proponer. SOLO navega; el
                 dato está pre-agregado y siempre fresco. Icono solo (mismo estilo que el Proponer): con
                 texto, el width:100% que vuetify.css fuerza en los button lo estiraba a toda la toolbar. -->
            <v-btn
              text
              icon
              color="#4a3aa7"
              v-roles="['ADMIN','PLANIFICADOR']"
              title="Informes pendientes (TPI) por inspector"
              @click="$f7router.navigate('/dashboard/informes-pendientes/')"
            >
              <v-icon>mdi-file-clock-outline</v-icon>
            </v-btn>

            <v-select
              v-if="!target || target != 'cordova'"
              v-model="type"
              :items="types"
              item-text="nombre"
              item-value="valor"
              dense
              outlined
              hide-details
              label="Tipo"
            ></v-select>
          </div>
        </v-toolbar>
      </v-sheet>

      <!-- C4-B2: franja BANCO DE HORAS + PRODUCCIÓN por semana (una tarjeta por semana del horizonte) -->
      <div v-if="bancoSemanas().length" class="banco-franja" :class="{'one': bancoSemanas().length === 1}">
        <div v-for="s in bancoSemanas()" :key="s.anio + '-' + s.semana" class="wk-card">
          <div class="wk-hd">
            <span class="wk-t">Semana {{s.semana}}</span>
            <span class="wk-r">L-V · objetivo {{Math.round(s.objetivo_horas)}} h</span>
          </div>
          <div class="wk-row">
            <div class="wk-tag">HORAS<br>(banco)</div>
            <div class="wk-m"><div class="k">Planificado</div><div class="val">{{fmtH(s.horas_planificadas)}} <small>/ {{Math.round(s.objetivo_horas)}} h</small></div></div>
            <div class="wk-m"><div class="k">Saldo semana</div><div class="val"><span class="pill" :class="s.saldo_semana >= 0 ? 'pos' : 'neg'">{{s.saldo_semana >= 0 ? '+' : ''}}{{fmtH(s.saldo_semana)}}</span></div></div>
            <div class="wk-m"><div class="k">Techo 46 h</div><div class="val"><span class="pill" :class="s.horas_planificadas > 46 ? 'over' : 'cap-ok'">{{s.horas_planificadas > 46 ? 'supera' : 'dentro'}}</span></div></div>
            <div class="wk-m wk-right"><div class="k">Saldo acumulado</div><div class="val"><span class="pill" :class="saldoAcumHasta(s) >= 0 ? 'pos' : 'neg'">{{saldoAcumHasta(s) >= 0 ? '+' : ''}}{{fmtH(saldoAcumHasta(s))}}</span></div></div>
          </div>
          <!-- C4-REALINEAMIENTO v2: retirada la fila PRODUCCIÓN (Reparto campo / Informes·TPIP / Cumplimiento).
               Duplicaba los indicadores OEB/TPIP reales de cabecera y el cumplimiento vive en el cockpit, no en
               el calendario. El banco de horas (fila superior) queda como único añadido de esta franja. -->
        </div>
      </div>
      <div v-if="bancoSemanas().length" class="banco-note">🏦 <b>Banco de horas:</b> el motor acumula y muestra el saldo de jornada; <b>la compensación la decide el responsable</b> (no se auto-compensa).</div>
      <div v-if="alertasPlazo.length" class="banco-callout">
        <b>⚠ Plazo de informe:</b>
        <span v-if="alertasPlazo.some(a => a.tipo === 'PLAZO_INFORME_EN_RIESGO')" class="al-roja">alerta ROJA — un P1 no cabe ni con +20' sobre 46 h antes de su plazo.</span>
        <span v-else class="al-ambar">ÁMBAR — algún informe con plazo va justo.</span>
        <span class="al-count">({{alertasPlazo.length}})</span>
      </div>
      <!-- #311 · el solver cortó el cálculo por tiempo: la propuesta de encima sale, pero sin optimizar
           del todo. Va aquí, pegado al resultado, porque es una forma de leer ESA propuesta. -->
      <div v-if="avisoTiempoAgotado" class="banco-callout aviso-tiempo-agotado">
        <b>⏱ Cálculo cortado por tiempo:</b>
        <span class="al-ambar">ÁMBAR</span> — {{avisoTiempoAgotado}}
      </div>

      <!-- C4-REALINEAMIENTO v2: leyenda de la capa propuesta (provisional). Solo tipos que el solver emite hoy.
           #240 · las dos primeras muestras afirmaban un relleno verde para el campo y violeta para el
           informe, y eso NUNCA se pintó: la propuesta se rellena como cualquier planificación, por su
           tipo de trabajo. Se cuenta con palabras lo que distingue a una de otra —el distintivo— en
           vez de enseñar dos colores inventados. -->
      <div v-if="propuestas.length" class="banco-leyenda">
        <span><i class="sw sw-prop"></i> Propuesta (provisional, pdte. de confirmar)</span>
        <span>Campo (inspección) e informe (TPIP) se rellenan por su tipo de trabajo, como una planificación real</span>
        <span><span class="tag-p1">P1</span> informe con plazo legal · <span class="tag-inf">INF</span> informe</span>
      </div>

      <!-- #49 · leyenda de los estados del calendario, con las cuatro entradas de la maqueta que
           aprobó dirección el 22/09.
           #240 · y ahora con la REGLA delante y las dos familias separadas, porque la leyenda
           anterior enseñaba cuatro muestras de borde como si fueran cuatro colores de bloque, y lo
           que la persona ve en el calendario es un bloque RELLENO. Dicho de otra forma: el estado
           está en el borde y la leyenda no lo decía, así que el relleno —que dice el tipo— se leía
           como si fuera el estado.
           Va siempre visible: una leyenda no cambia el comportamiento de nada, solo explica lo que
           ya se está pintando. -->
      <div class="calendario-leyenda">
        <span class="leyenda-grupo">Borde = estado:</span>
        <span><i class="sw sw-borde sw-pdte"></i> Pendiente de confirmar</span>
        <span><i class="sw sw-borde sw-confirmada"></i> Confirmada</span>
        <span><i class="sw sw-borde sw-realizada"></i> Realizada</span>
        <!-- #268 · el borde discontinuo de las vacaciones puestas a mano: sin esta entrada, la
             leyenda no explicaría algo que el calendario pinta. -->
        <span><i class="sw sw-borde sw-a-mano"></i> {{ $t('vacacionAMano.leyenda') }}</span>
      </div>
      <div class="calendario-leyenda">
        <span class="leyenda-grupo">Relleno = tipo:</span>
        <span><i class="sw sw-relleno sw-vacaciones"></i> T0006 vacaciones</span>
        <span><i class="sw sw-relleno sw-festivo"></i> T0083 festivo</span>
        <span><i class="sw sw-relleno sw-baja"></i> T0084 baja laboral</span>
        <span><i class="sw sw-relleno sw-compensacion"></i> T0085 compensación</span>
        <span><i class="sw sw-relleno sw-despl-empresa"></i> Desplazamiento de empresa</span>
        <span><i class="sw sw-relleno sw-despl-particular"></i> Desplazamiento particular</span>
        <span><i class="sw sw-relleno sw-fichaje"></i> Fichaje</span>
        <span><i class="sw sw-relleno sw-sin-pedido"></i> Inspección sin pedido</span>
        <span><i class="sw sw-relleno sw-resto"></i> Resto: un tono propio por tipo de trabajo (el relleno nunca dice el estado)</span>
      </div>

      <v-row class="full-height">
        <v-col class="full-height">
          <v-sheet class="full-height">
            <v-calendar
              ref="calendar"
              v-model="value"
              color="primary"
              :type="type"
              :events="events"
              :event-color="getEventColor"
              event-overlap-mode="column"
              :event-overlap-threshold="30"
              :event-ripple="false"
              :event-height="25"
              :weekdays="weekday"
              @change="getEvents"
              :interval-minutes="15"
              :interval-count="96"
              :short-intervals="false"
              :show-week="true"
              @mousedown:event="startDrag"
              @mousedown:time="startTime"
              @mousemove:time="mouseMove"
              @mouseup:time="endDrag"
              @mouseleave.native="cancelDrag"
              @click:event="showEvent"
              @click:more="viewDay"
              locale="es-ES"
              event-more-text="{0} más"
            >
              <template v-slot:event="{ event, timed }">
                <!-- #240 · el borde dice SOLO el estado. Los tres bordes que decían el TIPO
                     —negro y rojo del desplazamiento, naranja del «sin pedido»— se han ido al
                     relleno (`rellenoDeclarado`), porque ganaban por orden de hoja de estilos al
                     verde y al azul y dejaban esos bloques sin estado visible. -->
                <div :class="{'borde-provisional' : event && event.planificacion && event.planificacion.esPropuesta, 'borde-amarillo' : event && event.planificacion && event.planificacion.pendienteConfirmar && !event.planificacion.esPropuesta, 'borde-verde' : event && event.planificacion && event.planificacion.estado && event.planificacion.estado == 'REALIZADA' , 'borde-azul' : event && event.planificacion && event.planificacion.estado && event.planificacion.estado == 'PLANIFICADA', 'sumar-importe': event && event.planificacion && (!event.planificacion.idExpediente || event.planificacion.sumarImporte) && esInspector(event.planificacion) && !esVersion(event.planificacion), 'vac-a-mano': esVacacionAMano(event && event.planificacion)}">
                  <div
                    v-if="!timed"
                    class="v-event-draggable"
                    v-html="event.name"
                  ></div>
                  <!-- Este v-else se muestra cuando es semana o dia asi que tendremos que poner para que se vean mas datos -->
                  <div
                    v-else
                    class="v-event-draggable"
                  >
                    <span class="v-event-summary" :class="{'letrasNegras' : event.colorLetras == 'black'}">
                      <span v-if="event.planificacion.direccionInspeccion">
                          {{event.planificacion.direccionInspeccion.cp}}{{event.planificacion.direccionInspeccion.poblacion ? ' ' + event.planificacion.direccionInspeccion.poblacion : ''}}{{event.planificacion.direccionInspeccion.provinciaStr ? ' - ' + event.planificacion.direccionInspeccion.provinciaStr : (event.planificacion.direccionInspeccion.provincia ? ' - ' + event.planificacion.direccionInspeccion.provincia : '' ) }}
                        <br>
                      </span>
                      <strong>{{event.name}}</strong>
                      <span v-if="event.planificacion.esPropuesta && event.planificacion.esSegunda" class="tag-2a">2ª</span>
                      <span v-if="esVacacionAMano(event.planificacion)" class="tag-a-mano">{{ $t('vacacionAMano.etiqueta') }}</span>
                      <span v-if="event.planificacion.codigoExpediente">
                        <br>
                        <strong>{{event.planificacion.codigoExpediente}}</strong>
                      </span>
                      <span v-if="event.planificacion.tipo == 'DESPLAZAMIENTO' && (event.planificacion.desplazamiento || event.planificacion.moviloc)">
                        <br>
                        <strong>Desde:</strong> {{event.planificacion.desplazamiento ? event.planificacion.desplazamiento.startAddress : event.planificacion.moviloc.origen}}<br>
                        <strong>Hasta:</strong> {{event.planificacion.desplazamiento ? event.planificacion.desplazamiento.endAddress : event.planificacion.moviloc.destino}}<br>
                        <template v-if="event.planificacion.moviloc && event.planificacion.desplazamiento">
                          <strong>Distancia según google:</strong> {{event.planificacion.desplazamiento.distance ? event.planificacion.desplazamiento.distance.humanReadable : '—'}}<br>
                          <strong>Tiempo según google:</strong> {{event.planificacion.desplazamiento.duration ? event.planificacion.desplazamiento.duration.humanReadable : '—'}}<br>
                        </template>
                        <template v-if="event.planificacion.moviloc && event.planificacion.moviloc.consumo">
                          <strong>Consumo:</strong> {{event.planificacion.moviloc.consumo}} L<br>
                        </template>
                        <template v-if="event.planificacion.moviloc && event.planificacion.moviloc.velMedia">
                          <strong>Vel. Media:</strong> {{event.planificacion.moviloc.velMedia}} km/h<br>
                        </template>
                        <template v-if="event.planificacion.moviloc && event.planificacion.moviloc.matricula">
                          <strong>Matrícula:</strong> {{event.planificacion.moviloc.matricula}}
                        </template>
                      </span>
                      <span v-if="event.planificacion.cliente && (event.planificacion.cliente.nif || event.planificacion.cliente.razonSocial)">
                        <br>
                        {{event.planificacion.cliente.nif}} - {{event.planificacion.cliente.razonSocial}}
                      </span>
                      <span v-if="event.planificacion.empleadoContratacion">
                        <br>
                        E.Cont: {{event.planificacion.empleadoContratacion}}
                      </span>
                      <span v-if="event.planificacion.codigoPedido || event.planificacion.numeroPedido">
                        <br>
                        Ped: {{event.planificacion.numeroPedido ? event.planificacion.numeroPedido : event.planificacion.codigoPedido}} - Lin: {{event.planificacion.numLinea}}
                      </span>
                      <!-- C4-B2: importe de reparto por bloque (campo e informe), verde. En propuestas usa
                           importeReparto (el € de campo también, GAP B); en lo real, el totalSinIVA de siempre. -->
                      <span v-if="event.planificacion.importeReparto" class="imp-reparto">
                        <br>
                        {{fmtEur(event.planificacion.importeReparto)}}
                        <span v-if="esPlazoP1(event.planificacion)" class="tag-p1">P1</span>
                        <span v-else-if="event.planificacion.tipoTrabajo == 'INFORME'" class="tag-inf">INF</span>
                      </span>
                      <span v-else-if="event.planificacion.totalSinIVASinTasasConDescuento">
                        <br>
                        {{event.planificacion.totalSinIVASinTasasConDescuento.toString().replace('.',',')}} €
                      </span>
                      <span v-if="event.planificacion.tipoTarea">
                        <br>
                        {{event.planificacion.tipoTarea.codigo}} - {{event.planificacion.tipoTarea.nombre}}
                      </span>
                      <br>
                      <template v-if="event.planificacion.tipo != 'FICHAJE'">{{(event.planificacion.horaInicio ? DateUtils.dateFormat(event.planificacion.horaInicio, 'DD/MM/YYYY') + ' ' : '')}} {{moment(event.start).format('H:mm') + ' - ' + moment(event.end).format('H:mm')}}</template>
                      <span v-if="event.planificacion.tipo != 'FICHAJE' && event.planificacion.inspectores && event.planificacion.inspectores.length">
                        <br>
                        {{event.planificacion.inspectores.map(i => i.username).join(',')}}
                      </span>
                      <!-- {{event}} -->
                    </span>
                  </div>
                  <!-- #49 · sin tirador de redimensionado: alargar una vacación es otra forma de
                       modificarla, y acaba en el mismo PUT que el arrastre. #58 · en las vacaciones,
                       sin mirar el interruptor, como el lápiz y la papelera del detalle. -->
                  <div
                    v-if="timed && event.planificacion.tipo != 'FICHAJE' && (event.planificacion.tipo == 'TAREA' || (!event.planificacion.estado) || (event.planificacion.estado && event.planificacion.estado != 'REALIZADA')) && !esEventoBloqueado(event.planificacion)"
                    class="v-event-drag-bottom"
                    @mousedown.stop="extendBottom(event)"
                  ></div>
                </div>

              </template>
              <!-- Cabecera diaria en la vista dia y semana -->
              <template v-slot:day-label-header="{day, present, date}">
                  <div
                    :class="{'presente': present}"
                    v-html="day"
                  ></div>
                  <div class="datos-cabecera">
                  <r-badge
                    v-if="festivoDelDia(date)"
                    class="badge-festivo"
                    color="red"
                    :text="festivoDelDia(date).etiqueta"
                    v-tooltip="festivoDelDia(date).nombre"
                  ></r-badge>
                    <r-badge v-if="horasFichajeDia(date) != '0h 0m'" :color="colorBadgeFichaje()" :text="horasFichajeDia(date)" v-tooltip="'Horas imputadas: ' + horasFichajeDia(date)"></r-badge>
                    
                    <r-badge v-if="getTotalOeaDia(date)" color="lime"  :text="'OEA: ' + getTotalOeaDia(date)" v-tooltip="'OEA: ' + getTotalOeaDia(date) + '<br/>' + getPedidosDiaHtml(date)" @click="mostrarPedidos(date)"></r-badge>
                    
                    <r-badge v-if="totalImporteDia(date, undefined, false)" color="teal"  :text="totalImporteDia(date, undefined, false)" v-tooltip="'Importe día: ' + totalImporteDia(date, undefined, false)" ></r-badge>
                    <r-badge v-if="totalImporteDia(date,'REALIZADA')" color="green"  :text="'OEB-R: ' + totalImporteDia(date,'REALIZADA')" v-tooltip="'OEB-R: ' + totalImporteDia(date,'REALIZADA')" ></r-badge>
                    <r-badge v-if="totalImporteDia(date,'PLANIFICADA',false)" color="blue"  :text="'OEB-P: ' + totalImporteDia(date,'PLANIFICADA',false)" v-tooltip="'OEB-P: ' + totalImporteDia(date,'PLANIFICADA',false)" ></r-badge>
                    <r-badge v-if="totalImporteDia(date,'PLANIFICADA',true)" color="yellow"  :text="'OEB-PPEND: ' + totalImporteDia(date,'PLANIFICADA',true)" v-tooltip="'OEB-PPEND: ' + totalImporteDia(date,'PLANIFICADA',true)" ></r-badge>
                    <!-- C4-REALINEAMIENTO v2: retiradas las badges inventadas B2/B3 (Reparto día / obj campo /
                         TPIP día). Las propuestas ya suman en los indicadores REALES de abajo (OEB-PPEND / TPC /
                         TPIP / TPIP€) al materializarse como planificación PROPUESTA. -->

                    <r-badge v-if="totalTiempoPorTipo(null, date, 'particular', false)" color="black"  :text="totalTiempoPorTipo(null, date, 'particular', false)" v-tooltip="'Tiempo día: ' + totalTiempoPorTipo(null, date, 'particular', false)" ></r-badge>
                    <r-badge v-if="totalKmDia(date)" color="purple" :text="totalKmDia(date)" v-tooltip="'Km día: ' + totalKmDia(date)"></r-badge>
                    <r-badge v-if="totalKmDia(date, true)" color="purple" borderColor="red" :text="'Part: ' + totalKmDia(date, true)" v-tooltip="'Km día (part): ' + totalKmDia(date, true)"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('DESPLAZAMIENTO', date, 'particular', false)" color="purple" :text="'TD: ' + totalTiempoPorTipo('DESPLAZAMIENTO', date, 'particular', false)" v-tooltip="'Tiempo desplazamiento: ' + totalTiempoPorTipo('DESPLAZAMIENTO', date, 'particular', false)"></r-badge>
                    <!-- #563 · lo que el cálculo de la ruta dice de este día (sin ida porque durmió allí, un viaje
                         que no se pudo calcular, de dónde sale): junto a sus km y su TD, que es donde se nota. -->
                    <r-badge v-if="avisosRutaDia(date).length" :color="colorAvisosRutaDia(date)" :text="textoAvisosRutaDia(date)" v-tooltip="tooltipAvisosRutaDia(date)"></r-badge>
                    <r-badge v-if="totalConsumoDia(date)" color="deeppurple" :text="'Cons: ' + totalConsumoDia(date) + ' L'" v-tooltip="'Cons. día: ' + totalConsumoDia(date) + ' L'"></r-badge>
                    <r-badge v-if="totalConsumoDia(date, true)" color="deeppurple" borderColor="red" :text="'Cons. P: ' + totalConsumoDia(date, true) + ' L'" v-tooltip="'Consumo día (part): ' + totalConsumoDia(date, true) + ' L'"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo(['LINEA', 'SINPEDIDO'], date)" color="orange" :text="'TPC: ' + totalTiempoPorTipo(['LINEA', 'SINPEDIDO'], date)" v-tooltip="'Tiempo TPC: ' + totalTiempoPorTipo(['LINEA', 'SINPEDIDO'], date)"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA'])" color="lime" borderColor="teal" :text="'TPIR: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA'])" v-tooltip="'Tiempo TPIR: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA'])"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])" color="lime" borderColor="blue" :text="'TPIP: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])" v-tooltip="'Tiempo TPIP: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])"></r-badge>
                    <r-badge v-if="totalImporteDiaFirma(date, 'REALIZADA')" color="teal" borderColor="lime" :text="'TPIR€: ' + totalImporteDiaFirma(date, 'REALIZADA')" v-tooltip="'Importe TPIR: ' + totalImporteDiaFirma(date, 'REALIZADA')"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])" color="teal" borderColor="blue" :text="'TPIP€: ' + getFormatImporte(importePorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'], true))" @click="verTPIP(date)" v-tooltip="'Importe TPIP: ' + (importePorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'], true) )"></r-badge>
                    <r-badge v-if="getInformesPendientes(date)" color="red" :text="'Pdtes: ' + getInformesPendientes(date)" v-tooltip="'Informes Pendientes: ' + getInformesPendientes(date)" @click="verPendientes(date)"></r-badge>
                    <v-btn v-if="numEventosDia(date)" icon :color="numEventosDia(date, 'DESPLAZAMIENTO') ? 'blue' : 'gray'" v-tooltip="'Calcular ruta'">
                      <v-icon @click="diaSelected = date;popupCalcularRutaOpened = true;">mdi-routes</v-icon>
                    </v-btn>
                  </div>
              </template>
              <!-- Cajetin diario en la vista mensual -->
              <template v-slot:day-label="{day, present, date}">
                  <div
                    :class="{'presente': present}"
                    v-html="day"
                  ></div>
                  <div class="datos-cabecera">
                  <r-badge
                    v-if="festivoDelDia(date)"
                    class="badge-festivo"
                    color="red"
                    :text="festivoDelDia(date).etiqueta"
                    v-tooltip="festivoDelDia(date).nombre"
                  ></r-badge>
                    <r-badge v-if="horasFichajeDia(date) != '0h 0m'" :color="colorBadgeFichaje()" :text="horasFichajeDia(date)" v-tooltip="'Horas imputadas: ' + horasFichajeDia(date)"></r-badge>
                    
                    <r-badge v-if="getTotalOeaDia(date)" color="lime"  :text="'OEA: ' + getTotalOeaDia(date)" v-tooltip="'OEA: ' + getTotalOeaDia(date) + '<br/>' + getPedidosDiaHtml(date)" @click="mostrarPedidos(date)"></r-badge>
                    
                    <r-badge v-if="totalImporteDia(date)" color="teal"  :text="totalImporteDia(date)" v-tooltip="'Importe día: ' + totalImporteDia(date)" ></r-badge>
                    <r-badge v-if="totalImporteDia(date,'REALIZADA')" color="green"  :text="totalImporteDia(date,'REALIZADA')" v-tooltip="'OEB-R: ' + totalImporteDia(date,'REALIZADA')" ></r-badge>
                    <r-badge v-if="totalImporteDia(date,'PLANIFICADA')" color="blue"  :text="totalImporteDia(date,'PLANIFICADA')" v-tooltip="'OEB-P: ' + totalImporteDia(date,'PLANIFICADA')" ></r-badge>
                    <r-badge v-if="totalImporteDia(date,'PLANIFICADA',true)" color="yellow" style="color:blue;"  :text="totalImporteDia(date,'PLANIFICADA',true)" v-tooltip="'OEB-PPEND: ' + totalImporteDia(date,'PLANIFICADA',true)" ></r-badge>

                    <r-badge v-if="totalTiempoPorTipo(null, date, 'particular', false)" color="black"  :text="totalTiempoPorTipo(null, date, 'particular', false)" v-tooltip="'Tiempo día: ' + totalTiempoPorTipo(null, date, 'particular', false)" ></r-badge>
                    <r-badge v-if="(numEventosDia(date, 'LINEA') + numEventosDia(date, 'SINPEDIDO'))" color="green" :text="(numEventosDia(date, 'LINEA') + numEventosDia(date, 'SINPEDIDO')) + ' Insp.'" v-tooltip="'Número de inspecciones: ' + (numEventosDia(date, 'LINEA') + numEventosDia(date, 'SINPEDIDO'))"></r-badge>
                    <r-badge v-if="numEventosDia(date, 'TAREA')" color="blue" :text="numEventosDia(date, 'TAREA') + ' Tareas'" v-tooltip="'Número de tareas: ' + numEventosDia(date, 'TAREA')"></r-badge>
                    <r-badge v-if="totalKmDia(date)" color="purple" :text="totalKmDia(date)" v-tooltip="'Km día: ' + totalKmDia(date)"></r-badge>
                    <r-badge v-if="totalKmDia(date, true)" color="purple" borderColor="red" :text="'Part: ' + totalKmDia(date, true)" v-tooltip="'Km día (part): ' + totalKmDia(date, true)"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('DESPLAZAMIENTO', date, 'particular', false)" color="purple" :text="'TD: ' + totalTiempoPorTipo('DESPLAZAMIENTO', date, 'particular', false)" v-tooltip="'Tiempo desplazamiento: ' + totalTiempoPorTipo('DESPLAZAMIENTO', date, 'particular', false)"></r-badge>
                    <!-- #563 · lo que el cálculo de la ruta dice de este día (sin ida porque durmió allí, un viaje
                         que no se pudo calcular, de dónde sale): junto a sus km y su TD, que es donde se nota. -->
                    <r-badge v-if="avisosRutaDia(date).length" :color="colorAvisosRutaDia(date)" :text="textoAvisosRutaDia(date)" v-tooltip="tooltipAvisosRutaDia(date)"></r-badge>
                    <r-badge v-if="totalConsumoDia(date)" color="deeppurple" :text="'Cons: ' + totalConsumoDia(date) + ' L'" v-tooltip="'Cons. día: ' + totalConsumoDia(date) + ' L'"></r-badge>
                    <r-badge v-if="totalConsumoDia(date, true)" color="deeppurple" borderColor="red" :text="'Cons. P: ' + totalConsumoDia(date, true) + ' L'" v-tooltip="'Consumo día (part): ' + totalConsumoDia(date, true) + ' L'"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo(['LINEA', 'SINPEDIDO'], date)" color="orange" :text="'TPC: ' + totalTiempoPorTipo(['LINEA', 'SINPEDIDO'], date)" v-tooltip="'Tiempo TPC: ' + totalTiempoPorTipo(['LINEA', 'SINPEDIDO'], date)"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA'])" color="lime" borderColor="teal" :text="'TPIR: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA'])" v-tooltip="'Tiempo TPIR: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA'])"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])" color="lime" borderColor="blue" :text="'TPIP: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])" v-tooltip="'Tiempo TPIP: ' + totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])"></r-badge>
                    <r-badge v-if="totalImporteDiaFirma(date, 'REALIZADA')" color="teal" borderColor="lime" :text="'TPIR€: ' + totalImporteDiaFirma(date, 'REALIZADA')" v-tooltip="'Importe TPIR: ' + totalImporteDiaFirma(date, 'REALIZADA')"></r-badge>
                    <r-badge v-if="totalTiempoPorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'])" color="teal" borderColor="blue" :text="'TPIP€: ' + getFormatImporte(importePorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'], true) )" @click="verTPIP(date)" v-tooltip="'Importe TPIP: ' + (importePorTipo('TAREA', date, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'], true) )"></r-badge>
                    <r-badge v-if="numEventosDia(date, 'DESPLAZAMIENTO')" color="purple" :text="numEventosDia(date, 'DESPLAZAMIENTO') + ' Despl.'" v-tooltip="'Número de desplazamientos: ' + numEventosDia(date, 'DESPLAZAMIENTO')"></r-badge>
                    <r-badge v-if="getInformesPendientes(date)" color="red" :text="'Pdtes: ' + getInformesPendientes(date)" v-tooltip="'Informes Pendientes: ' + getInformesPendientes(date)" @click="verPendientes(date)"></r-badge>
                    <v-btn v-if="numEventosDia(date)" icon :color="numEventosDia(date, 'DESPLAZAMIENTO') ? 'blue' : 'gray'" v-tooltip="'Calcular ruta'">
                      <v-icon @click="diaSelected = date;popupCalcularRutaOpened = true;">mdi-routes</v-icon>
                    </v-btn>
                  </div>
              </template>
            </v-calendar>
            <!-- #482 · "No planificables": BOTÓN en el mismo rincón donde vivía el panel, y la
                 ventana con todo el desglose. El panel flotante tapaba la rejilla y obligaba a leer
                 el desglose por una mirilla con scroll; el botón solo ocupa su línea y el
                 calendario se ve entero. Sigue fijo abajo a la derecha, a la izquierda de la
                 burbuja del chat, así que no mueve, estrecha ni tapa nada de lo que ya había (§9
                 del CLAUDE.md del orquestador).
                 Las CIFRAS son las que deja la #325 y no se recalculan aquí. -->
            <div v-if="hayCorridaEnPantalla" class="boton-no-planificables">
              <!-- `<button>` nativo: trae foco, teclado y pulsación táctil de serie. Deshabilitado
                   cuando no hay nada que enseñar, para no abrir una ventana vacía (§9). -->
              <button
                type="button"
                class="btn-np"
                :class="{ 'btn-np-sin-lineas': !hayBloqueadas }"
                :disabled="!hayBloqueadas"
                :title="tituloBotonNoPlanificables"
                @click="abrirVentanaNoPlanificables()"
              >
                <span class="btn-np-icono">{{ iconoBotonNoPlanificables }}</span>
                <span class="btn-np-rotulo">{{ rotuloBotonNoPlanificables }}</span>
                <span v-if="hayBloqueadas" class="btn-np-ver">Ver detalle ⤢</span>
              </button>
              <!-- La nota va JUNTO al botón y no dentro de la ventana: habla de la cifra que el
                   botón acaba de decir, y quien no la abra tiene que poder leer que esa cifra es
                   solo de lo que se enseña. El aviso del RECORTE, en cambio, vive dentro: allí es
                   donde se ven las 200 líneas de las que habla. -->
              <div v-if="notaBotonNoPlanificables" class="btn-np-nota">{{ notaBotonNoPlanificables }}</div>
            </div>
            <!-- #482 · la ventana. Se cierra y se vuelve a abrir sin relanzar la propuesta: lo que
                 pinta sale del estado que ya dejó el Proponer, y abrirla no pide nada a la API. -->
            <v-dialog v-model="ventanaNoPlanificables" max-width="1600" scrollable>
              <v-card class="ventana-np">
                <v-toolbar dense dark color="#23355bdd" class="ventana-np-barra">
                  <v-toolbar-title class="ventana-np-titulo">{{ tituloVentanaNoPlanificables }}</v-toolbar-title>
                  <span class="ventana-np-sub" :title="subtituloVentanaNoPlanificables">{{ subtituloVentanaNoPlanificables }}</span>
                  <v-spacer></v-spacer>
                  <v-btn icon dark small @click="ventanaNoPlanificables = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="ventana-np-cuerpo">
                  <div class="np-kpis">
                    <div class="np-kpi np-kpi-total">
                      <div class="np-kpi-l">Total bloqueado</div>
                      <div class="np-kpi-v">{{ kpisNoPlanificables.total.importe }}
                        <small v-if="kpisNoPlanificables.total.lineas">· {{ kpisNoPlanificables.total.lineas }}</small>
                      </div>
                    </div>
                    <div class="np-kpi np-kpi-solver">
                      <div class="np-kpi-l">Solver · {{ inspectorFiltro || 'este inspector' }}</div>
                      <div class="np-kpi-v">{{ kpisNoPlanificables.solver.importe }}
                        <small v-if="kpisNoPlanificables.solver.lineas">· {{ kpisNoPlanificables.solver.lineas }}</small>
                      </div>
                    </div>
                    <div class="np-kpi np-kpi-negocio">
                      <div class="np-kpi-l">Negocio · global</div>
                      <div class="np-kpi-v">{{ kpisNoPlanificables.negocio.importe }}
                        <small v-if="kpisNoPlanificables.negocio.lineas">· {{ kpisNoPlanificables.negocio.lineas }}</small>
                      </div>
                    </div>
                  </div>
                  <!-- Solo cuando HAY recorte: no se avisa de un truncamiento que no existe (#325) -->
                  <div v-if="avisoRecorteVentana" class="np-aviso">{{ avisoRecorteVentana }}</div>
                  <div v-if="notaBotonNoPlanificables" class="np-aviso">{{ notaBotonNoPlanificables }}</div>
                  <div v-if="avisoGeo" class="aviso-geo">
                    ⚠ Geocodificación incompleta: {{ avisoGeo }} visitas sin coordenadas
                  </div>
                  <div class="np-herramientas">
                    <input
                      v-model="busquedaNoPlanificables"
                      type="search"
                      class="np-buscador"
                      placeholder="Buscar pedido, cliente, población…"
                    />
                    <div class="np-filtro">
                      <button
                        type="button"
                        v-for="op in filtrosNoPlanificables"
                        :key="op.clave"
                        :class="{ on: filtroNoPlanificables === op.clave }"
                        @click="filtroNoPlanificables = op.clave"
                      >{{ op.etiqueta }} ({{ op.lineas }})</button>
                    </div>
                    <span class="np-orden">Ordenar: <b>Importe ↓</b></span>
                    <button type="button" class="np-excel" @click="exportarNoPlanificables()">⬇ Excel</button>
                  </div>
                  <table class="np-tabla">
                    <thead>
                      <tr>
                        <th>Origen · causa</th>
                        <th>Línea de pedido</th>
                        <th>Oferta</th>
                        <th>Cliente</th>
                        <th>Población</th>
                        <th>Entidad · fecha</th>
                        <th class="np-der">Importe</th>
                        <th>Qué hacer</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="grupo in gruposVentanaNoPlanificables">
                        <tr :key="grupo.clave" class="np-grupo" :class="'np-grupo-' + grupo.origen.toLowerCase()">
                          <td colspan="6">
                            <span class="np-chip" :class="'np-chip-' + grupo.origen.toLowerCase()">{{ grupo.origen }}</span>
                            {{ grupo.etiqueta }} · {{ grupo.items.length }} {{ grupo.items.length === 1 ? 'línea' : 'líneas' }}
                          </td>
                          <!-- La suma de las líneas de debajo con el mismo contrato que los
                               recuadros (`textoSuma`): sin ningún importe, «—»; con importe, el
                               importe aunque sea 0; y si faltan algunos, cuántos, para no
                               presentar como importe del grupo una suma a la que le faltan
                               sumandos. -->
                          <td class="np-der">{{ textoSuma(grupo.suma, '—') }}</td>
                          <td class="np-accion">{{ grupo.accion ? '→ ' + grupo.accion : '—' }}</td>
                        </tr>
                        <tr v-for="fila in grupo.items" :key="grupo.clave + '-' + fila.lineaId">
                          <td></td>
                          <td class="np-linea-id">{{ fila.lineaId || '—' }}</td>
                          <td class="np-corta">{{ fila.oferta || '—' }}</td>
                          <td>{{ fila.cliente || '—' }}</td>
                          <td>{{ fila.poblacion || '—' }}</td>
                          <td class="np-corta">{{ fila.entidadFecha }}</td>
                          <td class="np-der">{{ importeCelda(fila.importe) }}</td>
                          <td class="np-accion">
                            <!-- §9: el enlace solo se dibuja si lleva a algún sitio donde la línea
                                 pulsada esté de verdad —las de NEGOCIO, y solo si la ruta está en
                                 el menú efectivo del usuario—. Si no, la acción se dice igual, pero
                                 como texto: un enlace que acaba en un 403, o en una tabla donde la
                                 línea no aparece, es peor que no tener enlace. -->
                            <f7-link
                              v-if="fila.enlaceQueHacer"
                              :href="fila.enlaceQueHacer"
                              :external="fila.enlaceQueHacerExterno"
                            >{{ fila.rotuloQueHacer }}</f7-link>
                            <span v-else>{{ fila.rotuloQueHacer }}</span>
                          </td>
                        </tr>
                      </template>
                      <tr v-if="!gruposVentanaNoPlanificables.length">
                        <td colspan="8" class="np-vacio">{{ mensajeVentanaVacia }}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-card-text>
                <v-card-actions class="np-pie">
                  <span class="np-leyenda">
                    Negocio: líneas con <i>planificable = false</i> en el pedido · Solver: lo que el
                    planificador no pudo colocar para este inspector
                  </span>
                  <v-btn color="#23355b" dark class="np-cerrar" @click="ventanaNoPlanificables = false">Cerrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- #460 · los dos paneles flotantes (`position: fixed`, abajo a la izquierda) viven AQUÍ, al
                 lado del de «No planificables», y no dentro de la barra de herramientas donde estaban.
                 Vuetify le pone `contain: layout` a `.v-toolbar`, y eso convierte a la barra en el bloque
                 contenedor —y en el contexto de apilado— de sus descendientes `fixed`: el panel se
                 colocaba respecto de una caja de 64 px de alto, así que su `bottom: 8px` lo subía fuera de
                 la pantalla por arriba y el calendario le pasaba por encima por abajo. Fuera de la barra,
                 `fixed` vuelve a medirse contra la ventana, igual que el de «No planificables», que nunca
                 tuvo el problema justo por estar aquí. -->
            <!-- C4-EXPLICABILIDAD: panel "¿Por qué esta propuesta?" — una línea legible por visita con el
                 motivo que el solver REGISTRÓ en el punto de decisión (explicaciones[] de /proponer).
                 Solo muestra; no recalcula nada (ENAC): mismos datos → mismo texto. -->
            <v-card v-if="panelPorQueAbierto && propuestasConMotivo().length" class="panel-por-que elevation-6">
              <v-toolbar dense dark color="#9c27b0dd">
                <v-toolbar-title style="font-size:14px;">
                  ¿Por qué esta propuesta? ({{ propuestasConMotivo().length }})
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark small @click="panelPorQueAbierto = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="panel-por-que-body">
                <div v-for="ev in propuestasConMotivo()" :key="'pq-' + ev.planificacion.lineaId" class="linea-pq">
                  {{ lineaPorQue(ev) }}
                  <div v-if="explicacionDe(ev.planificacion).alternativaDescartada" class="pq-alt">
                    ↳ {{ explicacionDe(ev.planificacion).alternativaDescartada }}
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <!-- SPEC-REGISTRO-PROPUESTAS: panel del audit-log — un desplegable por corrida con el informe
                 completo (solicitud + restricciones congeladas + proceso deductivo + resolución). -->
            <v-card v-if="registroAbierto" class="panel-por-que elevation-6">
              <v-toolbar dense dark color="#455a64">
                <v-toolbar-title style="font-size:14px;">
                  Registro de propuestas · {{ inspectorFiltro }} ({{ registros.length }})
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark small @click="registroAbierto = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="panel-por-que-body">
                <!-- #460 · la otra salida al informe (el enlace «Ver informe →» de cada corrida) sale
                     igualmente del calendario y se lleva la propuesta provisional. Mismo aviso y mismo
                     texto que en la banda, una sola vez y solo si hay algo que perder: en un panel con
                     una fila por corrida, repetirlo en cada enlace sería ruido. -->
                <div v-if="(propuestas || []).length" class="reg-aviso-provisional">
                  {{ $t('proponerDrawer.informeSaleDelCalendario') }}
                </div>
                <div v-if="cargandoRegistros">Cargando registros…</div>
                <div v-else-if="!registros.length">Sin corridas registradas para este inspector.</div>
                <div v-for="reg in registros" :key="'reg-' + reg.id" class="reg-item">
                  <div class="reg-cab" @click="registroExpandido = registroExpandido === reg.id ? null : reg.id">
                    <b>{{ fmtFechaHora(reg.solicitud && reg.solicitud.fecha) }}</b>
                    · {{ (reg.solicitud && reg.solicitud.usuarioSolicitante) || '?' }}
                    · <span class="reg-estado" :class="'reg-' + ((reg.resolucion && reg.resolucion.estado) || '').toLowerCase()">
                        {{ (reg.resolucion && reg.resolucion.estado) || '?' }}</span>
                    <!-- #460 · «prop» y las «aceptadas» del detalle se cuentan con el MISMO módulo
                         que el informe de la corrida (`RecuentoPropuesta`): este panel enlaza con
                         ese informe, así que no puede dar otra cifra de lo mismo. -->
                    · {{ reg.resultado && reg.resultado.totales ? (propuestasDeCorrida(reg) + ' prop · '
                         + Math.round((reg.resultado.totales.minutosPropuestos || 0) / 60 * 10) / 10 + ' h') : '' }}
                    <!-- SPEC-INFORME-PROPUESTA: entrada 1 — del panel del calendario al informe completo -->
                    <a class="reg-informe" href="#" @click.prevent.stop="verInforme(reg)">{{ $t('informeProp.verInforme') }}</a>
                    <span class="reg-flecha">{{ registroExpandido === reg.id ? '▾' : '▸' }}</span>
                  </div>
                  <div v-if="registroExpandido === reg.id" class="reg-detalle">
                    <div><b>Ventana:</b> {{ fmtFecha(reg.solicitud.desde) }} → {{ fmtFecha(reg.solicitud.hasta) }}
                      · <b>run:</b> {{ (reg.resultado && reg.resultado.runId) || '—' }}</div>
                    <div><b>Parámetros:</b> {{ resumenParametros(reg.solicitud.parametros) }}</div>
                    <div v-if="reg.snapshotRestricciones"><b>Restricciones (congeladas):</b>
                      {{ resumenRestricciones(reg.snapshotRestricciones) }}</div>
                    <div v-if="reg.resultado && reg.resultado.totales">
                      <b>Resultado:</b> {{ propuestasDeCorrida(reg) }} propuestas ·
                      {{ reg.resultado.totales.nNoPlanificables }} no planificables ·
                      {{ reg.resultado.totales.nAlertas }} alertas
                    </div>
                    <div v-if="reg.resultado && reg.resultado.explicaciones && reg.resultado.explicaciones.length"
                         class="reg-deductivo">
                      <b>Proceso deductivo:</b>
                      <div v-for="(ex, i) in reg.resultado.explicaciones" :key="'ex-' + reg.id + '-' + i" class="pq-alt">
                        {{ ex.lineaId }} — {{ ex.motivoColocacion }}: {{ ex.detalle }}
                      </div>
                    </div>
                    <div v-if="reg.resolucion">
                      <b>Resolución:</b>
                      <span v-if="reg.resolucion.aceptadas && reg.resolucion.aceptadas.length">
                        {{ aceptadasDeCorrida(reg) }} de {{ propuestasDeCorrida(reg) }} aceptadas
                        (por {{ reg.resolucion.aceptadas[0].usuario || '?' }}
                        el {{ fmtFechaHora(reg.resolucion.aceptadas[0].fecha) }})<!--
                        #460 · Sin esto, una corrida que alguien resolvió descartando lo que
                        quedaba decía «3 de 5 aceptadas» y parecía tener dos visitas sin atender.
                        Las dos cifras son altas creadas; lo descartado a mano se dice aquí.
                        -->{{ descartadasDeCorrida(reg) }}</span>
                      <span v-else>sin aceptaciones</span>
                      <span v-if="reg.resolucion.confirmadaPor"> · confirmada por {{ reg.resolucion.confirmadaPor }}
                        el {{ fmtFechaHora(reg.resolucion.fechaConfirmacion) }}</span>
                      <span v-if="reg.resolucion.descartadaPor"> · descartada por {{ reg.resolucion.descartadaPor }}
                        el {{ fmtFechaHora(reg.resolucion.fechaDescarte) }}</span>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <v-menu
              v-model="selectedOpen"
              v-if="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card
                v-if="selectedEvent"
                color="grey lighten-4"
                min-width="350px"
                flat
              >
                <v-toolbar
                  :color="selectedEvent && selectedEvent.color"
                  dark
                  dense
                  :class="{'letrasNegras' : selectedEvent && selectedEvent.colorLetras == 'black'}"
                >
                  <!-- #49 · sin lápiz en las vacaciones y los festivos generados: se gestionan desde su módulo.
                       #58 · en las vacaciones, además, sin mirar el interruptor (ver `esEventoBloqueado`).
                       Sin lápiz no hay modo de edición, y sin modo de edición no hay campos ni «Guardar»:
                       `readOnlyPlanif` arranca y vuelve a `true` en cada apertura. -->
                  <v-btn icon v-if="selectedEvent.planificacion.tipo != 'FICHAJE' && (selectedEvent.planificacion.tipo == 'TAREA' || selectedEvent.planificacion.estado != 'REALIZADA') && !esEventoBloqueado(selectedEvent.planificacion)">
                    <v-icon @click="readOnlyPlanif = !readOnlyPlanif">{{readOnlyPlanif ? 'mdi-pencil-outline' : 'mdi-pencil'}}</v-icon>
                  </v-btn>
                  <v-toolbar-title><span v-html="selectedEvent.name"></span></v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- #58 · el botón que lleva la papelera tampoco se dibuja en un evento bloqueado.
                       Las tres papeleras de dentro ya se iban con la #49, pero el `v-btn` se quedaba:
                       en el detalle de un día de vacaciones salía un botón vacío, sin icono y sin
                       nada que hacer, justo donde dirección vio la papelera. Un control que no hace
                       nada no se pinta (§9). El `v-else-if` de abajo era un `v-else`: con la
                       condición nueva habría recogido el evento bloqueado y pintado la papelera del
                       fichaje —sin fichaje—, así que dice a qué caso responde. -->
                  <!-- #268 · en un día de vacaciones la papelera vuelve, pero solo si el servidor dice
                       que ese día se puede borrar: los puestos a mano sí, los de una solicitud nunca.
                       Ver `papeleraVisible`. -->
                  <v-btn icon v-if="!selectedEvent.planificacion || (selectedEvent.planificacion.tipo != 'FICHAJE' && papeleraVisible(selectedEvent.planificacion))">
                    <!-- #49 · sin papelera en los festivos generados con el bloqueo encendido; #268 ·
                         en las vacaciones, la que diga `papeleraVisible` -->
                    <v-icon v-if="selectedEvent.planificacion && (selectedEvent.planificacion.tipo == 'TAREA' || selectedEvent.planificacion.estado != 'REALIZADA')" @click="borrarPlanificacion(selectedEvent.planificacion)">mdi-trash-can-outline</v-icon>
                    <v-icon v-else-if="selectedEvent.planificacion && selectedEvent.planificacion.tipo == 'DESPLAZAMIENTO'" v-roles="['ADMIN']" @click="borrarPlanificacion(selectedEvent.planificacion)">mdi-trash-can-outline</v-icon>
                    <v-icon v-if="!selectedEvent.planificacion" @click="borrarEvento(selectedEvent)">mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <v-btn icon v-else-if="selectedEvent.planificacion && selectedEvent.planificacion.tipo == 'FICHAJE'">
                    <v-icon @click="borrarFichaje(selectedEvent.planificacion.idFichaje)">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-toolbar>
                <!-- #58 · detalle de un día de vacaciones: la jornada, a qué solicitud pertenece y
                     en qué estado está. Lo único que se puede hacer desde aquí es ir al módulo: los
                     días de vacaciones no se editan, no se mueven y no se borran en el calendario
                     (punto 6 de la #58), y eso ya no depende del interruptor de la #49. -->
                <v-card-text v-if="esDiaDeVacaciones(selectedEvent.planificacion)" class="detalle-vacaciones">
                  <div class="vac-jornada">
                    {{ horaDe(selectedEvent.planificacion) }} ·
                    {{ selectedEvent.planificacion.tiempoEstimadoCampo || 480 }} min ·
                    {{ $t('misVacaciones.diaCompleto') }}
                  </div>
                  <!-- #268 · un día puesto a mano lo dice, en cualquier calendario y no solo en el
                       propio: es lo que lo distingue de uno de una solicitud, y lo que explica por
                       qué está pendiente. -->
                  <div v-if="selectedEvent.planificacion.vacacionAMano" class="vac-linea vac-a-mano-detalle">
                    {{ $t('vacacionAMano.detalle') }}
                  </div>
                  <!-- #268 · cuando la papelera no está, se dice por qué, quién puede quitar el día y
                       dónde, junto a donde estaría (§9). El texto es el del servidor: el mismo que
                       daría el 403. Mientras se pregunta no se dice nada. -->
                  <div v-if="motivoSinPapelera(selectedEvent.planificacion)" class="vac-linea vac-sin-papelera">
                    {{ motivoSinPapelera(selectedEvent.planificacion) }}
                  </div>
                  <!-- La solicitud y el botón, solo en el calendario propio: el endpoint contesta
                       con las vacaciones del usuario logueado, así que en el de otra persona
                       cualquiera de las dos frases sería mentira. Se mira el valor que se fijó al
                       abrir el día y no la condición en vivo, que puede cambiar con el detalle ya
                       abierto. Ver `cargarSolicitudDelDia`. -->
                  <!-- #59 · el detalle se enseña también en el calendario de la gente a la que se
                       aprueba, no solo en el propio: ahí la solicitud se pide por el endpoint que
                       recibe de quién es el calendario y comprueba si se puede mirar. Ver
                       `cargarSolicitudDelDia`. -->
                  <!-- #59 · y también cuando NO se ha podido saber de quién es el día: ahí no se
                       enseña el detalle, pero tampoco se calla. Sin esta tercera rama el bloque
                       entero desaparecía y un fallo de red se veía igual que un día que no es de
                       nadie a quien se apruebe. -->
                  <template v-if="detalleDiaEsMio || detalleDiaEsDeMiEquipo || errorEquipoDia">
                    <!-- No se ha llegado a preguntar por la solicitud porque no se sabe a quién se
                         aprueba. Se dice, y el reintento vuelve a pedir el equipo. -->
                    <div v-if="errorEquipoDia" class="vac-linea vac-sin-solicitud">
                      {{ $t('bandejaVacaciones.errorEquipoDia') }}
                      <f7-link @click="reintentarSolicitudDelDia()">
                        {{ $t('bandejaVacaciones.reintentar') }}
                      </f7-link>
                    </div>
                    <div v-else-if="cargandoSolicitudDia" class="vac-linea">…</div>
                    <template v-else-if="solicitudDelDia">
                      <div class="vac-linea">
                        <b>{{ $t('misVacaciones.detalleSolicitud') }}:</b> {{ solicitudDelDia.codigo }}
                        <span class="vac-estado">{{ $t('misVacaciones.estado_' + solicitudDelDia.estado) }}</span>
                      </div>
                      <div v-if="solicitudDelDia.aprobadorNombre || solicitudDelDia.aprobador" class="vac-linea">
                        {{ $t('misVacaciones.pieAprobador', { quien: solicitudDelDia.aprobadorNombre || solicitudDelDia.aprobador }) }}
                      </div>
                      <!-- #59 · Lo que escribió quien pide los días en «Comentario para quien
                           aprueba». Se enseña en los DOS sitios desde los que se resuelve —aquí y
                           la bandeja—: se escribió para esta decisión, y desde el calendario era
                           lo único que no se podía leer antes de pulsar. -->
                      <div v-if="solicitudDelDia.comentario" class="vac-linea vac-comentario">
                        {{ $t('bandejaVacaciones.comentarioSolicitante') }}: «{{ solicitudDelDia.comentario }}»
                      </div>
                      <!-- #59 · Aprobar y Denegar desde el día amarillo. Se enseñan donde el
                           SERVIDOR dice que se puede resolver (`puedeResolver`), que es el mismo
                           criterio con el que después va a aceptar o rechazar la acción: deducirlo
                           aquí del estado enseñaría el botón a quien no puede.
                           Y afectan a la SOLICITUD ENTERA, no al día que se ha pulsado: se dice
                           antes de pulsar, porque desde un día suelto no se ve. -->
                      <template v-if="solicitudDelDia.puedeResolver">
                        <div class="vac-linea vac-aviso-entera">
                          {{ $t('bandejaVacaciones.afectaALaSolicitudEntera', {
                            dias: solicitudDelDia.diasQueDescuenta,
                            fechas: fechasDeLaSolicitud(solicitudDelDia)
                          }) }}
                        </div>
                        <!-- #59 · Apagados mientras la resolución viaja: el diálogo se cierra al
                             aceptar, no al contestar el servidor, y con una respuesta lenta un
                             segundo toque mandaba otra resolución con la misma `version` —o la
                             contraria—. El cerrojo es el mismo que apaga los botones de la bandeja
                             y es **de la solicitud** (`unaAccionALaVez`): resolverla desde aquí
                             apaga también sus botones allí, y al contrario. Apagado dice por
                             qué (§9). -->
                        <v-btn color="green" dark small class="mt-2 mr-1"
                               :disabled="resolviendose(solicitudDelDia)"
                               @click="aprobarDesdeCalendario()">
                          {{ $t('bandejaVacaciones.aprobar') }}
                        </v-btn>
                        <v-btn color="red" dark small class="mt-2"
                               :disabled="resolviendose(solicitudDelDia)"
                               @click="denegarDesdeCalendario()">
                          {{ $t('bandejaVacaciones.denegar') }}
                        </v-btn>
                        <div v-if="resolviendose(solicitudDelDia)" class="vac-linea vac-resolviendo">
                          {{ $t('bandejaVacaciones.resolviendo') }}
                        </div>
                      </template>
                    </template>
                    <!-- Que no se haya podido leer no es que no tenga: afirmar «no pertenece a
                         ninguna solicitud» cuando la petición ha fallado es decir por cierto algo
                         que no se sabe. Se distingue, igual que en el formulario con las normas. -->
                    <div v-else-if="errorSolicitudDia" class="vac-linea vac-sin-solicitud">
                      {{ $t('misVacaciones.detalleErrorSolicitud') }}
                    </div>
                    <!-- Un día de vacaciones sin solicitud existe: son los que se cargaron a mano
                         antes del módulo. Se dice, en vez de dejar el hueco en blanco.
                         #268 · salvo que se sepa que se ha puesto a mano ahora: eso ya lo dice la
                         línea de arriba, y «antes de ponerlo en marcha» la contradiría. -->
                    <div v-else-if="!selectedEvent.planificacion.vacacionAMano" class="vac-linea vac-sin-solicitud">
                      {{ $t('misVacaciones.detalleSinSolicitud') }}
                    </div>
                    <!-- El mismo criterio que el botón de la barra: si la pantalla no es
                         alcanzable, su punto de entrada no se dibuja (§9). Aquí sí lleva texto a
                         propósito —está dentro del detalle del día y no en la toolbar, así que no
                         hay nada que estirar— y el detalle sigue diciendo la solicitud y su estado
                         aunque el botón no esté. -->
                    <v-btn v-if="puedeAbrirVacaciones" color="#d98324" dark small class="mt-2"
                           @click="irAVacaciones()">
                      {{ $t('misVacaciones.verEnModulo') }}
                    </v-btn>
                  </template>
                </v-card-text>
                <!-- C4: propuesta del solver (provisional, sin id): aceptar la pasa a pdte. de confirmar -->
                <v-card-text v-if="selectedEvent.planificacion && selectedEvent.planificacion.esPropuesta">
                  <!-- ENCARGO-023 §2: Aceptar por evento se DESHABILITA también en vista reducida. -->
                  <v-btn
                    color="#9c27b0"
                    dark
                    :disabled="pasadaAsyncModoReducido"
                    :title="pasadaAsyncModoReducido ? pasadaAsyncModoReducidoMotivo : ''"
                    @click="aceptarPropuesta(selectedEvent.planificacion)"
                  >
                    Aceptar propuesta
                  </v-btn>
                  <v-btn
                    color="red"
                    text
                    @click="descartarPropuesta(selectedEvent.planificacion)"
                  >
                    Descartar
                  </v-btn>
                  <br/><br/>
                  <span v-if="selectedEvent.planificacion.cliente"><b>Cliente:</b> {{ selectedEvent.planificacion.cliente.nombre }}<br/></span>
                  <span v-if="selectedEvent.planificacion.direccionInspeccion"><b>Dirección:</b> {{ selectedEvent.planificacion.direccionInspeccion.direccion }} ({{ selectedEvent.planificacion.direccionInspeccion.poblacion }})<br/></span>
                  <span v-if="selectedEvent.planificacion.codigoExpediente"><b>Expediente:</b> {{ selectedEvent.planificacion.codigoExpediente }}<br/></span>
                  <span v-if="selectedEvent.planificacion.totalSinIVASinTasasConDescuento"><b>Importe:</b> {{ getFormatImporte(selectedEvent.planificacion.totalSinIVASinTasasConDescuento) }}<br/></span>
                  <!-- MULTIDÍA: comentario de continuación de la tarea T0004 (viene del solver vía mapper) -->
                  <span v-if="selectedEvent.planificacion.comentariosTarea"><b>Continuación:</b> {{ selectedEvent.planificacion.comentariosTarea }}<br/></span>
                  <!-- C4-EXPLICABILIDAD: motivo registrado por el solver en el punto de decisión (solo muestra) -->
                  <span v-if="explicacionDe(selectedEvent.planificacion)">
                    <b>¿Por qué?</b> {{ textoMotivo(explicacionDe(selectedEvent.planificacion)) }}<br/>
                    <span v-if="explicacionDe(selectedEvent.planificacion).alternativaDescartada" class="pq-alt">
                      ↳ {{ explicacionDe(selectedEvent.planificacion).alternativaDescartada }}<br/>
                    </span>
                  </span>
                </v-card-text>
                <v-card-text v-if="selectedEvent.planificacion && selectedEvent.planificacion.id">
                  <!-- #49 · sin «Marcar como realizada» en las vacaciones ni en los festivos generados:
                       REALIZADA la pone solo el cierre nocturno cuando pasa el día (D-UX), y este botón
                       pasaba a REALIZADA la tarea entera saltándose ese circuito.
                       #58 · en las vacaciones, sin mirar el interruptor: sobre una solicitud que nadie ha
                       aprobado, este botón daba por disfrutados unos días que aún se pueden anular. -->
                  <span v-if="selectedEvent.planificacion.tipo == 'TAREA' && selectedEvent.planificacion.estado == 'PLANIFICADA' && !esEventoBloqueado(selectedEvent.planificacion)">
                    <v-btn
                      color="teal"
                      dark
                      @click="selectedEvent.planificacion.estado = 'REALIZADA'; guardarCambios(); onCerrarDetalle()"
                    >
                      Marcar como realizada
                    </v-btn>
                    <br/>
                    <br/>
                  </span>
                  <span v-if="selectedEvent.planificacion.tipo == 'DESPLAZAMIENTO'">
                    <v-btn
                      width="150px"
                      color="red"
                      dark
                      v-if="selectedEvent.planificacion.moviloc && !selectedEvent.planificacion.particular"
                      @click="selectedEvent.planificacion.particular = true; guardarCambios(); onCerrarDetalle()"
                    >
                      Es particular
                    </v-btn>
                    <v-btn
                      width="150px"
                      color="green"
                      dark
                      v-if="selectedEvent.planificacion.particular"
                      @click="selectedEvent.planificacion.particular = false; guardarCambios(); onCerrarDetalle()"
                    >
                      Es de trabajo
                    </v-btn>
                    <br/>
                  </span>
                  <span v-else>
                    <f7-link
                      v-if="selectedEvent.planificacion.tipo == 'FICHAJE'"
                      :href="getUrl('fichaje/view/' + selectedEvent.planificacion.idFichaje + '/')"
                      icon-f7="arrow_up_right_square"
                      color="green"
                      :external="target != 'cordova'"
                      v-tooltip="'Ver Tarea'"
                    > Ver Fichaje</f7-link>
                    <f7-link
                      v-if="selectedEvent.planificacion.tipo == 'TAREA'"
                      :href="getUrl('tarea/view/' + selectedEvent.planificacion.idTarea + '/')"
                      icon-f7="arrow_up_right_square"
                      color="orange"
                      :external="target != 'cordova'"
                      v-tooltip="'Ver Tarea'"
                    > Ver Tarea</f7-link>
                    <f7-link
                      v-if="selectedEvent.planificacion.idPedido"
                      :href="getUrl('pedidos/view/' + selectedEvent.planificacion.idPedido + '/')"
                      icon-f7="arrow_up_right_square"
                      color="purple"
                      :external="target != 'cordova'"
                      v-tooltip="'Ver Pedido' + ((selectedEvent.planificacion.numeroPedido || selectedEvent.planificacion.codigoPedido) ? ' ' + (selectedEvent.planificacion.numeroPedido || selectedEvent.planificacion.codigoPedido) : '')"
                    > Ver Pedido</f7-link>
                    <f7-link
                      v-if="selectedEvent.planificacion.idOferta"
                      :href="getUrl('ofertas/view/' + selectedEvent.planificacion.idOferta + '/')"
                      icon-f7="arrow_up_right_square"
                      color="blue"
                      :external="target != 'cordova'"
                      v-tooltip="'Ver Oferta' + ((selectedEvent.planificacion.numeroOferta || selectedEvent.planificacion.codigoOferta) ? ' ' + (selectedEvent.planificacion.numeroOferta || selectedEvent.planificacion.codigoOferta) : '')"
                    > Ver Oferta</f7-link>
                    <f7-link
                      v-if="selectedEvent.planificacion.cliente && selectedEvent.planificacion.cliente.id"
                      :href="getUrl('clientes/view/' + selectedEvent.planificacion.cliente.id + '/')"
                      icon-f7="arrow_up_right_square"
                      color="green"
                      :external="target != 'cordova'"
                      v-tooltip="'Ver Cliente ' + (selectedEvent.planificacion.cliente.codigo || '') + ' - ' + (selectedEvent.planificacion.cliente.razonSocial || '')"
                    > Ver Cliente</f7-link>
                    <f7-link
                      v-if="!selectedEvent.planificacion.idPedido && selectedEvent.planificacion.idExpediente"
                      icon-f7="arrow_up_right_square"
                      color="orange"
                      @click="popupAsociarOpened = true"
                      v-tooltip="'Asociar Pedido'"
                    > Asociar Pedido</f7-link>
                    <f7-link
                      v-if="selectedEvent.planificacion.idExpediente"
                      :href="getUrl(getPathExpediente(selectedEvent.planificacion))"
                      icon-f7="arrow_up_right_square"
                      color="green"
                      class="margin-left"
                      :external="target != 'cordova'"
                      @click="onCerrarDetalle()"
                      v-tooltip="'Ver Expediente' + (selectedEvent.planificacion.codigoExpediente ? ' ' + selectedEvent.planificacion.codigoExpediente : '')"
                    > Ver Expediente</f7-link>
                    <br>
                  </span>
                  <span><strong>{{selectedEvent.name}}</strong><br></span>
                  <span v-if="selectedEvent.planificacion.tipo == 'DESPLAZAMIENTO' && (selectedEvent.planificacion.desplazamiento || selectedEvent.planificacion.moviloc)">
                    <strong>Desde:</strong> {{selectedEvent.planificacion.desplazamiento ? selectedEvent.planificacion.desplazamiento.startAddress : selectedEvent.planificacion.moviloc.origen}}<br>
                    <strong>Hasta:</strong> {{selectedEvent.planificacion.desplazamiento ? selectedEvent.planificacion.desplazamiento.endAddress : selectedEvent.planificacion.moviloc.destino}}<br>
                    <template v-if="selectedEvent.planificacion.moviloc && selectedEvent.planificacion.desplazamiento">
                      <strong>Distancia según google:</strong> {{selectedEvent.planificacion.desplazamiento.distance ? selectedEvent.planificacion.desplazamiento.distance.humanReadable : '—'}}<br>
                      <strong>Tiempo según google:</strong> {{selectedEvent.planificacion.desplazamiento.duration ? selectedEvent.planificacion.desplazamiento.duration.humanReadable : '—'}}<br>
                    </template>
                    <template v-if="selectedEvent.planificacion.moviloc && selectedEvent.planificacion.moviloc.consumo">
                      <strong>Consumo:</strong> {{selectedEvent.planificacion.moviloc.consumo}} L<br>
                    </template>
                    <template v-if="selectedEvent.planificacion.moviloc && selectedEvent.planificacion.moviloc.velMedia">
                      <strong>Vel. Media:</strong> {{selectedEvent.planificacion.moviloc.velMedia}} km/h<br>
                    </template>
                    <template v-if="selectedEvent.planificacion.moviloc && selectedEvent.planificacion.moviloc.matricula">
                      <strong>Matrícula:</strong> {{selectedEvent.planificacion.moviloc.matricula}}<br>
                    </template>
                  </span>
                  <span>
                    {{(selectedEvent.planificacion.horaInicio ? DateUtils.dateFormat(selectedEvent.planificacion.horaInicio, 'DD/MM/YYYY') + ' ' : '') + moment(selectedEvent.start).format('H:mm') + (selectedEvent.planificacion.tipo == 'FICHAJE' ? '' : (' - ' + moment(selectedEvent.end).format('H:mm')))}}
                    <strong v-if="selectedEvent.planificacion.tipo != 'FICHAJE' && selectedEvent.planificacion.tiempoEstimadoCampo"> ( {{getMinutesHumanize(selectedEvent.planificacion.tiempoEstimadoCampo)}} )</strong>
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.tipo != 'FICHAJE' && selectedEvent.planificacion.tiempoEstimadoCampoLinea">
                    <strong>TPCE (línea):</strong> {{getMinutesHumanize(selectedEvent.planificacion.tiempoEstimadoCampoLinea)}}
                    <br>
                  </span>
                  <span v-roles="['ADMIN', 'DTYCAL']" v-if="selectedEvent.planificacion.tiempoReal">
                    <strong>Tiempo Real:</strong> {{selectedEvent.planificacion.tiempoReal}} min.
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.codigoPedido || selectedEvent.planificacion.numeroPedido">
                    <strong>Pedido:</strong> {{selectedEvent.planificacion.numeroPedido ? selectedEvent.planificacion.numeroPedido : selectedEvent.planificacion.codigoPedido}} - <strong>Línea:</strong> {{selectedEvent.planificacion.numLinea}}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.codigoExpediente">
                    <strong>Expediente:</strong> {{selectedEvent.planificacion.codigoExpediente}}
                    <r-badge v-if="selectedEvent.planificacion.estadoExpediente && (!selectedEvent.planificacion.tipo || selectedEvent.planificacion.tipo != 'TAREA')" :color="getColorBadgeEstadoExpediente(selectedEvent.planificacion.estadoExpediente)" :text="getTextEstadoExpediente(selectedEvent.planificacion.estadoExpediente)"></r-badge>
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.totalSinIVASinTasasConDescuento">
                    <strong>Importe:</strong> {{selectedEvent.planificacion.totalSinIVASinTasasConDescuento.toString().replace('.',',')}} €
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.cliente && (selectedEvent.planificacion.cliente.codigo || selectedEvent.planificacion.cliente.razonSocial || selectedEvent.planificacion.cliente.nif)">
                    <strong>Cliente:</strong> {{selectedEvent.planificacion.cliente.razonSocial || '' }} - {{selectedEvent.planificacion.cliente.nif || '' }} - {{selectedEvent.planificacion.cliente.codigo || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.titular || selectedEvent.planificacion.nifTitular">
                    <strong>Titular:</strong> {{selectedEvent.planificacion.titular || '' }} - {{selectedEvent.planificacion.nifTitular || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.empleadoContratacion">
                    <strong>Emp. Contratación:</strong> {{selectedEvent.planificacion.empleadoContratacion}}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.creationUserName && selectedEvent.planificacion.tipo != 'FICHAJE'">
                    <strong>Emp. Planificador:</strong> {{selectedEvent.planificacion.empleadoPlanificador || selectedEvent.planificacion.creationUserName}}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.fechaPlanificacion">
                    <strong>F. Planificacion:</strong> {{DateUtils.dateFormat(selectedEvent.planificacion.fechaPlanificacion, 'DD/MM/YYYY')}}
                    <br>
                  </span>
                  <r-badge v-if="selectedEvent.planificacion.pendienteConfirmar" :color="'red'" :text="'PDTE CONFIRMAR'"></r-badge>
                  <br v-if="selectedEvent.planificacion.pendienteConfirmar">
                  <span v-if="selectedEvent.planificacion.tipoTarea">
                    <strong>Tipo Tarea:</strong> {{selectedEvent.planificacion.tipoTarea.codigo || '' }} - {{selectedEvent.planificacion.tipoTarea.nombre || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.nombreTarea">
                    <strong>Desc Tarea:</strong> {{selectedEvent.planificacion.nombreTarea || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.comentariosTarea">
                    <strong>Coment Tarea:</strong> {{ selectedEvent.planificacion.comentariosTarea || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.tipo == 'TAREA' && fechaCreacionTarea">
                    <strong>Fecha de creación:</strong> {{DateUtils.dateFormat(fechaCreacionTarea, 'DD/MM/YYYY')}}
                    <br>
                  </span>
                  <r-badge v-if="selectedEvent.planificacion.tipo != 'DESPLAZAMIENTO' && selectedEvent.planificacion.tipo != 'FICHAJE'" :color="getColorBadgeEstado(selectedEvent)" :text="selectedEvent.planificacion.estado"></r-badge>
                  <r-badge v-if="selectedEvent.planificacion.sinKm" color="gray" text="No calcular km"></r-badge>
                  <br v-if="selectedEvent.planificacion.tipo != 'DESPLAZAMIENTO'">
                  <strong v-if="selectedEvent.planificacion.direccionInspeccion">Dirección:</strong>
                  <ul v-if="selectedEvent.planificacion.direccionInspeccion">
                    <li>{{selectedEvent.planificacion.direccionInspeccion.direccion}}
                      <br>{{selectedEvent.planificacion.direccionInspeccion.cp}} - {{selectedEvent.planificacion.direccionInspeccion.poblacion}}
                      <br>{{selectedEvent.planificacion.direccionInspeccion.provinciaStr}}
                    </li>
                  </ul>
                  <span v-if="selectedEvent.planificacion.contacto">
                    <strong>Contacto:</strong> {{ selectedEvent.planificacion.contacto || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.telefono1">
                    <strong>Teléfono 1:</strong> {{ selectedEvent.planificacion.telefono1 || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.telefono2">
                    <strong>Teléfono 2:</strong> {{ selectedEvent.planificacion.telefono2 || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.titularPresencial != undefined">
                    <strong>El titular ha comunicado que quiere presenciar la inspección:</strong> {{ selectedEvent.planificacion.titularPresencial ? 'Sí' : 'No' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.trabajoRealizar">
                    <strong>Características principales del trabajo a realizar:</strong> {{ selectedEvent.planificacion.trabajoRealizar || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.numUnidadesOfertadas">
                    <strong>Número de unidades ofertadas:</strong> {{ selectedEvent.planificacion.numUnidadesOfertadas || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.rae">
                    <strong>RAE:</strong> {{ selectedEvent.planificacion.rae || '' }}
                    <br>
                  </span>
                  <span v-if="selectedEvent.planificacion.tipo != 'FICHAJE'"><strong>Empleados:</strong></span>
                  <ul v-if="selectedEvent.planificacion.tipo != 'FICHAJE'">
                    <li v-for="insp in selectedEvent.planificacion.inspectores" :key="insp.username">{{insp.username}} - {{insp.rol}}</li>
                  </ul>
                  <v-text-field v-if="!readOnlyPlanif && selectedEvent.planificacion.tipo != 'TAREA'" label="Añadir inspector" v-model="selectedEvent.anadirInspector"></v-text-field>
                  <v-select
                    v-if="!readOnlyPlanif && selectedEvent.planificacion.tipo != 'TAREA' && selectedEvent.anadirInspector"
                    :items="roles"
                    label="Asignar rol al inspector"
                    v-model="selectedEvent.rolInspector"
                  ></v-select>
                  <v-text-field v-if="!readOnlyPlanif" label="Comentarios Planificación" v-model="selectedEvent.planificacion.comentariosPlanificacion"></v-text-field>
                  <span v-else>{{selectedEvent.planificacion.comentariosPlanificacion}}</span>
                  <v-text-field type="number" v-if="!readOnlyPlanif && (selectedEvent.planificacion.tipo == 'SINPEDIDO' || selectedEvent.planificacion.tipo == 'TAREA')" label="Importe" v-model="selectedEvent.planificacion.totalSinIVASinTasasConDescuento"></v-text-field>
                  <v-checkbox v-if="!readOnlyPlanif" label="Pendiente de confirmar" v-model="selectedEvent.planificacion.pendienteConfirmar"></v-checkbox>
                  <!-- <span v-html="'modificationDate: '+ selectedEvent.planificacion.modificationDate"></span><br> -->
                  <!-- <span v-html="selectedEvent.l.direccionInspeccion.cp"></span>
                  <span v-html="selectedEvent.l.direccionInspeccion.poblacion"></span>
                  <span v-html="selectedEvent.l.direccionInspeccion.provincia"></span>
                  <span v-html="selectedEvent.l.direccionInspeccion.comunidad"></span> -->
                  <template v-if="selectedEvent.planificacion.comentariosLinea || selectedEvent.planificacion.comentariosLineaCerrada || getComentariosDireccion(selectedEvent.planificacion)">
                    <div v-if ="getComentariosDireccion(selectedEvent.planificacion)" v-noroles="['ENAC', 'PRODUCCION']" class="item-inner col-100">
                      <f7-card class="no-margin linea-texto linea-comentario-direccion">
                          {{ getComentariosDireccion(selectedEvent.planificacion) }}
                      </f7-card>
                    </div>
                    <div v-noroles="['ENAC', 'PRODUCCION']" class="item-inner col-100" 
                      v-for="(texto, index2) in getLineasTexto(selectedEvent.planificacion.comentariosLinea)"
                      :key="'linea-' + index + 'texto' + index2">
                      <f7-card class="no-margin linea-texto">
                          {{ texto }}
                      </f7-card>
                    </div>
                    <div v-noroles="['ENAC', 'PRODUCCION']" class="item-inner col-100" 
                      v-for="(texto, index2) in getLineasTexto(selectedEvent.planificacion.comentariosLineaCerrada)"
                      :key="'lineaCerrada-' + index + 'texto' + index2">
                      <f7-card class="no-margin linea-texto linea-comentario-cerrada">
                          {{ texto }}
                      </f7-card>
                    </div>
                  </template>
                </v-card-text>
                <v-card-actions>
                  <f7-row>
                  <v-btn
                    class="col-50"
                    text
                    color="secondary"
                    @click="onCerrarDetalle()"
                  >
                    Cerrar
                  </v-btn>
                  <v-btn
                    class="col-50"
                    v-if="!readOnlyPlanif"
                    text
                    color="green"
                    @click="guardarCambios(), readOnlyPlanif = true"
                  >
                    Guardar
                  </v-btn>
                  </f7-row>
                </v-card-actions>
              </v-card>
          </v-menu>
          </v-sheet>
        </v-col>
      </v-row>

      <f7-popup tablet-fullscreen v-if="popupSelectDateOpened" ref="popupSelectDate" :opened="true" swipe-to-close @popup:closed="popupSelectDateOpened = false">
        <f7-page>
          <f7-navbar title="Selecciona fecha">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
            <f7-card class="elevation-3 padding-vertical-half padding-right full-height">
              <f7-card-content class="full-height" >
                <!-- <f7-list class="list-form">
                  <ul>
                    <f7-row>
                      <f7-col width="100" medium="100">
                        <r-input
                            class="col-100 medium-50"
                            floating-label
                            label="Mes"
                            :form="rform"
                            type="select"
                            :readonly="false"
                            :overrideReadonly="true"
                            :name="'month'"
                          >
                            <option v-for="mes in meses" :key="'meses-'+mes.valor" :value="mes.valor">{{mes.nombre}}</option>
                          </r-input>
                        <r-input
                          :clearButton="false"
                          outline
                          floating-label
                          label="Año"
                          :form="rform"
                          :readonly="false"
                          :overrideReadonly="true"
                          type="number"
                          name="year"
                        />
                      </f7-col>
                    </f7-row>
                  </ul>
                </f7-list> -->
                <year-calendar :display-week-number="true" @click-day="onSelectDate" class="full-height" language="es" :week-start="1"></year-calendar>
              </f7-card-content>
            </f7-card>
        </f7-page>
      </f7-popup>

      <f7-popup v-if="popupCrearOpened" ref="popupCrear" :opened="true" swipe-to-close @popup:closed="onPopupCrearCerrado">
        <f7-page>
          <f7-navbar title="Crear planificación">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
          <r-form 
            ref="rformCrear" 
            @save="onSaveCrear"
            :dbAdapter="null"
            classContent="full-height"
            :readonly="false"
            :defaultData="{fechaVisita: new Date(createStart)}"
          >
            <template v-slot:default="{ rform }">
              <v-expansion-panels>
                <!-- Pedido -->
                <v-expansion-panel>
                  <f7-card class="elevation-3 padding-vertical-half padding-right">
                    <v-expansion-panel-header class="expand-header-calendar">
                      Pedido
                      <template v-slot:actions>
                        <v-icon class="expand-icon-calendar" color="primary">
                          mdi-chevron-down
                        </v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <f7-card-content>
                          <f7-list class="list-form">
                            <ul>
                              <f7-row>
                                <f7-col width="100" medium="100">
                                  <r-input
                                    :clearButton="false"
                                    floating-label
                                    outline
                                    label="Número o código de pedido"
                                    :form="rform"
                                    name="numeroOCodigoPedido"
                                  />
                                  <r-input
                                    :clearButton="false"
                                    outline
                                    floating-label
                                    label="Número de línea"
                                    :form="rform"
                                    type="number"
                                    name="numeroLinea"
                                  />
                                  <r-input
                                    outline
                                    :clearButton="false"
                                    floating-label
                                    label="Fecha visita"
                                    :form="rform"
                                    type="datepicker"
                                    :calendar-params="{timePickerPlaceholder:'Selecciona hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                                    name="fechaVisita"
                                  />
                                  <r-input
                                    outline
                                    :clearButton="false"
                                    floating-label
                                    label="Comentarios"
                                    :form="rform"
                                    name="observacionesPlanificar"
                                  />
                                </f7-col>
                              </f7-row>
                            </ul>
                          </f7-list>
                        </f7-card-content>
                    </v-expansion-panel-content>
                  </f7-card>
                </v-expansion-panel>
                <!-- Tarea -->
                <v-expansion-panel>
                  <f7-card class="elevation-3 padding-vertical-half padding-right">
                  <v-expansion-panel-header class="expand-header-calendar">
                    Tarea
                    <template v-slot:actions>
                      <v-icon class="expand-icon-calendar" color="primary">
                        mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <f7-card-content>
                        <f7-list class="list-form">
                          <ul>
                            <f7-row>
                              <f7-col width="100" medium="100">
                                <r-input
                                  outline
                                  :clearButton="false"
                                  floating-label
                                  label="Código de tarea"
                                  :form="rform"
                                  name="codigoTarea"
                                />
                              </f7-col>
                            </f7-row>
                          </ul>
                        </f7-list>
                      </f7-card-content>
                  </v-expansion-panel-content>
                  </f7-card>
                </v-expansion-panel>
                <!-- Nueva Tarea -->
                <v-expansion-panel>
                  <f7-card class="elevation-3 padding-vertical-half padding-right">
                  <v-expansion-panel-header class="expand-header-calendar">
                    Crear Tarea
                    <template v-slot:actions>
                      <v-icon class="expand-icon-calendar" color="primary">
                        mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <f7-card-content>
                        <f7-list class="list-form">
                          <ul>
                            <f7-row>
                              <f7-col width="100" medium="100">
                                <!-- #49 · T0006 fuera del desplegable con el bloqueo encendido: una
                                     vacación creada por aquí nace sin solicitud ni aprobador. -->
                                <r-autocomplete
                                  :dbAdapter="TipoTarea"
                                  key="tipoTarea"
                                  class="col-100 medium-33"
                                  floating-label
                                  :label="$t('tarea.tipoTarea')"
                                  :form="rform"
                                  :idProp="null"
                                  name="tarea.tipo"
                                  labelProp="nombre"
                                  prefixProp="codigo"
                                  idFieldDetail="id"
                                  :shownFields="['id', 'codigo', 'nombre']"
                                  :show-item="esTipoTareaSeleccionable"
                                  :showNavigationLink="false"
                                  :validation="{isValid: obj => {return !validator.isEmpty(obj.id, {ignore_whitespace:true})}, errorMessage: '* El tipo de tarea es obligatorio'}"
                                ></r-autocomplete>
                                <!-- #271 · con el camino manual apagado, T0006 ya no está en el
                                     desplegable. Se dice junto al control —por qué, dónde se piden
                                     ahora y quién lo reabre (§9)— para que quien la busque no crea
                                     que le han quitado algo sin motivo. Con el bloqueo de la #49
                                     encendido no: eso ya lo dice la cabecera. -->
                                <div v-if="caminoManualApagado && !bloqueoVacaciones" class="aviso-camino-manual-cerrado">
                                  {{ textoCaminoManualCerrado() }}
                                  <f7-link v-if="puedeAbrirVacaciones" @click="irAMisVacacionesDesdeElAlta()">
                                    {{ $t('vacacionAMano.irAMisVacaciones') }}
                                  </f7-link>
                                </div>
                                <!-- #268 · el aviso va junto al control y antes de crear, no después
                                     de guardar: es lo único que separa el camino viejo del nuevo, y
                                     dice dónde está el oficial. Al guardar se vuelve a preguntar. -->
                                <div v-if="esTipoVacaciones(rform.formData && rform.formData.tarea && rform.formData.tarea.tipo)" class="aviso-vacacion-a-mano">
                                  <b>{{ $t('vacacionAMano.avisoTitulo') }}.</b>
                                  {{ textoAvisoVacacionAMano() }}
                                  <f7-link v-if="puedeAbrirVacaciones" @click="irAMisVacacionesDesdeElAlta()">
                                    {{ $t('vacacionAMano.irAMisVacaciones') }}
                                  </f7-link>
                                </div>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.descripcion')"
                                  :form="rform"
                                  type="text"
                                  name="tarea.descripcion"
                                  :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* La descripción es obligatoria'}"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.tiempoEstimado')"
                                  :form="rform"
                                  type="text"
                                  name="tarea.tiempoEstimado"
                                ></r-input>

                                
                                <r-autocomplete-m2m
                                  outline
                                  :dbAdapter="Empleado"
                                  key="empleados"
                                  class="col-100 medium-33"
                                  floating-label
                                  :label="'* '+$t('tarea.empleados')"
                                  :form="rform"
                                  name="tarea.empleados"
                                  labelProp="nombre"
                                  idProp="username"
                                  prefixProp="username"
                                  idFieldDetail="id"
                                  :showNavigationLink="false"
                                  type="textarea"
                                  :lineBreak="true"
                                  :validation="{isValid: str => {return !validator.isEmpty(str, {ignore_whitespace:true})}, errorMessage: '* El empleado es obligatorio'}"
                                ></r-autocomplete-m2m>



                                <r-direccion
                                  :form="rform"
                                  :name="'tarea.direccion'"
                                  :guardarCodigos="true"
                                  autocomplete="off"
                                  :showNavigationLink="false"
                                >
                                </r-direccion>
                                <f7-row>
                                  <r-input
                                    class="col-50"
                                    floating-label
                                    :label="$t('tarea.numeroPedido')"
                                    :form="rform"
                                    type="text"
                                    name="tarea.numeroPedido"
                                  ></r-input>
                                  <r-input
                                    class="col-50"
                                    floating-label
                                    :label="$t('tarea.numeroLineaPedido')"
                                    :form="rform"
                                    type="text"
                                    name="tarea.numeroLineaPedido"
                                  ></r-input>
                                </f7-row>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.numeroOferta')"
                                  :form="rform"
                                  type="text"
                                  name="tarea.numeroOferta"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.codigoCliente')"
                                  :form="rform"
                                  type="text"
                                  name="tarea.codigoCliente"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.codigoOportunidad')"
                                  :form="rform"
                                  type="text"
                                  name="codigoOportunidad"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.codigoCampania')"
                                  :form="rform"
                                  type="text"
                                  name="codigoCampania"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.comentarios')"
                                  :form="rform"
                                  type="text"
                                  name="tarea.comentarios"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.comentariosPlanificacion')"
                                  :form="rform"
                                  type="text"
                                  name="tarea.comentariosPlanificacion"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="$t('tarea.importe')"
                                  :form="rform"
                                  type="number"
                                  step="0.01"
                                  name="tarea.importe"
                                ></r-input>
                              </f7-col>
                            </f7-row>
                          </ul>
                        </f7-list>
                      </f7-card-content>
                  </v-expansion-panel-content>
                  </f7-card>
                </v-expansion-panel>
                <!-- Expediente sin pedido -->
                <v-expansion-panel>
                  <f7-card class="elevation-3 padding-vertical-half padding-right">
                  <v-expansion-panel-header class="expand-header-calendar">
                    Expediente sin pedido
                    <template v-slot:actions>
                      <v-icon class="expand-icon-calendar" color="primary">
                        mdi-chevron-down
                      </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <f7-card-content>
                        <f7-list class="list-form">
                          <ul>
                            <f7-row>
                              <f7-col width="100" medium="100">
                                <r-input
                                  :clearButton="false"
                                  floating-label
                                  :label="$t('inspeccion_sin_pedido.fechaVisita')"
                                  :form="rform"
                                  type="datepicker"
                                  :calendar-params="{timePickerPlaceholder:'Selecciona hora', toolbarCloseText:'Hecho',closeOnSelect:true,timePicker: true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit', hour:'2-digit',minute:'2-digit' } }"
                                  name="fechaVisita"
                                />
                                <r-autocomplete
                                  :dbAdapter="Cliente"
                                  floating-label
                                  :label="$t('inspeccion_sin_pedido.cliente')"
                                  :form="rform"
                                  :name="'inspeccionSinPedido.cliente'"
                                  :labelProp="'codigoNombre'"
                                  :minLength="3"
                                  :shownFields="['nif', 'razonSocial', 'codigo']"
                                  :async="true"
                                >
                                </r-autocomplete>
                                <r-autocomplete
                                  floating-label
                                  :label="$t('inspeccion_sin_pedido.servicio')"
                                  key="servicio"
                                  :dbAdapter="Servicio"
                                  class="col-100"
                                  :form="rform"
                                  :name="'inspeccionSinPedido.servicio'"
                                  labelProp="nombre"
                                  prefixProp="codigo"
                                  :shownFields="['codigo', 'precios', 'tasas', 'tasaDefecto', 'codCuentaMayor', 'tiempoEstimadoCampo', 'tiempoEstimadoOficina', 'materia', 'userText']"
                                ></r-autocomplete>
                                <r-input
                                  floating-label
                                  :label="$t('inspeccion_sin_pedido.tiempoEstimadoCampo')"
                                  :form="rform"
                                  type="text"
                                  name="inspeccionSinPedido.tiempoEstimadoCampo"
                                ></r-input>
                                <r-direccion
                                  :form="rform"
                                  :name="'inspeccionSinPedido.direccionInspeccion'"
                                  :guardarCodigos="true"
                                  autocomplete="off"
                                  :showNavigationLink="false"
                                >
                                </r-direccion>
                                <r-input
                                  floating-label
                                  :label="$t('inspeccion_sin_pedido.comentariosPlanificacion')"
                                  :form="rform"
                                  type="text"
                                  name="inspeccionSinPedido.comentariosPlanificacion"
                                ></r-input>
                                <r-input
                                  floating-label
                                  :label="'Importe'"
                                  :form="rform"
                                  type="number"
                                  step="0.01"
                                  name="inspeccionSinPedido.totalSinIVASinTasasConDescuento"
                                ></r-input>
                                <r-input
                                  :label="'No calcular km'"
                                  :form="rform"
                                  type="check"
                                  :overrideReadonly="true"
                                  name="inspeccionSinPedido.sinKm"
                                ></r-input>
                              </f7-col>
                            </f7-row>
                          </ul>
                        </f7-list>
                      </f7-card-content>
                  </v-expansion-panel-content>
                  </f7-card>
                </v-expansion-panel>
              </v-expansion-panels>
              <f7-row>
                <f7-col width="100" medium="100">
                  <f7-button
                      fill
                      icon-f7="disk"
                      text="Planificar"
                      class="display-flex margin-vertical margin-left"
                      color="green"
                      @click="rform.saveItem()"
                    ></f7-button>
                </f7-col>
              </f7-row>
            </template>
          </r-form>
        </f7-page>

      </f7-popup>
      <f7-popup v-if="popupAsociarOpened" ref="popupAsociar" :opened="true" swipe-to-close @popup:closed="popupAsociarOpened = false">
        <f7-page>
          <f7-navbar title="Asociar a pedido">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
          <r-form 
            ref="rformAsociar" 
            @save="onSaveAsociar"
            :dbAdapter="null"
            classContent="full-height"
            :readonly="false"
            :defaultData="{idExpediente: selectedEvent.planificacion.idExpediente}"
          >
            <template v-slot:default="{ rform }">
              <f7-card class="elevation-3 padding-vertical-half padding-right">
                <f7-card-content>
                  <f7-list class="list-form">
                    <ul>
                      <f7-row>
                        <f7-col width="100" medium="100">
                          <r-input
                            :clearButton="false"
                            floating-label
                            outline
                            label="Número o código de pedido"
                            :form="rform"
                            name="numeroOCodigoPedido"
                          />
                          <r-input
                            :clearButton="false"
                            outline
                            floating-label
                            label="Número de línea"
                            :form="rform"
                            type="number"
                            name="numeroLinea"
                          />
                        </f7-col>
                      </f7-row>
                    </ul>
                  </f7-list>
                </f7-card-content>
              </f7-card>
              <f7-row>
                <f7-col width="100" medium="100">
                  <f7-button
                      fill
                      icon-f7="disk"
                      text="Asociar"
                      class="display-flex margin-vertical margin-left"
                      color="green"
                      @click="rform.saveItem()"
                    ></f7-button>
                </f7-col>
              </f7-row>
            </template>
          </r-form>
        </f7-page>

      </f7-popup>
      <f7-popup v-if="popupCalcularRutaOpened" ref="popupCalcularRuta" :opened="true" swipe-to-close @popup:closed="popupCalcularRutaOpened = false" @popup:opened="onOpenCalcularRuta">
        <f7-page>
          <f7-navbar title="Cálculo de ruta">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
          <r-form 
            ref="rformCalucarRuta" 
            @save="onSaveCalcularRuta"
            :dbAdapter="null"
            classContent="full-height"
            :readonly="false"
            :defaultData="{dia: diaSelected, inspector: inspectorFiltro, direccionInicio: '', direccionFin: '', horaInicio: new Date()}"
          >
            <template v-slot:default="{ rform }">
              <f7-card class="elevation-3 padding-vertical-half padding-right">
                <f7-card-content>
                  <f7-list class="list-form">
                    <ul>
                      <f7-row>
                        <f7-col width="100" medium="100">
                          <!-- <r-timepicker
                            outline
                            floating-label
                            label="Hora Inicio"
                            :form="rform"
                            name="horaInicio"
                            :clearButton="false"
                          ></r-timepicker> -->
                          <r-input
                            :clearButton="false"
                            floating-label
                            outline
                            label="Dirección Inicio"
                            :form="rform"
                            name="direccionInicio"
                          />
                          <r-input
                            :clearButton="false"
                            floating-label
                            outline
                            label="Dirección Fin"
                            :form="rform"
                            name="direccionFin"
                          />
                        </f7-col>
                      </f7-row>
                    </ul>
                  </f7-list>
                </f7-card-content>
              </f7-card>
              <f7-row>
                <f7-col width="100" medium="100">
                  <f7-button
                      fill
                      icon-f7="disk"
                      text="Calcular"
                      class="display-flex margin-vertical margin-left"
                      color="green"
                      @click="rform.saveItem()"
                    ></f7-button>
                </f7-col>
              </f7-row>
            </template>
          </r-form>
        </f7-page>

      </f7-popup>

    <!-- ENCARGO-025 · BANDA FLOTANTE de estado de la pasada asíncrona. Se dibuja SIEMPRE que
         hay algo que decir, esté el drawer abierto o cerrado. Estaba dentro del drawer y con
         proponerDesdeDrawer() cerrando el drawer justo antes de lanzar, el planificador podía
         quedarse sin ver el avance ni el rechazo por "ocupado por otro" (P2 de José Antonio en
         PR #1713). Se porteleaa a <body> como el drawer para escapar de los stacking contexts
         de F7/Vuetify. v-show en el wrapper (no v-if): el nodo vive una sola vez y Vue no lo
         reinserta en su padre original al cambiar de página. -->
    <!-- #283 · el `top` lo calcula `recolocarBandaFaseAsync()` midiendo dónde acaba la barra de
         indicadores (OEB-PPEND, TPC, TPIP, TPIP€, horas, km): esa barra es justo la cifra que se
         mira después de proponer y la banda la tapaba. El 12px del CSS queda como suelo para
         cuando no hay barra que esquivar (cordova no pinta los badges). Y `bloqueAvisoFlotante`
         deja UN solo bloque vivo: nunca dos `c4d-fase` apilados. -->
    <div ref="c4dFaseRoot" v-show="hayAvisoAsync" class="c4d-fase-flotante"
         :style="{ top: topBandaFaseAsync + 'px' }">
      <!-- Fase actual (viva o terminada). El ✕ sale en los estados TERMINALES (FIN y ERROR) y NO
           depende de `runPropuesta`: antes la fila de acciones entera colgaba de él y al aceptar
           o al limpiar la propuesta —que lo ponen a null— el aviso de FIN se quedaba en pantalla
           sin ninguna salida (#283). En las fases en curso no hay ✕ a propósito: el hilo sigue
           avanzando y ocultarlo llevaría a un fallo silencioso; lo que evita que estorbe es el
           `top` medido, que sí aplica a todas las fases. -->
      <div v-if="bloqueAvisoFlotante === 'fase'" class="c4d-fase" :class="'fase-' + (pasadaAsync.fase || '').toLowerCase()">
        <button v-if="avisoFaseAsyncCerrable" class="c4d-fase-x"
                :title="$t('proponerDrawer.cerrar')" :aria-label="$t('proponerDrawer.cerrar')"
                @click="cerrarAvisoFaseAsync()">✕</button>
        <div class="c4d-fase-lbl">{{ faseLabel(pasadaAsync.fase) }}</div>
        <div v-if="pasadaAsync.fase === 'ERROR' && pasadaAsync.error" class="c4d-fase-msg">{{ pasadaAsync.error }}</div>
        <div v-else-if="pasadaAsync.mensaje" class="c4d-fase-msg">{{ pasadaAsync.mensaje }}</div>
        <!-- El recuento habla de la propuesta que hay en pantalla, así que sigue atado a
             `runPropuesta`: tras aceptar o limpiar diría «0 visitas propuestas». Y "Ver informe
             completo" sigue atado a `registroId`, que es lo que ese botón necesita para abrir
             algo. Lo que ya no depende de ninguno de los dos es el cierre. -->
        <div v-if="pasadaAsync.fase === 'FIN' && (runPropuesta || pasadaAsync.registroId)" class="c4d-fase-acc">
          <span v-if="runPropuesta" class="c4d-fase-cnt">{{ $t('proponerDrawer.finResumen', { n: (propuestas || []).length }) }}</span>
          <button v-if="pasadaAsync.registroId" class="c4d-fase-btn" @click="abrirInformeDeRegistro(pasadaAsync.registroId)">
            {{ $t('proponerDrawer.verInforme') }}
          </button>
          <!-- #460 · lo que CUESTA pulsar ese botón, dicho junto al botón: el informe es otra pantalla
               y la capa provisional no sobrevive al salto (vive en memoria de la pantalla del
               calendario; la vista va con `preloadPreviousPage: false` y la ruta con
               `keepAlive: false`). Al volver no hay propuesta que aceptar y hay que relanzar. Solo se
               dice cuando hay algo que perder: con la propuesta ya aceptada o limpiada no sobra el
               aviso, es que diría algo falso. -->
          <span v-if="(propuestas || []).length" class="c4d-fase-nota">
            {{ $t('proponerDrawer.informeSaleDelCalendario') }}
          </span>
        </div>
      </div>
      <!-- ENCARGO-023 §2 · vista reducida cuando /resultado devolvió 410 y hemos tenido que caer
           al informe(). Aceptar está deshabilitado; el motivo lo pone el backend (motivo del
           cuerpo 410) o el default de traducción.
           #283 · ya no es "permanente": tiene ✕ como el resto. Lo que el ✕ oculta es el AVISO,
           no la marca — `pasadaAsyncModoReducido` sigue deshabilitando Aceptar y su motivo sigue
           en el `title` del propio botón, que es donde §9 pide que esté. Tampoco autocierra: no
           es un mensaje de éxito, es la explicación de un control bloqueado. -->
      <div v-if="bloqueAvisoFlotante === 'reducido'" class="c4d-fase fase-en_cola">
        <button class="c4d-fase-x" :title="$t('proponerDrawer.cerrar')" :aria-label="$t('proponerDrawer.cerrar')"
                @click="cerrarAvisoModoReducido()">✕</button>
        <div class="c4d-fase-lbl">{{ $t('proponerDrawer.reducidaTitulo') }}</div>
        <div class="c4d-fase-msg">{{ pasadaAsyncModoReducidoMotivo || $t('proponerDrawer.reducidaDefault') }}</div>
      </div>
      <!-- Aviso de 15 min sin eventos: nunca un spinner infinito. El ✕ libera el estado local y
           deja el flujo disponible para relanzar (antes era un botón «Cerrar» de texto; #283 lo
           unifica en el ✕ de la esquina, igual que el resto de la banda). -->
      <div v-if="bloqueAvisoFlotante === 'timeout'" class="c4d-fase fase-error">
        <button class="c4d-fase-x" :title="$t('proponerDrawer.cerrar')" :aria-label="$t('proponerDrawer.cerrar')"
                @click="cerrarAvisoTimeoutPasadaAsync()">✕</button>
        <div class="c4d-fase-msg">{{ $t('proponerDrawer.timeoutSinEventos') }}</div>
      </div>
      <!-- ENCARGO-025 · rechazo por inspector ocupado por OTRO usuario. Motivo LITERAL del
           backend (§1.2 del encargo 021). Antes vivía dentro del drawer y con éste cerrado
           por proponerDesdeDrawer() se perdía sin dejar rastro — P2 de José Antonio en
           PR #1713. Aquí en la banda flotante SÍEMPRE se ve. ✕ para descartarlo cuando el
           planificador ya se ha enterado. -->
      <div v-if="bloqueAvisoFlotante === 'ocupado'" class="c4d-fase fase-en_cola">
        <button class="c4d-fase-x" :title="$t('proponerDrawer.cerrar')" :aria-label="$t('proponerDrawer.cerrar')"
                @click="cerrarAvisoOcupadoAsync()">✕</button>
        <div class="c4d-fase-msg">
          {{ pasadaAsyncOcupadoDeOtro.motivo
             || $t('proponerDrawer.ocupadoDeOtro', { inspector: pasadaAsyncOcupadoDeOtro.inspector, usuario: pasadaAsyncOcupadoDeOtro.usuario }) }}
        </div>
      </div>
      <!-- Oferta de "ver terminada" al abrir el drawer: la pasada del USUARIO CONECTADO acabó
           dentro de la retención (30 min por defecto). Aparece SOLO cuando el drawer está
           abierto (sondearPasadaAsyncEnCurso la produce en abrirDrawerProponer), pero se
           dibuja en la banda flotante para no depender del layout del drawer.
           Aquí los dos botones SE QUEDAN: son las dos respuestas a una pregunta, no un «Cerrar»
           repetido, y «Descartar y lanzar otra» dice qué pasa después. El ✕ hace lo mismo que
           descartar, que es lo que se espera de un ✕ y de `Esc`. -->
      <div v-if="bloqueAvisoFlotante === 'terminada'" class="c4d-fase fase-fin">
        <button class="c4d-fase-x" :title="$t('proponerDrawer.cerrar')" :aria-label="$t('proponerDrawer.cerrar')"
                @click="descartarPasadaTerminada()">✕</button>
        <div class="c4d-fase-msg">{{ $t('proponerDrawer.reengancheTerminada') }}</div>
        <div class="c4d-fase-acc">
          <button class="c4d-fase-btn" @click="verPasadaTerminada()">{{ $t('proponerDrawer.reengancheTerminadaAccion') }}</button>
          <button class="c4d-fase-btn c4d-fase-btn-alt" @click="descartarPasadaTerminada()">{{ $t('proponerDrawer.reengancheDescartar') }}</button>
        </div>
      </div>
    </div>

    <!-- SPEC-PARAMETRIZACION-PROPONER: drawer de parametrización del Proponer + preview ligero
         ("esto es lo que vas a proponer": ficha vigente + conteo con desglose + avisos, SIN correr
         el solver). El botón final invoca el MISMO proponerPlanificacion() de siempre.
         El nodo se PORTALEA a document.body en mounted (y se retira en beforeDestroy): dentro de la
         página quedaba bajo el appbar por los stacking contexts de F7/Vuetify. v-show (no v-if) para
         que el nodo viva una sola vez y Vue no intente reinsertarlo en su padre original. -->
    <div ref="c4dRoot" v-show="drawerProponerAbierto" class="c4d-root">
    <div class="c4d-overlay" @click="cerrarDrawerProponer()"></div>
    <aside class="c4d-drawer">
      <div class="c4d-head">
        <div class="c4d-head-row">
          <h1>{{ $t('proponerDrawer.titulo') }}</h1>
          <button class="c4d-x" @click="cerrarDrawerProponer()">✕</button>
        </div>
        <div class="c4d-sub">{{ $t('proponerDrawer.subtitulo') }}</div>
      </div>
      <div class="c4d-body">
        <!-- Inspector (se elige en el filtro Empleado del calendario; aquí se refleja) -->
        <div class="c4d-grp">
          <div class="c4d-grp-t">{{ $t('proponerDrawer.inspector') }}</div>
          <div class="c4d-insp">
            <div class="c4d-av">{{ inicialesInspector() }}</div>
            <div v-if="inspectorFiltro">
              <div class="c4d-nm">{{ inspectorFiltro }}</div>
              <div class="c4d-mt" v-if="previewVigente && previewVigente.ficha && previewVigente.ficha.baseDireccion">
                {{ previewVigente.ficha.baseDireccion }}</div>
            </div>
            <div v-else class="c4d-mt">{{ $t('proponerDrawer.sinInspector') }}</div>
          </div>
        </div>
        <!-- Parámetros (los MISMOS campos del panel de siempre, solo recolocados) -->
        <div class="c4d-grp">
          <div class="c4d-grp-t">{{ $t('proponerDrawer.parametros') }}</div>
          <div class="c4d-fld">
            <label>{{ $t('proponerDrawer.ventana') }}</label>
            <div class="c4d-row2">
              <!-- La ventana la manda el calendario (desde = semana visible); aquí solo se refleja -->
              <input class="c4d-inp" type="date" :value="fechaDesdeFiltro" readonly :title="$t('proponerDrawer.desde')">
              <div class="c4d-seg">
                <button :class="{ on: semanasHorizonte === 1 }" @click="semanasHorizonte = 1">{{ $t('proponerDrawer.unaSemana') }}</button>
                <button :class="{ on: semanasHorizonte === 2 }" @click="semanasHorizonte = 2">{{ $t('proponerDrawer.dosSemanas') }}</button>
              </div>
            </div>
          </div>
          <div class="c4d-fld">
            <label>{{ $t('proponerDrawer.alcance') }}</label>
            <select class="c4d-sel" v-model="alcancePropuesta">
              <option value="HORIZONTE">{{ $t('proponerDrawer.alcanceHorizonte') }}</option>
              <option value="UN_DIA">{{ $t('proponerDrawer.alcanceUnDia') }}</option>
              <option value="COMPLETAR_DIA">{{ $t('proponerDrawer.alcanceCompletarDia') }}</option>
            </select>
          </div>
          <div class="c4d-fld">
            <label>{{ $t('proponerDrawer.modo') }}</label>
            <div class="c4d-seg">
              <button :class="{ on: modoPropuesta === 'CUBRIR_HUECOS' }" @click="modoPropuesta = 'CUBRIR_HUECOS'">{{ $t('proponerDrawer.modoCubrir') }}</button>
              <button :class="{ on: modoPropuesta === 'REPLANIFICAR_DIAS' }" @click="modoPropuesta = 'REPLANIFICAR_DIAS'">{{ $t('proponerDrawer.modoReplan') }}</button>
            </div>
            <div class="c4d-mini">{{ $t('proponerDrawer.modoHint') }}</div>
          </div>
          <div v-if="modoPropuesta === 'REPLANIFICAR_DIAS'" class="c4d-fld">
            <label>{{ $t('proponerDrawer.diasReplan') }}</label>
            <div class="c4d-seg">
              <button v-for="n in [1,2,3,4]" :key="'dr' + n" :class="{ on: diasReplan === n }" @click="diasReplan = n">{{ n }}</button>
              <button :class="{ on: diasReplan === 5 }" @click="diasReplan = 5">{{ $t('proponerDrawer.semana') }}</button>
            </div>
          </div>
          <div class="c4d-fld">
            <label>{{ $t('proponerDrawer.comida') }}</label>
            <div class="c4d-row3">
              <input class="c4d-inp" type="time" v-model="comidaInicioMin">
              <input class="c4d-inp" type="time" v-model="comidaInicioMax">
              <input class="c4d-inp" type="time" v-model="comidaPreferente">
            </div>
            <div class="c4d-row2" style="margin-top:8px;">
              <input class="c4d-inp" type="number" min="15" max="120" v-model.number="comidaDuracionMin">
              <div class="c4d-toggle-inline" @click="planificarConComida = !planificarConComida">
                <span class="c4d-sw" :class="{ on: planificarConComida }"></span>
                <span class="c4d-tl-s">{{ $t('proponerDrawer.conComida') }}</span>
              </div>
            </div>
          </div>
          <div class="c4d-fld">
            <label>{{ $t('proponerDrawer.jornada') }}</label>
            <div class="c4d-row2">
              <input class="c4d-inp" type="time" v-model="jornadaInicioPreferente">
              <input class="c4d-inp" type="time" v-model="jornadaInicioMin">
            </div>
            <div class="c4d-mini">{{ $t('proponerDrawer.jornadaHint') }}</div>
          </div>
          <div class="c4d-fld">
            <label>{{ $t('proponerDrawer.sueloAntiguedad') }}</label>
            <select class="c4d-sel" v-model.number="mesesAntiguedadMax" @change="refrescarPreviewProponer()">
              <option v-for="m in [12, 18, 24, 36, 48]" :key="'ma' + m" :value="m">{{ $t('proponerDrawer.meses', { n: m }) }}</option>
            </select>
          </div>
          <div class="c4d-toggle" @click="planificarConPernocta = !pernoctaEfectiva">
            <div><div class="c4d-tl">{{ $t('proponerDrawer.pernocta') }}</div>
              <div class="c4d-td">{{ $t('proponerDrawer.pernoctaHint') }}</div></div>
            <span class="c4d-sw" :class="{ on: pernoctaEfectiva }"></span>
          </div>
          <div class="c4d-toggle" @click="proponerInformes = !proponerInformes; refrescarPreviewProponer()">
            <div><div class="c4d-tl">{{ $t('proponerDrawer.informes') }}</div>
              <div class="c4d-td">{{ $t('proponerDrawer.informesHint') }}</div></div>
            <span class="c4d-sw" :class="{ on: proponerInformes }"></span>
          </div>
        </div>
        <!-- Preview ligero (endpoint /proponer/preview, debounced) -->
        <div class="c4d-grp">
          <div class="c4d-grp-t">{{ $t('proponerDrawer.antesDeLanzar') }}</div>
          <div class="c4d-preview">
            <div class="c4d-pv-t">🔎 {{ $t('proponerDrawer.previewTitulo') }}</div>
            <div v-if="previewCargando" class="c4d-mini">{{ $t('proponerDrawer.previewCargando') }}</div>
            <div v-else-if="previewError" class="c4d-aviso wn">⚠️ {{ $t('proponerDrawer.previewError') }}</div>
            <template v-else-if="previewVigente">
              <div class="c4d-chips">
                <span v-if="previewVigente.ficha.baseDireccion" class="c4d-chip">📍 {{ $t('proponerDrawer.chipBase') }} <b>{{ previewVigente.ficha.baseDireccion }}</b></span>
                <span v-if="previewVigente.ficha.radioMaxKm" class="c4d-chip">{{ $t('proponerDrawer.chipRadio') }} <b>{{ previewVigente.ficha.radioMaxKm }} km</b></span>
                <span v-if="previewVigente.ficha.topeHorasDiaOverride" class="c4d-chip">{{ $t('proponerDrawer.chipTope') }} <b>{{ previewVigente.ficha.topeHorasDiaOverride }} h/día</b></span>
                <span v-if="(previewVigente.ficha.zonasProvincias || []).length" class="c4d-chip">{{ $t('proponerDrawer.chipProvincias') }} <b>{{ previewVigente.ficha.zonasProvincias.join(' · ') }}</b></span>
                <span v-if="(previewVigente.ficha.zonaPreferente || []).length" class="c4d-chip">{{ $t('proponerDrawer.chipZonaPref') }} <b>{{ previewVigente.ficha.zonaPreferente.join(' · ') }}</b></span>
                <span class="c4d-chip">{{ $t('proponerDrawer.chipPernocta') }} <b>{{ previewVigente.ficha.pernoctaPermitida ? $t('proponerDrawer.si') : $t('proponerDrawer.no') }}</b></span>
              </div>
              <div class="c4d-cand"><span class="c4d-n">{{ previewVigente.total }}</span>
                <span class="c4d-l">{{ $t('proponerDrawer.candidatas') }}</span></div>
              <div class="c4d-stack" v-if="previewStackTotal() > 0">
                <i v-for="s in previewStack()" :key="'st-' + s.clave" :style="{ width: s.pct + '%', background: s.color }"></i>
              </div>
              <div class="c4d-leg">
                <span v-for="s in previewStack()" :key="'lg-' + s.clave">
                  <i class="c4d-d" :style="{ background: s.color }"></i>{{ s.texto }}</span>
              </div>
              <!-- #760 · la medida de la puerta del bloque vivo (#670), junto a las candidatas. Las dos
                   líneas se pintan SIEMPRE que el backend las mide, también a cero: una medida que se
                   oculta cuando es cero no demuestra que se midió. Cifras y listas son las del mismo
                   reparto del backend, así que no se recuentan aquí. -->
              <div v-if="puertaPreview()" class="c4d-puerta">
                <div class="c4d-puerta-l">
                  <span>{{ textoPuertaSoloHistorico() }}</span>
                  <button v-if="puertaPreview().soloHistorico.length" type="button" class="c4d-puerta-ver"
                          aria-controls="c4d-puerta-lista-solo" :aria-expanded="listaPuertaAbierta === 'SOLO' ? 'true' : 'false'"
                          @click="alternarListaPuerta('SOLO')">{{ listaPuertaAbierta === 'SOLO'
                       ? $t('proponerDrawer.puertaOcultarLista') : $t('proponerDrawer.puertaVerLista') }}</button>
                </div>
                <div v-if="listaPuertaAbierta === 'SOLO' && puertaPreview().soloHistorico.length" id="c4d-puerta-lista-solo" class="c4d-puerta-lista">
                  <table class="c4d-puerta-t">
                    <thead><tr>
                      <th>{{ $t('proponerDrawer.puertaColPedido') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColLinea') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColCliente') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColImporte') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColUltimo') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColMotivo') }}</th>
                    </tr></thead>
                    <tbody>
                      <tr v-for="f in puertaPreview().soloHistorico" :key="'ph-' + f.pedido + '-' + f.linea">
                        <td>{{ f.codigoPedido || f.pedido }}</td>
                        <td>{{ f.linea }}</td>
                        <td>{{ f.cliente || '—' }}</td>
                        <td class="c4d-puerta-num">{{ f.importe != null ? fmtEur(f.importe) : '—' }}</td>
                        <td>{{ f.ultimoRealizado ? fmtFecha(f.ultimoRealizado) : $t('proponerDrawer.puertaSinFecha') }}</td>
                        <td>{{ textoMotivoPuerta(f.motivo) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="c4d-puerta-l">
                  <span>{{ textoPuertaBloqueVivo() }}</span>
                  <button v-if="puertaPreview().bloqueVivo.length" type="button" class="c4d-puerta-ver"
                          aria-controls="c4d-puerta-lista-vivo" :aria-expanded="listaPuertaAbierta === 'VIVO' ? 'true' : 'false'"
                          @click="alternarListaPuerta('VIVO')">{{ listaPuertaAbierta === 'VIVO'
                       ? $t('proponerDrawer.puertaOcultarLista') : $t('proponerDrawer.puertaVerLista') }}</button>
                </div>
                <div v-if="listaPuertaAbierta === 'VIVO' && puertaPreview().bloqueVivo.length" id="c4d-puerta-lista-vivo" class="c4d-puerta-lista">
                  <table class="c4d-puerta-t">
                    <thead><tr>
                      <th>{{ $t('proponerDrawer.puertaColPedido') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColLinea') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColCliente') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColBloque') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColUltimo') }}</th>
                      <th>{{ $t('proponerDrawer.puertaColMotivo') }}</th>
                    </tr></thead>
                    <tbody>
                      <tr v-for="f in puertaPreview().bloqueVivo" :key="'pv-' + f.pedido + '-' + f.linea">
                        <td>{{ f.codigoPedido || f.pedido }}</td>
                        <td>{{ f.linea }}</td>
                        <td>{{ f.cliente || '—' }}</td>
                        <td>{{ textoBloqueVivo(f) }}</td>
                        <td>{{ f.ultimoRealizado ? fmtFecha(f.ultimoRealizado) : '—' }}</td>
                        <td>{{ textoMotivoPuerta(f.motivo) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="c4d-mini">{{ $t('proponerDrawer.puertaHint') }}</div>
              </div>
              <div class="c4d-avisos">
                <div v-for="(a, i) in previewVigente.avisos" :key="'av-' + i"
                     class="c4d-aviso" :class="a.nivel === 'ok' ? 'ok' : 'wn'">
                  {{ a.nivel === 'ok' ? '✅' : '⚠️' }} {{ textoAvisoPreview(a) }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="c4d-foot">
        <!-- #296 · el motivo por el que este inspector no va a recibir campo, JUNTO al botón que lo
             lanza (§9: ni mudo ni al principio de la pantalla). Dice por qué, quién lo desbloquea y
             dónde, y nombra al inspector. -->
        <div v-if="avisoSinServiciosPreview()" class="c4d-aviso wn c4d-aviso-pie">
          ⚠️ {{ $t('proponerDrawer.sinServiciosPie', { inspector: nombreInspectorAviso(avisoSinServiciosPreview()) }) }}
        </div>
        <button class="c4d-btn-cancel" @click="cerrarDrawerProponer()">{{ $t('proponerDrawer.cancelar') }}</button>
        <button class="c4d-btn-prop"
                :disabled="!inspectorFiltro || proponiendoEnCurso || (pasadaAsync && pasadaAsync.enCurso)"
                @click="proponerDesdeDrawer()">
          {{ previewVigente && previewVigente.total != null
             ? $t('proponerDrawer.proponerN', { n: previewVigente.total })
             : $t('proponerDrawer.proponer') }}
        </button>
      </div>
    </aside>
    </div>
    </v-app>
  </f7-page>
</template>
<script>
import Planificacion from "./../../js/db/Planificacion.js";
import MotivosPlanificacion from "./../../js/MotivosPlanificacion.js";
import RecuentoPropuesta from "./../../js/RecuentoPropuesta.js";
import TiemposProponer from "./../../js/TiemposProponer.js";
import UnidadAceptable from "./../../js/UnidadAceptable.js";
// ENCARGO-021c · adaptador SSE del /proponer/async. Filtro DURO por pasadaId dentro del propio
// adaptador — la vista pasa el suyo al suscribirse y ninguna otra corrida se le cuela.
import ProponerPlanificacionEvents from "./../../js/db/ProponerPlanificacionEvents.js";
import Fichaje from "./../../js/db/Fichaje.js";
import Inspeccion from "./../../js/db/Inspeccion.js";
import LineaPedido from "./../../js/db/LineaPedido.js";
import Pedido from "./../../js/db/Pedido.js";
import Empleado from "./../../js/db/Empleado.js";
import TipoTarea from "./../../js/db/TipoTarea.js";
import Tarea from "./../../js/db/Tarea.js";
import RhSolicitudesVacaciones from "./../../js/db/RhSolicitudesVacaciones.js";
import RhVacaciones from "./../../js/db/RhVacaciones.js";
import PermisosVacaciones from "./../vacaciones/permisos.js";
import { puedeAbrirControlPlanificacion, RUTA_CONTROL_PLANIFICACION, ROLES_CONTROL_PLANIFICACION } from "./../dashboard/permisos-control-planificacion.js";
import RhBandejaVacaciones, { EVENTO_VACACIONES_RESUELTA } from "./../../js/db/RhBandejaVacaciones.js";
import carrilPeticiones from "./../../js/utils/carrilPeticiones.js";
import mismaClave from "./../../js/utils/mismaClave.js";
import identidadSesion, { sigueLaSesion } from "./../../js/utils/identidadSesion.js";
import accionDeLaSesion from "./../../js/utils/accionDeLaSesion.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import cerrojoDeLaSesion from "./../../js/utils/cerrojoDeLaSesion.js";
import { atarALaSesion } from "./../../js/utils/sesionDePeticiones.js";
import textoDeLasFechas from "./../../js/utils/tramosSolicitud.js";
import Servicio from "./../../js/db/Servicio.js";
import rInput from "./../../components/rInput.vue";
import rTimepicker from "./../../components/rTimepicker.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import rAutocompleteM2m from '../../components/rAutocompleteM2m.vue';
import rDireccion from "./../../components/rDireccion.vue";
import Cliente from "./../../js/db/Cliente.js";
import Oeb from "./../../js/db/Oeb.js";
import Festivo from "./../../js/db/Festivo.js";
import soloMandaLaDeDelante from "./../../js/utils/soloMandaLaDeDelante.js";
import { unaAccionALaVez, claveDeSolicitud } from "./../../js/utils/unaAccionALaVez.js";
import mensajeDelServidor from "./../../js/utils/mensajeDelServidor.js";
import rBadge from './../../components/rBadge';
import Utils from "./../../js/Utils.js";
import RoutesUtils from "./../../js/RoutesUtils.js";
import rForm from "./../../components/rForm.vue";
import DateUtils from '../../js/DateUtils';
import moment from 'moment';
import validator from "validator";
import YearCalendar from 'v-year-calendar';
import { EventBus } from "../../js/EventBus";
import 'v-year-calendar/locales/v-year-calendar.es';

// import 'vuetify/dist/vuetify.min.css';

// #49 · el mismo texto que devuelve el servidor (RhBloqueoGenericoService.MENSAJE). Lo lee una
// persona en el calendario, así que dice a dónde ir y no qué falló, y conviene que sea idéntico
// venga el corte de aquí o del 4xx.
const MENSAJE_BLOQUEO_VACACIONES = 'Las vacaciones se gestionan desde el módulo de Vacaciones';

// #268 · sobre qué es el alta del popup «Crear planificación», para el cerrojo de
// `accionDeLaSesion`: con una en vuelo no sale otra igual por un segundo Guardar.
const CLAVE_ALTA_DEL_CALENDARIO = 'calendario:alta';
// Y de la papelera de un evento, que va por planificación.
const CLAVE_BORRADO_DEL_CALENDARIO = 'calendario:borrar:';

// #325 (opción A, decisión técnica del 08/10/2026) · por qué el panel puede no tener el total.
//
// Ya NO son cinco causas de red: el total viaja CON la lista en la respuesta del Proponer, así que
// no hay una segunda petición que pueda tardar, cortarse o fallar. Lo que queda son las tres formas
// en que esa respuesta puede no traer la cifra, y las tres se dicen distintas porque la acción que
// toca es distinta: la primera es un despliegue desparejado, la segunda es un fallo del servidor al
// derivarla y la tercera es un contrato roto. Quien prueba no tiene el registro del servidor
// delante: lo tiene que decir la pantalla (§9 del CLAUDE.md).
const MOTIVOS_SIN_TOTAL = {
  ausente: 'este servidor no envía el total junto a la lista',
  desconocido: 'el servidor no ha podido calcularlo',
  cuerpo: 'el servidor ha contestado algo que no se entiende'
};

// #325 (opción A) · los tres valores de `completitud` que el servidor puede afirmar. Cualquier otra
// cosa —un valor nuevo que esta pantalla no conoce— se trata como «no lo sé» y no como «completo»:
// afirmar que no falta nada es justo lo que no se puede hacer sin haberlo medido.
const COMPLETITUD_COMPLETO = 'COMPLETO';
const COMPLETITUD_PARCIAL = 'PARCIAL';
const COMPLETITUD_DESCONOCIDO = 'DESCONOCIDO';

// #482 · a dónde lleva «Qué hacer» de las líneas de NEGOCIO de la ventana: Control de planificación,
// que es la pantalla donde una línea bloqueada se desbloquea (reasignar el EST PLA) o se escala a
// incidencia. La ventana solo INFORMA; desde ella no se desbloquea nada.
//
// SOLO las de negocio, y esto no es un detalle de estilo (ronda 2): esa pantalla carga por defecto
// las líneas con `planificable = NO` (`control-planificacion.vue`, `cargarLineas`), que es
// exactamente el universo de las bloqueadas por negocio. Las del SOLVER son lo contrario —líneas
// planificables que el planificador no pudo colocar por coordenadas, habilitación o cupo—, así que
// allí no aparecen: mandarlas sería dejar a quien pulsa delante de una tabla donde su línea no
// está, buscándola. Esas dicen la acción de SU causa y no llevan a ninguna parte.
//
// La ruta y la lista de roles salen de `dashboard/permisos-control-planificacion.js`, el mismo
// módulo del que las lee la ruta, para que el enlace y la pantalla no puedan contestar cosas
// distintas. Con el menú cargado manda el menú —que es el control de acceso real— y la lista solo
// decide mientras el menú no está: `RoutesUtils.tieneAcceso` lo documenta.

// Lo que dice «Qué hacer» en una línea del SOLVER cuya causa no está en el mapa de causas conocidas
// (`gruposNoPlanificables`). Una sola constante para los dos sitios: la fila de grupo y la de la
// línea dicen la misma cosa, y si fueran dos literales podrían separarse.
const ACCION_SOLVER_POR_DEFECTO = 'Revisar la línea';

// #482 (prueba de Dirección del 30/10) · el `accion` del catálogo EST PLA no es un texto para la
// planificadora: es la ORDEN que la API ejecuta al poner el motivo (`linea.planificable = false`,
// ver `PedidoServiceImpl.aplicarAsignacionSimpleLinea`). Pintada tal cual, la fila de grupo decía
// «→ linea.planificabl…». Una acción con esa forma no se enseña y en su lugar se dice qué hacer con
// la causa; cualquier otro texto, que sí es para leer, se respeta.
const ORDEN_DEL_CATALOGO = /^\s*linea\.[A-Za-z_][\w.]*\s*=/;
const ACCION_NEGOCIO_POR_DEFECTO = 'Revisar y desbloquear';

// #482 · qué dice el botón cuando la corrida no dejó ninguna línea bloqueada. Se queda en gris y no
// abre nada: una ventana vacía no es información, y un control que no se puede usar dice por qué
// (§9 del CLAUDE.md del orquestador).
const BOTON_SIN_BLOQUEADAS = 'Sin líneas no planificables';
const MOTIVO_SIN_BLOQUEADAS = 'Esta propuesta no ha dejado ninguna línea bloqueada, así que no hay '
  + 'desglose que abrir';

// #482 (ronda 2) · y qué dice cuando la propuesta en pantalla se ha RECONSTRUIDO del registro.
//
// Esa vía es la reducida del ENCARGO-023 §2: el DTO cacheado del Proponer caducó, se cae al
// audit-log y de ahí sale lo que se pinta. El registro NO guarda las bloqueadas por negocio ni el
// importe de las no cubiertas del solver, así que de esas cifras no se sabe nada — y no saber no es
// un cero. Decir «Sin líneas no planificables» ahí sería afirmar que la corrida no dejó ninguna
// basándose en que el registro no las trae, y rotular «0,00 €» sería inventarse el importe.
//
// Como todo control que no se puede usar, dice por qué, quién lo desbloquea y dónde (§9): lo
// desbloquea el propio planificador volviendo a lanzar Proponer, que es lo único que recupera el
// desglose entero.
// La NOTA va junto al botón y el MOTIVO en su título y en la ventana, que es donde hay sitio: la
// nota del rincón no pasa de 420 px y rompe en renglones hacia arriba, o sea sobre la rejilla, así
// que ahí se dice lo justo —qué falta y qué hacer— y no la frase entera (§9: nada de lo que ya se ve
// se tapa para hacer sitio a algo nuevo).
const BOTON_RECONSTRUIDA = 'No planificables · desglose no disponible';
const NO_DISPONIBLE = 'no disponible';
const NOTA_RECONSTRUIDA = 'esta propuesta se ha reconstruido del registro: no trae las bloqueadas '
  + 'por negocio ni los importes · vuelve a lanzar Proponer para verlas';
const MOTIVO_RECONSTRUIDA = 'Esta propuesta se ha reconstruido del registro, que no guarda las '
  + 'líneas bloqueadas por negocio ni los importes: no se sabe si hubo alguna. Vuelve a lanzar '
  + 'Proponer para verlas.';

// #283 · autocierre de la banda flotante en los estados TERMINALES (FIN y ERROR). Dirección pidió
// «4-5 segundos»: 4,5 s da tiempo a leer «Propuesta lista (N visitas)» sin dejar el aviso encima
// del resultado, que es lo que se mira a continuación. Las fases en curso NO entran aquí.
const AUTOCIERRE_FASE_MS = 4500;

// #283 · separación entre la barra de indicadores y la banda flotante que se coloca debajo.
const HOLGURA_BANDA_FASE_PX = 8;
// Suelo del `top` de la banda: el valor de siempre, para cuando no hay barra que esquivar.
const TOP_BANDA_FASE_PX = 12;

// #283 (ronda 6) · cuánto tiempo tiene que recordar la banda un aviso que el planificador ya
// cerró. Es el espejo de `application.solver.async-retencion-terminadas-ms` del backend (30 min;
// `movilidad/src/main/resources/application.properties`): mientras dura esa retención,
// /proponer/async/en-curso sigue devolviendo la pasada terminada, así que es el ÚNICO plazo en el
// que un aviso cerrado puede volver a entrar él solo. Pasada la retención la anotación ya no
// puede servir para nada, y lo que toca es tirarla.
const RETENCION_PASADA_MS = 30 * 60 * 1000;
// #283 (ronda 6) · tope del registro de avisos cerrados. Es un seguro, no un presupuesto: el
// backend admite UNA pasada viva por inspector y la retención es de media hora, así que llegar a
// cuarenta anotaciones vivas exigiría lanzar y cerrar cuarenta propuestas en ese rato. Está para
// que el registro no pueda crecer sin límite con la pantalla abierta toda la jornada.
const MAX_PASADAS_DESCARTADAS = 40;

// #240 · LA REGLA DEL COLOR DEL CALENDARIO, Y ES UNA SOLA:
//
//   el BORDE de 3 px, en color vivo, dice el ESTADO;
//   el RELLENO, siempre en un tono PÁLIDO, dice el TIPO de trabajo y nunca el estado.
//
// Antes no había regla. El relleno salía de un hash del `código + nombre` del tipo de tarea sobre
// los 16 millones de colores, así que a cada tipo le tocaba un color al azar que podía caer
// exactamente encima de un color de estado — y caía:
//
//   T0006 VACACIONES  -> #960fa1 morado   (ningún morado en la leyenda)
//   T0083 FIESTA      -> #edda5c amarillo (en la leyenda, «Pendiente de confirmar»)
//   T0084 BAJA LABORAL-> #211b06 casi negro
//   T0085 COMPENSACIÓN-> #d8f396 verde claro
//   T0005 TPI         -> #5438b4 morado   (casi el morado de «propuesta provisional»)
//
// Los dos primeros son los que vio dirección en preview-3. Que no fueran más es casualidad del
// hash, no un acierto del diseño: cualquier servicio nuevo podía sacar otro.
//
// Lo que cierra la familia entera, y no solo esos dos casos, es que el relleno NO PUEDA caer en un
// color de estado. Y lo que de verdad los separa es el REGISTRO, no el tono: todo relleno vive en
// una banda pálida cerrada (saturación 55 %, luminosidad 85 %) y los cuatro colores de estado están
// entre el 42 % y el 54 % de luminosidad, o sea más de 30 puntos más oscuros. Un relleno es un
// bloque macizo y lavado; un estado es un contorno de 3 px vivo. Nunca pueden ser el mismo color.
const TONO_RELLENO_SAT = 55;
const TONO_RELLENO_LUZ = 85;

// Encima de eso, un margen de tono como seguro para la ojeada rápida: ningún relleno del hash se
// acerca a menos de 13° del tono de un color RESERVADO. El margen se pide a 14 y no a 13 porque el
// redondeo a enteros de 8 bits del hex corre el tono hasta un grado: a 13 justos, el color que se
// pinta de verdad mide 12 y se sale (lo cazó el banco de pruebas, las dos veces).
const SEPARACION_TONO = 14;

// Y «reservado» son DOS cosas, que es lo que la primera versión de este arreglo se dejó a medias:
//
//  1. los cuatro tonos de los BORDES de estado —amarillo 60 (pendiente), verde 101 (realizada),
//     azul 207 (confirmada), morado 291 (propuesta provisional)—;
//  2. los tonos de los rellenos DECLARADOS, los que la leyenda enseña uno por uno.
//
// La segunda clase faltaba, y sin ella el arreglo tapaba la mitad del defecto: el hash recorría
// también los tonos declarados, así que un servicio corriente podía pintarse EXACTAMENTE con el
// relleno que la leyenda anuncia para otra cosa. `SV0081` sacaba el tono 12, o sea `#eeccc4`, el
// relleno de «Desplazamiento particular»; barriendo 5000 códigos de servicio, 132 caían en uno de
// los siete tonos declarados (vacaciones, festivo, baja, compensación, los dos desplazamientos y la
// inspección sin pedido). Es el mismo defecto de la incidencia leído del revés: antes el relleno
// invadía un color de ESTADO, aquí invade un color de TIPO, y las dos veces la leyenda miente.
//
// Por eso los tonos declarados se escriben AQUÍ y de aquí salen las dos tablas de rellenos: así un
// relleno declarado nuevo queda fuera del hash por construcción, sin que nadie se tenga que acordar.
const TONOS_ESTADO = [60, 101, 207, 291];
const TONO_DECLARADO = {
  DESPLAZAMIENTO_PARTICULAR: 12,
  SIN_PEDIDO: 36,
  FICHAJE: 125,
  T0083: 175,
  T0085: 238,
  T0006: 266,
  T0084: 325
};
const TONOS_RESERVADOS = TONOS_ESTADO.concat(
  Object.keys(TONO_DECLARADO).map(k => TONO_DECLARADO[k]));

/** Distancia entre dos tonos, por el camino corto del círculo. */
function distanciaTono(a, b) {
  const d = Math.abs(a - b) % 360;
  return d > 180 ? 360 - d : d;
}

/** Los arcos de tono que quedan a `margen` o más de todos los tonos reservados. */
function arcosLibres(reservados, margen) {
  const arcos = [];
  let inicio = null;
  for (let t = 0; t < 360; t++) {
    const libre = reservados.every(r => distanciaTono(t, r) >= margen);
    if (libre && inicio === null) inicio = t;
    if (!libre && inicio !== null) {
      arcos.push([inicio, t]);
      inicio = null;
    }
  }
  if (inicio !== null) arcos.push([inicio, 360]);
  return arcos;
}

// Los arcos ya no están escritos a mano: con solo los cuatro tonos de estado reservados, esta misma
// regla devuelve los 252° de la ronda 1 repartidos en los cinco arcos de siempre, así que la
// derivación es fiel (bordea dos tonos distintos, 193 y 220, que estaban justo en el límite y el
// cálculo a mano había redondeado al revés).
//
// Reservando además los siete tonos declarados quedan siete arcos y 74 tonos —52 hexes distintos,
// porque el redondeo a 8 bits junta tonos vecinos—, y se va el arco cálido entero: el terracota y el
// arena viven en él, pegados al amarillo de «pendiente». Sigue sobrando para lo que el relleno del
// hash tiene que hacer, que es que dos bloques del MISMO servicio se vean iguales sin leerlos; que
// dos servicios distintos coincidan nunca estuvo garantizado —es un hash— y no dice nada falso:
// ninguno de los dos colores está en la leyenda. Lo que sí tiene que ser imposible es coincidir con
// un color que la leyenda SÍ anuncia, y eso es lo que estos arcos aseguran.
const ARCOS_TONO_LIBRE = arcosLibres(TONOS_RESERVADOS, SEPARACION_TONO);
const GRADOS_TONO_LIBRE = ARCOS_TONO_LIBRE.reduce((t, a) => t + (a[1] - a[0]), 0);

/** Un tono (0-360) dentro de los arcos libres, a partir de un entero cualquiera. */
function tonoLibre(n) {
  let resto = ((n % GRADOS_TONO_LIBRE) + GRADOS_TONO_LIBRE) % GRADOS_TONO_LIBRE;
  for (let i = 0; i < ARCOS_TONO_LIBRE.length; i++) {
    const ancho = ARCOS_TONO_LIBRE[i][1] - ARCOS_TONO_LIBRE[i][0];
    if (resto < ancho) {
      return ARCOS_TONO_LIBRE[i][0] + resto;
    }
    resto -= ancho;
  }
  return ARCOS_TONO_LIBRE[0][0];   // inalcanzable: los anchos suman GRADOS_TONO_LIBRE
}

/** Hex del relleno de un tono dado, siempre en la banda pálida. */
function rellenoDeTono(tono) {
  const s = TONO_RELLENO_SAT / 100;
  const l = TONO_RELLENO_LUZ / 100;
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((tono / 60) % 2) - 1));
  const m = l - c / 2;
  const sector = Math.floor(tono / 60) % 6;
  const rgb = [[c, x, 0], [x, c, 0], [0, c, x], [0, x, c], [x, 0, c], [c, 0, x]][sector];
  return '#' + rgb.map(v => ('0' + Math.round((v + m) * 255).toString(16)).slice(-2)).join('');
}

// Los rellenos DECLARADOS, los que la leyenda enseña uno por uno. Cada uno es un tipo de bloque que
// una persona tiene que poder reconocer sin leer el texto de dentro. Los valores están escritos en
// la hoja de estilos de esta misma pantalla para las muestras de la leyenda; la prueba
// `scripts/prueba-colores-leyenda-calendario.js` falla si se separan.
const RELLENO_TIPO = {
  DESPLAZAMIENTO_PARTICULAR: rellenoDeTono(TONO_DECLARADO.DESPLAZAMIENTO_PARTICULAR), // #eeccc4 terracota
  SIN_PEDIDO:                rellenoDeTono(TONO_DECLARADO.SIN_PEDIDO),                // #eeddc4 arena
  FICHAJE:                   rellenoDeTono(TONO_DECLARADO.FICHAJE),                   // #c4eec7 verde
  // El de empresa no tiene tono propio: es un gris, y el hash no puede sacarlo porque todos sus
  // rellenos salen con saturación 55. Por eso es el único declarado que no está en TONO_DECLARADO.
  DESPLAZAMIENTO_EMPRESA:    '#dedede'
};

// Y los rellenos de las cuatro AUSENCIAS, por código de tipo de tarea. Están los cuatro y no solo
// los dos que se vieron: son la misma familia —las escribe el módulo de RH y antes las coloreaba el
// mismo hash— y dejarse dos fuera era volver a la incidencia con el siguiente color que cayera mal.
// La lista es la de `TipoAusencia` de movilidad (T0006, T0083, T0084, T0085).
//
// A propósito NO se mira `grupoTarea`: los días que crea el módulo de RH llegan con `tipoTarea` y
// sin grupo, así que exigir `FEST-` dejaría sin color declarado justo a los festivos generados —los
// de la incidencia— y volverían al hash. Para el COLOR basta el tipo: una FIESTA creada a mano y una
// generada son lo mismo que mirar. El grupo sigue decidiendo lo que de verdad depende de él, que es
// si el bloque es intocable (`esTipoReservado`, #49), y eso no se toca aquí.
const RELLENO_AUSENCIA = {
  T0083: rellenoDeTono(TONO_DECLARADO.T0083),   // #c4eeea verde agua — fiesta
  T0085: rellenoDeTono(TONO_DECLARADO.T0085),   // #c4c5ee azul lavanda — compensación
  T0006: rellenoDeTono(TONO_DECLARADO.T0006),   // #d6c4ee violeta — vacaciones
  T0084: rellenoDeTono(TONO_DECLARADO.T0084)    // #eec4dc rosa — baja laboral
};

  export default {
    // #58 · las tres formas de dejar de ser la pantalla de delante acaban en `dejarDeMandar`, que
    // aquí tira solo lo del detalle de vacaciones (ver `soloMandaLaDeDelante`).
    // #59 · y una resolución a la vez **por solicitud**: el cerrojo de `unaAccionALaVez` apaga
    // Aprobar y Denegar del día amarillo mientras su POST viaja. Vive en el módulo y va por la
    // clave de la solicitud, así que es el MISMO cerrojo que el de la bandeja.
    mixins: [soloMandaLaDeDelante, unaAccionALaVez],
    components: {
      rInput,
      rForm,
      rBadge,
      rAutocomplete,
      rAutocompleteM2m,
      rDireccion,
      rTimepicker,
      YearCalendar
    },
    data: () => ({
      TipoTarea,
      Servicio,
      Cliente,
      Fichaje,
      validator,
      moment,
      value: '',
      type: process.env.TARGET && process.env.TARGET == 'cordova' ? 'day' : 'week',
      types: [
        {
          nombre: 'Mes',
          valor: 'month'
        },
        {
          nombre: 'Semana',
          valor: 'week'
        },
        {
          nombre: 'Día',
          valor: 'day'
        }],
      meses: [
        {
          nombre: 'Enero',
          valor: 1
        },
        {
          nombre: 'Febrero',
          valor: 2
        },
        {
          nombre: 'Marzo',
          valor: 3
        },
        {
          nombre: 'Abril',
          valor: 4
        },
        {
          nombre: 'Mayo',
          valor: 5
        },
        {
          nombre: 'Junio',
          valor: 6
        },
        {
          nombre: 'Julio',
          valor: 7
        },
        {
          nombre: 'Agosto',
          valor: 8
        },
        {
          nombre: 'Septiembre',
          valor: 9
        },
        {
          nombre: 'Octubre',
          valor: 10
        },
        {
          nombre: 'Noviembre',
          valor: 11
        },
        {
          nombre: 'Diciembre',
          valor: 12
        }],
      selectedMonth: 0,
      events: [],
      mapaTpcFechas: {},
      clavesEnEvents: {},
      weekday: [1, 2, 3, 4, 5, 6, 0],
      colors: ['#2196F3', '#3F51B5', '#673AB7', '#00BCD4', '#4CAF50', '#FF9800', '#757575'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      dragEvent: null,
      previousDragEvent: null,
      nextDragEvent: null,
      initialDragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
      extendOriginal: null,
      Planificacion,
      LineaPedido,
      Pedido,
      Inspeccion,
      Empleado,
      DateUtils,
      inspectorFiltro: null,
      fechaDesdeFiltro: null,
      fechaHastaFiltro: null,
      // Festivos de la persona cuyo calendario se está viendo, indexados por 'yyyy-MM-dd' (#54).
      // Es lo que pinta la etiqueta de ámbito encima del día («Autonómica», «Local»). Van aparte
      // de `events` a propósito: la T0083 ya viaja como un evento más y esto solo dice de dónde
      // sale el festivo, que es un dato del catálogo y no de la planificación.
      festivosPorDia: {},
      // C4: propuesta del solver (capa PROVISIONAL; solo se persiste al aceptar)
      propuestas: [],
      noPlanificables: [],
      // #325 (opción A) · la CAPTURA de bloqueadas por negocio tal y como llega en la respuesta del
      // Proponer: `{ lineas, resumen }`. `lineas` es una PÁGINA (las 200 de mayor importe) y
      // `resumen` dice cuántas hay detrás y si la página es todo o una parte — las dos cosas de la
      // misma consulta y del mismo instante.
      //
      // Es UN solo campo a propósito. Antes eran dos (`bloqueadosNegocio` y el total aparte), y cada
      // camino que vaciaba la lista tenía que acordarse de olvidar el total o el panel afirmaba un
      // total de algo que ya no estaba enseñando. Con la lista colgando de aquí (ver el computed
      // `bloqueadosNegocio`) no hay dos mitades que puedan desincronizarse: se pone entera o se
      // quita entera.
      capturaNegocio: null,
      // #482 · el primer día del tramo que se propuso, para la «Semana N» de la ventana. Se guarda al
      // lanzar porque la propuesta sigue en pantalla aunque se navegue a otra semana, y la ventana
      // habla de la corrida, no de lo que se esté mirando ahora.
      desdeDeLaPropuesta: null,
      // C4-B2: banco de horas por semana (respuesta /proponer), alertas de plazo y horizonte 1/2 semanas
      banco: [],
      alertasPlazo: [],
      // #311 · mensaje de la alerta TIEMPO_AGOTADO del solver de la propuesta en pantalla, o null.
      avisoTiempoAgotado: null,
      // SPEC-REGISTRO-PROPUESTAS: audit-log de corridas. runPropuesta = runId de la ÚLTIMA corrida en
      // pantalla; viaja en el CreatePlanificacionDTO al aceptar (vínculo principal aceptación→registro).
      runPropuesta: null,
      registroAbierto: false,
      registros: [],
      registroExpandido: null,
      cargandoRegistros: false,
      // C4-EXPLICABILIDAD: motivo de colocación POR VISITA (ProponerResponseDTO.explicaciones, solver
      // v0.17). El front SOLO lo muestra — no recalcula nada (ENAC). Se une por lineaId.
      explicaciones: [],
      panelPorQueAbierto: false,
      proponiendoEnCurso: false,       // FIX apilamiento: guard de doble pulsación de "Proponer" en vuelo
      // ENCARGO-021c · estado de la pasada asíncrona activa en el drawer. Se limpia a null
      // cuando NO hay pasada — así el drawer sabe si pintar la banda de fase o el flujo normal.
      // La forma la fija el propio adaptador SSE: { pasadaId, fase, mensaje, runId, registroId,
      // error, enCurso }. `pasadaAsyncOff` es la función de desuscripción del canal (para
      // llamarla al cerrar el drawer o al terminar). `pasadaAsyncTimer` es el timeout de 15 min
      // sin eventos — se reinicia con cada evento y nunca deja el drawer en spinner infinito.
      pasadaAsync: null,
      pasadaAsyncOff: null,
      pasadaAsyncTimer: null,
      pasadaAsyncTimeoutAviso: false,      // v-if de la banda "sin respuesta en 15 min"
      pasadaAsyncOcupadoDeOtro: null,      // { inspector, usuario } cuando lanzado=false y no es del propio user
      pasadaAsyncTerminadaOferta: null,    // snapshot devuelto por /en-curso al abrir el drawer si estaba terminada
      // ENCARGO-023 §2 · si /resultado devuelve 410, entramos en "modo reducido": pintamos
      // desde el audit-log pero deshabilitamos Aceptar y mostramos banda con el motivo.
      pasadaAsyncModoReducido: false,
      pasadaAsyncModoReducidoMotivo: null,
      // #283 · el ✕ de la banda de vista reducida oculta SOLO el aviso. La marca de arriba es la
      // que deshabilita Aceptar y no se toca al cerrar: una propuesta que no se ve entera sigue
      // sin poderse aceptar. Dos banderas y no una porque son dos cosas distintas, y mezclarlas
      // convertiría un «ya lo he leído» en un permiso para aceptar a ciegas.
      pasadaAsyncModoReducidoAvisoCerrado: false,
      // #283 (ronda 3) · DE QUÉ pasada es el modo reducido. Sin este sello la marca sobrevivía a
      // su pasada sin que nadie supiera de cuál hablaba, y entonces tapaba el avance de la
      // SIGUIENTE: al reenganchar otra pasada desde otra pestaña, la banda se quedaba muda o
      // repitiendo lo de la anterior (r4212680956).
      pasadaAsyncModoReducidoPasadaId: null,
      // #283 (ronda 6) · y DE QUÉ INSPECTOR era esa pasada. Es la otra mitad del sello de arriba:
      // las dos juntas son la identidad con la que se archiva su cierre, y el inspector no se
      // puede deducir del filtro de la pantalla en el momento de cerrar (ver
      // `inspectorDePasada`).
      pasadaAsyncModoReducidoInspector: null,
      // #283 (ronda 3, reescrito en la 6) · REGISTRO de los avisos de la banda que el planificador
      // ya ha cerrado con un ✕ o con `Esc`. La banda no vuelve a hablar de ellos por ningún otro
      // camino: el sondeo de /en-curso sigue devolviendo la pasada terminada durante la retención
      // (30 min) y, sin esta memoria, al cerrar un bloque reaparecía otro preguntando por el mismo
      // resultado (r4212680944).
      //
      // Una ENTRADA POR AVISO CERRADO y no una sola ranura: la pantalla rota entre inspectores
      // dentro de la misma sesión —y cada inspector tiene su propia pasada—, así que con un escalar
      // cerrar el aviso del segundo borraba el del primero y al volver a él reaparecía
      // (r4213238853). Cada entrada guarda la IDENTIDAD de lo que se cerró, que es lo que decidió
      // dirección el 08/10 (opción 2 de la #283):
      //
      //   { usuario, inspector, pasadaId, cerradoEnMs }
      //     · usuario  — la SESIÓN: el planificador conectado que pulsó el ✕. El registro no se
      //                  persiste en ninguna parte, así que ya muere con la pantalla; esto cubre
      //                  lo único que puede cambiar debajo sin destruirla, que es la sesión.
      //     · inspector — a quién pertenecía la pasada (NO el filtro del momento).
      //     · pasadaId  — la PROPUESTA. Es UUID por pasada, así que una propuesta nueva nunca
      //                  hereda el cierre de la anterior.
      //     · cerradoEnMs — para purgar lo que ya no puede volver (ver `anotarAvisoCerrado`).
      //
      // NO se rebobina al lanzar una corrida nueva: esa trae su propio `pasadaId`, y borrar el
      // registro resucitaría la oferta de las viejas.
      pasadaAsyncDescartadas: [],
      // #283 · timeout del autocierre de los estados terminales (FIN/ERROR). Distinto del de 15
      // min sin eventos (`pasadaAsyncTimer`): ese vigila el silencio del solver, este solo quita
      // de en medio un aviso ya terminal.
      pasadaAsyncAutocierre: null,
      // #283 · `top` en píxeles de la banda flotante, medido para que empiece DEBAJO de la barra
      // de indicadores. Arranca en el valor de siempre; `recolocarBandaFaseAsync()` lo ajusta.
      topBandaFaseAsync: TOP_BANDA_FASE_PX,
      // SPEC-PARAMETROS-COMIDA-JORNADA (solver v0.18): defaults = los del solver (solo transporte).
      comidaDuracionMin: 45,
      comidaInicioMin: '13:00',
      comidaInicioMax: '15:30',
      comidaPreferente: '14:00',
      jornadaInicioPreferente: '07:45',
      jornadaInicioMin: '06:00',
      semanasHorizonte: 1,
      // #482 · la ventana de «No planificables». Son TRES campos de pantalla y ninguno de dato: lo
      // que la ventana enseña sale del estado que ya dejó el Proponer, así que cerrarla y volver a
      // abrirla no relanza nada ni pierde nada. El buscador y el filtro se rebobinan al abrir (ver
      // `abrirVentanaNoPlanificables`): quien la abre la encuentra entera, como la dejó la corrida.
      ventanaNoPlanificables: false,
      busquedaNoPlanificables: '',
      filtroNoPlanificables: 'TODAS',
      planificarConComida: true,
      // SPEC-PROPONER-PERNOCTA (15/09/2026): null = "según ficha del inspector"; true/false = usuario ha
      // elegido explícitamente y su elección gana sobre la ficha. Contrato documentado en el backend en
      // SolverController.java:208. Antes era `false` hardcoded, que pisaba silenciosamente el
      // `pernoctaPermitida:true` de la ficha (defecto latente desde 22/07/2026).
      planificarConPernocta: null,
      proponerInformes: true,          // C4-REALINEAMIENTO: check "Proponer informes" (SÍ por defecto)
      // SPEC-PARAMETRIZACION-PROPONER: drawer de parametrización + preview ligero (/proponer/preview)
      drawerProponerAbierto: false,
      previewProponer: null,           // respuesta del preview: { ficha, campo, informes, total, avisos }
      // #296 · usuario al que pertenece el `previewProponer` guardado. El drawer no se destruye al
      // cerrarse (es un v-show, y en Cordova la instancia del componente sobrevive al cambio de
      // «Empleado»), así que sin esta marca no hay forma de saber si lo que hay en memoria habla del
      // inspector que la pantalla está mostrando o del anterior.
      previewInspector: null,
      previewCargando: false,
      previewError: false,
      previewTimer: null,              // debounce del preview reactivo
      previewSeq: 0,                   // descarta respuestas fuera de orden (última petición gana)
      listaPuertaAbierta: null,        // #760 · lista de la medida de la puerta abierta: 'SOLO' | 'VIVO' | null
      mesesAntiguedadMax: 24,          // suelo de antigüedad de campo (default del backend)
      alcancePropuesta: 'HORIZONTE',   // C4-REALINEAMIENTO: HORIZONTE | UN_DIA | COMPLETAR_DIA
      modoPropuesta: 'CUBRIR_HUECOS',  // C4-REALINEAMIENTO v2: CUBRIR_HUECOS | REPLANIFICAR_DIAS
      diasReplan: 1,                   // C4-REALINEAMIENTO v2: nº de días desde `desde` a vaciar/rehacer en Modo B (1/2/3/4/5=semana)
      Utils,
      rules: [
        value => !!value || 'Debe introducir un inspector'
      ],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      readOnlyPlanif: true,
      // #58 · la solicitud de vacaciones a la que pertenece el día abierto, y si se está
      // pidiendo. Se cuelga de la pantalla y no del evento porque el evento es una planificación
      // compartida con la rejilla: escribirle campos propios la ensuciaría para todo lo demás.
      solicitudDelDia: null,
      cargandoSolicitudDia: false,
      /**
       * #268 · lo que contestó el servidor sobre si la papelera alcanza al día de vacaciones abierto:
       * `{ id, borrable, motivo, error }`. Con `null` —todavía no ha contestado— no se dibuja: la
       * papelera de un día de vacaciones sale solo cuando se sabe que el borrado va a entrar. El
       * `id` es el de la planificación por la que se preguntó, y la respuesta de otra no vale.
       */
      papeleraDia: null,
      /**
       * #268 · De qué petición es la respuesta de la papelera. Sube con cada una y al cerrar el
       * detalle: solo vale la última. Propio y no `diaAbierto`, que sube también al reintentar la
       * solicitud con el mismo día abierto, y entonces la papelera se quedaba sin pedir otra vez.
       */
      papeleraPedida: 0,
      /** Si la última lectura falló. «No se ha podido leer» no es «no tiene solicitud». */
      errorSolicitudDia: false,
      /**
       * #59 · Si no se ha podido saber **de quién es** este día, porque la consulta del equipo
       * falló. Es distinto de `errorSolicitudDia`: allí se sabía a quién preguntar y la respuesta
       * no llegó; aquí no se ha llegado a preguntar. Y es distinto de no tener solicitud: con esto
       * puesto el detalle no afirma nada del día, lo dice y ofrece volver a intentarlo.
       */
      errorEquipoDia: false,
      /**
       * #58 · De quién son los eventos que hay AHORA en `events`. No es `inspectorFiltro`: ese es
       * el valor del desplegable, que cambia al soltarlo, mientras la rejilla sigue enseñando a la
       * persona anterior hasta que conteste la petición. Ver `esMiCalendario`.
       */
      duenioEventos: null,
      /**
       * #58 · Si el día abierto en el detalle era del calendario propio CUANDO se abrió. Se fija
       * al abrirlo y no se recalcula: con el detalle abierto puede llegar la respuesta de otra
       * persona y cambiar de quién es la rejilla por debajo.
       */
      detalleDiaEsMio: false,
      /**
       * #58 · Si esta persona puede abrir «Mis vacaciones», que es lo que decide si se dibujan sus
       * puntos de entrada: el botón de la barra y el «Ver en Vacaciones» del detalle del día. Un
       * botón que lleva a un 403 hace creer que le han quitado permisos (§9), y quién llega lo
       * dice el menú efectivo, no el rol. Lo resuelve `created`.
       */
      puedeAbrirVacaciones: false,
      /**
       * #1133 · Si se dibuja el botón de ACEL PLANIFICACIÓN de la barra. Lo mismo que
       * `puedeAbrirVacaciones` y por lo mismo: lo decide el menú efectivo y lo resuelve `created`.
       */
      puedeAbrirAcelPlanificacion: false,
      /**
       * #59 · Lo mismo, pero para el calendario de alguien a quien se aprueba. Se fija igual al
       * abrir el día, y por el mismo motivo.
       */
      detalleDiaEsDeMiEquipo: false,
      /** #59 · De quién era el calendario cuando se abrió el día: es a quien se le aprueba. */
      detalleDiaDe: null,
      /**
       * #59 · Qué día del detalle es el vigente. Sube uno cada vez que se abre un día **y cada vez
       * que el detalle se cierra** (`cerrarDetalleDelDia`), y es lo que descarta a quien llegue
       * tarde: la espera de `/mi-equipo`, la apertura diferida de `showEvent` y la confirmación de
       * un diálogo de aprobar o denegar pueden contestar cuando ya se está mirando otra cosa.
       * Mismo papel que el token del carril, pero para las esperas y no para las respuestas.
       */
      diaAbierto: 0,
      /**
       * #59 · Las personas a las que este usuario aprueba las vacaciones, tal como las dice el
       * servidor. `null` mientras no se ha preguntado; lista vacía = no aprueba a nadie.
       */
      miEquipo: null,
      /**
       * #59 · Si la última consulta de `/mi-equipo` **falló**. `miEquipo` a `null` no lo distingue
       * de «todavía no se ha preguntado», y la diferencia es la que decide si hay algo que ofrecer:
       * el reintento solo se pinta cuando se sabe que hubo un fallo (ver `reintentarMiEquipo`).
       */
      falloMiEquipo: false,
      popupSelectDateOpened: false,
      popupCrearOpened: false,
      // #268 · para quién se abrió el «Crear planificación»: lo fija `startTime` al abrirlo.
      inspectorDelAlta: null,
      popupAsociarOpened: false,
      popupCalcularRutaOpened: false,
      clickedEvent: null,
      totalTotal: null,
      tiempoTotal: null,
      totalRealizado: null,
      totalPlanif: null,
      totalPPend:null,
      totalContratado: null,
      totalTotalKm: null,
      totalTotalKmParticular: null,
      totalTotalConsumo: null,
      totalTotalConsumoParticular: null,
      totalTiempoDesplazamiento: null,
      totalTiempoDesplazamientoParticular: null,
      totalTiempoTPIR: null,
      totalTiempoTPIP: null,
      totalImporteTPIR: null,
      totalImporteTPIP: null,
      totalImporteInformesPendientes: null,
      totalesDia: [],
      fechaPrimerInformePdte: null,
      totalTiempoTPC: null,
      fechaCreacionTarea: null,
      infPdtes: null,
      diaSelected: false,
      target: process.env.TARGET,
      diarios: [],
      rolesInspectorSuma: ['INSPECTOR', 'SUPERVISADO'],
      roles: ['INSPECTOR', 'OBSERVADOR', 'SUPERVISOR', 'SUPERVISADO', 'SUPERVISADO_FORMACION'],
      precioMinuto_1: 8.33,
      precioMinuto_2: 11.66667,
      dialogFilter: false,
      filterData: {},
      filterOptions: {
        tipos: [
          {
            value: 'LINEA',
            text: 'Inspección'
          },
          {
            value: 'TAREA',
            text: 'Tarea'
          },
          {
            value: 'DESPLAZAMIENTO',
            text: 'Desplazamiento'
          },
          {
            value: 'FICHAJE',
            text: 'Fichaje'
          },
          {
            value: 'SINPEDIDO',
            text: 'Sin pedido'
          }
        ],
        tiposTareas: [
          {
            value: 'T0005',
            text: 'TPI'
          },
          {
            value: 'T0040',
            text: 'Firma de expediente'
          },
          {
            value: 'OTRAS',
            text: 'Otras'
          }
        ]
      },
    }),
    mounted: function () {
      const self = this;
      EventBus.$on("fichajeGuardado", this.getPlanificaciones);
      // Normalizado desde el primer momento: el modelo del desplegable «Empleado» y sus opciones
      // tienen que casar ya en el primer pintado, no solo después de la primera carga.
      self.inspectorFiltro = self.comoUsername(self.username);
      self.$nextTick(() => {
        self.$refs.calendar.scrollToTime({hour:7,minute:0})
      });
      // SPEC-PARAMETRIZACION-PROPONER: portal del drawer a <body> (los stacking contexts de F7/Vuetify
      // dejaban el appbar por encima). Vue sigue parcheando el nodo aunque cuelgue de body.
      if (self.$refs.c4dRoot) {
        document.body.appendChild(self.$refs.c4dRoot);
      }
      // ENCARGO-025 · misma porteleada para la banda flotante. Necesita colgar de <body>
      // porque el drawer también lo hace y el z-index del appbar F7 la taparía si viviera
      // dentro de la <f7-page>.
      if (self.$refs.c4dFaseRoot) {
        document.body.appendChild(self.$refs.c4dFaseRoot);
      }
      // #283 · `Esc` cierra el aviso flotante con el mismo efecto que su ✕. El oyente va en
      // `document` porque la banda cuelga de <body> y nadie tiene el foco dentro de ella. Los
      // manejadores se guardan FUERA de `data` —son funciones, no estado de la pantalla— con el
      // mismo criterio que `carrilFestivos` en created().
      self.manejadorEscBandaFase = function (ev) { self.onEscBandaFaseAsync(ev); };
      document.addEventListener('keydown', self.manejadorEscBandaFase);
      // #283 · al cambiar la anchura la barra de indicadores reparte los badges en más filas y
      // crece: hay que volver a medir o la banda acaba otra vez encima.
      self.manejadorResizeBandaFase = function () { self.recolocarBandaFaseAsync(); };
      window.addEventListener('resize', self.manejadorResizeBandaFase);
      self.recolocarBandaFaseAsync();
      // if (self.inspectorFiltro) {
      //   self.loadInformesPdtes();
      // }
    },
    // #283 · los indicadores también cambian de alto SIN que cambie la ventana: las cifras llegan
    // por petición y los badges aparecen de uno en uno (`v-if="totalPPend"` y compañía). Medir
    // solo al abrir el aviso dejaba la banda bien colocada un instante y encima medio segundo
    // después. `recolocarBandaFaseAsync` solo asigna si el valor cambia, así que no se realimenta.
    updated: function () {
      if (this.hayAvisoAsync) this.recolocarBandaFaseAsync();
    },
    beforeDestroy: function () {
      // #58 · de darse de baja del aviso de cierre de sesión responde el mixin
      // (`soloMandaLaDeDelante`), que es el que lo puso.
      // retira el nodo porteleado (Vue ya no lo quitará: su padre original desapareció con la página)
      if (this.$refs.c4dRoot && this.$refs.c4dRoot.parentNode === document.body) {
        document.body.removeChild(this.$refs.c4dRoot);
      }
      // ENCARGO-025 · idem para la banda flotante.
      if (this.$refs.c4dFaseRoot && this.$refs.c4dFaseRoot.parentNode === document.body) {
        document.body.removeChild(this.$refs.c4dFaseRoot);
      }
      // ENCARGO-021c · limpieza defensiva. La pasada del BACKEND sigue viva y su SSE seguirá
      // llegando (bien: reengancharse tras F5 depende de eso). Solo desenchufamos ESTE
      // listener y cancelamos el timeout local — el canal del hub SIGUE compartido por otros
      // canales (Alertas, DTForm, …), no lo cerramos.
      if (this.pasadaAsyncOff) { try { this.pasadaAsyncOff(); } catch (e) {} this.pasadaAsyncOff = null; }
      if (this.pasadaAsyncTimer) { clearTimeout(this.pasadaAsyncTimer); this.pasadaAsyncTimer = null; }
      // #283 · y los que ha añadido el cierre de la banda flotante. El autocierre dispararía
      // sobre un componente ya destruido, y los dos oyentes globales sobrevivirían a la página.
      this.cancelarAutocierreFaseAsync();
      if (this.manejadorEscBandaFase) {
        document.removeEventListener('keydown', this.manejadorEscBandaFase);
        this.manejadorEscBandaFase = null;
      }
      if (this.manejadorResizeBandaFase) {
        window.removeEventListener('resize', this.manejadorResizeBandaFase);
        this.manejadorResizeBandaFase = null;
      }
    },
    created: function() {
      var self = this;
      // Moverse por los meses con las flechas lanza una petición de festivos por pulsación y no
      // vuelven en orden: sin el carril, la respuesta —o el error— de un tramo ya abandonado
      // pintaba encima del que se está mirando y las etiquetas del día desaparecían. Fuera de
      // `data` a propósito: es un contador, no estado de la pantalla, y Vue no tiene que observarlo.
      self.carrilFestivos = carrilPeticiones();
      // #58 · y uno por cada carga del detalle del evento, por lo mismo: las dos se relanzan al
      // abrir otro evento y sus respuestas tampoco vuelven en orden.
      self.carrilSolicitudDia = carrilPeticiones();
      self.carrilFechaTarea = carrilPeticiones();
      // #58 · de cuándo esa lectura deja de mandar en el detalle responde `dejarDeMandar`, que lo
      // recibe por las tres salidas (`soloMandaLaDeDelante`). Ya no se suscribe aquí: el aviso del
      // cierre de sesión lo pone el mixin, que es el que las tiene enumeradas.
      // #58 · si se dibujan los puntos de entrada a «Mis vacaciones» (§9). Se resuelve aquí y no
      // en un `computed`: el permiso sale del menú de `localStorage`, que no es reactivo, y un
      // `computed` sin dependencias reactivas no se recalcula nunca (revisión del PR #1742).
      // Y aquí no hay ventana de permiso viejo: las dos rutas del calendario entran por
      // `barreraBloqueoVacaciones`, que espera a `UsuarioActualizado.esperar()` ANTES de montar
      // esta pantalla, así que el menú que se lee ya es el de esta carga.
      self.puedeAbrirVacaciones = PermisosVacaciones.abrirMisVacaciones();
      // #1133 · y el de ACEL PLANIFICACIÓN, con la misma pregunta que su ruta y su tarjeta.
      self.puedeAbrirAcelPlanificacion = puedeAbrirControlPlanificacion();
      // #58 · un carril por cada carga del detalle del evento: las dos se relanzan al abrir otro
      // evento y sus respuestas no vuelven en orden.
      self.carrilSolicitudDia = carrilPeticiones();
      self.carrilFechaTarea = carrilPeticiones();
      // #59 · un carril por cada fuente de la rejilla. Las cuatro se relanzan al cambiar de
      // empleado o de semana, y todas van con la clave de `claveDelCalendario`: ninguna respuesta
      // se escribe si ya no es del empleado y del periodo que se están mirando.
      //
      // #472 · Aquí no se le da `vaciar` a ningún carril, y es a propósito: lo que se tira al
      // cambiar de empleado o de semana es de las CINCO cargas a la vez —y del detalle del día—, y
      // lo hace `vaciarLoPintado` en `getPlanificaciones`, que es por donde pasan todas antes de
      // lanzarse y compara la clave pintada con la nueva igual que el carril. Puesto en uno de los
      // cinco, invalidaría a los otros recién lanzados, y sin empleado no se vaciaría nada.
      self.carrilAgenda = carrilPeticiones();
      self.carrilPedidos = carrilPeticiones();
      self.carrilDiarios = carrilPeticiones();
      self.carrilTpc = carrilPeticiones();
      /**
       * #59 · La carga de la agenda que está en vuelo, para poder **esperarla**: la rejilla no
       * dice de quién es hasta que esa petición contesta (`duenioEventos`), y hay decisiones que
       * no se pueden tomar sin saberlo (`conDuenioDeLaAgenda`).
       *
       * Es la promesa que devuelve el carril, que se cumple también cuando la respuesta se
       * descarta por caducada: no se espera a que haya datos, se espera a que no quede nada por
       * llegar. Si la petición **falla** vuelve a `null`, que es lo que significa «no hay nada en
       * camino»: así quien necesite saber de quién es la rejilla puede volver a pedirla en vez de
       * esperar a una carga que ya terminó sin traerla.
       * Fuera de `data` por lo mismo que `promesaMiEquipo` y los carriles: no se pinta.
       */
      self.promesaAgenda = null;
      /**
       * #59 · De quién y de qué semana es lo que hay AHORA pintado en la rejilla. Es la clave con
       * la que se lanzaron las cuatro cargas vigentes, y sirve para saber cuándo la pantalla pasa
       * a mirar OTRA cosa: entonces lo de antes no puede quedarse puesto mientras llega lo nuevo
       * (ver `vaciarLoPintado`). Fuera de `data` por lo mismo que `promesaAgenda`: no se pinta.
       */
      self.clavePintada = null;
      // #59 · de quién es aprobador este usuario. Se pide una vez: de ella dependen el selector
      // «Empleado» y los botones del día amarillo, y no cambia mientras se navega.
      self.cargarMiEquipo();
      if (self.username == undefined || self.username == 'undefined')  {
        self.inspectorFiltro = self.comoUsername(Utils.getUser().username);
        self.username = self.inspectorFiltro;
        // app.views.current.router.navigate({url: "/calendario/" + self.inspectorFiltro + "/", ignoreCache: true});
        // window.open("#!/calendario/"+ self.inspectorFiltro + "/");
        // return;
      } else {
        self.inspectorFiltro = self.comoUsername(self.username);
      }
      // #425 · `?fecha=YYYY-MM-DD` abre el calendario en esa fecha en vez de en hoy. Lo usa el aviso
      // de planificaciones abiertas del pedido para llevar a la planificación concreta, y no solo a
      // la agenda de la persona. `value` es el foco del v-calendar; sin el parámetro se queda en ''
      // y Vuetify sigue partiendo de hoy, que es el comportamiento de siempre.
      const fechaPedida = self.$f7route && self.$f7route.query ? self.$f7route.query.fecha : null;
      if (fechaPedida && /^\d{4}-\d{2}-\d{2}$/.test(fechaPedida)) {
        self.value = fechaPedida;
      }
    },
    props: {
      username: {
        type: String,
      },
      /**
       * #49 · ¿bloquea el servidor las vacaciones (T0006) y los festivos generados (T0083 con grupo
       * FEST-) en los caminos genéricos del calendario?
       *
       * Llega YA RESUELTO desde la barrera de la ruta (`barreraBloqueoVacaciones.js`), que consulta
       * `GET /rh/vacaciones/bloqueo-generico` antes de montar esta pantalla. Que sea un `prop` y no
       * un dato que se pide en `created` es la decisión de diseño del 01/10/2026: mientras el valor
       * llegaba tarde, «todavía no se sabe» se trataba como «apagado» y cada gesto del calendario
       * —abrir, teclear, arrastrar, estirar, guardar, borrar— tenía su propia carrera que tapar.
       * Aquí no cambia nunca durante la vida del componente, así que no hay nada que reconciliar.
       *
       * Obligatorio a propósito: si alguien monta el calendario por un camino que no pase por la
       * barrera, Vue lo avisa en consola en vez de dejarlo arrancar como «apagado».
       */
      bloqueoVacaciones: {
        type: Boolean,
        required: true
      },
      /**
       * #174 · ¿el valor de `bloqueoVacaciones` es el que dijo el servidor, o el restrictivo que se
       * asume cuando `bloqueo-generico` no ha contestado?
       *
       * Solo sirve para pintar el aviso de la cabecera: la pantalla se comporta igual en los dos
       * casos, porque lo que gobierna la edición es `bloqueoVacaciones` y ya viene decidido. Si
       * fuese lo contrario —un «no se sabe» que la pantalla tuviera que interpretar— volvería la
       * ventana de carrera que la #49 cerró.
       *
       * Opcional a propósito, al revés que `bloqueoVacaciones`: su ausencia significa que el dato
       * se obtuvo, que es el caso normal, y quien monta el calendario sin pasar por la barrera ya
       * queda avisado por el otro `prop`.
       */
      avisoBloqueoVacaciones: {
        type: Boolean,
        default: false
      },
      /**
       * #271 · ¿Ha cerrado Dirección el camino manual de las vacaciones? Llega resuelto desde la
       * barrera, en la misma consulta que `bloqueoVacaciones` y por el mismo motivo: no cambia
       * durante la vida del componente. Con él encendido, «Crear tarea» no ofrece T0006 y el alta
       * de una vacación no se manda. La papelera de las que ya estaban puestas a mano no lo mira.
       *
       * Obligatorio, como `bloqueoVacaciones`: montar el calendario sin pasar por la barrera no
       * puede arrancarlo como «permitido» en silencio.
       */
      caminoManualApagado: {
        type: Boolean,
        required: true
      }

    },
    computed: {
      /**
       * #58 · Si los días que hay pintados en la rejilla son los del propio usuario logueado.
       *
       * No vale `username`, que es la prop de la ruta y puede traer a otra persona; el usuario
       * logueado es el de la sesión. Se compara sin distinguir mayúsculas, el mismo criterio que
       * usa el módulo en el servidor: la ERP guarda «JJCS» y el login «jjcs».
       *
       * **Y se compara contra `duenioEventos`, no contra `inspectorFiltro`.** `inspectorFiltro` es
       * el valor del desplegable «Empleado» y cambia en cuanto se suelta; `events` no se vacía
       * hasta que contesta `getPlanificaciones`. En Cordova —donde cambiar de persona no navega a
       * otra ruta— volver a uno mismo desde un calendario ajeno dejaba esta condición en `true`
       * con los días de la otra persona todavía en pantalla, y abrir uno preguntaba por las
       * vacaciones propias de esa fecha (revisión CODEX del PR #1733). Atado al dueño de lo que
       * se está viendo, los dos van siempre a la vez.
       */
      esMiCalendario: function() {
        const yo = (Utils.getUser() || {}).username;
        if (!yo || !this.duenioEventos) return false;
        return this.mismoUsuario(yo, this.duenioEventos);
      },
      /**
       * #59 · Qué calendarios puede elegir quien NO tiene ninguno de los seis roles que ven todo:
       * el suyo y el de las personas a las que aprueba.
       *
       * Las opciones salen del servidor (`/rh/bandeja-vacaciones/mi-equipo`), que es el mismo
       * sitio del que sale lo que la búsqueda de planificaciones le deja ver: si el desplegable
       * ofreciera a alguien que la búsqueda no permite, el calendario se quedaría en blanco sin
       * explicar por qué.
       *
       * Con un solo elemento —él— el desplegable **no se enseña**: no hay nada que elegir, y es
       * el caso de todo el mundo que no aprueba a nadie.
       *
       * **El valor de cada opción va normalizado** (`comoUsername`), que es la misma forma a la
       * que `getPlanificaciones` lleva `inspectorFiltro`. El `v-select` casa su modelo con el
       * `item-value` por igualdad exacta: con el login en minúsculas —«jjcs» frente a «JJCS», que
       * es un caso que este fichero ya contempla— la opción elegida dejaba de encontrarse en
       * cuanto se cargaba el calendario, y el campo «Empleado» se quedaba en blanco aunque la
       * rejilla estuviera enseñando a esa persona (revisión CODEX del PR #1735, ronda 5).
       */
      opcionesEmpleado: function() {
        const self = this;
        const yo = self.comoUsername((Utils.getUser() || {}).username);
        const opciones = [];
        if (yo) opciones.push({ username: yo, texto: yo });
        if (!self.miEquipo) return opciones;
        (self.miEquipo.personas || []).forEach(function(p) {
          const username = self.comoUsername(p.username);
          if (!username) return;
          opciones.push({
            username: username,
            texto: p.nombre ? p.nombre + ' (' + username + ')' : username
          });
        });
        return opciones;
      },
      // SPEC-PROPONER-PERNOCTA (15/09/2026): el toggle "Permitir pernocta" del drawer refleja la ficha
      // del inspector mientras el usuario no lo toque. Al pulsarlo la primera vez, se materializa como
      // true/false explícito y gana sobre la ficha (contrato del backend: SolverController.java:208,
      // `null = ficha C1; true/false fuerzan`). Sincroniza con el chip informativo "Pernocta Sí/No"
      // del preview (línea ~1778), que también lee de la ficha. Antes divergían: chip = ficha,
      // toggle = false hardcoded.
      //
      // Reglas de ausencia (JJCS 15/09/2026): elección del usuario SOLO cuando planificarConPernocta
      // es `true` o `false` estrictos. Cualquier otro valor (null, undefined, ausente) se trata como
      // "no ha elegido" y cae al valor de la ficha. Sobre la ficha: si `pernoctaPermitida` no viene
      // del backend, el `!!` de abajo lo cuenta como false — consistente con el chip.
      pernoctaEfectiva: function() {
        if (this.planificarConPernocta === true) return true;
        if (this.planificarConPernocta === false) return false;
        return !!(this.previewVigente && this.previewVigente.ficha
                  && this.previewVigente.ficha.pernoctaPermitida);
      },
      // #296 (P2 Codex, ronda 2) · el preview guardado, pero SOLO si habla del inspector que la
      // pantalla está mostrando. `previewInspector` ya registraba de quién era la medición; lo que
      // faltaba es que la comprobaran todos los que la leen y no solo el aviso del pie. La cabecera,
      // los chips de ficha, el contador del botón, la barra de tramos y este toggle de pernocta leían
      // `previewProponer` a pelo, así que bastaba con que `inspectorFiltro` cambiase sin relanzar la
      // consulta para que los números de A saliesen bajo el nombre de B. Un único sitio por el que
      // pasan todos: así la marca y su comprobación no pueden volver a separarse.
      previewVigente: function() {
        if (this.previewInspector !== this.inspectorFiltro) return null;
        return this.previewProponer;
      },
      /**
       * #283 · QUÉ bloque de la banda flotante se dibuja. Uno y solo uno: antes cada bloque tenía
       * su `v-if` independiente y había combinaciones que se apilaban de verdad —la vista reducida
       * convive siempre con la fase FIN que la provoca, y el aviso de 15 min sin eventos convive
       * con la fase en curso que se ha quedado muda—, así que la banda crecía hacia abajo con dos
       * `c4d-fase` y, encima, los dos decían cosas distintas del mismo hecho.
       *
       * El orden NO es cosmético: gana el que cuenta la verdad más reciente sobre el resultado.
       *
       *  - `timeout` por delante de `fase`: si el solver lleva 15 min callado, «🧮 Enviando al
       *    solver…» ya es mentira y además es el único bloque con una salida accionable. Al
       *    revés el aviso de timeout no se vería JAMÁS, porque `pasadaAsync` sigue vivo siempre.
       *  - `reducido` por delante de `fase`: «✅ Propuesta lista» y «el resultado completo ha
       *    caducado, faltan desplazamientos y avisos» no pueden estar los dos en pantalla —es el
       *    corolario de §9, dos partes de la misma pantalla diciendo lo contrario—. Y el que
       *    importa es el que explica por qué Aceptar está deshabilitado.
       *  - `ocupado` por delante de `fase`: es el rechazo de lo último que hizo el planificador.
       *    Hoy no coinciden nunca (al rechazar, `pasadaAsync` ya está a null), pero el orden lo
       *    deja decidido en vez de dejarlo al azar del DOM.
       *
       * Y la fase queda suprimida mientras el modo reducido de ESA MISMA pasada siga ACTIVO, no
       * solo mientras su aviso esté abierto. La prioridad sola no bastaba: al pulsar el ✕ de la
       * vista reducida —que solo marca «ya lo he leído»— el relevo descubría la fase FIN de debajo
       * y la banda pasaba de «el resultado completo ha caducado» a «✅ Propuesta lista», con su
       * autocierre armado; o sea volvía a dar por completo lo que acababa de declarar incompleto
       * (r4212149679). El ✕ cierra el AVISO; que el resultado esté incompleto no se cierra con un
       * ✕, igual que no vuelve a habilitar «Aceptar planificación».
       *
       * Cada candidato dice DE QUÉ PASADA habla, y eso es lo que cierra la familia entera (ronda 3
       * de revisión): un bloque no se dibuja si habla de una pasada que ya no es la vigente —el
       * modo reducido del resultado anterior tapaba el avance de la pasada nueva (r4212680956)— ni
       * si habla de una que el planificador ya descartó de la banda —al cerrar un bloque aparecía
       * otro preguntando por el mismo resultado (r4212680944)—. Con la decisión aquí, quien
       * produce los avisos (el sondeo de /en-curso, los eventos SSE, el 410 del /resultado) no
       * tiene que acordarse de apagar a sus hermanos: escribe su estado y este computed decide.
       *
       * QUÉ calla el descarte, y qué no (ronda 4): el descarte es la memoria de «ya he leído lo que
       * la banda me contaba de esta pasada», así que alcanza a los PARTES DE ESTADO —la fase, el
       * aviso de 15 min sin eventos, la oferta de «ver terminada»—, que repiten algo que el
       * planificador ya vio. La vista reducida no es un parte de estado: es la CORRECCIÓN de lo que
       * se dijo («lo que acabo de llamar propuesta lista no se ve entero») y la razón por la que
       * «Aceptar planificación» está deshabilitado. Nace de un 410 del /resultado que llega DESPUÉS
       * del FIN, así que el ✕ —o el autocierre de 4,5 s— de la banda de FIN puede adelantársele, y
       * entonces el descarte la callaba sin que nadie la hubiera leído: el planificador se quedaba
       * con un «Aceptar» apagado y sin enterarse de que faltan datos (r4212996634). Por eso este
       * bloque se gobierna SOLO por su propio «ya lo he leído»
       * (`pasadaAsyncModoReducidoAvisoCerrado`), que únicamente pone su propio ✕.
       *
       * DE QUIÉN habla cada bloque (ronda 6): además de la pasada, el inspector. Los avisos
       * cerrados se recuerdan por su identidad —sesión, inspector y pasada— y esa identidad se lee
       * de aquí, que es el único sitio donde está escrito a qué pasada corresponde cada bloque. No
       * se deduce del filtro de la pantalla: la banda sobrevive a propósito a un cambio de
       * inspector, así que el filtro del momento del cierre puede ser ya otro.
       */
      candidatosBandaFlotante: function() {
        const pasadaFase = this.pasadaAsync ? (this.pasadaAsync.pasadaId || null) : null;
        const inspectorFase = this.pasadaAsync ? (this.pasadaAsync.inspector || null) : null;
        const pasadaReducida = this.pasadaAsyncModoReducidoPasadaId || null;
        const oferta = this.pasadaAsyncTerminadaOferta;
        // Un modo reducido SIN sello (estado heredado) se trata como si fuera de la pasada que hay
        // en pantalla: entre callar el avance y volver a decir «Propuesta lista» de un resultado
        // que puede estar incompleto, lo segundo es lo que §9 prohíbe.
        const reducidoTapaLaFase = !!this.pasadaAsyncModoReducido
          && (!pasadaReducida || pasadaReducida === pasadaFase);
        // `loCallaElDescarte`: ¿cerrar un bloque de esta pasada da también por leído a este? Sí en
        // los partes de estado, no en la vista reducida (ver la cabecera).
        // `inspector`: de quién es la pasada de la que habla el bloque. Va aquí y no se deduce en
        // cada cierre porque es la mitad de la identidad con la que se archiva el cierre (ronda 6).
        return [
          { bloque: 'timeout',   pasadaId: pasadaFase,     inspector: inspectorFase,
            loCallaElDescarte: true,
            hay: !!this.pasadaAsyncTimeoutAviso },
          { bloque: 'reducido',  pasadaId: pasadaReducida, inspector: this.pasadaAsyncModoReducidoInspector || null,
            loCallaElDescarte: false,
            hay: !!this.pasadaAsyncModoReducido && !this.pasadaAsyncModoReducidoAvisoCerrado },
          { bloque: 'ocupado',   pasadaId: null,           inspector: null,
            loCallaElDescarte: true,
            hay: !!this.pasadaAsyncOcupadoDeOtro },
          { bloque: 'fase',      pasadaId: pasadaFase,     inspector: inspectorFase,
            loCallaElDescarte: true,
            hay: !!this.pasadaAsync && !reducidoTapaLaFase },
          { bloque: 'terminada', pasadaId: oferta ? (oferta.pasadaId || null) : null,
            inspector: oferta ? (oferta.inspector || null) : null,
            loCallaElDescarte: true,
            hay: !!oferta }
        ];
      },
      bloqueAvisoFlotante: function() {
        const self = this;
        const vigente = this.pasadaAsync ? (this.pasadaAsync.pasadaId || null) : null;
        const elegido = this.candidatosBandaFlotante.find(function(c) {
          if (!c.hay) return false;
          // «Ocupado por otro» es el único bloque que no habla de una pasada propia: es el rechazo
          // del lanzamiento, y no hay nada que sellar.
          if (!c.pasadaId) return true;
          if (c.loCallaElDescarte && self.avisoCerradoDeLaPasada(c.inspector, c.pasadaId)) return false;
          return !vigente || c.pasadaId === vigente;
        });
        return elegido ? elegido.bloque : null;
      },
      // ENCARGO-025 · v-show del contenedor flotante de avisos. Se dibuja solo cuando hay
      // algo que decir — así no metemos un div fantasma cubriendo el calendario cuando no hay
      // pasada.
      hayAvisoAsync: function() {
        return !!this.bloqueAvisoFlotante;
      },
      // #283 · ¿la fase que se está pintando es TERMINAL? Es lo que decide si sale el ✕ y si hay
      // autocierre. Antes esto estaba escrito tres veces en la plantilla con literales ('FIN',
      // 'ERROR') y una de ellas llevaba pegado `&& runPropuesta`, que es de donde salía el aviso
      // mudo. Aquí vive una vez y usa las constantes del adaptador.
      avisoFaseAsyncCerrable: function() {
        const FASES = ProponerPlanificacionEvents.FASES;
        if (!this.pasadaAsync) return false;
        return this.pasadaAsync.fase === FASES.FIN || this.pasadaAsync.fase === FASES.ERROR;
      },
      // #283 · el autocierre solo cuenta si ese bloque terminal es ADEMÁS el que se está viendo:
      // con la vista reducida por delante, cerrar la fase de debajo no quitaría nada de pantalla
      // y dejaría el aviso visible sin fase que lo sostenga.
      avisoFaseAsyncAutocierra: function() {
        return this.bloqueAvisoFlotante === 'fase' && this.avisoFaseAsyncCerrable;
      },
      // #283 · ¿el bloque visible tiene salida? Lo usa `Esc`, que no puede cerrar una fase en
      // curso: es la misma regla que el ✕, en un solo sitio para que no se separen.
      avisoFlotanteCerrable: function() {
        const bloque = this.bloqueAvisoFlotante;
        if (!bloque) return false;
        if (bloque === 'fase') return this.avisoFaseAsyncCerrable;
        return true;
      },
      // C4 panel no planificables: agrupar por causa técnica (viaja en `detalle`, no en `motivo`)
      gruposNoPlanificables: function() {
        const self = this;
        const MOTIVOS = {
          'sin coordenadas':                 { etiqueta: 'Sin coordenadas',            accion: 'Corregir dirección / geocodificar' },
          'sin habilitación para el servicio': { etiqueta: 'Inspector sin habilitación', accion: 'Revisar cualificación' },
          'ningún inspector elegible':       { etiqueta: 'Sin inspector elegible',     accion: 'Completar ficha del inspector / base' },
          'inspector no está en la petición': { etiqueta: 'Inspector fuera de la propuesta', accion: 'Revisar asignación de la línea' }
        };
        const grupos = {};
        (self.noPlanificables || []).forEach(function(np) {
          // detalle = "campo no cubierto: <causa>"; si no llega, cae al motivo EST PLA
          let clave = (np.detalle || '').replace('campo no cubierto: ', '').trim() || (np.motivo || 'otro');
          if (!grupos[clave]) {
            const meta = MOTIVOS[clave] || { etiqueta: clave, accion: ACCION_SOLVER_POR_DEFECTO };
            grupos[clave] = { clave: clave, etiqueta: meta.etiqueta, accion: meta.accion, items: [] };
          }
          grupos[clave].items.push(np);
        });
        return self.ordenarPorImporte(Object.keys(grupos).map(function(k) { return grupos[k]; }));
      },
      // #482 (ronda 4) · lo bloqueado por el SOLVER, como SUMA y no como número: la lista del solver
      // puede no traer el importe de una línea (`importeONulo` lo documenta), y convertir esa
      // ausencia en un 0 hacía que los recuadros «Solver» y «Total bloqueado» afirmaran «0,00 €».
      // Ver `sumaImportes`.
      importeSolver: function() {
        return this.sumaImportes((this.noPlanificables || []).map(function(np) { return np.importe; }));
      },
      // #325 (opción A) · la lista que pinta el panel es la de la captura, no un campo aparte. No
      // tiene setter a propósito: si alguien la asignara volveríamos a tener una lista y un resumen
      // que pueden decir cosas distintas, que es la familia que esta decisión vino a cerrar.
      bloqueadosNegocio: function() {
        return (this.capturaNegocio && this.capturaNegocio.lineas) || [];
      },
      // Fase 2: bloqueadas por NEGOCIO (EST PLA) — ámbito GLOBAL, no del inspector propuesto
      gruposNegocio: function() {
        const grupos = {};
        (this.bloqueadosNegocio || []).forEach(function(b) {
          const clave = b.valor || 'SIN_MOTIVO';
          if (!grupos[clave]) {
            // La acción se decide AQUÍ, una vez por causa: de este grupo la copian la fila de grupo,
            // la de cada línea y el Excel, y ninguno de los tres puede enseñar la orden del catálogo.
            const accion = (b.accion && !ORDEN_DEL_CATALOGO.test(b.accion)) ? b.accion : ACCION_NEGOCIO_POR_DEFECTO;
            grupos[clave] = { clave: clave, etiqueta: b.label || clave, accion: accion, items: [] };
          }
          grupos[clave].items.push(b);
        });
        return this.ordenarPorImporte(Object.keys(grupos).map(function(k) { return grupos[k]; }));
      },
      // #482 (ronda 4) · lo mismo para la PÁGINA de bloqueadas por negocio: es la cifra que la #325
      // rotula cuando la página es todo el universo o cuando no se sabe el total.
      importeNegocioMostrado: function() {
        return this.sumaImportes((this.bloqueadosNegocio || []).map(function(b) { return b.importe; }));
      },
      // #325 (opción A) · lo que el panel PUEDE AFIRMAR del universo de bloqueadas por NEGOCIO.
      //
      // La lista que se pinta es una PÁGINA: como máximo las 200 de mayor importe
      // (`SolverRequestBuilder.CAP_BLOQUEADOS_NEGOCIO`), así que su longitud es «lo que se enseña» y
      // nunca el total. Lo que hay detrás lo dice el `resumen` que viene EN LA MISMA RESPUESTA y de
      // la misma consulta, con la conclusión ya hecha en `completitud`.
      //
      // AQUÍ NO SE COMPARA NADA, y eso es el cambio. Hasta la decisión del 08/10 el total se pedía
      // aparte y esta pantalla comparaba las dos cifras para decidir si había recorte. Las dos
      // lecturas no coincidían en seis cosas —el dedup del espejo, la copia elegida, el importe, el
      // minuto de retraso del caché, el orden y el tope—, y cuatro rondas de revisión seguidas
      // arreglaron una cada una y descubrieron la siguiente. Dirección cerró la familia por la raíz:
      // una sola consulta, y la conclusión la saca el único sitio donde las dos cifras son la misma
      // lectura. Si aquí vuelve a aparecer un `>` entre una cifra de la lista y una del total, la
      // familia está reabierta.
      //
      // Cuatro situaciones, y cada una se dice distinta en pantalla (`modo`):
      //   - 'sin-seccion': no hay bloqueadas por negocio, así que no hay tope del que hablar.
      //   - 'completo':    la página ES todo el universo. Se rotulan sus cifras, sin coletilla: no se
      //                    avisa de un recorte que no existe (criterio 2 de la ficha).
      //   - 'recorta':     el tope ha recortado. Se rotula el total y qué parte se está viendo.
      //   - 'sin-total':   no se sabe el total, y la nota dice POR QUÉ (`motivo`). Nunca se rotula la
      //                    cifra de la página como si fuera el total.
      //
      // Las cifras de «lo que se enseña» salen de la LISTA PINTADA y no del `mostradas` del resumen,
      // aunque sean el mismo número: lo que la cabecera promete tiene que cuadrar con el desglose por
      // causa que va justo debajo, y ese desglose se agrupa de la lista. Si un día llegaran distintos,
      // lo honesto es decir lo que se está pintando (§9 del CLAUDE.md).
      resumenNegocio: function() {
        const mostradas = (this.bloqueadosNegocio || []).length;
        const suma = this.importeNegocioMostrado;
        const importeMostrado = suma.importe;
        const r = (this.capturaNegocio && this.capturaNegocio.resumen) || null;
        // #482 (ronda 4) · `importe` puede ser `null` (ninguna línea de la página trae importe) y
        // `sinImporte` dice cuántas no lo traen: las dos mitades de la suma viajan juntas para que el
        // rótulo no pueda presentar como medido un total al que le faltan sumandos.
        const base = { mostradas: mostradas, importeMostrado: importeMostrado,
          lineas: mostradas, importe: importeMostrado,
          conImporte: suma.conImporte, sinImporte: suma.sinImporte };
        if (!mostradas) {
          return Object.assign(base, { modo: 'sin-seccion', motivo: null });
        }
        // Un despliegue desparejado (front nuevo, API anterior) no manda el resumen. No se adivina.
        if (!r || !r.completitud) {
          return Object.assign(base, { modo: 'sin-total', motivo: 'ausente' });
        }
        if (r.completitud === COMPLETITUD_DESCONOCIDO) {
          return Object.assign(base, { modo: 'sin-total', motivo: 'desconocido' });
        }
        if (r.completitud === COMPLETITUD_COMPLETO) {
          return Object.assign(base, { modo: 'completo', motivo: null });
        }
        if (r.completitud !== COMPLETITUD_PARCIAL) {
          // Un valor que esta pantalla no conoce no puede leerse como «está todo».
          return Object.assign(base, { modo: 'sin-total', motivo: 'cuerpo' });
        }
        const total = typeof r.total === 'number' ? r.total : NaN;
        const importeTotal = typeof r.importeTotal === 'number' ? r.importeTotal : NaN;
        if (!isFinite(total) || total < 0 || !isFinite(importeTotal)) {
          return Object.assign(base, { modo: 'sin-total', motivo: 'cuerpo' });
        }
        // El total REAL es el del servidor (#325) y no se reinterpreta aquí. El recuento de líneas sin
        // importe de la página no se arrastra: hablaría de 200 líneas al lado de un total de 610.
        return Object.assign(base, { modo: 'recorta', motivo: null,
          lineas: total, importe: importeTotal, conImporte: total, sinImporte: 0 });
      },
      // #482 (ronda 4) · lo de NEGOCIO que la #325 manda rotular —el total real o, sin él, la
      // página—, en la misma forma que `importeSolver` para que las dos mitades se sumen igual.
      sumaNegocio: function() {
        const r = this.resumenNegocio;
        return this.suma(r.importe || 0, r.conImporte || 0, r.sinImporte || 0);
      },
      // #325: primera línea de la cabecera del panel. Suma lo del SOLVER —que NO está capado: el
      // solver devuelve todas sus no cubiertas— con lo de NEGOCIO. Cuando no se sabe el total, las
      // cifras son las de lo que se enseña y la cabecera lo dice ahí mismo en vez de dejarlo entender.
      cabeceraNoPlanificables: function() {
        const r = this.resumenNegocio;
        const soloPagina = r.modo === 'sin-total';
        const lineas = (this.noPlanificables || []).length + r.lineas;
        // #482 (ronda 4) · la suma del solver más la de negocio, con sus ausencias: si ninguna línea
        // trae importe no hay cifra que dar, y si faltan algunas la cifra se dice PARCIAL.
        const suma = this.juntarSumas(this.importeSolver, this.sumaNegocio);
        const cabeza = 'No planificables (' + lineas + (soloPagina ? ' mostradas' : '') + ') · ';
        if (suma.importe === null) {
          return cabeza + 'importe ' + NO_DISPONIBLE;
        }
        return cabeza + this.importeVentana(suma.importe)
          + (soloPagina ? ' en lo que se enseña' : ' bloqueados')
          + this.coletillaSinImporte(suma);
      },
      // #325: segunda línea, la que impide leer la primera como si fuera todo. Solo aparece cuando hay
      // algo que advertir: si la página es el universo entero no se avisa de un truncamiento que no
      // existe, y sin sección NEGOCIO no hay tope del que hablar. Y si no se sabe el total, dice por
      // qué no se sabe: un control que no puede dar lo que promete no se queda mudo (§9 del CLAUDE.md).
      //
      // La nota del recorte DICE DE QUÉ habla, y no es cosmética: la cifra de la primera línea suma
      // el SOLVER —que no está capado— con el total de NEGOCIO, así que «se muestran las 200» a secas
      // se lee como «de las 615 de arriba se ven 200» cuando en pantalla hay 200 de negocio MÁS todas
      // las del solver (205 con 5 técnicas). El tope solo recorta las de negocio, y es lo único que
      // la nota puede prometer (§9: dos partes de la misma pantalla no pueden decir lo contrario).
      notaNoPlanificables: function() {
        const r = this.resumenNegocio;
        if (r.modo === 'sin-seccion' || r.modo === 'completo') {
          return null;
        }
        if (r.modo === 'recorta') {
          return 'de las bloqueadas por negocio se muestran las ' + r.mostradas + ' de mayor importe';
        }
        // La causa solo se nombra si se conoce: afirmar «el servidor ha fallado» cuando no se sabe
        // sería cambiar una cifra inventada por una culpa inventada.
        //
        // Y también dice de qué total habla, por lo mismo que la nota del recorte: lo que falta es el
        // de las bloqueadas por negocio; las del solver están todas y de esas no falta nada.
        const causa = MOTIVOS_SIN_TOTAL[r.motivo];
        return 'no se ha podido obtener el total de las bloqueadas por negocio'
          + (causa ? ' · ' + causa : '');
      },
      // #325 (opción A) · la edad y el alcance de la captura, que es lo que hace legibles las dos
      // cifras: son del mismo instante y del mismo ámbito. Va en el tooltip de la cabecera y no en
      // una tercera línea a propósito — el panel no se reorganiza para hacer sitio a nada nuevo
      // (§9 del CLAUDE.md), y la hora solo importa cuando alguien se pregunta de cuándo son las
      // cifras que tiene delante.
      tooltipNoPlanificables: function() {
        const r = (this.capturaNegocio && this.capturaNegocio.resumen) || null;
        if (!r) {
          return null;
        }
        const partes = [];
        if (r.ambito) {
          partes.push(r.ambito === 'GLOBAL'
            ? 'Bloqueadas por negocio: ámbito global, no solo del inspector de la propuesta'
            : 'Ámbito: ' + r.ambito);
        }
        const hora = this.horaDeLaCaptura(r.capturadoEn);
        if (hora) {
          // «El total y lo que se muestra salen de la misma consulta» solo se puede decir cuando hay
          // total: con `modo` en 'sin-total' —`DESCONOCIDO`, un resumen ilegible o una API anterior—
          // la cabecera está diciendo justo lo contrario, que no se ha podido obtener, y el tooltip
          // afirmaría de dónde sale una cifra que no existe. Dos partes de la misma pantalla no
          // pueden decir lo contrario la una de la otra (§9 del CLAUDE.md). La hora sí vale en los
          // dos casos: sigue siendo cuándo se tomó lo que se está pintando.
          partes.push(this.resumenNegocio.modo === 'sin-total'
            ? 'Lo que se muestra se tomó a las ' + hora
            : 'Cifras tomadas a las ' + hora + ': el total y lo que se muestra salen de la '
              + 'misma consulta');
        }
        return partes.length ? partes.join(' · ') : null;
      },
      avisoGeo: function() {
        const self = this;
        const sinCoords = (self.noPlanificables || []).filter(function(np) {
          return (np.detalle || '').indexOf('sin coordenadas') > -1;
        }).length;
        const candidatas = (self.noPlanificables || []).length + (self.propuestas || []).length;
        return (candidatas > 0 && sinCoords / candidatas > 0.3) ? sinCoords : 0;
      },

      // ======================= #482 · el botón y la ventana de «No planificables» ==================
      // Lo que sigue solo PRESENTA: las cifras, el reparto SOLVER/NEGOCIO y la conclusión de recorte
      // son las de la #325 (`resumenNegocio`, `cabeceraNoPlanificables`, `notaNoPlanificables`) y
      // aquí no se recalculan ni se reinterpretan.

      // ¿Hay una corrida de la que hablar? Sin propuesta en pantalla no se dibuja nada: el botón en
      // gris dice «esta propuesta no dejó ninguna bloqueada», y eso solo es verdad si hubo corrida.
      hayCorridaEnPantalla: function() {
        return !!this.capturaNegocio
          || !!(this.propuestas || []).length
          || !!(this.noPlanificables || []).length;
      },
      hayBloqueadas: function() {
        return !!(this.noPlanificables || []).length || !!(this.bloqueadosNegocio || []).length;
      },
      /**
       * #482 (ronda 2) · ¿lo que hay en pantalla se ha RECONSTRUIDO del registro?
       *
       * Lo dice la propia captura, que es el único sitio del que cuelga el estado de las bloqueadas
       * por negocio (#325: la lista y su total son el mismo campo para que no puedan separarse). Un
       * booleano aparte volvería a tener dos mitades que acordarse de mover a la vez.
       *
       * Importa porque en esa vía la ausencia de datos no es una ausencia de líneas: ni el desglose
       * de negocio ni los importes del solver se persisten en el audit-log. Nada de lo que la
       * pantalla diga aquí puede sonar a conclusión.
       */
      propuestaReconstruida: function() {
        return !!(this.capturaNegocio && this.capturaNegocio.reconstruida);
      },
      // El rótulo del botón es LA MISMA frase que rotulaba el panel (#325): el total real cuando se
      // conoce, y «(N mostradas) … en lo que se enseña» cuando no. Nunca «(200)» a secas.
      //
      // Con la propuesta reconstruida la frase de la #325 no sirve, y no por cómo está escrita: sus
      // dos cifras saldrían de un estado que no tiene ni las bloqueadas por negocio ni los importes
      // del solver, así que diría «(5) · 0,00 € bloqueados». El nº de líneas del solver sí se sabe y
      // se publica como «mostradas»; el importe, que no, se dice que no está.
      rotuloBotonNoPlanificables: function() {
        if (!this.hayBloqueadas) {
          return this.propuestaReconstruida ? BOTON_RECONSTRUIDA : BOTON_SIN_BLOQUEADAS;
        }
        if (this.propuestaReconstruida) {
          return 'No planificables (' + (this.noPlanificables || []).length + ' mostradas) · '
            + 'importe ' + NO_DISPONIBLE;
        }
        return this.cabeceraNoPlanificables;
      },
      tituloBotonNoPlanificables: function() {
        if (this.propuestaReconstruida) {
          return MOTIVO_RECONSTRUIDA;
        }
        return this.hayBloqueadas ? (this.tooltipNoPlanificables || '') : MOTIVO_SIN_BLOQUEADAS;
      },
      // El «✓» es una afirmación como el rótulo, y en gris es lo primero que se ve: solo se pone
      // cuando de verdad no quedó ninguna bloqueada. Con la propuesta reconstruida no se sabe, y
      // eso se dibuja «?» (ronda 2).
      iconoBotonNoPlanificables: function() {
        if (this.hayBloqueadas) {
          return '!';
        }
        return this.propuestaReconstruida ? '?' : '✓';
      },
      // Junto al botón solo se dice lo que hace falta para leer SU cifra: que no se ha podido
      // obtener el total y que, por tanto, lo que ahí se lee es solo lo que se enseña. El aviso del
      // RECORTE no va aquí sino dentro de la ventana, que es donde se ven las líneas de las que
      // habla; repetirlo en los dos sitios era la tercera frase del rincón y nadie la leía.
      notaBotonNoPlanificables: function() {
        // Reconstruida: lo que falta no es el total de una lista que se está enseñando, es la lista
        // entera y los importes. Se dice con sus palabras, que son las mismas del título del botón
        // —el gris no tiene más sitio que su `title`, y quien no lo pose tiene que poder leerlo
        // igual— y salen también dentro de la ventana, junto a los recuadros que dicen «no
        // disponible».
        if (this.propuestaReconstruida) {
          return NOTA_RECONSTRUIDA;
        }
        if (this.resumenNegocio.modo !== 'sin-total') {
          return null;
        }
        return this.notaNoPlanificables + '; las cifras son solo de lo que se enseña';
      },
      // «se muestran las 200 de mayor importe de 610», con el total real de la #325. Solo cuando hay
      // recorte de verdad: la conclusión la da el servidor (`completitud`), aquí no se compara nada.
      avisoRecorteVentana: function() {
        const r = this.resumenNegocio;
        if (r.modo !== 'recorta') {
          return null;
        }
        return 'De las bloqueadas por negocio se muestran las ' + r.mostradas
          + ' de mayor importe de ' + r.lineas + '.';
      },
      instanteDeLaPropuesta: function() {
        const capturadoEn = (this.capturaNegocio && this.capturaNegocio.resumen
          && this.capturaNegocio.resumen.capturadoEn) || null;
        if (!capturadoEn) {
          return null;
        }
        const m = this.moment(capturadoEn);
        return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : null;
      },
      tituloVentanaNoPlanificables: function() {
        const instante = this.instanteDeLaPropuesta;
        return 'No planificables' + (instante ? ' · propuesta del ' + instante : '');
      },
      subtituloVentanaNoPlanificables: function() {
        const partes = [];
        if (this.inspectorFiltro) {
          partes.push('Inspector: ' + this.inspectorFiltro);
        }
        // De la semana PROPUESTA (`desdeDeLaPropuesta`) y, si la corrida no pasó por el lanzamiento
        // —una pasada recogida tras recargar—, del tramo que pinta el calendario. No de `value`: está
        // vacío hasta que se navega, y por eso la cabecera salía sin semana (prueba del 30/10).
        // Semana ISO, la de los calendarios de aquí: el 10/10/2026 es la 41, como en el mockup.
        const desde = this.desdeDeLaPropuesta || this.fechaDesdeFiltro;
        const semana = desde ? this.moment(desde) : null;
        if (semana && semana.isValid()) {
          partes.push('Semana ' + semana.isoWeek());
        }
        return partes.join(' · ');
      },
      // Los tres recuadros, con su texto YA RESUELTO. El de NEGOCIO publica el total REAL (o el de
      // la página cuando no se sabe el total, y entonces la nota de arriba lo dice): es la cifra de
      // la #325, la misma que suma el rótulo del botón.
      //
      // El texto se arma aquí y no en la plantilla (ronda 2) porque con la propuesta reconstruida
      // dos de los tres recuadros no tienen cifra que dar, y un `v-if` por recuadro repetido tres
      // veces es justo donde se olvida uno y queda un «0,00 €» afirmando lo que no se sabe.
      kpisNoPlanificables: function() {
        const r = this.resumenNegocio;
        const lineas = function(n) { return n + (n === 1 ? ' línea' : ' líneas'); };
        if (this.propuestaReconstruida) {
          // Del solver se sabe CUÁNTAS son —el registro guarda la lista— pero no su importe; de
          // negocio no se sabe ni eso. Lo que no se sabe se dice, no se pone a cero.
          return {
            total: { importe: NO_DISPONIBLE, lineas: null },
            solver: { importe: NO_DISPONIBLE, lineas: lineas((this.noPlanificables || []).length) },
            negocio: { importe: NO_DISPONIBLE, lineas: null }
          };
        }
        // Ronda 4 · los tres salen de SUMAS (`sumaImportes`), no de números: un recuadro cuyas líneas
        // no traen importe dice «no disponible», y uno al que le faltan algunas dice cuántas, en vez
        // de rotular como medido un total al que le faltan sumandos. El 0 de verdad sigue siendo
        // «0,00 €».
        return {
          total: { importe: this.textoSuma(this.juntarSumas(this.importeSolver, this.sumaNegocio), NO_DISPONIBLE),
            lineas: lineas((this.noPlanificables || []).length + r.lineas) },
          solver: { importe: this.textoSuma(this.importeSolver, NO_DISPONIBLE),
            lineas: lineas((this.noPlanificables || []).length) },
          negocio: { importe: this.textoSuma(this.sumaNegocio, NO_DISPONIBLE), lineas: lineas(r.lineas) }
        };
      },
      /**
       * Las líneas de la ventana, las dos procedencias en la MISMA forma: lo que cambia entre una
       * bloqueada por negocio y una no cubierta por el solver es de dónde sale, no cómo se lee.
       *
       * Se apoya en los grupos que ya existen (`gruposNoPlanificables` y `gruposNegocio`) para no
       * tener un segundo criterio de agrupación por causa que pueda separarse del del panel.
       */
      lineasVentanaNoPlanificables: function() {
        const self = this;
        const filas = [];
        (self.gruposNoPlanificables || []).forEach(function(grupo) {
          (grupo.items || []).forEach(function(np) {
            filas.push(self.filaVentana('SOLVER', grupo, np));
          });
        });
        (self.gruposNegocio || []).forEach(function(grupo) {
          (grupo.items || []).forEach(function(b) {
            filas.push(self.filaVentana('NEGOCIO', grupo, b));
          });
        });
        return filas;
      },
      // Las que pasan el BUSCADOR (pedido, cliente o población). Los contadores del filtro salen de
      // aquí, no de la lista entera: si se busca algo, «Solver (0)» tiene que poder decir que por
      // ahí no hay nada, en vez de prometer líneas que la tabla no va a enseñar.
      lineasBuscadasNoPlanificables: function() {
        const texto = (this.busquedaNoPlanificables || '').trim().toLowerCase();
        if (!texto) {
          return this.lineasVentanaNoPlanificables;
        }
        return this.lineasVentanaNoPlanificables.filter(function(f) {
          return f.buscable.indexOf(texto) > -1;
        });
      },
      filtrosNoPlanificables: function() {
        const encontradas = this.lineasBuscadasNoPlanificables;
        const solver = encontradas.filter(function(f) { return f.origen === 'SOLVER'; }).length;
        return [
          { clave: 'TODAS', etiqueta: 'Todas', lineas: encontradas.length },
          { clave: 'SOLVER', etiqueta: 'Solver', lineas: solver },
          { clave: 'NEGOCIO', etiqueta: 'Negocio', lineas: encontradas.length - solver }
        ];
      },
      // Lo que la tabla enseña: buscador y filtro aplicados, agrupado por causa y ordenado por
      // importe descendente —los grupos entre sí y las líneas dentro de cada grupo—.
      //
      // El nº de líneas y el importe de la fila de grupo se recuentan sobre lo que QUEDA visible, no
      // sobre el grupo entero: la fila de grupo encabeza las filas que tiene debajo, y prometer un
      // importe que no es la suma de lo que se ve es la misma clase de defecto que la #325 vino a
      // cerrar arriba.
      gruposVentanaNoPlanificables: function() {
        const filtro = this.filtroNoPlanificables;
        const grupos = {};
        this.lineasBuscadasNoPlanificables.forEach(function(fila) {
          if (filtro !== 'TODAS' && fila.origen !== filtro) {
            return;
          }
          if (!grupos[fila.claveGrupo]) {
            grupos[fila.claveGrupo] = { clave: fila.claveGrupo, origen: fila.origen,
              etiqueta: fila.etiquetaGrupo, accion: fila.accionGrupo, items: [] };
          }
          grupos[fila.claveGrupo].items.push(fila);
        });
        const self = this;
        // El importe del grupo es la SUMA de lo que queda visible (`sumaImportes`, ronda 4): `null`
        // si ninguna línea trae importe, el 0 de verdad como 0, y `sinImporte` cuando faltan algunas,
        // que es lo que la celda dice en vez de presentar la suma como el importe del grupo.
        return this.ordenarPorImporte(Object.keys(grupos).map(function(k) {
          const g = grupos[k];
          g.suma = self.sumaImportes(g.items.map(function(f) { return f.importe; }));
          g.importe = g.suma.importe;
          g.items = self.ordenarPorImporte(g.items);
          return g;
        }));
      },
      mensajeVentanaVacia: function() {
        if ((this.busquedaNoPlanificables || '').trim() || this.filtroNoPlanificables !== 'TODAS') {
          return 'Ninguna línea cuadra con lo que se está buscando.';
        }
        // Reconstruida: la tabla está vacía porque el desglose no se ha podido traer, no porque la
        // corrida no dejara bloqueadas. Decir lo segundo sería la misma afirmación de más que el
        // botón ya no hace (ronda 2).
        return this.propuestaReconstruida
          ? MOTIVO_RECONSTRUIDA
          : 'Esta propuesta no ha dejado ninguna línea bloqueada.';
      },
      /**
       * §9 · el enlace de «Qué hacer» solo existe si el usuario puede entrar en Control de
       * planificación. Y «puede» lo decide el MENÚ efectivo, que es el control de acceso real de las
       * rutas; la lista de roles es la misma que declara la ruta y solo manda mientras el menú no
       * está cargado (ver `RoutesUtils.tieneAcceso`). Sin acceso, la celda dice igualmente quién lo
       * gestiona: lo que no puede hacer es quedarse muda ni mandar a nadie a un 403.
       */
      enlaceControlPlanificacion: function() {
        return RoutesUtils.tieneAcceso(RUTA_CONTROL_PLANIFICACION, ROLES_CONTROL_PLANIFICACION)
          ? this.getUrl(RUTA_CONTROL_PLANIFICACION.replace(/^\//, ''))
          : null;
      },
      rotuloQueHacer: function() {
        return this.enlaceControlPlanificacion
          ? 'Ir a Control de planificación'
          : 'Lo gestiona Planificación';
      },
      /**
       * #482 (ronda 2) · Lo que la celda «Qué hacer» ofrece a las líneas de NEGOCIO: el enlace a
       * Control de planificación si la ruta está en el menú, y si no, quién lo gestiona.
       *
       * Sale de los dos de arriba y está aquí para que `filaVentana` lo resuelva una sola vez por
       * tabla en vez de preguntarlo por fila: la respuesta es la misma para todas y no depende de
       * la línea.
       */
      queHacerNegocio: function() {
        // Ronda 4 · `externo` como el resto de enlaces internos del calendario (`target != 'cordova'`):
        // en la web `getUrl` da una URL con `#!/` que se abre como navegación del navegador, pero en
        // Cordova da una ruta interna, y marcada `external` Framework7 se salta su router y la
        // pantalla no se abre.
        return { enlace: this.enlaceControlPlanificacion, rotulo: this.rotuloQueHacer,
          externo: this.target != 'cordova' };
      }
    },
    watch: {
      // #283 · el autocierre se arma AQUÍ y no en el manejador de eventos SSE a propósito: una
      // fase terminal puede entrar por tres caminos distintos —el evento FIN/ERROR, el reenganche
      // a una pasada viva que ya había acabado, y el relevo de prioridad cuando se cierra el
      // bloque que tenía por delante—. Colgado del estado resultante los cubre los tres; colgado
      // de uno de ellos habría que acordarse en los otros dos, que es exactamente la clase de
      // olvido que dejó el aviso sin salida.
      avisoFaseAsyncAutocierra: function (procede) {
        if (procede) this.armarAutocierreFaseAsync();
        else this.cancelarAutocierreFaseAsync();
      },
      // #283 · al asomar el aviso hay que medir la barra de indicadores YA PINTADA, de ahí el
      // nextTick. Después de esto lo mantiene al día el hook `updated` y el oyente de `resize`.
      hayAvisoAsync: function (visible) {
        if (visible) this.$nextTick(this.recolocarBandaFaseAsync);
      }
    },
    methods: {
      precioMinuto: function(fecha) {
        const self = this;

        if (new Date(fecha) < new Date('2025-05-27')) {
          return self.precioMinuto_1;
        } else {
          return self.precioMinuto_2;
        }
      },
      verTPIP: function() {

      },
      verPendientes: function(date) {
        const self = this;
        let url = '/lineaspedidos/filter/?filter={"onlyAggregations":false,"withoutAggregations":true,"activo":true,"lineas##camposUsuario##cpEj":["'+self.inspectorFiltro+'"],"lineas##camposUsuario##trabCm":["S"],"lineas##camposUsuario##trabOf":["N"],"estado##estado":["CREADO","PLANIFICADO","EN_EJECUCION","EJECUTADO","FACTURADO","CERRADO"],"fechaContratacionDesde":"2020-12-31T23:00:00.000Z","tipoReparto":"REPARTOEJECUCION"}';
        self.$f7router.navigate(url);
      },
      onSelectDate(data) {
        const self = this;
        self.value = self.moment(data.date).format('YYYY-MM-DD');
        self.$refs.popupSelectDate.close();
        // if (data) {
        //   if (!data.year || data.year.toString().length < 4) {
        //     data.year = new Date().getFullYear();
        //   }
        //   if (!data.month) {
        //     data.month = new Date().getMonth()
        //   }
        //   self.value = data.year.toString().padStart(4, '0') + '-' + data.month.toString().padStart(2, '0') + '-01';
        //   self.$refs.popupSelectDate.close();
        // }
      },
      getUrl(url) {
        const self = this;
        var currentUrl = new URL(window.location.href);
        if (self.target == 'cordova') {
          return '/' + url;
        }
        return currentUrl.pathname + ('#!/' + url);
      },
      getPathExpediente(planificacion) {
        const self = this;
        if (self.target == 'cordova'){
          if (planificacion.estado == "PLANIFICADA"){
            return 'inspecciones-offline/' + planificacion.idExpediente + '/';
          } else{
            return 'inspecciones/view-offline/' + planificacion.idExpediente + '/';
          }
        }
        return 'inspecciones/view/' + planificacion.idExpediente + '/';
      },
      getMinutesHumanize(minutes, withDays = true) {
        let duration = moment.duration(minutes, 'minutes');
        let str = "";
        if (duration.days() > 0 && withDays) {
          str += `${duration.days()} días `;
        }
        let horas = duration.hours();
        if (!withDays) {
          horas = horas + (duration.days() * 24);
        }
        if (horas > 0) {
          str += `${horas}h `;
        }
        str += `${duration.minutes()}min`;
        return str;
      },
      onCerrarDetalle() {
        this.cerrarDetalleDelDia();
      },
      /**
       * #59 · **Cerrar el detalle del día es esto, y solo esto.** El único sitio por el que el
       * detalle se va de la pantalla: lo cierra, suelta lo que enseñaba y descarta lo que tuviera
       * en vuelo.
       *
       * Estaba repartido en siete sitios, cada uno apagando los campos que recordaba —unos solo
       * `selectedOpen`, otros también el evento, ninguno la solicitud de vacaciones ni su
       * petición—, y por eso el detalle era lo único de la pantalla que no colgaba de «lo que hay
       * en pantalla ahora»: al cambiar de persona o de semana la rejilla se vaciaba y el menú del
       * día se quedaba ahí, **con Aprobar y Denegar puestos sobre la solicitud de la persona
       * anterior**. Decidido por Dirección el 04/10/2026 (opción 1): si lo que se mira ya no es de
       * quien se miraba, el detalle se cierra; no hay caso en que convenga dejar un botón de
       * aprobar sobre una solicitud que ya no está en pantalla.
       *
       * El token `diaAbierto` sube aquí: es lo que impide que una espera o una respuesta del día
       * que acaba de cerrarse escriba en el que se abra después, lo que corta la apertura
       * diferida de `showEvent` si entre el clic y el fotograma se cambió de persona, y lo que
       * descarta un Aprobar o un Denegar confirmado en un diálogo que llevaba rato abierto.
       *
       * Queda un camino que **no** pasa por aquí y es a propósito: el `v-model` del menú, que baja
       * `selectedOpen` cuando se pulsa fuera. Lo que el detalle enseña solo se puede ver mientras
       * está abierto, y al abrir el siguiente día `cargarSolicitudDelDia` lo rehace entero, así
       * que ahí no queda nada a la vista de antes. Meter la limpieza en un `watch` de
       * `selectedOpen` sí se intentó y no vale: `showEvent` cierra y vuelve a abrir para pasar de
       * un evento a otro, y el `watch` —que corre después de preparar el día nuevo— se llevaría
       * por delante justo esa preparación.
       */
      cerrarDetalleDelDia() {
        const self = this;
        self.selectedOpen = false;
        self.selectedEvent = {};
        self.selectedElement = null;
        self.readOnlyPlanif = true;
        self.diaAbierto++;
        self.carrilSolicitudDia.invalidar();
        self.carrilFechaTarea.invalidar();
        self.solicitudDelDia = null;
        self.cargandoSolicitudDia = false;
        self.errorSolicitudDia = false;
        self.papeleraDia = null;
        self.papeleraPedida++;
        self.errorEquipoDia = false;
        self.detalleDiaEsMio = false;
        self.detalleDiaEsDeMiEquipo = false;
        self.detalleDiaDe = null;
        self.fechaCreacionTarea = null;
      },
      getColorBadgeEstado(event) {
        let color = "gray";
        if (event.planificacion && event.planificacion.estado) {
          switch (event.planificacion.estado) {
            case "PLANIFICADA":
              color = "blue";
              break;
            case "REALIZADA":
              color = "teal";
              break;
          }
        }
        return color;
      },
      getColorBadgeEstadoExpediente(estado) {
        let color = "gray";
        if (estado) {
          switch (estado) {
            case "GENERADO":
              color = "lime";
              break;
            case "INSPECCIONADO":
              color = "green";
              break;
            case "PLANIFICADO":
              color = "blue";
              break;
            case "AUDITADO":
              color = "teal";
              break;
            case "PDTE_FACTURAR":
              color = "purple";
              break;
            case "PDTE_CONFORMIDAD":
              color = "deeppurple";
              break;
            case "PDTE_ENVIO":
              color = "yellow";
              break;
            case "ENVIADO":
              color = "orange";
              break;
            case "CANCELADO":
              color = "red";
              break;
            case "PENDIENTE_REVISION_CALIDAD":
              color = "pink";
              break;
            case "CORREGIR_ERRORES_AUDITORIA_CALIDAD":
              color = "darkblue";
              break;
            case "PENDIENTE_FIRMA_INSPECTOR":
              color = "deeppurple";
              break;
            case "FIRMADO_INSPECTOR":
              color = "lightblue";
              break;
          }
        }
        return color;
      },
      getTextEstadoExpediente(estado) {
        let text = "No definido";
        if (estado) {
          switch (estado) {
            case "GENERADO":
              text = "Creado";
              break;
            case "INSPECCIONADO":
              text = "Inspeccionado";
              break;
            case "PLANIFICADO":
              text = "Planificado";
              break;
            case "AUDITADO":
              text = "Auditado";
              break;
            case "PDTE_FACTURAR":
              text = "Pdte. Facturar";
              break;
            case "PDTE_CONFORMIDAD":
              text = "Pdte. Confirmar";
              break;
            case "PDTE_ENVIO":
              text = "Pdte. Envío";
              break;
            case "ENVIADO":
              text = "Enviado";
              break;
            case "CANCELADO":
              text = "Cancelado";
              break;
            case "PENDIENTE_REVISION_CALIDAD":
              text = "Pdte. de revisión (calidad)";
              break;
            case "CORREGIR_ERRORES_AUDITORIA_CALIDAD":
              text = "Corregir errores (calidad)";
              break;
            case "PENDIENTE_FIRMA_INSPECTOR":
              text = "Pdte. de firma";
              break;
            case "FIRMADO_INSPECTOR":
              text = "Certificado firmado";
              break;
          }
        }
        return text;
      },
      guardarCambios() {
        var self = this;
        var lineaPlan = self.selectedEvent;
        // #49 · el cierre del detalle: aquí no se guarda una vacación ni un festivo generado, venga
        // el guardado del botón «Guardar» o de «Marcar como realizada». Los v-if de los botones
        // dependen además de `readOnlyPlanif`, que es estado de la PANTALLA y sobrevive de un evento
        // a otro; esto no.
        //
        // Y se DICE, no se calla: callarse dejaba en pantalla los valores que se acababan de teclear
        // —el estado, el día, el check de pendiente de confirmar— como si se hubieran guardado. Se
        // cierra el detalle y se releen las planificaciones para que lo que se vea sea lo que hay de
        // verdad en el servidor. Con el interruptor apagado no cambia nada.
        if (lineaPlan && self.avisarSiBloqueado(lineaPlan.planificacion)) {
          return;
        }
        if (lineaPlan.anadirInspector) {
          lineaPlan.planificacion.inspectores.push({username: lineaPlan.anadirInspector, rol:(lineaPlan.rolInspector?lineaPlan.rolInspector:'INSPECTOR') })
        }
        var data = {lineas: [lineaPlan.planificacion]};
        Planificacion.save({
          data: data,
          itemId: null
        }).then(function(res) {

        }).catch(function(e) {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
          self.errors = e.errors || {};
        }).finally(function(res) {
          // self.selectedEvent = {};
          self.getPlanificaciones();
        });
      },
      onSaveCrear () {
        const self = this;
        const app = self.$f7;
        // #268 · el alta es UNA acción desde que se pulsa Guardar hasta que el servidor contesta o
        // se abandona, y lo que necesita se toma en ese clic: la sesión, la pantalla, el cerrojo,
        // el borrador y la persona. Entre el clic y el POST caben dos consultas y, si es una
        // vacación, un aviso que espera a una persona sin tope, y cada cosa que se leía al
        // continuar era un hueco: otra cuenta (ronda 3), un segundo Guardar, el error de la
        // consulta enseñado a otra cuenta y la persona cambiada en el selector (ronda 4 de la
        // revisión CODEX del PR #1842). Lo lleva `accionDeLaSesion`, el mismo sitio que los
        // diálogos de aprobar, denegar y anular, para que no quede ningún paso que lo olvide.
        // Y el popup: es el formulario del alta, y cerrarlo —también deslizándolo con la consulta en
        // vuelo, cuando el preloader ya se ha ido— es cancelarla (revisión CODEX del PR #1842).
        const popup = self.$refs.popupCrear;
        const accion = accionDeLaSesion(self, CLAVE_ALTA_DEL_CALENDARIO, {
          sigueAbierto: function() { return self.popupCrearOpened && self.$refs.popupCrear === popup; },
          avisoCerrado: 'vacacionAMano.formularioCerrado'
        });
        if (!accion.empezar()) return undefined;
        self.altaEnCurso = accion;
        const crearPlani = self.borradorDelAlta();
        // #49 · el cierre del alta, igual que `guardarCambios` es el del detalle. El desplegable ya
        // no ofrece T0006 con el interruptor encendido (`show-item`), pero la validación del campo
        // solo exige que haya un `id`: esto cierra el formulario, no la pantalla. Con el interruptor
        // apagado no cambia nada.
        const tipoTarea = crearPlani.tarea && crearPlani.tarea.tipo;
        if (tipoTarea && !self.esTipoTareaSeleccionable(tipoTarea)) {
          accion.terminar();
          app.dialog.alert(self.mensajeTipoNoSeleccionable());
          return undefined;
        }
        // #49 · el popup tiene DOS caminos hacia una tarea y el de arriba solo cubre uno. El panel
        // «Crear Tarea» elige el tipo en un desplegable —eso es `tarea.tipo`—, pero el panel
        // «Tarea» escribe a mano el código de una tarea que YA existe, y por ahí se colaba una
        // T0006 de las cargadas a mano. Este sí cuesta una consulta, así que solo se pregunta con el
        // interruptor encendido.
        return self.tareaExistenteBloqueada(crearPlani.codigoTarea).then(function(bloqueada) {
          if (bloqueada) return { bloqueada: true };
          // #268 · antes de poner a mano una vacación, el aviso, y no después de guardar: es lo
          // único que separa el camino viejo del nuevo. No bloquea —quien lo necesite sigue
          // pudiendo—, pero no se puede guardar sin haberlo tenido delante.
          return self.altaEsDeVacaciones(crearPlani).then(function(esVacacion) {
            return { esVacacion: esVacacion };
          });
        }).then(accion.continuar(function(comprobado) {
          if (comprobado.bloqueada) {
            accion.terminar();
            app.dialog.alert(MENSAJE_BLOQUEO_VACACIONES);
            return;
          }
          // #271 · con el camino manual apagado, una vacación no sale de aquí por ninguno de los dos
          // caminos del popup: ni el tipo elegido —el desplegable ya no lo ofrece— ni el código de
          // una T0006 que ya existía escrito en «Tarea». Se dice por qué y no se manda: el servidor
          // la rechazaría con el mismo texto.
          if (comprobado.esVacacion && self.caminoManualApagado) {
            accion.terminar();
            app.dialog.alert(self.textoCaminoManualCerrado());
            return;
          }
          const guardar = accion.sellar(function() { self.guardarAlta(crearPlani, accion, popup); });
          if (!comprobado.esVacacion) {
            guardar();
            return;
          }
          self.confirmarVacacionAMano(accion, guardar);
        }), accion.continuar(function() {
          // Sin saber si es una vacación no se guarda: el POST puede ir bien aunque la búsqueda
          // haya fallado, y entonces la vacación entraría sin el aviso. El popup sigue abierto
          // con lo escrito, así que reintentar es volver a pulsar Guardar (revisión del PR #1842).
          accion.terminar();
          app.dialog.alert(self.$t('vacacionAMano.comprobacionError'));
        }));
      },
      /**
       * #268 · Cerrar «Crear planificación» abandona el alta que no haya salido todavía y suelta su
       * cerrojo, para que reabrirlo no diga que hay otra en marcha. La que ya ha salido no se toca:
       * `terminar` no suelta lo que es del envío. Lo que impide que la abandonada se guarde es su
       * `sigueAbierto`; esto libera lo que tenía cogido y, desde la #271, cierra también su aviso de
       * vacación a mano si seguía abierto (`accionDeLaSesion`).
       */
      onPopupCrearCerrado() {
        this.popupCrearOpened = false;
        if (this.altaEnCurso) {
          this.altaEnCurso.terminar();
          this.altaEnCurso = null;
        }
      },
      /**
       * #268 · Lo que se va a dar de alta, tomado al pulsar Guardar: el formulario y la persona para
       * la que se abrió. No `inspectorFiltro`, que es el selector de ahora y puede haber cambiado
       * mientras se buscaba la tarea o se leía el aviso (revisión CODEX del PR #1842, ronda 4).
       * Una copia, para que el formulario no cambie al guardar.
       */
      borradorDelAlta() {
        const formData = this.$refs.rformCrear.formData;
        const borrador = Object.assign({}, formData, {
          inspectores: [{username: this.inspectorDelAlta, rol: 'INSPECTOR'}]
        });
        if (formData.inspeccionSinPedido) {
          borrador.inspeccionSinPedido = Object.assign({}, formData.inspeccionSinPedido,
            { horaInicio: formData.FechaVisita });
        }
        return borrador;
      },
      /**
       * El guardado del popup «Crear planificación», una vez pasados los cierres de `onSaveCrear`.
       * #268 · lo que viene después del POST —cerrar el popup, el error, recargar— es de la sesión
       * y de la pantalla que lo empezaron: `accion.enviar` no se lo enseña a otra cuenta. Y el
       * popup que se cierra es el del alta, no el que haya abierto ahora.
       */
      guardarAlta(crearPlani, accion, popup) {
        const self = this;
        const app = self.$f7;

        return accion.enviar(Planificacion.save({
          data: crearPlani,
          itemId: null
        }), {
          exito: function() {
            if (popup && self.$refs.popupCrear === popup) popup.close();
          },
          fallo: function(e) {
            if (typeof e == "string") {
              e = {
                message: e
              };
            }
            app.dialog.alert(e.message);
            self.errors = e.errors || {};
          },
          pantalla: function() {
            self.getPlanificaciones();
          }
        });
      },
      /**
       * #268 · ¿Lo que se va a dar de alta es una vacación? Por los DOS caminos del popup, como el
       * cierre de la #49: el tipo elegido en «Crear Tarea» o la tarea ya existente cuyo código se ha
       * escrito en «Tarea». El segundo cuesta una consulta y solo se hace si hay código.
       *
       * Ante un fallo de esa consulta la promesa se rechaza, y no resuelve `false` como el cierre de
       * la #49: allí quien bloquea de verdad es el servidor, pero el aviso de aquí no lo da nadie
       * más, y darlo por «no es vacaciones» dejaba poner una sin haberlo visto (revisión del PR
       * #1842). Es `onSaveCrear` quien decide qué hacer con el rechazo.
       */
      altaEsDeVacaciones(crearPlani) {
        const self = this;
        if (self.esTipoVacaciones(crearPlani && crearPlani.tarea && crearPlani.tarea.tipo)) {
          return Promise.resolve(true);
        }
        const codigo = crearPlani && crearPlani.codigoTarea != null ? String(crearPlani.codigoTarea).trim() : '';
        if (!codigo) return Promise.resolve(false);
        return Tarea.getList({
          projection: 'codigo,tipo',
          filter: { andList: [{ nombre: 'codigo', valor: self.escaparRegex(codigo), operacion: 'EQUALS_IGNORE_CASE' }] }
        }, true).then(function(res) {
          const tareas = (res && res.list) || [];
          return tareas.some(function(tarea) { return self.esTipoVacaciones(tarea.tipo); });
        });
      },
      /** #268 · ¿Es T0006 este tipo de tarea? Por el código, como `esDiaDeVacaciones`. */
      esTipoVacaciones(tipo) {
        return !!(tipo && tipo.codigo == 'T0006');
      },
      /**
       * #268 · El texto del aviso: que esto no es pedirlas, qué le pasa al día y dónde está el
       * mecanismo oficial. «Dónde» depende de si esta persona llega a «Mis vacaciones» (§9: no se
       * señala un sitio al que no puede entrar), y quien puede registrar en nombre de otra persona
       * (#70) se entera de que esa es su vía.
       */
      textoAvisoVacacionAMano() {
        const self = this;
        const partes = [self.$t('vacacionAMano.aviso'),
          self.$t(self.puedeAbrirVacaciones ? 'vacacionAMano.dondeOficial' : 'vacacionAMano.dondeOficialSinAcceso')];
        if (self.puedeAbrirVacaciones && PermisosVacaciones.registrarEnNombreDe()) {
          partes.push(self.$t('vacacionAMano.enNombreDeOtro'));
        }
        return partes.join(' ');
      },
      /**
       * #268 · La pregunta antes de guardar una vacación a mano, con botones propios: `confirm`
       * rotularía los suyos en inglés. «Cancelar» primero y la acción después, como el resto de
       * preguntas de la pantalla. Y la salida buena, como botón, cuando se puede entrar en ella.
       *
       * #271 · La abre `accionDeLaSesion` (`abrir`), que es su dueña: sella los dos botones que
       * hacen algo con la sesión que empezó el alta —el diálogo queda por encima de todo, también
       * del login—, deja aceptar uno solo y, si se cierra sin ponerla —«Cancelar», Escape, salir de
       * la pantalla o cerrar sesión—, abandona el alta y suelta su cerrojo. Aquí ya no se escucha
       * su cierre.
       */
      confirmarVacacionAMano(accion, continuar) {
        const self = this;
        const botones = [{ text: self.$t('vacacionAMano.cancelar'), keyCodes: [27] }];
        if (self.puedeAbrirVacaciones) {
          botones.push({
            text: self.$t('vacacionAMano.irAMisVacaciones'),
            onClick: function() { self.irAMisVacacionesDesdeElAlta(); }
          });
        }
        botones.push({ text: self.$t('vacacionAMano.ponerlaIgualmente'), bold: true, onClick: continuar });
        accion.abrir({
          title: self.$t('vacacionAMano.avisoTitulo'),
          text: self.textoAvisoVacacionAMano(),
          buttons: botones,
          verticalButtons: true
        });
      },
      /** #268 · Del popup de alta a «Mis vacaciones», sin dejar el popup abierto detrás. */
      irAMisVacacionesDesdeElAlta() {
        const self = this;
        if (self.$refs.popupCrear) self.$refs.popupCrear.close();
        self.$f7router.navigate('/vacaciones/');
      },
      /**
       * #268 · ¿Es esta planificación una vacación puesta a mano desde el calendario? Lo dice el
       * servidor con `vacacionAMano`, que solo pone él al crear el día; las puestas antes de la #268
       * no lo llevan y se pintan como siempre.
       */
      esVacacionAMano(plani) {
        return !!(plani && plani.vacacionAMano === true && this.esDiaDeVacaciones(plani));
      },
      /**
       * #268 · Las cuatro ausencias del módulo de RH (`TipoAusencia` de movilidad): la misma lista
       * que `PlanificacionServiceImpl.esAusencia`, con la que el servidor las aparta de sus barridos.
       */
      esAusenciaDeRh(plani) {
        return !!(plani && plani.tipo === 'TAREA' && plani.tipoTarea
          && ['T0006', 'T0083', 'T0084', 'T0085'].indexOf(plani.tipoTarea.codigo) >= 0);
      },
      /**
       * #268 · Pregunta al servidor si la papelera alcanza a este día de vacaciones. Lo que conteste
       * solo vale para la última petición: si entretanto se ha abierto otro evento —o se ha cerrado
       * el detalle—, la respuesta se tira.
       *
       * Por un token de la petición y no comparando con `selectedEvent`: `showEvent` llama aquí
       * antes de poner el evento nuevo, que llega dos fotogramas después, y una respuesta que
       * llegaba en ese hueco se comparaba con el evento ANTERIOR y se tiraba siendo buena. El día
       * se quedaba sin papelera ni mensaje (revisión del PR #1842).
       */
      pedirPapeleraDia(plani) {
        const self = this;
        self.papeleraDia = null;
        // Sube también cuando no hay nada que pedir: la respuesta pendiente del evento anterior
        // tampoco vale para este.
        const miPeticion = ++self.papeleraPedida;
        if (!self.esDiaDeVacaciones(plani) || !plani.id || self.bloqueoVacaciones) return;
        const id = plani.id;
        const sigueAbierto = function() {
          return miPeticion === self.papeleraPedida;
        };
        RhVacaciones.papelera(id).then(function(res) {
          if (!sigueAbierto()) return;
          self.papeleraDia = { id: id, borrable: res.borrable, motivo: res.motivo, error: false };
        }).catch(function() {
          if (!sigueAbierto()) return;
          self.papeleraDia = { id: id, borrable: false, motivo: null, error: true };
        });
      },
      /** #268 · ¿Contestó el servidor que este día de vacaciones se puede borrar? */
      papeleraDeVacacionesPermitida(plani) {
        const p = this.papeleraDia;
        return !this.bloqueoVacaciones && !!plani && !!p && p.id === plani.id && p.borrable === true;
      },
      /**
       * #268 · ¿Se dibuja la papelera de este evento? En un día de vacaciones, cuando el servidor
       * dice que se puede borrar —los puestos a mano sí y sin mirar el rol; los de una solicitud
       * nunca, se anulan desde Vacaciones— y el interruptor de la #49 está apagado. En el resto, lo
       * de siempre: `esEventoBloqueado`. Lápiz, arrastre y «Marcar como realizada» no cambian: la
       * #268 solo abre la papelera.
       */
      papeleraVisible(plani) {
        if (this.esDiaDeVacaciones(plani)) return this.papeleraDeVacacionesPermitida(plani);
        return !this.esEventoBloqueado(plani);
      },
      /**
       * #268 · Lo que se dice en lugar de la papelera de un día de vacaciones, o '' si no hay nada
       * que decir: la papelera está, o todavía no se sabe.
       */
      motivoSinPapelera(plani) {
        if (!this.esDiaDeVacaciones(plani) || this.papeleraDeVacacionesPermitida(plani)) return '';
        if (this.bloqueoVacaciones) return MENSAJE_BLOQUEO_VACACIONES;
        const p = this.papeleraDia;
        if (!p || p.id !== plani.id) return '';
        if (p.error) return this.$t('vacacionAMano.papeleraError');
        return p.motivo || '';
      },
      /**
       * #268 · El cierre de la papelera. En un día de vacaciones, el mismo criterio con el que se
       * dibuja; en el resto, el de la #49. Si se corta, lo dice, como `avisarSiBloqueado`.
       */
      avisarSiNoSeBorra(plani) {
        const self = this;
        if (!self.esDiaDeVacaciones(plani)) return self.avisarSiBloqueado(plani);
        if (self.papeleraDeVacacionesPermitida(plani)) return false;
        self.$f7.dialog.alert(self.motivoSinPapelera(plani) || MENSAJE_BLOQUEO_VACACIONES);
        self.onCerrarDetalle();
        self.getPlanificaciones();
        return true;
      },
      onSaveAsociar () {
        const self = this;
        const app = self.$f7;
        var asociarPlani = self.$refs.rformAsociar.formData;
        // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        var asociacion = {
          idExpediente: asociarPlani.idExpediente,
          numeroOCodigoPedido: asociarPlani.numeroOCodigoPedido,
          numeroLineaPedido: asociarPlani.numeroLinea
        };
        espera.mostrar();
        Inspeccion.asociarPedido(asociacion).then(res => {
          self.$refs.popupAsociar.close();
          app.dialog.alert("Asociación realizada con éxito");
          // app.$f7.views.current.router.navigate('/ofertas/view/' + rform.formData.idOferta + '/')
          // return res;
        }).catch(e => {
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          app.dialog.alert(e.message);
        }).then(function(){
          espera.cerrar();
          self.getPlanificaciones();
        });
      },
      borrarEvento (evento) {
        var self = this;
        var i = self.events.indexOf(self.evento);
        self.events.splice(i, 1);
        self.cerrarDetalleDelDia();
      },

      borrarPlanificacion(plani) {
        var self = this;
        const app = self.$f7;
        // #49 · el tercer camino por el que el calendario escribe, cerrado como `guardarCambios` y
        // `endDrag`. Se comprueba ANTES de preguntar, para no sacar un diálogo de confirmación de
        // algo que va a cortarse. No hace falta repetirlo dentro del callback —aunque en medio haya
        // un diálogo esperando a una persona—: `bloqueoVacaciones` llega resuelto desde la barrera de
        // la ruta y no cambia mientras el calendario está en pantalla.
        if (self.avisarSiNoSeBorra(plani)) {
          return;
        }
        // #268 · la papelera vuelve a alcanzar a las vacaciones puestas a mano, y sin mirar el rol:
        // el «¿Está seguro?» lleva dentro la sesión que lo abrió, como el aviso del alta, para que
        // otra cuenta no borre lo que eligió la anterior (regla de la #59; revisión CODEX del PR
        // #1842, ronda 3). Vale igual para cualquier evento: para la misma sesión no cambia nada.
        const inspector = self.inspectorFiltro;
        const accion = accionDeLaSesion(self, CLAVE_BORRADO_DEL_CALENDARIO + plani.id);
        accion.confirmar(
          "¿Está seguro que desea desplanificar este evento para el empleado " + inspector + " ?",
          "Advertencia",
          function() {
            if (plani.esQuedada == null) {
              plani.esQuedada = false;
            }
            accion.enviar(Planificacion.borrarInspector({data: {inspector: inspector, idPlani: plani.id, idPedido: plani.idPedido, numeroLinea: plani.numLinea, esQuedada: plani.esQuedada}}), {
              exito: function() {
                app.dialog.alert("Planificación para el empleado " + inspector + " borrada correctamente.");
              },
              fallo: function(e) {
                if (typeof e == "string") e = { error: e };
                let error = e.message || e.error || e.error_description;
                app.dialog.alert(error);
              },
              pantalla: function() {
                self.getPlanificaciones();
              }
            });
          }
        )
      },
      borrarFichaje(idFichaje) {
        const self = this;
        const app = self.$f7;
        app.dialog.confirm(
          'Si elimina un registro, se eliminará el rango completo de Entrada y Salida, ¿esta seguro?',
          "Eliminar",
          function () {
            Fichaje.delete({ itemId: idFichaje }).then(function (res) {
              if (res) {
                app.dialog.alert("Fichaje borrado correctamente.");
                self.getPlanificaciones();
              }
            }).catch(function (error) {
              app.dialog.alert(error.message);
            });
          }
        );
      },
      /**
       * #58 · Si una planificación es un día de vacaciones (T0006). Es el mismo criterio con el
       * que el módulo los escribe y con el que los leen los seis lectores de ausencias: el código
       * del tipo de tarea. No se mira el nombre, que se puede cambiar desde el catálogo.
       */
      esDiaDeVacaciones(plani) {
        return !!(plani && plani.tipoTarea && plani.tipoTarea.codigo == 'T0006');
      },
      /** «08:00». Se saca de la hora de inicio de la propia planificación, no de un literal. */
      horaDe(plani) {
        if (!plani || !plani.horaInicio) return '';
        const d = new Date(plani.horaInicio);
        if (isNaN(d.getTime())) return '';
        return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
      },
      /** #1133 · A ACEL PLANIFICACIÓN, la pantalla de trabajo de las planificadoras. */
      irAAcelPlanificacion() {
        this.$f7router.navigate(RUTA_CONTROL_PLANIFICACION);
      },
      /**
       * #58 · A «Mis vacaciones». Pedir, anular y ver el saldo se hacen allí, no aquí.
       *
       * #59 · Y si lo que se está mirando es el calendario de alguien a quien se aprueba, lleva a
       * la **bandeja**, que es donde están sus solicitudes: el botón VACACIONES de la barra abre
       * «la ventana de esa persona», y la ventana de esa persona, para quien la aprueba, es la
       * pestaña Pendientes con sus acciones. Llevarle a «Mis vacaciones» desde el calendario de
       * otro sería cambiarle de persona sin avisar.
       */
      irAVacaciones() {
        const self = this;
        // El destino depende de DOS respuestas, y hasta ahora solo se esperaba una. Se esperaba a
        // `/mi-equipo` —pulsado nada más entrar, `apruebaA` decía que no por no haber llegado y al
        // aprobador se le abría «Mis solicitudes»—, pero no a la agenda, y `duenioEventos` no se
        // escribe hasta que ella contesta: pulsar «Vacaciones» nada más abrir el calendario de
        // otra persona preguntaba `apruebaA(null)`, que es `false`, y llevaba otra vez a las
        // solicitudes propias (revisión CODEX del PR #1735, ronda 5).
        self.conQuienSeMira(function() {
          if (!self.esMiCalendario && self.apruebaA(self.duenioEventos)) {
            self.$f7router.navigate('/vacaciones/?pestana=PENDIENTES');
            return;
          }
          self.$f7router.navigate('/vacaciones/');
        }, function() {
          // Y si no se sabe de quién es este calendario ni a quién se aprueba, **no se navega**:
          // las dos salidas de arriba llevan a sitios distintos y elegir sin saberlo es abrir las
          // solicitudes de otra persona. Se dice y se puede volver a intentar; el reintento vuelve
          // a preguntar lo que faltaba (ver `conDuenioDeLaAgenda` y `conMiEquipo`).
          self.$f7.dialog.confirm(
            self.$t('bandejaVacaciones.errorAbrirVacaciones'),
            self.$t('bandejaVacaciones.titulo'),
            function() { self.irAVacaciones(); }
          );
        });
      },
      /**
       * #59 · **La puerta de lo que depende de a quién se está mirando.** Ejecuta `hacer` cuando
       * se sabe lo que hace falta para responderlo: de quién es la agenda que hay en la rejilla
       * (`duenioEventos`) y, **solo si no es la propia**, a quién aprueba este usuario
       * (`/mi-equipo`).
       *
       * Son dos esperas distintas y la primera ya tenía su portero; faltaba la segunda, y por eso
       * el fallo volvió a salir en el mismo botón una ronda después. Juntas aquí, quien decide no
       * tiene que acordarse de ninguna de las dos.
       *
       * **Y se espera por lo que decide, no por las dos siempre.** Primero el dueño y después el
       * equipo, porque en el calendario propio a quién se aprueba no cambia la respuesta: pedirlo
       * ahí era retrasar la decisión sin motivo y, con `/mi-equipo` colgado, no tomarla nunca.
       * `esMiCalendario` sale de `duenioEventos`, así que esto solo se puede preguntar después de
       * `conDuenioDeLaAgenda` (revisión CODEX del PR #1735, ronda 9).
       */
      conQuienSeMira(hacer, siNoSeSabe) {
        const self = this;
        self.conDuenioDeLaAgenda(function() {
          if (self.esMiCalendario) {
            hacer();
            return;
          }
          self.conMiEquipo(hacer, siNoSeSabe);
        }, siNoSeSabe);
      },
      /**
       * #59 · Ejecuta `hacer` cuando la rejilla ya dice de quién es.
       *
       * «Ya lo dice» es que `duenioEventos` sea el del empleado que se está mirando: mientras la
       * carga de otro está en vuelo, lo que hay escrito es del anterior.
       *
       * Si mientras se esperaba se pidió otra agenda —se cambió de empleado— se espera también a
       * esa: la que se estaba esperando ya se descartó por caducada en el carril y no ha escrito
       * nada. Cada vuelta espera a una petición distinta, así que esto termina en cuanto el
       * usuario deja de cambiar de persona.
       *
       * **Y si la agenda no llega, no se decide.** Antes se seguía adelante «con lo que se sepa»,
       * dando por bueno que la rejilla vacía y `apruebaA(null)` eran el lado seguro: no lo son
       * cuando lo que cuelga de esto es a dónde lleva un botón. Con la agenda caída, el botón
       * VACACIONES del calendario de otra persona abría las solicitudes **propias** sin decir que
       * algo había fallado — el mismo fallo silencioso que el criterio de dirección del 04/10/2026
       * cerró para `/mi-equipo`, por el otro camino de la misma puerta. Ahora se termina en error
       * con reintento (`noSeSabeQuien`).
       *
       * Y el reintento puede salir bien: si no hay ninguna carga en camino que vaya a decir de
       * quién es la rejilla —porque nunca se pidió, o porque la última falló— se **pide** aquí. Un
       * «volver a intentarlo» que no vuelve a preguntar nada no es un reintento.
       */
      conDuenioDeLaAgenda(hacer, siNoSeSabe) {
        const self = this;
        if (self.esLaAgendaDeQuienSeMira()) {
          hacer();
          return;
        }
        if (!self.promesaAgenda) {
          // Sin empleado en el campo «Empleado» no hay agenda que pedir, y `getPlanificaciones`
          // se queda en su aviso sin contestar nunca: aquí se termina, no se espera a nadie.
          if (!self.inspectorFiltro) {
            self.noSeSabeQuien(siNoSeSabe);
            return;
          }
          self.getPlanificaciones().catch(function() {
            // Aquí no hay nada que hacer: el fallo de esta carga lo cuenta el carril con su
            // diálogo y lo recoge la espera de abajo, al ver que la rejilla sigue sin dueño. Se
            // recoge solo para que el rechazo no quede suelto ensuciando la consola.
          });
          if (!self.promesaAgenda) {
            self.noSeSabeQuien(siNoSeSabe);
            return;
          }
        }
        const esperada = self.promesaAgenda;
        const deLaSesion = identidadSesion();
        esperada.then(function() {
          // Si por el camino se ha cambiado de cuenta, esta espera no decide nada: ni se navega ni
          // se avisa. Lo que la esperaba era una acción de la cuenta anterior.
          if (!sigueLaSesion(deLaSesion)) return;
          if (self.promesaAgenda && self.promesaAgenda !== esperada) {
            self.conDuenioDeLaAgenda(hacer, siNoSeSabe);
            return;
          }
          if (self.esLaAgendaDeQuienSeMira()) {
            hacer();
            return;
          }
          self.noSeSabeQuien(siNoSeSabe);
        });
      },
      /** #59 · Si los días pintados son ya los del empleado que dice el campo «Empleado». */
      esLaAgendaDeQuienSeMira() {
        if (!this.duenioEventos) return false;
        if (!this.inspectorFiltro) return true;
        return this.mismoUsuario(this.inspectorFiltro, this.duenioEventos);
      },
      /**
       * #59 · **La única puerta** por la que se decide algo que dependa de a quién se aprueba.
       * Ejecuta `hacer` cuando `/mi-equipo` ya ha contestado, y ahora mismo si ya está —que es el
       * caso normal, porque se pide en `created`—.
       *
       * Lo que depende de `miEquipo` no puede decidirse con `null`: eso no es «no aprueba a
       * nadie», es «todavía no se sabe», y las dos cosas daban la misma respuesta. Esa confusión
       * salió en dos rondas seguidas de revisión en dos sitios distintos —el botón VACACIONES y
       * el detalle del día amarillo— y la segunda vez se intentó tapar volviendo a evaluar el día
       * abierto cuando llegaba la respuesta; tampoco bastaba, porque `showEvent` pide la solicitud
       * **antes** de marcar el detalle como abierto y esa reevaluación se perdía (revisión CODEX
       * del PR #1735, rondas 1 a 3). Así que ya no se decide y se corrige: se espera, y se espera
       * aquí.
       *
       * Si nadie ha pedido todavía el equipo, se pide: de esta función no se sale con un `false`
       * que signifique «no ha llegado». Y si el intento anterior **falló**, se vuelve a pedir —no
       * hay respuesta guardada que reutilizar—, con una sola petición en vuelo cada vez.
       *
       * **Y si la consulta falla, `hacer` no se ejecuta.** La promesa de `cargarMiEquipo` se
       * cumple también cuando la petición se cae, así que esperarla no es tener respuesta: quien
       * esperaba seguía adelante con `miEquipo` a `null`, clasificaba al empleado como no
       * aprobable y navegaba o abría el día como si el servidor hubiera contestado que no aprueba
       * a nadie. Un fallo que se comporta como un éxito (revisión CODEX del PR #1735 y criterio de
       * dirección del 04/10/2026: la acción que esperaba termina en error con reintento, no en
       * éxito, y no se resuelve con un equipo desconocido). Lo que dice si hubo respuesta es
       * `miEquipo`, y es lo que se mira aquí.
       *
       * `siNoSeSabe` es ese final en error. Quien decide algo con el equipo tiene que decir qué
       * hacer cuando no se sabe; si no lo dice, `noSeSabeQuien` lo avisa de todas formas, pero la
       * decisión no se toma.
       */
      conMiEquipo(hacer, siNoSeSabe) {
        const self = this;
        if (self.miEquipo) {
          hacer();
          return;
        }
        const deLaSesion = identidadSesion();
        (self.promesaMiEquipo || self.cargarMiEquipo()).then(function() {
          // Igual que en `conDuenioDeLaAgenda`: con otra cuenta dentro, lo que esperaba por el
          // equipo era de la anterior y no se resuelve ni en éxito ni en error.
          if (!sigueLaSesion(deLaSesion)) return;
          if (self.miEquipo) {
            hacer();
            return;
          }
          self.noSeSabeQuien(siNoSeSabe);
        });
      },
      /**
       * #59 · **El final en error de una decisión que no se puede tomar**, en un solo sitio.
       *
       * Las dos puertas de espera —`conMiEquipo` y `conDuenioDeLaAgenda`— acaban aquí cuando la
       * respuesta que necesitaban no ha llegado. Lo que NO se hace es seguir adelante con lo que
       * se sepa: eso es lo que convertía un corte de red en una navegación a las solicitudes
       * equivocadas o en un día ajeno sin sus botones, sin que nadie se enterara de que algo había
       * fallado.
       *
       * Si el llamante dice cómo terminar, termina así —lo normal es un aviso con «volver a
       * intentarlo»—. Si no lo dice, se avisa igual: un tercer llamante que se olvide del segundo
       * argumento se queda sin reintento, no con una respuesta inventada.
       */
      noSeSabeQuien(siNoSeSabe) {
        if (siNoSeSabe) {
          siNoSeSabe();
          return;
        }
        this.$f7.dialog.alert(this.$t('bandejaVacaciones.errorNoSeSabeQuien'));
      },
      /**
       * #59 · Si este usuario aprueba las vacaciones de esa cuenta.
       *
       * Lo dice el **servidor** (`/rh/bandeja-vacaciones/mi-equipo`) y no se deduce del rol: el
       * permiso de aprobar no es un rol, es figurar como aprobador o suplente en la ficha de
       * alguien (D3), y eso el front no lo sabe. Mientras no haya contestado se responde `false`,
       * que es el lado seguro: enseñar botones que el servidor va a rechazar es peor que
       * enseñarlos un segundo más tarde.
       *
       * Comparación sin distinguir mayúsculas, el mismo criterio de username que el servidor: la
       * ERP guarda «JJCS» y el login llega «jjcs».
       *
       * **`todaLaPlantilla` cuenta por sí solo.** ADMIN y DIRECTOR aprueban sin figurar en
       * ninguna ficha (D3, D18) y el servidor se lo dice con esa marca. `personas` les llega
       * enumerada, pero con la **cuenta gestora** de cada persona (D-USR), y el calendario se abre
       * por la cuenta con la que esa persona trabaja, que puede ser la otra: ahí la lista no casa
       * y el día amarillo se quedaba sin Aprobar ni Denegar para quien puede aprobarlo todo. Lo
       * único que no levanta la marca es uno mismo: nadie aprueba sus propias vacaciones (D3).
       */
      apruebaA(username) {
        const self = this;
        if (!self.miEquipo || !username) return false;
        const buscado = self.comoUsername(username);
        const yo = (Utils.getUser() || {}).username;
        if (yo && self.comoUsername(yo) === buscado) return false;
        if (self.miEquipo.todaLaPlantilla) return true;
        return (self.miEquipo.personas || []).some(function(p) {
          return !!p.username && self.comoUsername(p.username) === buscado;
        });
      },
      /**
       * #59 · El `username` **en la única forma en la que esta pantalla lo compara y lo guarda**:
       * sin espacios y en mayúsculas, que es como lo guarda la ERP («JJCS») aunque el login llegue
       * en minúsculas («jjcs»).
       *
       * Estaba repetido —`esMiCalendario`, `apruebaA`, `claveDelCalendario`, dos `toUpperCase()`
       * sueltos en las cargas— y las opciones del desplegable «Empleado» se quedaron fuera, que es
       * justo donde se notó: el modelo del `v-select` se transformaba y sus opciones no, así que
       * el campo se vaciaba solo. Con una sola función no hay un sitio al que se le pueda olvidar.
       *
       * Lo que no es un nombre se devuelve tal cual: `null`, `undefined` y `''` significan «no hay
       * empleado» y los llamantes los distinguen de un nombre.
       */
      comoUsername(valor) {
        if (!valor) return valor;
        return String(valor).trim().toUpperCase();
      },
      /** #59 · Si dos `username` son de la misma cuenta, con el criterio de `comoUsername`. */
      mismoUsuario(uno, otro) {
        if (!uno || !otro) return false;
        return this.comoUsername(uno) === this.comoUsername(otro);
      },
      /**
       * #59 · De quién es aprobador este usuario. Se pide **una vez** al entrar en el calendario:
       * no cambia mientras se navega, y de ella dependen el selector «Empleado» y los botones del
       * día amarillo.
       *
       * **Un fallo no se guarda como respuesta.** Se dejaba `personas` vacío, que es un objeto con
       * valor, así que `conMiEquipo` daba la carga por hecha para siempre: un corte de red al
       * montar la pantalla le retiraba al aprobador el selector de su equipo y los botones de
       * aprobar durante toda la vida de la vista, sin error y sin nada que pulsar para volver a
       * intentarlo: en Cordova cambiar de empleado no navega, así que se quedaba así hasta salir
       * del calendario y volver a entrar (esta ruta no lleva `keepAlive`, que es lo único que
       * acotaba el daño). Ahora el fallo deja
       * la respuesta en «no se sabe» y suelta la promesa, así que la siguiente decisión que
       * necesite el equipo vuelve a pedirlo. `apruebaA` sigue contestando que no mientras no se
       * sepa, que es el lado seguro, y no hay tormenta de peticiones: solo se pide cuando alguien
       * necesita la respuesta y nunca hay dos en vuelo.
       *
       * Quien no aprueba a nadie **no** pasa por aquí: {@code /mi-equipo} le contesta con la lista
       * vacía, que es una respuesta y se guarda como tal.
       *
       * La promesa se guarda porque hay decisiones que **no pueden tomarse sin esta respuesta**:
       * quien las toma espera por `conMiEquipo`, que es el único sitio donde se espera.
       */
      cargarMiEquipo() {
        const self = this;
        // De qué sesión es esta respuesta. El equipo es de quien estuviera dentro al pedirlo: si se
        // cambia de cuenta mientras está en vuelo, guardarlo le daría a la cuenta nueva el selector
        // «Empleado» y los botones de Aprobar/Denegar de la anterior. Se descarta y se suelta la
        // promesa, así que la primera decisión de la cuenta nueva vuelve a preguntar por la suya.
        const deLaSesion = identidadSesion();
        // Mientras esta petición está en vuelo no hay fallo que enseñar: si la anterior falló, el
        // botón de reintentar desaparece hasta saber cómo acaba esta.
        self.falloMiEquipo = false;
        self.promesaMiEquipo = RhBandejaVacaciones.miEquipo()
          .then(function(res) {
            if (!sigueLaSesion(deLaSesion)) {
              self.miEquipo = null;
              self.promesaMiEquipo = null;
              return;
            }
            self.miEquipo = res || { personas: [] };
          })
          .catch(function() {
            self.miEquipo = null;
            // Un descarte por cambio de cuenta no es un fallo de esta sesión: lo que hay que
            // reintentar es la del usuario que esté dentro ahora, y eso lo pide su primera
            // decisión.
            self.falloMiEquipo = sigueLaSesion(deLaSesion);
            // Se suelta la promesa cumplida: si se quedara guardada, `conMiEquipo` esperaría por
            // una petición que ya terminó y no trajo nada, y volvería a no hacer nada.
            self.promesaMiEquipo = null;
            // El fallo NO se traga aquí: `miEquipo` a `null` es lo que `conMiEquipo` mira para
            // saber que no hubo respuesta y terminar en error quien estuviera esperando. Se
            // recoge en vez de rechazar porque a esta carga también se la llama sin esperarla
            // —en `created`—, y un rechazo sin recoger no avisa a nadie: ensucia la consola.
          });
        return self.promesaMiEquipo;
      },
      /**
       * #59 · **El reintento al alcance del dedo** cuando `/mi-equipo` falla al montar la pantalla.
       *
       * El reintento ya existía, pero colgado de las decisiones que esperan por `conMiEquipo`, y
       * en el **calendario propio de un aprobador sin ninguno de los seis roles que ven todo** no
       * quedaba ninguna que lo disparase: el campo «Empleado» solo se enseña con más de una opción
       * y sin equipo solo está él, así que no hay a quién cambiar; el botón VACACIONES no pregunta
       * por el equipo en el calendario propio a propósito (`conQuienSeMira`, ronda 9); y abrir un
       * día amarillo ajeno —que sí lo pediría— exige antes poder cambiar de empleado. El selector
       * se quedaba perdido hasta salir del calendario y volver a entrar (revisión CODEX del PR
       * #1735, ronda 1).
       *
       * Así que en el sitio del campo «Empleado» se pinta este botón mientras el fallo esté en pie.
       * No se reintenta solo: un `/mi-equipo` caído reintentado en bucle es una tormenta de
       * peticiones, y aquí quien decide cuándo volver a probar es quien está delante. La pantalla
       * de la bandeja ya lo tenía resuelto así —su «Recargar» de la barra—; este era el único sitio
       * del módulo donde el fallo retiraba un control sin dejar nada que pulsar.
       */
      reintentarMiEquipo() {
        const self = this;
        // Con una petición en vuelo no se lanza otra: `cargarMiEquipo` la sustituiría y las dos
        // escribirían sobre `miEquipo`.
        if (self.promesaMiEquipo) return;
        self.cargarMiEquipo().then(function() {
          // Si vuelve a fallar se dice, por el mismo sitio que lo dicen las esperas. Y si lo que
          // pasó es que se cambió de cuenta, no se dice nada: esa respuesta ya no era de nadie.
          if (self.miEquipo || !self.falloMiEquipo) return;
          self.noSeSabeQuien();
        });
      },
      /**
       * #59 · «21/12 – 30/12» de la solicitud entera, para decir a qué afecta el botón. Con varios
       * tramos se escriben los tramos («3/12 – 5/12 · 20/12 – 22/12») y no los dos extremos: desde
       * un día suelto no se ve cuáles son, y decir 3–22 cuando se piden seis días es afirmar un
       * periodo que nadie ha pedido. Lo compone `tramosSolicitud`, el mismo sitio que la bandeja.
       */
      fechasDeLaSolicitud(solicitud) {
        const self = this;
        return textoDeLasFechas(solicitud, function(iso) { return self.fechaCortaIso(iso); });
      },
      /**
       * «21/12». Se compone del texto ISO sin pasar por `Date`: un `LocalDate` llega como
       * «2026-12-21» y parsearlo lo movería un día según la zona del navegador.
       */
      fechaCortaIso(iso) {
        if (!iso) return '';
        const trozos = String(iso).substring(0, 10).split('-');
        return trozos.length === 3 ? trozos[2] + '/' + trozos[1] : String(iso);
      },
      /**
       * #59 · Si **esa** solicitud se está resolviendo ahora mismo, se haya pulsado aquí o en la
       * bandeja. Es lo que apaga Aprobar y Denegar del día amarillo y lo que enseña la frase que lo
       * explica (ver `unaAccionALaVez`).
       */
      resolviendose(solicitud) {
        return this.accionEnVueloSobre(claveDeSolicitud(solicitud && solicitud.id));
      },
      /**
       * #59 · Aprobar desde el día amarillo. Afecta a la **solicitud entera**, no al día que se ha
       * pulsado: es la misma acción y el mismo endpoint que el botón de la bandeja, sobre la misma
       * solicitud.
       */
      aprobarDesdeCalendario() {
        const self = this;
        const solicitud = self.solicitudDelDia;
        if (!solicitud) return;
        // De qué detalle es esta acción. El diálogo se queda esperando a una persona y en ese rato
        // la pantalla puede haber pasado a mirar a otra —y entonces el detalle se cerró—: resolver
        // después sería aprobar una solicitud que ya no está en pantalla.
        const miDia = self.diaAbierto;
        // Y de qué SESIÓN es. `diaAbierto` no lo cubre: destruir el componente al cerrar sesión no
        // lo incrementa, así que seguía casando y el POST salía con el token de la cuenta nueva
        // (revisión CODEX del PR #1735, ronda 4). Lo sella `accionDeLaSesion`, el mismo sitio por
        // el que pasan los diálogos de la bandeja y el de anular.
        //
        // Y de qué SOLICITUD es, que es de lo que se coge el cerrojo: con una resolución de ésta
        // en vuelo —se haya pulsado aquí o en la bandeja— no se abre otra, y eso lo decide
        // `accionDeLaSesion` y no un `if` de esta pantalla.
        const accion = accionDeLaSesion(self, claveDeSolicitud(solicitud.id));
        accion.confirmar(
          self.$t('bandejaVacaciones.confirmaAprobar', {
            quien: solicitud.nombre || solicitud.username,
            fechas: self.fechasDeLaSolicitud(solicitud)
          }),
          self.$t('bandejaVacaciones.titulo'),
          function() {
            if (miDia !== self.diaAbierto) return;
            self.resolverDesdeCalendario(accion,
              RhBandejaVacaciones.aprobar(solicitud.id, solicitud.version, null),
              self.$t('bandejaVacaciones.aprobada'));
          }
        );
      },
      /**
       * #59 · Denegar desde el día amarillo. El motivo es **obligatorio** —es lo que va a leer
       * quien pidió los días— y por eso va un `prompt` y no un `confirm`. Vacío se corta aquí para
       * no gastar un viaje, pero quien manda es el servidor, que lo exige igual.
       */
      denegarDesdeCalendario() {
        const self = this;
        const solicitud = self.solicitudDelDia;
        if (!solicitud) return;
        // Lo mismo que en aprobar: el motivo se escribe con el diálogo abierto, y lo que hay en
        // pantalla detrás ha podido cambiar de persona —o de cuenta— mientras se escribía. Y aquí
        // el rato es más largo todavía, porque hay que redactar el motivo.
        const miDia = self.diaAbierto;
        const accion = accionDeLaSesion(self, claveDeSolicitud(solicitud.id));
        accion.pedir(
          self.$t('bandejaVacaciones.pideMotivo', {
            quien: solicitud.nombre || solicitud.username,
            fechas: self.fechasDeLaSolicitud(solicitud)
          }),
          self.$t('bandejaVacaciones.titulo'),
          function(motivo) {
            if (miDia !== self.diaAbierto) return;
            if (!motivo || !motivo.trim()) {
              self.$f7.dialog.alert(self.$t('bandejaVacaciones.motivoObligatorio'));
              return;
            }
            self.resolverDesdeCalendario(accion,
              RhBandejaVacaciones.denegar(solicitud.id, solicitud.version, motivo.trim()),
              self.$t('bandejaVacaciones.denegada'));
          }
        );
      },
      /**
       * El tronco común de las dos. Cierra el detalle y **recarga la rejilla**: aprobar deja los
       * días en azul y denegar los borra del calendario, así que lo que hay pintado deja de ser
       * cierto en cuanto el servidor contesta.
       *
       * **Y nada de esto se hace si entre medias se ha cambiado de cuenta.** Esta pantalla no
       * sobrevive al cierre de sesión, pero la promesa sí: el acuse, el diálogo del error, el aviso
       * del badge y la recarga de la rejilla son efectos de fuera del componente y se ejecutaban
       * igual, ya con las credenciales de la cuenta nueva —a quien se le enseñaba «Aprobada» de una
       * solicitud que no es suya— (revisión CODEX del PR #1735). Es la misma comprobación que ya
       * hacen la bandeja al aprobar y denegar, «Mis vacaciones» al anular y la ventana de solicitar
       * al enviar. El `preloader` sí se apaga siempre: es global y dejarlo encendido bloquea la
       * pantalla de quien acaba de entrar.
       *
       * **Ni si se ha salido del calendario sin cambiar de cuenta**, que es el hueco que dejaba lo
       * anterior: la ruta es `keepAlive`, así que navegar a otra pantalla no destruye nada y la
       * sesión sigue siendo la misma, de modo que la recarga arrancaba igual —preloader global
       * encendido y varias consultas— **encima de la pantalla de destino**, y el camino de fallo
       * abría allí su diálogo (revisión CODEX del PR #1735, 17/10/2026). Lo descarta el mismo sitio
       * que sella la sesión, por el sello de pantalla de `soloMandaLaDeDelante`, que es donde están
       * enumeradas las tres salidas. Al volver a entrar, la rejilla se pide de nuevo: no se pierde
       * nada por no recargar aquí.
       *
       * El badge del menú, en cambio, va en `fuera` y se avisa igual: es del menú lateral y no de
       * esta pantalla, así que haberse ido del calendario no es motivo para dejarlo con el número
       * de antes.
       *
       * La `accion` llega de quien abrió el diálogo y **no se crea aquí**: el sello que vale es el
       * de entonces. Creándolo al enviar, una resolución aceptada ya con otra cuenta dentro se
       * comparaba contra esa cuenta nueva y pasaba la comprobación (ronda 4).
       */
      resolverDesdeCalendario(accion, promesa, textoOk) {
        const self = this;
        const app = self.$f7;
        accion.enviar(promesa, {
          exito: function() {
            app.toast.create({ text: textoOk, position: 'center', closeTimeout: 2500 }).open();
            self.cerrarDetalleDelDia();
            self.recargarLaRejillaEsperando();
          },
          fallo: function(e) {
            // Lo mismo que en la bandeja: un intento repetido cortado por el adaptador, o la
            // respuesta de una sesión que ya se fue, no escriben ningún aviso (`sinNadaQueDecir`).
            if (RhBandejaVacaciones.sinNadaQueDecir(e)) return;
            app.dialog.alert(mensajeDelServidor(e, self.$t('bandejaVacaciones.errorResolviendo')));
          },
          // Lo mismo que hace la bandeja al resolver: el badge del menú lateral no se vuelve a
          // pedir solo, porque ese menú se monta una vez y no se entera de nada de lo que pasa
          // aquí. Resolver desde el día amarillo descuenta igual que resolver desde la bandeja.
          fuera: function() {
            EventBus.$emit(EVENTO_VACACIONES_RESUELTA);
          }
        });
      },
      /**
       * #59 · **La recarga que arranca al resolver lleva su propia espera**, y la mantiene después
       * de que la acción haya terminado.
       *
       * Aprobar o denegar desde el día amarillo deja la rejilla mintiendo —los días siguen
       * amarillos, o siguen puestos si se denegó— hasta que la recarga conteste. La espera de la
       * acción (`accionDeLaSesion`) se suelta en cuanto el POST contesta, así que entre una cosa y
       * otra la pantalla se quedaba sin ninguna señal de carga con los días de antes a la vista:
       * el mismo defecto que tenía «Mis vacaciones» al anular, y la otra mitad del contrato que
       * fijó Donchurru el 17/10/2026 —«la recarga que arranca desde el éxito de una acción debe
       * mantener su propio testigo después de terminar la acción»—.
       *
       * Pide **su** testigo a `esperaGlobal` por `preloaderDeLaSesion`, que es la pieza que ya
       * saben usar los tres diálogos de este flujo: así la espera de la acción y la de la recarga
       * se solapan, nadie apaga la del otro y, además, la recarga no deja el indicador puesto sobre
       * el formulario de acceso si entre medias se cierra la sesión.
       *
       * No se encadena nada a la recarga ni se avisa de su fallo: de eso responde
       * `getPlanificaciones`, que ya vacía la rejilla y lo dice. Aquí se espera y se suelta, y se
       * suelta **por los dos caminos**, también cuando la carga no llega a salir —no hay empleado
       * que mirar, o la pantalla ya está navegando a otro calendario y no devuelve promesa—: un
       * indicador que no se puede apagar tapa la aplicación entera.
       */
      recargarLaRejillaEsperando() {
        const self = this;
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        let recarga;
        try {
          recarga = self.getPlanificaciones();
        } catch (noHaSalido) {
          espera.cerrar();
          throw noHaSalido;
        }
        if (!recarga || typeof recarga.then !== 'function') {
          espera.cerrar();
          return;
        }
        // #472 · Y se suelta cuando el CARRIL de la agenda ya no espera a nadie, no cuando se cumple
        // esta promesa: se cumple también si su respuesta se descarta porque otra recarga la ha
        // relevado, y entonces el indicador se apagaba con la vigente todavía en vuelo y los días
        // de antes de resolver a la vista como si fueran definitivos. Si queda una vigente, se
        // espera a la suya, que es la última que se ha guardado en `promesaAgenda`.
        let esperada = recarga;
        const alTerminar = function() {
          const siguiente = self.promesaAgenda;
          if (self.carrilAgenda.esperando() && siguiente && siguiente !== esperada) {
            esperada = siguiente;
            siguiente.then(alTerminar);
            return;
          }
          espera.cerrar();
        };
        recarga.then(alTerminar, alTerminar);
      },
      /**
       * #58 · **esta pantalla deja de ser la de delante: lo que tenga pedido del detalle de
       * vacaciones ya no manda.** Las tres salidas —cerrar sesión, salir del calendario y
       * destruirse— entran por aquí y están enumeradas en un solo sitio
       * (`soloMandaLaDeDelante`): la ruta es `keepAlive`, así que ninguna de las dos primeras
       * destruye nada y la respuesta de esa lectura seguía siendo la vigente de su carril —las
       * vacaciones de quien se acaba de ir, o de un día que ya nadie tiene abierto— (revisión
       * CODEX del PR #1733, rondas 7 y 8).
       *
       * Se tira **solo lo del detalle de vacaciones**, que es lo de esta incidencia; del resto de
       * la pantalla responde quien la abrió. Y lo que se está viendo se limpia también al salir,
       * no solo al cerrar sesión: el detalle es de un día concreto y al volver se abre vacío.
       */
      dejarDeMandar() {
        // Por el mismo sitio que lo cierra cualquiera: `cerrarDetalleDelDia` sube el token del día
        // —lo que descarta las esperas— e invalida los dos carriles del detalle. Repetir aquí la
        // lista de lo que hay que soltar es como estaba antes de la #54: dos sitios y uno que se
        // olvida del siguiente campo que se añada.
        if (this.carrilSolicitudDia) this.cerrarDetalleDelDia();
      },
      /**
       * #58 · La solicitud a la que pertenece un día de vacaciones. La pregunta el servidor por la
       * fecha del día: el vínculo de verdad es que la solicitud nombre ese día, y leer el código
       * del texto de `comentariosTarea` ataría la pantalla al literal con el que hoy se escribe
       * esa tarea.
       *
       * **De quién es el día se decide AL ABRIRLO y se guarda.** Si es el calendario propio lo
       * dice `detalleDiaEsMio`: el detalle sigue abierto mientras la rejilla puede recargarse con
       * otra persona, y una condición que se recalcula sola cambiaría de respuesta con el día de
       * antes todavía en pantalla.
       *
       * #59 · «Es de alguien a quien apruebo» se guarda igual, pero **no se decide hasta que
       * `/mi-equipo` ha contestado** (`conMiEquipo`): con la respuesta a medio camino lo único que
       * se puede decir es «todavía no se sabe», y resolverlo como un `false` dejaba el día sin
       * Aprobar/Denegar para siempre. El token `diaAbierto` es lo que impide que la espera conteste
       * sobre un día que ya no está en pantalla, igual que hace el carril con las respuestas.
       *
       * **Pero el día propio no espera a nadie.** `detalleDiaEsDeMiEquipo` solo puede ser cierto
       * si el día NO es propio, así que en el calendario de uno mismo `/mi-equipo` no cambia nada:
       * esperarlo retrasaba el detalle sin motivo y, si esa petición se queda colgada, las
       * vacaciones propias no se pedían nunca. Y mientras se decide de quién es el día el
       * indicador de carga va encendido: apagado, el detalle afirmaba «se cargó a mano» —la frase
       * del caso sin solicitud— durante toda la espera (revisión CODEX del PR #1735, ronda 9).
       */
      cargarSolicitudDelDia(plani) {
        const self = this;
        self.solicitudDelDia = null;
        self.errorSolicitudDia = false;
        self.errorEquipoDia = false;
        self.detalleDiaEsMio = self.esMiCalendario;
        self.detalleDiaEsDeMiEquipo = false;
        self.detalleDiaDe = self.duenioEventos;
        // El carril se invalida siempre, también cuando el día que se abre no es de vacaciones:
        // si no, la respuesta pedida para el día anterior llegaba y se pintaba en este.
        self.carrilSolicitudDia.invalidar();
        const miDia = ++self.diaAbierto;
        const deQuien = self.detalleDiaDe;
        // El «…» se enciende YA, antes de cualquier espera: lo apaga `pedirSolicitudDelDia`, que
        // es el único que sabe si hay algo que pedir y cuándo ha llegado.
        self.cargandoSolicitudDia = !!self.fechaDeLaVacacion(plani);
        if (self.detalleDiaEsMio) {
          self.pedirSolicitudDelDia(plani);
          return;
        }
        self.conMiEquipo(function() {
          // Mientras se esperaba el equipo se ha podido abrir otro día o cambiar de persona: esa
          // respuesta ya no decide nada aquí.
          if (miDia !== self.diaAbierto) return;
          // #59 · si no es el propio, puede ser el de alguien a quien se aprueba: ahí también hay
          // solicitud que enseñar, y además con sus botones.
          self.detalleDiaEsDeMiEquipo = self.apruebaA(deQuien);
          self.pedirSolicitudDelDia(plani);
        }, function() {
          if (miDia !== self.diaAbierto) return;
          // Sin saber a quién se aprueba, este día no se clasifica: decir que no es de nadie sobre
          // quien se pueda preguntar escondía la solicitud y sus botones como si el servidor
          // hubiera contestado. Se dice que no se ha podido comprobar y se ofrece reintentarlo
          // —`conMiEquipo` vuelve a pedir el equipo en el reintento—.
          self.cargandoSolicitudDia = false;
          self.errorEquipoDia = true;
        });
      },
      /**
       * #59 · Volver a intentar lo que no se pudo saber del día que está abierto: se repite la
       * clasificación entera desde el principio, no solo la petición de la solicitud, porque lo
       * que faltó fue saber de quién es el día.
       */
      reintentarSolicitudDelDia() {
        const plani = this.selectedEvent && this.selectedEvent.planificacion;
        if (!plani) return;
        this.cargarSolicitudDelDia(plani);
      },
      /**
       * #59 · «2026-12-21» del día de vacaciones que hay en esa planificación, o `null` si no hay
       * nada que pedir —no es un T0006, no trae hora o la trae ilegible—.
       *
       * Está aparte porque lo necesitan los dos: quien enciende el indicador de carga al abrir el
       * día y quien lanza la petición. Decidido en dos sitios, el indicador se quedaba encendido
       * sobre un día por el que nunca se iba a preguntar.
       */
      fechaDeLaVacacion(plani) {
        if (!this.esDiaDeVacaciones(plani) || !plani.horaInicio) return null;
        const d = new Date(plani.horaInicio);
        if (isNaN(d.getTime())) return null;
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2)
          + '-' + ('0' + d.getDate()).slice(-2);
      },
      /**
       * #59 · La petición en sí, una vez decidido de quién es el día. Aparte de
       * `cargarSolicitudDelDia` solo porque esa parte puede ejecutarse más tarde, cuando llega el
       * equipo: el estado que se limpia al abrir el día tiene que limpiarse **ya**.
       */
      pedirSolicitudDelDia(plani) {
        const self = this;
        const fecha = self.fechaDeLaVacacion(plani);
        if (!fecha || (!self.detalleDiaEsMio && !self.detalleDiaEsDeMiEquipo)) {
          // No hay nada que pedir. El «…» se apaga aquí, que es el único sitio que lo sabe: el
          // día no es de vacaciones, o no es de nadie sobre quien se pueda preguntar.
          self.cargandoSolicitudDia = false;
          return;
        }
        // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla la continuación que lo soltaba.
        cerrojoDeLaSesion(self, 'cargandoSolicitudDia');
        // Dos endpoints y no uno: el de «Mis vacaciones» (#58) contesta SIEMPRE con las del
        // usuario logueado y no recibe de quién es el calendario, así que en el de otra persona
        // enseñaría una solicitud propia que coincidiera en la fecha. El de la #59 recibe el
        // username y deja que el servidor decida si se puede mirar.
        const peticion = self.detalleDiaEsMio
          ? RhSolicitudesVacaciones.solicitudDelDia(fecha)
          : RhBandejaVacaciones.solicitudDelDia(self.detalleDiaDe, fecha);
        // El carril descarta las respuestas de un día que ya no es el abierto, y lo hace también
        // cuando la petición vieja FALLA: el `catch` borraba la solicitud que la nueva ya había
        // pintado, y el `finally` apagaba el «…» mientras la nueva seguía en vuelo.
        self.carrilSolicitudDia.lanzar(peticion, {
          // Y de qué sesión es. El carril de este detalle solo sabe de orden y del día abierto, y
          // ninguno de los dos cambia al cambiar de cuenta: la solicitud de vacaciones de la cuenta
          // anterior —con su estado y sus botones— se pintaba en el detalle que quedara abierto.
          clave: identidadSesion(),
          deAhora: identidadSesion,
          exito: function(res) {
            self.solicitudDelDia = res;
            self.errorSolicitudDia = false;
            self.cargandoSolicitudDia = false;
          },
          limpiar: function() {
            // Que no se pueda leer la solicitud no puede tumbar el detalle del día: se queda sin
            // ella, pero se dice que no se ha podido leer y no que no pertenezca a ninguna.
            self.solicitudDelDia = null;
            self.errorSolicitudDia = true;
            self.cargandoSolicitudDia = false;
          }
        });
      },
      showEvent ({ nativeEvent, event }) {
        var self = this;
        // #58 · si el día es de vacaciones, su solicitud se pide al abrirlo.
        self.cargarSolicitudDelDia(event && event.planificacion);
        // #268 · y si la papelera lo alcanza.
        self.pedirPapeleraDia(event && event.planificacion);
        // En tareas mostramos la fecha de creación de la TAREA (no viaja en la planificación):
        // la pedimos al abrir, trayendo solo creationDate para que la consulta sea mínima.
        self.fechaCreacionTarea = null;
        // Igual que con la solicitud del día: se invalida aunque el evento nuevo no sea una
        // tarea, o la respuesta de la tarea anterior pintaba su fecha de creación en este.
        self.carrilFechaTarea.invalidar();
        if (event && event.planificacion && event.planificacion.tipo == 'TAREA' && event.planificacion.idTarea) {
          // Por su propio carril, y por el mismo motivo que la solicitud del día: abrir otra tarea
          // antes de que contestara esta pintaba la fecha de creación de la anterior encima.
          self.carrilFechaTarea.lanzar(
            Tarea.getList({ projection: "creationDate", filter: { id: event.planificacion.idTarea } }), {
              // La misma clave de sesión que la solicitud del día, por lo mismo: con otra cuenta
              // dentro, esta fecha es de una tarea que la nueva no está mirando.
              clave: identidadSesion(),
              deAhora: identidadSesion,
              exito: function(res) {
                if (res && res.list && res.list.length) {
                  self.fechaCreacionTarea = res.list[0].creationDate;
                }
              },
              limpiar: function() { self.fechaCreacionTarea = null; }
            });
        }
        // #59 · De qué apertura es este `open`. Lo subió `cargarSolicitudDelDia` hace un momento,
        // y lo vuelve a subir `cerrarDetalleDelDia`: entre el clic y el fotograma en el que el
        // detalle se abre de verdad caben dos `requestAnimationFrame`, y en ese hueco la pantalla
        // ha podido pasar a mirar a otra persona o a otra semana. Abrirlo entonces pondría el día
        // de la persona anterior —con sus botones de Aprobar y Denegar— sobre la rejilla nueva,
        // justo lo que el cierre acababa de quitar.
        const miApertura = self.diaAbierto;
        const open = () => {
          if (miApertura !== self.diaAbierto) return;
          self.selectedEvent = event
          self.selectedElement = nativeEvent.target
          // #49 · abrir un evento lo abre SIEMPRE en solo lectura. El modo de edición es de la
          // pantalla, no del evento: si se enciende en uno normal y el detalle se cierra pulsando
          // fuera, `selectedOpen` pasa a false pero `readOnlyPlanif` se queda en false, y la
          // siguiente vacación se abría con los campos editables y el botón «Guardar» puestos —sin
          // lápiz, que es lo único que oculta el v-if— hasta llevarse el 4xx del servidor. Es lo
          // mismo que ya hacía la rama de abajo al pasar de un evento abierto a otro.
          self.readOnlyPlanif = true;
          // La comprobación va también aquí dentro, y no solo al entrar: lo que se aplaza dos
          // fotogramas es LEVANTAR el detalle, así que es ese gesto el que puede acabar ocurriendo
          // cuando ya se está mirando a otra persona.
          requestAnimationFrame(() => requestAnimationFrame(() => {
            if (miApertura !== self.diaAbierto) return;
            self.selectedOpen = true;
          }))
        }
        if (self.selectedOpen) {
          self.selectedOpen = false;
          self.readOnlyPlanif = true;
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }
        nativeEvent.stopPropagation()
      },
      viewDay ({ date }) {
        const self = this;
        self.value = date;
        self.type = 'day';
      },
      open(url) {
        const self = this;
        const app = self.$f7;
        if (self.target && self.target == 'cordova') {
          app.views.current.router.navigate({url: url, ignoreCache: true});
        } else {
          window.open('#!' + url);
        }
      },
      // C4: pide la PROPUESTA del solver para este inspector y semana (SOLO LECTURA; no escribe).
      // SPEC-PARAMETRIZACION-PROPONER: drawer de parametrización + preview ligero. El preview es SOLO
      // LECTURA (/proponer/preview, sin solver); el botón final llama al proponerPlanificacion() de siempre.
      abrirDrawerProponer() {
        const self = this;
        self.drawerProponerAbierto = true;
        // Reset del toggle "Permitir pernocta" cada vez que se abre el drawer: arranca en "según ficha"
        // del inspector actual, no arrastra la elección hecha para un inspector anterior en la sesión.
        self.planificarConPernocta = null;
        self.cargarPreviewProponer();
        // ENCARGO-021c · sondeo de reenganche: preguntamos si el USUARIO CONECTADO tiene una
        // pasada viva o recientemente terminada para el inspector visible. Solo aquí, no en
        // cada montaje de la vista — es un GET ligero pero si el usuario no piensa proponer
        // no tiene por qué pagarlo.
        self.sondearPasadaAsyncEnCurso();
      },
      cerrarDrawerProponer() {
        this.drawerProponerAbierto = false;
        if (this.previewTimer) { clearTimeout(this.previewTimer); this.previewTimer = null; }
        // ENCARGO-025 · cerrar el drawer NO cancela la pasada NI oculta las bandas de avance,
        // timeout u "ocupado por otro". Antes las limpiaba aquí y con `proponerDesdeDrawer()`
        // cerrando el drawer justo antes de lanzar, esas bandas quedaban invisibles (P2 de
        // José Antonio en PR #1713). Ahora la banda vive en la banda flotante fuera del
        // drawer y solo se oculta por su propio botón de cerrar o al lanzar una nueva
        // pasada. La oferta de "ver terminada" SÍ es efímera del propio drawer: se sondea
        // en abrirDrawerProponer y no tiene sentido fuera de ese contexto.
        this.pasadaAsyncTerminadaOferta = null;
      },
      // ENCARGO-021c · GET /proponer/async/en-curso?inspector=X. Nunca devuelve la pasada de
      // otro usuario (el backend responde 204 aunque haya una viva del inspector). Con 204,
      // flujo normal. Con 200 y `enCurso=true`, reenganche automático (drawer entra en modo
      // "viendo pasada"). Con 200 y `enCurso=false`, ofrecemos "ver resultado" no invasivo.
      sondearPasadaAsyncEnCurso() {
        const self = this;
        if (!self.inspectorFiltro) return;
        self.pasadaAsyncTerminadaOferta = null;
        Planificacion.proponerAsyncEnCurso({ inspector: self.inspectorFiltro }).then(function (res) {
          // ENCARGO-027: el endpoint devuelve ResponseDto<ProponerAsyncEstadoDTO>. sendRequest
          // unwrap-ea `res.data.dto` cuando es truthy y devuelve el envelope crudo cuando es null
          // (así preservamos la semántica "204 equivalente"). Aceptamos ambos: envelope o DTO
          // directo.
          const est = (res && res.dto) ? res.dto : res;
          if (!est || !est.pasadaId) return;
          if (est.enCurso) {
            // Reenganche a una pasada viva: NO relanzamos; nos suscribimos al canal filtrando
            // por su pasadaId y pintamos el estado actual como si acabáramos de recibir un
            // evento con esa fase.
            self.reengancharPasadaAsync(est);
          } else {
            // Terminada dentro de la retención (30 min): guardamos la oferta pero NO pintamos
            // nada agresivo. El usuario decide si quiere verla o descartarla.
            self.pasadaAsyncTerminadaOferta = est;
          }
        }).catch(function (e) {
          // No es error rojo: si no hay conexión con /en-curso el drawer aún puede lanzar una
          // pasada nueva. Log en consola y seguir.
          console.warn('[proponerAsync] /en-curso falló', e);
        });
      },
      // Reengancha a una pasada viva devuelta por /en-curso. `estado` es el snapshot
      // {pasadaId, fase, mensaje, runId, registroId, enCurso}. Registramos la suscripción al
      // canal filtrando por pasadaId y pintamos el estado como fase actual.
      reengancharPasadaAsync(estado) {
        const self = this;
        if (self.pasadaAsyncOff) { try { self.pasadaAsyncOff(); } catch (e) {} }
        self.pasadaAsync = {
          pasadaId: estado.pasadaId,
          // #283 (ronda 6) · el snapshot de /en-curso ya dice de quién es la pasada
          // (ProponerAsyncEstadoDTO.inspector); el filtro de la pantalla es solo el respaldo para
          // el reenganche del rechazo por «ocupado por ti mismo», que no lo trae.
          inspector: estado.inspector || self.inspectorFiltro || null,
          fase: estado.fase || 'CONSTRUYENDO',
          mensaje: estado.mensaje || null,
          runId: estado.runId || null,
          registroId: estado.registroId || null,
          error: estado.error || null,
          enCurso: true,
          reenganchada: true
        };
        self.pasadaAsyncOcupadoDeOtro = null;
        self.pasadaAsyncTerminadaOferta = null;
        // #283 (ronda 3) · la marca del modo reducido de un resultado ANTERIOR no se levanta aquí,
        // aunque esta pasada sea otra: la propuesta reducida sigue pintada en el calendario y
        // quitarla volvería a habilitar «Aceptar planificación» sobre algo que no se ve entero
        // (ENCARGO-023 §2). Lo que sí se consigue es que su aviso no tape el avance de esta
        // pasada: lo decide el sello `pasadaAsyncModoReducidoPasadaId` en `bloqueAvisoFlotante`, y
        // la marca se rebobina sola en el FIN de esta pasada, que es cuando se repinta la
        // propuesta (r4212680956).
        self.pasadaAsyncOff = ProponerPlanificacionEvents.subscribe(estado.pasadaId, function (payload) {
          self.onProponerEvento(payload);
        });
        self.armarTimeoutPasadaAsync();
      },
      // Descarta la oferta de "ver terminada" (usuario dice: no me interesa, prefiero lanzar).
      // #283 (ronda 3) · por el cierre único, que además deja anotada la pasada: el sondeo de
      // /en-curso la devuelve durante los 30 min de retención y sin eso volvía a preguntar lo
      // mismo con solo reabrir el drawer.
      descartarPasadaTerminada() {
        const oferta = this.pasadaAsyncTerminadaOferta;
        this.descartarPasadaDeLaBanda(oferta ? oferta.pasadaId : null);
      },
      // Toma la pasada terminada de la oferta: si tenía registroId, abre el informe; si acabó
      // en ERROR, muestra el motivo y la borra para no ocultar el flujo normal.
      verPasadaTerminada() {
        const self = this;
        const est = self.pasadaAsyncTerminadaOferta;
        if (!est) return;
        // #283 (ronda 3) · la pregunta queda contestada: por el cierre único, para que el sondeo
        // de /en-curso no la repita al reabrir el drawer dentro de la retención.
        self.descartarPasadaDeLaBanda(est.pasadaId);
        if (est.registroId) {
          self.abrirInformeDeRegistro(est.registroId);
        } else if (est.error) {
          self.$f7.dialog.alert(est.error);
        }
      },
      // ENCARGO-032 · corrige la navegación al informe-propuesta.vue. La ruta declarada es
      // '/dashboard/informe-propuesta/:registroId?/' (src/pages/dashboard/routes.js:46) y la
      // página lee params.registroId (informe-propuesta.vue:mounted). El formato `?id=<x>` que
      // había aquí desde 2249052f (PR #1713) no coincidía con ninguna ruta declarada —> "Página
      // no encontrada". El mismo camino path-param lo usa `verInforme(reg)` (ver más abajo)
      // desde d822f1ef (14/08/2026), que sí funciona: mantener un solo formato en todo el front.
      abrirInformeDeRegistro(registroId) {
        if (!registroId) return;
        const app = this.$f7;
        const path = '/dashboard/informe-propuesta/' + encodeURIComponent(registroId) + '/';
        if (app && app.views && app.views.main) {
          app.views.main.router.navigate(path);
        } else {
          window.open('#!' + path, '_blank');
        }
      },
      proponerDesdeDrawer() {
        this.cerrarDrawerProponer();
        this.proponerPlanificacion();
      },
      // Preview reactivo con debounce: se dispara desde los controles que cambian el CONTEO
      // (suelo de antigüedad, proponer informes). El resto de parámetros no altera el pool.
      refrescarPreviewProponer() {
        const self = this;
        if (!self.drawerProponerAbierto) return;
        if (self.previewTimer) clearTimeout(self.previewTimer);
        self.previewTimer = setTimeout(function() { self.cargarPreviewProponer(); }, 400);
      },
      cargarPreviewProponer() {
        const self = this;
        if (!self.inspectorFiltro) {
          self.previewProponer = null;
          self.previewInspector = null;
          return;
        }
        // #296 (P2 Codex, ronda 1): el preview guardado describe a UN inspector concreto. Si el del
        // filtro ya no es ese, lo que hay en memoria NO habla de esta pantalla, así que se tira ANTES
        // de pedir y no cuando llegue la respuesta. Sin esto, durante toda la petición el drawer
        // seguía enseñando los datos del inspector anterior bajo el nombre del nuevo: su dirección
        // base en la cabecera, su número en el botón de Proponer, su `pernoctaPermitida` en el toggle
        // (que ademas viaja en la propuesta, porque `abrirDrawerProponer` resetea la elección del
        // usuario) y su aviso de ficha sin servicios en el pie. Para una recarga del MISMO inspector
        // —cambiar el suelo de antigüedad o el toggle de informes— no se tira nada: el dato sigue
        // siendo suyo y la pantalla no pega un salto en blanco.
        // Las dos a la vez, siempre: `previewInspector` describe lo que hay guardado en
        // `previewProponer`, y en cuanto una diga algo que la otra no sostiene vuelve la fuga.
        if (self.previewInspector !== self.inspectorFiltro) {
          self.previewProponer = null;
          self.previewInspector = null;
        }
        const seq = ++self.previewSeq;
        const solicitado = self.inspectorFiltro;
        cerrojoDeLaSesion(self, 'previewCargando');
        self.previewError = false;
        self.Planificacion.proponerPreview({ data: {
          inspector: solicitado,
          mesesAntiguedadMax: self.mesesAntiguedadMax,
          proponerInformes: self.proponerInformes
        }}).then(function(res) {
          if (seq !== self.previewSeq) return;   // llegó una respuesta vieja: la última petición gana
          // #296 (P2 Codex, ronda 2): `seq` solo ordena las peticiones ENTRE SÍ. Si el filtro de
          // «Empleado» cambia mientras esta vuela y nadie relanza —`cambiarEmpleado()` no recarga el
          // preview, y `getPlanificaciones()` reescribe `inspectorFiltro` por su cuenta: lo pasa a
          // mayúsculas, o lo devuelve al usuario conectado—, `seq` sigue siendo el último y esta
          // respuesta, que es de OTRO inspector, se guardaría como si fuera del que se está viendo.
          // Se tira, y con ella lo que quedara en memoria: era la medición de `solicitado`, y
          // `solicitado` ya no es quien está en pantalla.
          if (solicitado !== self.inspectorFiltro) {
            self.previewProponer = null;
            self.previewInspector = null;
            self.previewError = false;
            return;
          }
          const data = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
          self.previewProponer = (data && data.campo) ? data : null;
          // El usuario del que es la respuesta es el que se pidió, no el que haya ahora en el filtro:
          // el `seq` descarta las respuestas viejas, pero el filtro puede haber cambiado mientras
          // esta volaba y entonces marcarla como suya la volvería a dar por válida.
          self.previewInspector = self.previewProponer ? solicitado : null;
          self.previewError = !self.previewProponer;
        }).catch(function() {
          if (seq !== self.previewSeq) return;
          self.previewProponer = null;
          self.previewInspector = null;
          // Mismo criterio que en el éxito: lo que ha fallado es la consulta de `solicitado`. Si el
          // filtro ya no es ese, el error no es de este inspector y no se le atribuye en pantalla.
          self.previewError = (solicitado === self.inspectorFiltro);
        }).finally(function() {
          if (seq === self.previewSeq) self.previewCargando = false;
        });
      },
      inicialesInspector() {
        return (this.inspectorFiltro || '?').substring(0, 3).toUpperCase();
      },
      // Tramos de la barra apilada del preview (solo los > 0), con su leyenda
      previewStack() {
        const self = this;
        const pv = self.previewVigente;
        if (!pv) return [];
        const c = pv.campo || {};
        const tramos = [
          { clave: 'coloc', n: c.colocables || 0, color: '#1baf7a', texto: self.$t('proponerDrawer.colocables', { n: c.colocables || 0 }) },
          { clave: 'seg', n: c.segundasProximas || 0, color: '#2a78d6', texto: self.$t('proponerDrawer.segundas', { n: c.segundasProximas || 0 }) },
          { clave: 'ant', n: c.antiguas || 0, color: '#eda100', texto: self.$t('proponerDrawer.antiguas', { n: c.antiguas || 0 }) },
          { clave: 'geo', n: c.sinCoordenadas || 0, color: '#e34948', texto: self.$t('proponerDrawer.sinCoords', { n: c.sinCoordenadas || 0 }) },
          { clave: 'inf', n: pv.informes || 0, color: '#6d5ce0', texto: self.$t('proponerDrawer.informesN', { n: pv.informes || 0 }) }
        ].filter(function(s) { return s.n > 0; });
        const total = tramos.reduce(function(a, s) { return a + s.n; }, 0) || 1;
        tramos.forEach(function(s) { s.pct = Math.max(2, Math.round(s.n / total * 100)); });
        return tramos;
      },
      previewStackTotal() {
        return this.previewStack().reduce(function(a, s) { return a + s.n; }, 0);
      },
      // #760 · la medida de la puerta del bloque vivo tal y como la manda el backend, o null si el
      // backend no la trae (un despliegue anterior a la #760). Null y no «ninguna»: decir «ninguna» sin
      // haberlo medido sería afirmar un cero que nadie ha contado.
      puertaPreview() {
        const c = (this.previewVigente && this.previewVigente.campo) || null;
        if (!c || !Array.isArray(c.soloHistoricoLineas) || !Array.isArray(c.yaPlanificadasLineas)) return null;
        return {
          candidatas: c.candidatas || 0,
          soloHistorico: c.soloHistoricoLineas,
          importe: c.soloHistoricoImporte,
          bloqueVivo: c.yaPlanificadasLineas
        };
      },
      textoPuertaSoloHistorico() {
        const p = this.puertaPreview();
        const x = p.soloHistorico.length;
        if (x === 0) return this.$t('proponerDrawer.puertaSoloHistoricoNinguna', { n: p.candidatas });
        return this.$t(x === 1 ? 'proponerDrawer.puertaSoloHistoricoUna' : 'proponerDrawer.puertaSoloHistorico',
          { n: p.candidatas, x: x, importe: this.fmtEur(p.importe) });
      },
      textoPuertaBloqueVivo() {
        const z = this.puertaPreview().bloqueVivo.length;
        if (z === 0) return this.$t('proponerDrawer.puertaBloqueVivoNinguna');
        return this.$t(z === 1 ? 'proponerDrawer.puertaBloqueVivoUna' : 'proponerDrawer.puertaBloqueVivo', { z: z });
      },
      alternarListaPuerta(cual) {
        this.listaPuertaAbierta = this.listaPuertaAbierta === cual ? null : cual;
      },
      // El motivo llega como código del catálogo cerrado del backend (MotivoPuertaBloqueVivo).
      textoMotivoPuerta(motivo) {
        if (motivo === 'SOLO_HISTORICO') return this.$t('proponerDrawer.motivoSoloHistorico');
        if (motivo === 'BLOQUE_VIVO') return this.$t('proponerDrawer.motivoBloqueVivo');
        return motivo;
      },
      textoBloqueVivo(f) {
        const partes = [f.pendienteConfirmar ? this.$t('proponerDrawer.puertaPendiente') : this.$t('proponerDrawer.puertaPlanificada')];
        if (f.fechaBloqueVivo) partes.push(this.fmtFecha(f.fechaBloqueVivo));
        if (f.inspectorBloqueVivo) partes.push(f.inspectorBloqueVivo);
        return partes.join(' · ');
      },
      // #296 · usuario al que se refiere un aviso del preview, para poder darlo nominal.
      nombreInspectorAviso(a) {
        return (a && a.inspector) || this.inspectorFiltro
          || this.$t('proponerDrawer.sinServiciosInspectorAnonimo');
      },
      // #296 · §9 del CLAUDE.md del orquestador: «un control que no se puede usar dice por qué, quién
      // lo desbloquea y dónde, y JUNTO al control, no en un aviso al principio de la pantalla». El
      // aviso de ficha sin servicios ya sale en la lista de avisos del preview, pero esa lista queda
      // arriba, dentro del cuerpo con scroll del drawer: quien pulsa Proponer no la relaciona con lo
      // que acaba de pasarle. Lo repetimos en el pie, pegado al botón. No deshabilitamos el botón: los
      // informes sí se siguen pudiendo proponer, y el número que luce el botón es exactamente ese.
      avisoSinServiciosPreview() {
        // (P2 Codex, ronda 1) Mientras la consulta está en vuelo el cuerpo del preview enseña
        // «calculando» y esconde su lista de avisos; el pie tiene que callar igual. Si no, afirmaría
        // —y nominalmente, que es lo que lo hace grave— que un inspector no tiene servicios usando la
        // medición del anterior. La comprobación del usuario —ahora en `previewVigente`, compartida
        // con todos los demás consumidores (ronda 2)— cierra además la ventana del debounce, en la
        // que `previewCargando` todavía es `false`.
        if (this.previewCargando) return null;
        const avisos = (this.previewVigente && this.previewVigente.avisos) || [];
        return avisos.find(function(a) { return a.codigo === 'SIN_SERVICIOS_HABILITADOS'; }) || null;
      },
      // Texto legible de un aviso del preview (códigos del backend → i18n)
      textoAvisoPreview(a) {
        const self = this;
        const pv = self.previewVigente;
        const c = (pv && pv.campo) || {};
        switch (a.codigo) {
          case 'FICHA_OK': return self.$t('proponerDrawer.fichaOk');
          case 'FICHA_INCOMPLETA':
            return (pv && pv.ficha && pv.ficha.estado === 'SIN_CONFIGURAR')
              ? self.$t('proponerDrawer.fichaSinConfigurar')
              : self.$t('proponerDrawer.fichaIncompleta');
          // #296: nominal. El backend manda el usuario dentro del propio aviso; si faltara, el del
          // filtro del calendario es el mismo inspector del que habla el preview.
          case 'SIN_SERVICIOS_HABILITADOS':
            return self.$t('proponerDrawer.sinServicios', { inspector: self.nombreInspectorAviso(a) });
          case 'RECORTE_TOPE': return self.$t('proponerDrawer.recorteTope', { n: c.candidatas, tope: c.trasTope });
          case 'SIN_COORDENADAS': return self.$t('proponerDrawer.sinCoordsAviso', { n: c.sinCoordenadas });
          // PALANCA C3: anomalías "antes de lanzar". Las cerradas SAP están EXCLUIDAS del pool por el
          // gate C1 (la cifra viene del bucket del preview); las cobradas/facturadas sin realizar son
          // globales (out.anomalias del backend) y solo se avisan para revisión de negocio.
          case 'CERRADAS_SAP_EXCLUIDAS': return self.$t('proponerDrawer.cerradasSapAviso', { n: c.cerradasSap });
          case 'COBRADO_FACTURADO_SIN_REALIZAR': {
            const an = (pv && pv.anomalias && pv.anomalias.cobradoFacturadoSinRealizar) || {};
            return self.$t('proponerDrawer.cobradoSinRealizarAviso', { n: an.n || 0, importe: self.fmtEur(an.importe) });
          }
          default: return a.codigo;
        }
      },
      proponerPlanificacion() {
        const self = this;
        const app = self.$f7;
        // ENCARGO-021c · vía ASÍNCRONA: /proponer/async devuelve 202 al instante con `pasadaId`,
        // el trabajo real avanza en el ExecutorService del backend y las fases llegan por SSE.
        // Diseño clave: PRIMERO se lanza, DESPUÉS se suscribe (y filtramos por pasadaId, así
        // ningún evento residual de otra corrida se cuela). Y no bloqueamos la pantalla — la
        // banda de fase vive en el drawer y el resto del calendario sigue navegable.
        if (self.proponiendoEnCurso) return;
        cerrojoDeLaSesion(self, 'proponiendoEnCurso');
        // #1201 · del clic a la propuesta pintada; se escribe en la consola al terminar. Fuera de
        // `data` a propósito: es medida, no estado de la pantalla.
        self.$_cronoProponer = TiemposProponer.empezar();
        // Reset del estado provisional de la corrida anterior — la banda del drawer arranca
        // limpia y, si algo falla, no quedan restos ni un spinner colgado.
        self.propuestas = [];
        self.noPlanificables = [];
        self.olvidarCapturaNegocio();            // #325: la captura de la corrida anterior no vale para esta
        self.desdeDeLaPropuesta = self.fechaDesdeFiltro || null;
        self.banco = [];
        self.alertasPlazo = [];
        self.avisoTiempoAgotado = null;
        self.explicaciones = [];
        self.runPropuesta = null;
        self.panelPorQueAbierto = false;
        // #283 · la corrida nueva empieza con la banda limpia: ni un aviso de vista reducida que
        // alguien dio por leído en la anterior, ni el autocierre de la fase terminal de antes.
        self.limpiarBandaFlotante();
        if (self.pasadaAsyncOff) { try { self.pasadaAsyncOff(); } catch (e) {} self.pasadaAsyncOff = null; }
        Planificacion.proponerAsync({ data: {
          inspector: self.inspectorFiltro,
          desde: self.fechaDesdeFiltro,
          hasta: self.horizonteHasta(),                 // horizonte 1/2 semanas del toggle
          planificarConComida: self.planificarConComida,
          planificarConPernocta: self.planificarConPernocta,
          proponerInformes: self.proponerInformes,      // C4-REALINEAMIENTO: check "Proponer informes"
          mesesAntiguedadMax: self.mesesAntiguedadMax,  // SPEC-PARAMETRIZACION-PROPONER: suelo de antigüedad del drawer
          alcance: self.alcancePropuesta,               // C4-REALINEAMIENTO: HORIZONTE / UN_DIA / COMPLETAR_DIA
          modo: self.modoPropuesta,                     // C4-REALINEAMIENTO v2: CUBRIR_HUECOS | REPLANIFICAR_DIAS
          diasAReplanificar: self.diasReplanList(),     // C4-REALINEAMIENTO v2: días a liberar en Modo B (movilidad los usa en cargarBloquesFijos)
          // SPEC-PARAMETROS-COMIDA-JORNADA (solver v0.18): comida flexible + jornada del panel
          comidaDuracionMin: self.comidaDuracionMin,
          comidaInicioMin: self.comidaInicioMin,
          comidaInicioMax: self.comidaInicioMax,
          comidaPreferente: self.comidaPreferente,
          jornadaInicioPreferente: self.jornadaInicioPreferente,
          jornadaInicioMin: self.jornadaInicioMin
        }}).then(function(res) {
          const data = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
          if (!data || !data.pasadaId) {
            self.proponiendoEnCurso = false;
            app.dialog.alert(self.$t('proponerDrawer.errorLanzar'));
            return;
          }
          // §1.2 · si el backend rechaza por inspector ocupado, `lanzado=false` y trae motivo +
          // `pasadaEnCursoDe` (usuario dueño). Si el dueño es EL MISMO usuario, reenganchamos a
          // esa pasada — mostrar 'ocupado por ti mismo' sería incoherente. Si es otro usuario,
          // pintamos el motivo LITERAL y no forzamos ningún flujo (el planificador decide).
          if (data.lanzado === false) {
            const yo = self.getMiUsername();
            if (yo && data.pasadaEnCursoDe && data.pasadaEnCursoDe === yo) {
              // Reenganche a la propia pasada viva (el pasadaId del rechazo es el de la viva).
              self.reengancharPasadaAsync({
                pasadaId: data.pasadaId,
                fase: 'CONSTRUYENDO',                   // conservador; el 1er evento lo actualiza
                enCurso: true
              });
            } else {
              self.pasadaAsyncOcupadoDeOtro = {
                inspector: data.inspector || self.inspectorFiltro,
                usuario: data.pasadaEnCursoDe || (data.usuario || '?'),
                motivo: data.motivo || null
              };
            }
            self.proponiendoEnCurso = false;
            return;
          }
          // Admitida: entramos en modo "pasada viva". Suscripción DESPUÉS del lanzamiento y
          // filtrada por pasadaId; el hub no reenvía canales por usuario (matiz de seguridad,
          // ver PR #1951 §5.2) así que si conectamos con la pasada ya avanzando, el 1er evento
          // en llegar será el próximo — de ahí que dejemos la fase inicial en EN_COLA visible.
          self.pasadaAsync = {
            pasadaId: data.pasadaId,
            // #283 (ronda 6) · de quién es esta pasada, sellado en el momento de lanzarla: el
            // filtro de la pantalla puede cambiar mientras corre, y el aviso se archiva por el
            // inspector de la pasada, no por el que esté puesto al cerrarlo.
            inspector: data.inspector || self.inspectorFiltro || null,
            fase: ProponerPlanificacionEvents.FASES.EN_COLA,
            mensaje: null,
            runId: null,
            registroId: null,
            error: null,
            enCurso: true,
            reenganchada: false
          };
          TiemposProponer.lanzada(self.$_cronoProponer, data.pasadaId);   // #1201
          self.pasadaAsyncOff = ProponerPlanificacionEvents.subscribe(data.pasadaId, function (payload) {
            self.onProponerEvento(payload);
          });
          self.armarTimeoutPasadaAsync();
          self.proponiendoEnCurso = false;
        }).catch(function(e) {
          if (typeof e == "string") e = { error: e };
          self.proponiendoEnCurso = false;
          // 503 = el bean del job async no está montado (extraño en producción, útil que hable).
          if (e && e.status === 503) {
            app.dialog.alert(self.$t('proponerDrawer.error503'));
          } else {
            app.dialog.alert(e.message || e.error || self.$t('proponerDrawer.errorLanzar'));
          }
        }).finally(function() {
          // NO tocamos preloader ni proponiendoEnCurso más — se resolvieron arriba. El drawer
          // sigue abierto pintando la banda de fase, el resto de la app sigue disponible.
        });
      },
      // ENCARGO-021c · manejador único de eventos SSE de UNA pasada. El adaptador ya filtró por
      // pasadaId; aquí solo tenemos que traducir el payload a estado del drawer. Cada evento
      // reinicia el timeout de 15 min — la única forma de dejar el drawer bloqueado es que el
      // solver enmudezca por completo, y para eso está el aviso legible del timeout.
      onProponerEvento(payload) {
        const self = this;
        if (!self.pasadaAsync || !payload || !payload.pasadaId) return;
        if (payload.pasadaId !== self.pasadaAsync.pasadaId) return;   // doble red: nunca pasa
        self.pasadaAsync.fase = payload.fase || self.pasadaAsync.fase;
        self.pasadaAsync.mensaje = payload.mensaje || null;
        if (payload.runId) self.pasadaAsync.runId = payload.runId;
        if (payload.registroId) self.pasadaAsync.registroId = payload.registroId;
        if (payload.error) self.pasadaAsync.error = payload.error;
        self.armarTimeoutPasadaAsync();
        const FASES = ProponerPlanificacionEvents.FASES;
        if (payload.fase === FASES.FIN) {
          // #1201 · el aviso de fin ha llegado: lo que quede hasta pintar ya es del navegador.
          self.$_cronoProponer = TiemposProponer.dePasada(self.$_cronoProponer, payload.pasadaId);
          TiemposProponer.marcar(self.$_cronoProponer, 'fin');
          self.pasadaAsync.enCurso = false;
          self.cancelarTimeoutPasadaAsync();
          self.finalizarPasadaAsync(payload);
        } else if (payload.fase === FASES.ERROR) {
          self.pasadaAsync.enCurso = false;
          self.cancelarTimeoutPasadaAsync();
          // Nada más — el drawer pinta la banda ERROR con el mensaje literal del backend.
        }
      },
      // 15 min sin eventos: se reinicia con cada evento (el timeout se rearmar en cada llamada
      // a `armarTimeoutPasadaAsync`). Al cumplirse, pintamos un aviso legible y dejamos que el
      // planificador decida si vuelve a lanzar. Nunca un spinner infinito, nunca una banda muda.
      armarTimeoutPasadaAsync() {
        const self = this;
        self.cancelarTimeoutPasadaAsync();
        self.pasadaAsyncTimeoutAviso = false;
        self.pasadaAsyncTimer = setTimeout(function () {
          self.pasadaAsyncTimeoutAviso = true;
        }, 15 * 60 * 1000);
      },
      cancelarTimeoutPasadaAsync() {
        if (this.pasadaAsyncTimer) {
          clearTimeout(this.pasadaAsyncTimer);
          this.pasadaAsyncTimer = null;
        }
      },
      /**
       * #283 (ronda 3) · ÚNICA salida de la banda flotante: retira de ella TODO lo que habla de
       * `pasadaId` y deja constancia de que el planificador ya la descartó.
       *
       * Por aquí pasan los cuatro ✕ y el `Esc`, y es lo que cierra la familia de las tres rondas
       * de revisión: los bloques de esta banda no son avisos independientes —nacen juntos— así que
       * cerrar uno marcándolo «leído» descubría el de debajo, que hablaba del mismo resultado y
       * decía lo contrario: la fase FIN detrás de la vista reducida (r4212149679) y la oferta de
       * «ver terminada» detrás de las dos (r4212680944). Repartir la limpieza por cada cierre es
       * lo que hacía falta recordar en cada ronda; aquí se recuerda una vez.
       *
       * La memoria del descarte es necesaria porque el estado vuelve a entrar SOLO: el sondeo de
       * /en-curso devuelve la pasada terminada durante toda la retención (30 min), así que sin
       * ella bastaba con reabrir el drawer para que el aviso descartado volviera. Y es un REGISTRO
       * con una entrada por aviso, no una ranura: con una sola, cerrar el aviso de un inspector
       * borraba el del anterior y la pantalla rota entre inspectores dentro de la misma sesión
       * (r4213238853, ronda 6). Ver `anotarAvisoCerrado`.
       *
       * Y una pasada que puede seguir corriendo NO se recuerda como descartada: si luego se
       * reengancha, su avance tiene que verse. Es la misma regla que impide cerrar una fase en
       * curso, escrita para el único cierre que puede alcanzar una pasada viva (el del aviso de 15
       * min sin eventos, que libera el estado local para poder relanzar).
       *
       * Lo que vive aquí es la memoria COMPARTIDA de la banda —qué pasada ya no tiene nada que
       * decir—, no el «ya lo he leído» de cada bloque: ese lo pone su propio ✕, igual que
       * `cerrarAvisoOcupadoAsync` suelta su aviso. La diferencia importa en la vista reducida
       * (ronda 4): nace del 410 del /resultado, que llega DESPUÉS del FIN, así que marcarla leída
       * desde aquí la daba por vista cuando el ✕ pulsado era el de otro bloque — y en el camino
       * normal, el del autocierre de FIN, ni existía todavía (r4212996634).
       */
      descartarPasadaDeLaBanda(pasadaId) {
        const id = pasadaId || null;
        const esLaFase = !!this.pasadaAsync && (this.pasadaAsync.pasadaId || null) === id;
        // El inspector se resuelve ANTES de soltar el estado: dos líneas más abajo `pasadaAsync`
        // puede quedar en null y entonces ya no habría a quién atribuir el cierre.
        if (id && !(esLaFase && this.pasadaAsync.enCurso)) {
          this.anotarAvisoCerrado(this.inspectorDePasada(id), id);
        }
        if (esLaFase) {
          this.pasadaAsync = null;
          this.pasadaAsyncTimeoutAviso = false;
          this.cancelarAutocierreFaseAsync();
          this.cancelarTimeoutPasadaAsync();
          // Desengancha el listener SSE de esta pasada: ya no vamos a pintar más eventos suyos y
          // el canal del hub sigue vivo para otros SSE.
          if (this.pasadaAsyncOff) { try { this.pasadaAsyncOff(); } catch (e) {} this.pasadaAsyncOff = null; }
        }
        if (this.pasadaAsyncTerminadaOferta
            && (this.pasadaAsyncTerminadaOferta.pasadaId || null) === id) {
          this.pasadaAsyncTerminadaOferta = null;
        }
      },
      /**
       * #283 (ronda 6) · a qué inspector pertenece una de las pasadas que la banda tiene en la
       * mano. Se pregunta a los propios bloques (`candidatosBandaFlotante`), que es donde está
       * escrito de quién habla cada uno.
       *
       * NO se deduce de `inspectorFiltro`, y esto es la mitad del arreglo: la banda sobrevive a
       * propósito a un cambio de inspector —la propuesta anterior sigue pintada y es ella la que
       * gobierna «Aceptar planificación»—, así que cerrar el aviso de la pasada de A con el filtro
       * ya puesto en B archivaría el cierre bajo B, y al volver a A el aviso reaparecería: el mismo
       * defecto que se está cerrando, por otra puerta.
       */
      inspectorDePasada(pasadaId) {
        if (!pasadaId) return null;
        // Se mira el candidato aunque ya no se dibuje (`hay` en false): el ✕ de la vista reducida
        // marca su «ya lo he leído» ANTES de pasar por la salida única, así que para cuando se
        // pregunta aquí su bloque ya no se está pintando y seguiría teniendo que archivarse bien.
        const conNombre = this.candidatosBandaFlotante.find(function (c) {
          return c.pasadaId === pasadaId && !!c.inspector;
        });
        return conNombre ? conNombre.inspector : null;
      },
      /**
       * #283 (ronda 6) · ¿el planificador ya cerró el aviso de ESTA pasada? Mira la identidad
       * entera con la que se archivó: sesión, inspector y pasada.
       *
       * El `pasadaId` es UUID por pasada, así que por sí solo ya distingue una propuesta de otra
       * —y es lo que garantiza que una propuesta NUEVA no herede el cierre de la anterior—. La
       * sesión y el inspector no están para volver a demostrar eso, sino para que una anotación no
       * se aplique fuera de donde se hizo; de ahí que un lado desconocido no invalide la
       * coincidencia: convertir un dato que falta en «este aviso no estaba cerrado» es justo el
       * defecto que se está arreglando.
       */
      avisoCerradoDeLaPasada(inspector, pasadaId) {
        if (!pasadaId) return false;
        const yo = this.getMiUsername() || null;
        const delInspector = inspector || null;
        return (this.pasadaAsyncDescartadas || []).some(function (d) {
          if (d.pasadaId !== pasadaId) return false;
          if (d.usuario && yo && d.usuario !== yo) return false;
          if (d.inspector && delInspector && d.inspector !== delInspector) return false;
          return true;
        });
      },
      /**
       * #283 (ronda 6) · anota que el aviso de esta pasada queda cerrado. Una entrada por aviso,
       * con su identidad y con el instante del cierre.
       *
       * El plazo (`RETENCION_PASADA_MS`) se aplica AL ESCRIBIR, que es cuando el registro crece, y
       * no al leer. Dos razones: una pasada que ya pasó la retención del backend no puede volver a
       * entrar ella sola —/en-curso ya no la devuelve—, así que caducar la anotación no cambia
       * nada de lo que se ve; y meter `Date.now()` en el computed de la banda daría una caducidad
       * falsa, porque un computed no se recalcula porque venza un plazo. O sea: el plazo está para
       * no acumular anotaciones inservibles, no para dejar de recordar.
       *
       * El tope es la segunda red, para la pantalla que se queda abierta toda la jornada: si la
       * purga por tiempo no bastara, se van las anotaciones más antiguas, que son precisamente las
       * que ya no pueden volver.
       */
      anotarAvisoCerrado(inspector, pasadaId) {
        if (!pasadaId) return;
        if (this.avisoCerradoDeLaPasada(inspector, pasadaId)) return;
        const ahora = Date.now();
        const vivas = (this.pasadaAsyncDescartadas || []).filter(function (d) {
          return (ahora - d.cerradoEnMs) < RETENCION_PASADA_MS;
        });
        vivas.push({
          usuario: this.getMiUsername() || null,
          inspector: inspector || null,
          pasadaId: pasadaId,
          cerradoEnMs: ahora
        });
        this.pasadaAsyncDescartadas = vivas.length > MAX_PASADAS_DESCARTADAS
          ? vivas.slice(vivas.length - MAX_PASADAS_DESCARTADAS)
          : vivas;
      },
      /**
       * #283 (ronda 3) · deja la banda flotante en blanco para empezar una corrida nueva. La
       * lista de banderas de la banda vive AQUÍ y no desplegada en `proponerPlanificacion`: era
       * una enumeración que había que repasar cada vez que la banda estrenaba un estado, y
       * olvidarse de una es exactamente lo que deja un aviso de la pasada anterior encima de la
       * nueva.
       *
       * `pasadaAsyncDescartadas` NO se rebobina: la corrida nueva trae su propio `pasadaId`, y
       * borrar el registro de los cierres resucitaría la oferta de «ver terminada» de las viejas.
       * Que la nueva no herede el cierre de la anterior lo garantiza la identidad de cada entrada,
       * no el vaciado del registro (ronda 6).
       */
      limpiarBandaFlotante() {
        this.pasadaAsync = null;
        this.pasadaAsyncOcupadoDeOtro = null;
        this.pasadaAsyncTerminadaOferta = null;
        this.pasadaAsyncTimeoutAviso = false;
        this.pasadaAsyncModoReducido = false;
        this.pasadaAsyncModoReducidoMotivo = null;
        this.pasadaAsyncModoReducidoPasadaId = null;
        this.pasadaAsyncModoReducidoInspector = null;
        this.pasadaAsyncModoReducidoAvisoCerrado = false;
        this.cancelarAutocierreFaseAsync();
      },
      // El ✕ del aviso de timeout: cierra el aviso y limpia la pasada — el planificador
      // puede relanzar desde el botón normal del drawer.
      cerrarAvisoTimeoutPasadaAsync() {
        this.pasadaAsyncTimeoutAviso = false;
        this.descartarPasadaDeLaBanda(this.pasadaAsync ? this.pasadaAsync.pasadaId : null);
      },
      // ENCARGO-025 · ✕ de la banda flotante de fase (solo se ofrece en FIN y ERROR — el resto
      // de fases sigue avanzando y ocultarlas sería un fallo silencioso).
      cerrarAvisoFaseAsync() {
        this.descartarPasadaDeLaBanda(this.pasadaAsync ? this.pasadaAsync.pasadaId : null);
      },
      // ENCARGO-025 · ✕ de la banda flotante de "ocupado por otro". El planificador ya ha leído
      // el motivo del backend; a partir de aquí puede esperar a que se libere el inspector y
      // volver a lanzar. Sin esta salida la banda quedaría fija en pantalla hasta la próxima
      // pasada.
      cerrarAvisoOcupadoAsync() {
        this.pasadaAsyncOcupadoDeOtro = null;
      },
      // #283 · ✕ de la banda de vista reducida, que hasta ahora era el único bloque de la banda
      // sin ninguna salida (su propio comentario la llamaba «vista reducida permanente»).
      //
      // Lo que oculta es el AVISO y no la marca que deshabilita «Aceptar planificación»:
      // `pasadaAsyncModoReducido` sigue puesta, porque aceptar una propuesta que no se ve entera
      // sigue prohibido pase lo que pase con el aviso (ENCARGO-023 §2) y el motivo sigue junto al
      // botón, en su `title`, que es donde §9 pide que esté.
      //
      // El «ya lo he leído» lo pone ESTE ✕ y solo este (ronda 4): es el único que acredita que el
      // aviso estuvo delante de alguien. Lo que sí es de toda la banda —que esta pasada ya no tiene
      // nada más que decir— lo sigue anotando la salida única.
      cerrarAvisoModoReducido() {
        this.pasadaAsyncModoReducidoAvisoCerrado = true;
        this.descartarPasadaDeLaBanda(this.pasadaAsyncModoReducidoPasadaId);
      },
      /**
       * #283 · cierre único de la banda flotante: cierra EL bloque que se está viendo, con el
       * mismo efecto que su ✕. Lo usa `Esc`.
       *
       * Un único punto de entrada y no un `if` por bloque dentro del manejador de teclado: así
       * `Esc` y el ✕ no pueden divergir, que es como la fila de botones de FIN se quedó colgando
       * de `runPropuesta` sin que nadie lo notara en el resto de los caminos.
       */
      cerrarAvisoFlotante() {
        if (!this.avisoFlotanteCerrable) return false;
        switch (this.bloqueAvisoFlotante) {
          case 'timeout':   this.cerrarAvisoTimeoutPasadaAsync(); return true;
          case 'reducido':  this.cerrarAvisoModoReducido();       return true;
          case 'ocupado':   this.cerrarAvisoOcupadoAsync();       return true;
          case 'fase':      this.cerrarAvisoFaseAsync();          return true;
          case 'terminada': this.descartarPasadaTerminada();      return true;
          default: return false;
        }
      },
      // #283 · `Esc` cierra el aviso cuando es cerrable. Las fases en curso no lo son, así que
      // `Esc` no puede ocultar una pasada que sigue avanzando: la misma regla que el ✕.
      onEscBandaFaseAsync(ev) {
        if (!ev) return;
        if (ev.key !== 'Escape' && ev.key !== 'Esc' && ev.keyCode !== 27) return;
        if (!this.avisoFlotanteCerrable) return;
        // Con un popup de Framework7 o un diálogo de Vuetify abiertos, el `Esc` es suyo: la banda
        // queda detrás y cerrar a ciegas algo que no se está viendo es peor que no hacer nada.
        if (document.querySelector('.modal-in, .v-dialog--active')) return;
        this.cerrarAvisoFlotante();
      },
      // #283 · autocierre de los estados terminales a los 4,5 s. Lo arma el watch de
      // `avisoFaseAsyncAutocierra`, nunca se llama a mano.
      armarAutocierreFaseAsync() {
        const self = this;
        self.cancelarAutocierreFaseAsync();
        self.pasadaAsyncAutocierre = setTimeout(function () {
          self.pasadaAsyncAutocierre = null;
          // Se vuelve a preguntar al disparar: entre armar y cerrar cabe una pasada nueva (que
          // deja la fase en EN_COLA) o un bloque con más prioridad por delante. Cerrar sin mirar
          // ocultaría una fase en curso, que es justo lo que no se puede hacer.
          if (self.avisoFaseAsyncAutocierra) self.cerrarAvisoFaseAsync();
        }, AUTOCIERRE_FASE_MS);
      },
      cancelarAutocierreFaseAsync() {
        if (this.pasadaAsyncAutocierre) {
          clearTimeout(this.pasadaAsyncAutocierre);
          this.pasadaAsyncAutocierre = null;
        }
      },
      /**
       * #283 · coloca la banda flotante DEBAJO de la barra de indicadores, para que no tape nunca
       * OEB-PPEND, TPC, TPIP, TPIP€, horas ni km — que es la cifra que se mira justo después de
       * proponer.
       *
       * Se mide en vez de fijar un número porque la barra no tiene un alto fijo: los badges van
       * apareciendo a medida que llegan las cifras (`v-if="totalPPend"` y compañía) y se reparten
       * en más filas al estrechar la ventana, y el enunciado pide que no solape «en ninguna fase y
       * a cualquier anchura». Se toma el borde inferior MÁS BAJO de la barra y de su contenedor:
       * el `v-sheet` tiene alto fijo (64) y los badges pueden desbordarlo.
       *
       * Mover la banda, y no reorganizar la cabecera: §9 del CLAUDE.md del orquestador —una
       * pantalla que ya funciona no se reordena para hacer sitio a un aviso—.
       */
      recolocarBandaFaseAsync() {
        const raiz = this.$el;
        let fondo = 0;
        if (raiz && typeof raiz.querySelector === 'function') {
          // `.badges-totales` no se pinta en cordova (v-if sobre `target`), así que el contenedor
          // es el respaldo y no un adorno.
          ['.sheetPadre', '.badges-totales'].forEach(function (selector) {
            const nodo = raiz.querySelector(selector);
            if (!nodo || typeof nodo.getBoundingClientRect !== 'function') return;
            const caja = nodo.getBoundingClientRect();
            if (caja && caja.height > 0 && caja.bottom > fondo) fondo = caja.bottom;
          });
        }
        const top = fondo > 0
          ? Math.max(TOP_BANDA_FASE_PX, Math.round(fondo) + HOLGURA_BANDA_FASE_PX)
          : TOP_BANDA_FASE_PX;
        // Solo se asigna si cambia: esto lo llama el hook `updated`, y reasignar el mismo valor
        // volvería a renderizar sin fin.
        if (this.topBandaFaseAsync !== top) this.topBandaFaseAsync = top;
      },
      // ENCARGO-023 · FIN de la pasada: SIEMPRE se prueba primero `/resultado` (el
      // ProponerResponseDTO íntegro cacheado por el backend). Con él, la pasada async se pinta
      // EXACTAMENTE IGUAL que la síncrona porque ambos pasan por la MISMA función de
      // materialización — `aplicarProponerResponseDto(data)` — sin transformar el DTO ni
      // reconstruir nada.
      //
      // Si el /resultado devuelve 410 (caducado por tope o purga temporal, o la pasada terminó
      // en ERROR — en ese caso ya no llegamos aquí, pero por defensa), se cae al `informe(id, runId)`
      // como RESPALDO REDUCIDO: la propuesta se pinta desde el audit-log (menos campos), el
      // Aceptar queda DESHABILITADO y aparece una banda permanente que dice qué falta y por
      // qué. **No se acepta una propuesta que no se ve entera.**
      finalizarPasadaAsync(finPayload) {
        const self = this;
        const app = self.$f7;
        const crono = TiemposProponer.dePasada(self.$_cronoProponer, finPayload.pasadaId);   // #1201
        // Reset del modo reducido antes de intentar el /resultado.
        self.pasadaAsyncModoReducido = false;
        self.pasadaAsyncModoReducidoMotivo = null;
        self.pasadaAsyncModoReducidoPasadaId = null;        // #283 · y del sello de a quién era
        self.pasadaAsyncModoReducidoInspector = null;       // #283 · y de su inspector
        self.pasadaAsyncModoReducidoAvisoCerrado = false;   // #283 · y del "ya lo he leído"
        Planificacion.proponerAsyncResultado({ pasadaId: finPayload.pasadaId })
          .then(function (res) {
            // 200 OK: `data` es el ProponerResponseDTO. Pasa por la misma función que la vía
            // síncrona — línea 2674 antes del refactor de 021c (`Planificacion.proponer().then`)
            // → ahora está factorizada en `aplicarProponerResponseDto(data)` para reutilizarla
            // desde ambos caminos SIN TRANSFORMAR el DTO.
            const data = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
            if (!data) {
              app.dialog.alert(self.$t('proponerDrawer.errorLanzar'));
              return;
            }
            TiemposProponer.marcar(crono, 'resultado');
            self.aplicarProponerResponseDto(data);
            TiemposProponer.marcar(crono, 'aplicada');
            // #1201 · la propuesta entra en la rejilla con la recarga de la agenda, así que «pintada» es
            // cuando esa recarga termina y Vue ha repintado. Si la recarga falla, ya lo avisa ella.
            Promise.resolve(self.getPlanificaciones()).then(function () {
              self.$nextTick(function () {
                TiemposProponer.marcar(crono, 'pintada');
                TiemposProponer.trazar(crono, data.tiempos);
              });
            }, function () {});
          })
          .catch(function (e) {
            if (typeof e === 'string') e = { error: e };
            // 410 Gone → vista reducida desde el audit-log + Aceptar deshabilitado con motivo.
            // ENCARGO-027: el backend ahora tira CustomException(motivo, GONE) y el envelope
            // del core lo devuelve como ResponseDto{error:{message:motivo}}. sendRequest lo
            // reempaqueta como e.message (ver DatabaseModel.sendRequest → errorCallback).
            const es410 = e && (e.status === 410 || (e.xhr && e.xhr.status === 410));
            if (es410) {
              const motivoBackend = e.message
                || (e.xhr && e.xhr.response && (function () {
                    try {
                      const body = JSON.parse(e.xhr.response);
                      return (body.error && body.error.message) || body.motivo || null;
                    } catch (ex) { return null; }
                  })())
                || null;
              self.finalizarPasadaAsyncModoReducido(finPayload, motivoBackend);
              return;
            }
            app.dialog.alert(e.message || e.error || self.$t('proponerDrawer.errorLanzar'));
          });
      },
      // §2 del ENCARGO-023 · si el DTO completo ya no está, respaldo desde el audit-log y
      // Aceptar deshabilitado permanentemente. La banda del drawer avisa por qué falta y qué.
      finalizarPasadaAsyncModoReducido(finPayload, motivoBackend) {
        const self = this;
        const app = self.$f7;
        // Marca de estado — la vista deshabilita el botón Aceptar y muestra la banda.
        self.pasadaAsyncModoReducido = true;
        self.pasadaAsyncModoReducidoMotivo = motivoBackend
          || self.$t('proponerDrawer.reducidaDefault');
        // #283 (ronda 3) · DE QUIÉN es la marca. Es lo que permite que el avance de la pasada
        // siguiente se vea aunque esta siga deshabilitando Aceptar (r4212680956).
        self.pasadaAsyncModoReducidoPasadaId = finPayload.pasadaId || null;
        // #283 (ronda 6) · y de qué inspector, que es la otra mitad de la identidad con la que se
        // archiva su cierre. Sale de la pasada que acaba de terminar, no del filtro: para cuando
        // llega el 410 del /resultado la pantalla puede estar mirando a otro inspector.
        self.pasadaAsyncModoReducidoInspector = (self.pasadaAsync && self.pasadaAsync.inspector)
          || finPayload.inspector || self.inspectorFiltro || null;
        // #283 · aviso nuevo, salida nueva: si se cerró el de la corrida anterior, este se ve.
        self.pasadaAsyncModoReducidoAvisoCerrado = false;
        Planificacion.informePropuesta({ data: {
          id: finPayload.registroId,
          runId: finPayload.runId
        }}).then(function (res) {
          const data = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
          if (!data || !data.registro) {
            app.dialog.alert(self.$t('proponerDrawer.errorLanzar'));
            return;
          }
          self.materializarDesdeInforme(data);
          self.getPlanificaciones();
        }).catch(function (e) {
          if (typeof e === 'string') e = { error: e };
          app.dialog.alert(e.message || e.error || self.$t('proponerDrawer.errorLanzar'));
        });
      },
      // Función ÚNICA de materialización a partir de un `ProponerResponseDTO` (mismo shape que
      // devuelve `/planificacion/proponer` y `/planificacion/proponer/async/{id}/resultado`).
      // La misma que usaba antes el bloque `.then(function(res) { … })` del sync — ahora está
      // factorizada para reutilizarla desde ambos caminos SIN transformación del DTO.
      // ENCARGO-023 §2.1 (línea con línea): esta función es exactamente el bloque que estaba
      // in-line en `proponerPlanificacion()` pre-021b (SolverController.proponer entregaba a
      // este mismo consumo). Cambiar una línea aquí afectaría a las DOS vías por igual — es lo
      // que garantiza que se pintan igual.
      aplicarProponerResponseDto(data) {
        const self = this;
        // #460 (ronda 12) · mismo contrato de entrada que la agenda: la capa provisional acaba
        // dentro de `events` (`getPlanificaciones` hace el push al final), así que una propuesta
        // nula envenenaría el filtro y la plantilla por el otro lado. Se descarta, no se inventa.
        self.propuestas = self.planificacionesPintables(data.propuestas, 'la propuesta del solver').map(function(l) {
          self.materializarPropuesta(l);
          const color = self.getColorEvento(l);
          return {
            name: self.nombrePropuesta(l),
            color: color,
            colorLetras: self.getColorLetrasEvento(color),
            start: new Date(l.horaInicio).getTime(),
            end: l.horaFin ? new Date(l.horaFin).getTime()
                 : new Date(l.horaInicio).getTime() + ((l.tiempoEstimadoCampo || 0) * 60000),
            timed: true,
            planificacion: l
          };
        });
        // C4-B2: banco por semana + alertas de plazo (para la franja y el callout)
        self.banco = data.banco || [];
        self.alertasPlazo = (data.alertas || []).filter(function(a) {
          return a.tipo === 'PLAZO_INFORME_EN_RIESGO' || a.tipo === 'PLAZO_INFORME_JUSTO';
        });
        self.avisoTiempoAgotado = self.avisoTiempoAgotadoDe(data.alertas);
        self.noPlanificables = data.noPlanificables || [];
        // #325 (opción A): la página y el total del mismo universo llegan JUNTOS en esta respuesta.
        // Se guardan como una sola captura — no hay segunda petición que lanzar, ni dos relojes que
        // cuadrar, ni nada que comparar aquí. Si la API no manda el resumen (despliegue desparejado),
        // `resumen` queda a null y el panel dice que no tiene el total en vez de inventárselo.
        self.capturaNegocio = {
          lineas: data.bloqueadosNegocio || [],
          resumen: data.bloqueadosNegocioResumen || null
        };
        // C4-EXPLICABILIDAD: motivo por visita, tal cual lo registró el solver (transporte puro)
        self.explicaciones = data.explicaciones || [];
        // SPEC-REGISTRO-PROPUESTAS: runId de esta corrida → viajará en el aceptar (vínculo al registro).
        // OJO: el DTO serializa `run_id` (Jackson @JsonProperty) — hallazgo C4 de la auditoría 14/08.
        self.runPropuesta = (data.run && (data.run.run_id || data.run.runId)) || null;
      },
      /**
       * #325 (opción A) · Olvida la captura de bloqueadas por negocio: la lista Y su total, que son
       * lo mismo y viven en el mismo campo. Va en cada sitio que deja de enseñar la propuesta de la
       * corrida anterior.
       *
       * Antes esto eran dos pasos —vaciar la lista y olvidar el total— y había que acordarse de los
       * dos en cuatro caminos distintos; si uno se olvidaba, el panel afirmaba un total de algo que ya
       * no estaba pintando. Con la lista colgando de la captura (ver el computed `bloqueadosNegocio`)
       * es un solo campo y no hay mitad que se pueda quedar puesta.
       */
      olvidarCapturaNegocio() {
        this.capturaNegocio = null;
      },
      /**
       * #482 (ronda 2) · La captura de una propuesta RECONSTRUIDA del audit-log: sin líneas, sin
       * resumen y MARCADA como tal.
       *
       * No es lo mismo que no tener captura (`olvidarCapturaNegocio`). Sin captura la pantalla no
       * está enseñando ninguna propuesta y no afirma nada; aquí sí hay una propuesta delante, y lo
       * que falta es el dato: el registro no guarda las bloqueadas por negocio. La marca viaja en
       * el mismo campo que la lista y el resumen —y no en un booleano aparte— por lo mismo que la
       * #325 juntó la lista y el total: un solo campo no tiene mitades que se queden puestas.
       */
      marcarCapturaNegocioReconstruida() {
        this.capturaNegocio = { lineas: [], resumen: null, reconstruida: true };
      },
      /**
       * #325 · La hora de la captura, para el tooltip de la cabecera. Devuelve null si no hay fecha o
       * no se entiende: un tooltip sin hora es mejor que un tooltip con «Invalid date».
       */
      horaDeLaCaptura(fecha) {
        if (!fecha) {
          return null;
        }
        const m = moment(fecha);
        return m.isValid() ? m.format('HH:mm') : null;
      },
      /**
       * #482 · Una línea de la ventana, venga de donde venga. Las dos procedencias traen campos
       * distintos —la lista del solver no tiene fecha de bloqueo ni username, y puede no traer
       * población— y lo que falta se pinta «—»: el dato no se inventa ni se saca de otra consulta.
       *
       * `buscable` es lo que mira el buscador y se arma AQUÍ, con los mismos tres campos que promete
       * el hueco de búsqueda (pedido, cliente y población): si se armara en el filtro, cada sitio
       * que buscara miraría unos campos distintos de los que el placeholder anuncia.
       *
       * Y «Qué hacer» también se resuelve AQUÍ, por fila y según su procedencia (ronda 2): solo las
       * de NEGOCIO llevan al Control de planificación, porque solo ellas están allí (ver
       * `RUTA_CONTROL_PLANIFICACION`). Las del solver dicen la acción de su causa y no llevan a
       * ninguna parte: no hay pantalla que reciba una línea concreta para corregirle la dirección o
       * la habilitación, y el dato con el que apuntar a una (el pedido) no viaja en su DTO.
       */
      filaVentana(origen, grupo, linea) {
        const entidad = linea.entidad || null;
        const fecha = linea.fecha
          ? DateUtils.dateFormat(new Date(linea.fecha), 'DD/MM/YYYY')
          : null;
        const queHacer = origen === 'NEGOCIO'
          ? this.queHacerNegocio
          : { enlace: null, rotulo: grupo.accion || ACCION_SOLVER_POR_DEFECTO, externo: false };
        return {
          origen: origen,
          enlaceQueHacer: queHacer.enlace,
          enlaceQueHacerExterno: queHacer.externo,
          rotuloQueHacer: queHacer.rotulo,
          claveGrupo: origen + ':' + grupo.clave,
          etiquetaGrupo: grupo.etiqueta,
          accionGrupo: grupo.accion || null,
          lineaId: linea.lineaId || null,
          expediente: linea.expediente || null,
          servicio: linea.servicio || null,
          oferta: linea.oferta || null,
          cliente: linea.cliente || null,
          poblacion: linea.poblacion || null,
          entidad: entidad,
          fecha: fecha,
          // Las dos mitades de la columna «Entidad · fecha», ya resueltas: si no hay ninguna, «—».
          entidadFecha: (entidad || fecha) ? [entidad, fecha].filter(Boolean).join(' · ') : '—',
          // El importe conserva el 0 y guarda el `null` para cuando el campo no viaja: las dos
          // cosas se leen distinto y quien lo decide es `importeONulo`, aquí y en un solo sitio.
          importe: this.importeONulo(linea.importe),
          buscable: [linea.lineaId, linea.expediente, linea.cliente, linea.poblacion]
            .filter(Boolean).join(' ').toLowerCase()
        };
      },
      /**
       * #482 · Abre la ventana. NO relanza la propuesta ni pide nada: todo lo que enseña está ya en
       * el estado que dejó el Proponer, así que cerrarla y volver a abrirla es gratis.
       *
       * Rebobina el buscador y el filtro, que es lo que hace que «volver a abrirla» enseñe lo mismo
       * que la primera vez. Sin esto, una búsqueda de hace dos corridas seguiría puesta y la ventana
       * se abriría casi vacía sin que se viera por qué.
       */
      abrirVentanaNoPlanificables() {
        if (!this.hayBloqueadas) {
          return;                 // §9: no se abre una ventana vacía
        }
        this.busquedaNoPlanificables = '';
        this.filtroNoPlanificables = 'TODAS';
        this.ventanaNoPlanificables = true;
      },
      /**
       * #482 (ronda 3) · El ÚNICO sitio que decide si un importe HA LLEGADO.
       *
       * «No hay importe» y «el importe es cero» son dos cosas distintas, y hasta esta ronda eran el
       * mismo valor falsy: cada sitio —la celda de la línea, la de la fila de grupo, el Excel y los
       * recuadros— lo volvía a decidir con un `||`, así que una línea de 0 € se leía «—» y bajaba al
       * Excel con la celda vacía, y una línea sin importe podía rotularse «0,00 €». Es la misma
       * confusión que la ronda 2 quitó del botón, un nivel más abajo: en el valor de cada línea.
       *
       * Devuelve el número —el **0 incluido**, que es un importe medido— o `null` cuando el campo no
       * viaja. La lista del solver (`SolveResponseDTO.NoPlanificableDTO`) no trae importe y una
       * propuesta reconstruida del registro tampoco, así que el `null` es un caso corriente.
       */
      importeONulo(valor) {
        if (valor === null || valor === undefined || valor === '') {
          return null;
        }
        const n = Number(valor);
        return isFinite(n) ? n : null;
      },
      /**
       * #482 (ronda 3) · Y el único que decide cómo se LEE en una celda de la tabla: «—» cuando no
       * hay importe y el importe escrito cuando lo hay, con el 0 como «0,00 €». La plantilla no
       * vuelve a preguntarlo —no hay ningún `importe ? … : '—'` suelto—, que es lo que hacía que
       * cada celda pudiera contestar distinto.
       */
      importeCelda(valor) {
        const n = this.importeONulo(valor);
        return n === null ? '—' : this.importeVentana(n);
      },
      /**
       * #482 · El importe tal y como lo escribe el resto de la pantalla, pero sin dejar un 0 pelado:
       * `getFormatImporte` devuelve el propio valor cuando es 0 o null, y un recuadro de dinero que
       * dice «0» al lado de otro que dice «1197,00 €» se lee como un error de carga.
       *
       * Y sin dejar que una ausencia se lea como un cero medido (ronda 3): si no hay importe lo dice
       * con las mismas palabras que los recuadros de una propuesta reconstruida.
       */
      importeVentana(importe) {
        const n = this.importeONulo(importe);
        if (n === null) {
          return NO_DISPONIBLE;
        }
        return this.getFormatImporte(n) || '0,00 €';
      },
      /**
       * #482 (ronda 4) · El ÚNICO sitio que SUMA importes de «No planificables»: los recuadros, el
       * rótulo del botón y las filas de grupo pasan por aquí.
       *
       * La ronda 3 dejó en `importeONulo` qué es una ausencia y qué un cero en UNA línea, pero las
       * sumas seguían cada una por su lado, y la del solver convertía las ausencias en ceros: con la
       * lista del solver sin importe, «Solver» y «Total bloqueado» afirmaban «0,00 €». Una suma es
       * más que un número, y lo demás viaja con él:
       *   - `importe`: lo que suman las líneas que SÍ traen importe (el 0 cuenta como importe), o
       *     `null` si hay líneas y ninguna lo trae —no se sabe, y eso no es cero—. Sin líneas es 0:
       *     no hay nada bloqueado, y eso sí es un cero medido.
       *   - `conImporte` / `sinImporte`: cuántas lo traen y cuántas no. Con `sinImporte` y un
       *     `importe` no nulo, la suma es PARCIAL y quien la pinte tiene que decirlo (`textoSuma`).
       *     Los dos recuentos hacen falta para JUNTAR sumas: el 0 de una lista vacía no es un
       *     importe que se pueda sumar a una ausencia y llamarlo «0,00 €».
       */
      sumaImportes(valores) {
        const self = this;
        let total = 0;
        let conImporte = 0;
        let sinImporte = 0;
        (valores || []).forEach(function(v) {
          const n = self.importeONulo(v);
          if (n === null) {
            sinImporte++;
          } else {
            conImporte++;
            total += n;
          }
        });
        return this.suma(total, conImporte, sinImporte);
      },
      /** Dos sumas en una, sin que dos ausencias den un cero ni una ausencia borre lo que sí se sabe. */
      juntarSumas(a, b) {
        return this.suma((a.importe || 0) + (b.importe || 0),
          (a.conImporte || 0) + (b.conImporte || 0), (a.sinImporte || 0) + (b.sinImporte || 0));
      },
      // La regla de la ausencia, escrita una vez: sin ningún sumando con importe y alguno sin él, no
      // hay cifra.
      suma(total, conImporte, sinImporte) {
        return { importe: !conImporte && sinImporte ? null : total,
          conImporte: conImporte, sinImporte: sinImporte };
      },
      /**
       * Cómo se LEE una suma: `vacio` cuando no hay ningún importe («—» en la tabla, «no disponible»
       * en los recuadros), el importe escrito cuando lo hay, y si es parcial, cuántas líneas se han
       * quedado fuera de ella.
       */
      textoSuma(suma, vacio) {
        if (!suma || suma.importe === null) {
          return vacio;
        }
        return this.importeVentana(suma.importe) + this.coletillaSinImporte(suma);
      },
      coletillaSinImporte(suma) {
        const n = (suma && suma.sinImporte) || 0;
        return n ? ' (' + n + ' sin importe)' : '';
      },
      /**
       * Grupos o líneas por importe descendente. El ORDEN sí trata la ausencia como 0: no es una
       * afirmación, y un `null` en la resta daría NaN y un orden indefinido. Los grupos de la #325
       * no guardan su importe, así que se mide aquí con la misma suma que pinta la ventana.
       */
      ordenarPorImporte(lista) {
        const self = this;
        const clave = function(x) {
          if (x.items) {
            return self.sumaImportes(x.items.map(function(i) { return i.importe; })).importe || 0;
          }
          return self.importeONulo(x.importe) || 0;
        };
        return lista.slice().sort(function(a, b) { return clave(b) - clave(a); });
      },
      /**
       * #482 · Excel de lo que la ventana está enseñando EN ESE MOMENTO, con el buscador y el filtro
       * puestos. Mismo patrón que `informes-pendientes.vue` y `control-planificacion.vue`: CSV con
       * BOM y «;», que Excel en es-ES abre de doble clic. No se añade librería nueva.
       */
      exportarNoPlanificables() {
        const self = this;
        const esc = function(v) {
          let s = String(v == null ? '' : v);
          // Anti-inyección de fórmulas: Excel ejecuta como fórmula las celdas que empiezan por
          // =,+,-,@ (o TAB/CR); el apóstrofo inicial las fuerza a texto.
          if (/^[=+\-@\t\r]/.test(s)) s = "'" + s;
          return '"' + s.replace(/"/g, '""') + '"';
        };
        const cab = ['Origen', 'Causa', 'Accion de la causa', 'Linea de pedido', 'Expediente',
          'Oferta', 'Cliente', 'Poblacion', 'Entidad', 'Fecha', 'Importe'];
        const cuerpo = [];
        self.gruposVentanaNoPlanificables.forEach(function(grupo) {
          grupo.items.forEach(function(f) {
            // La celda se deja VACÍA cuando no hay importe, igual que la tabla pinta «—»: un 0 en
            // una hoja de cálculo se suma y se promedia como si fuera un importe medido, y en una
            // propuesta reconstruida del registro ese dato simplemente no viaja. Y al revés: un
            // importe que ES 0 baja como 0 y no como celda vacía (ronda 3). Lo decide el mismo
            // `importeONulo` que la tabla, para que el Excel no pueda discrepar de lo que se ve.
            const importe = self.importeONulo(f.importe);
            cuerpo.push([grupo.origen, grupo.etiqueta, grupo.accion || '', f.lineaId, f.expediente,
              f.oferta, f.cliente, f.poblacion, f.entidad, f.fecha].map(esc)
              .concat(importe === null ? esc('') : self.numeroExcel(importe)).join(';'));
          });
        });
        // El BOM va como código y no como carácter literal: invisible en el fuente, lo borra
        // cualquier herramienta que normalice el fichero, y sin él Excel abre las tildes rotas.
        const BOM = String.fromCharCode(0xFEFF);
        const csv = BOM + cab.join(';') + '\n' + cuerpo.join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'no-planificables-' + new Date().toISOString().slice(0, 10) + '.csv';
        a.click();
        URL.revokeObjectURL(a.href);
      },
      /**
       * #482 (prueba del 31/10) · Un importe como lo lee Excel en es-ES: coma decimal, sin separador
       * de miles y sin comillas. Con el punto de `String(197.5)` Excel guardaba «197.5» como TEXTO y
       * la columna no se podía sumar. Va fuera de `esc` a propósito: sale de un número, así que no
       * puede ser una fórmula, y el apóstrofo que `esc` pone a un negativo lo volvería texto otra vez.
       */
      numeroExcel(n) {
        return Number(n).toFixed(2).replace('.', ',');
      },
      // Reconstruye las propuestas a partir del audit-log del /registro-propuestas/informe.
      // El registro guarda un RESUMEN por propuesta (nº pedido, nº línea, tipo, horaInicio,
      // minutos, lineaId) y `lineas` trae contexto comercial resuelto (cliente, población,
      // servicio, materia, importe). Cross-join por "numeroPedido#numLinea".
      // DEGRADACIONES (documentadas en la RESPUESTA-021c §3):
      //   - `esSegunda`, `desplazamientoPropuesto`, banco B2, bloqueadosNegocio y los cubos
      //     de no cubiertas NO se persisten en el audit-log → no se pintan.
      //   - `tipoTrabajo` se aproxima desde `tipo` (LINEA → CAMPO, TAREA → INFORME).
      // El flujo de "aceptar propuesta" NO se degrada: usa `runPropuesta` (el runId del solver)
      // que sí queda persistido. La materialización visual es un follow-up backend (deuda #128
      // hermana: extender ProponerJobService para cachear el ProponerResponseDTO completo).
      materializarDesdeInforme(informeData) {
        const self = this;
        const reg = informeData.registro;
        const lineasCtx = informeData.lineas || {};
        const resultado = (reg && reg.resultado) || {};
        // #460 (ronda 12) · ídem para la propuesta reconstruida del audit-log: un resumen nulo no
        // da un bloque, y el `null` que saldría de él viaja a `events` igual que los buenos.
        const propuestasResumen = self.planificacionesPintables(resultado.propuestasResumen, 'el registro de la propuesta');
        self.propuestas = propuestasResumen.map(function (r) {
          const clave = (r.numeroPedido != null ? r.numeroPedido : '') + '#' + (r.numLinea != null ? r.numLinea : '');
          const ctx = lineasCtx[clave] || {};
          // Construimos un objeto "planificación propuesta" con los campos que espera el
          // canvas y el resto del código (nombrePropuesta, getColorEvento, …). Falta lo que
          // no está en el audit-log; con lo que hay, el bloque se ve y se puede aceptar.
          const l = {
            id: null,
            estado: 'PLANIFICADA',
            pendienteConfirmar: false,
            tipo: r.tipo || 'LINEA',
            tipoTrabajo: (r.tipo === 'TAREA') ? 'INFORME' : 'CAMPO',
            // #460 · la CLASIFICACIÓN que la corrida tiene guardada, tal cual. El `tipoTrabajo` de
            // arriba es una aproximación —el audit-log no guarda `tipoTarea`— y mete en el mismo
            // saco un informe de oficina y una continuación multidía; con ellas confundidas, el
            // descarte de un día se llevaba la visita entera (ver `UnidadAceptable.tipoGuardado`).
            // Es `null` en las corridas anteriores a la opción A, y entonces manda la aproximación.
            tipoUnidad: r.tipoUnidad || null,
            lineaId: r.lineaId || null,
            numeroPedido: r.numeroPedido,
            codigoPedido: r.codigoPedido || ctx.codigoPedido || null,
            numLinea: r.numLinea,
            horaInicio: r.horaInicio ? new Date(r.horaInicio) : null,
            horaFin: null,
            tiempoEstimadoCampo: r.minutos || null,
            idPedido: ctx.idPedido || null,
            cliente: ctx.cliente ? { nombre: ctx.cliente, razonSocial: ctx.cliente } : null,
            direccionInspeccion: (ctx.poblacion || ctx.provincia) ? {
              poblacion: ctx.poblacion || null,
              provinciaStr: ctx.provincia || null
            } : null,
            servicio: ctx.servicio ? {
              codigo: ctx.servicio,
              materia: ctx.materia ? { codigo: ctx.materia } : null
            } : null,
            importeReparto: ctx.importe || null,
            esSegunda: null,                     // no persistido en el audit-log
            desplazamientoPropuesto: null        // ídem
          };
          self.materializarPropuesta(l);
          const color = self.getColorEvento(l);
          const startMs = l.horaInicio ? l.horaInicio.getTime() : 0;
          return {
            name: self.nombrePropuesta(l),
            color: color,
            colorLetras: self.getColorLetrasEvento(color),
            start: startMs,
            end: startMs + ((l.tiempoEstimadoCampo || 0) * 60000),
            timed: true,
            planificacion: l
          };
        });
        // Explicaciones por visita (mismo shape que ProponerResponseDTO.ExplicacionVisitaDTO
        // menos `inspectorId`, que el registro no tiene pero el join por lineaId no necesita).
        self.explicaciones = (resultado.explicaciones || []).map(function (e) {
          return {
            lineaId: e.lineaId,
            motivoColocacion: e.motivoColocacion,
            detalle: e.detalle,
            alternativaDescartada: e.alternativaDescartada,
            criterio: e.criterio
          };
        });
        // El runId de la corrida sirve para el flujo de aceptar (marcarAceptadas por runId).
        self.runPropuesta = resultado.runId || null;
        // #460 · aceptar desde una propuesta rehecha del audit-log no necesita aquí ninguna marca:
        // el plan de unidades de la corrida lo tiene la API, derivado de la propuesta que guardó
        // cuando el solver la dio, con el tipo de trabajo completo. El denominador no sale de aquí.
        // Lo que sí sale de aquí es a qué unidad pertenece cada bloque en pantalla, y para eso la
        // reconstrucción lleva `tipoUnidad` (la clasificación guardada): sin él, la degradación
        // «una continuación multidía vuelve como informe» agrupaba sus días en una sola unidad y el
        // descarte de uno se llevaba todos. Sigue en pie, y es tarea aparte, que el ACEPTAR de una
        // continuación reconstruida crea un T0005 en vez del T0004 que toca: eso cambia lo que el
        // Aceptar crea y no entra en el alcance de esta.
        // No-planificables técnicas resumidas (algunas propiedades comerciales pueden faltar).
        self.noPlanificables = (resultado.noPlanificables || []).map(function (np) {
          return {
            lineaId: np.lineaId,
            expediente: np.expediente,
            motivo: np.motivo,
            detalle: np.detalle
          };
        });
        // Estos tres NO están en el audit-log — quedan vacíos y sus paneles no se pintan.
        // Documentado en la RESPUESTA-021c como degradación conocida.
        self.banco = [];
        // #325: sin lista de negocio no se pinta su sección, así que tampoco se afirma un total de
        // algo que no se está enseñando. La lista y su total se van juntos: son la misma captura.
        //
        // #482 (ronda 2): y la captura se deja MARCADA como reconstruida, no simplemente olvidada.
        // Desde que el desglose se abre con un botón, «no hay captura» se leía en pantalla como
        // «esta propuesta no dejó ninguna línea bloqueada» —el botón en gris lo decía con esas
        // palabras—, y eso es una conclusión que este camino no puede sacar: aquí no se sabe si
        // hubo bloqueadas, porque el audit-log no las guarda. Tampoco los importes de las no
        // cubiertas del solver, que van más arriba sin `importe`.
        self.marcarCapturaNegocioReconstruida();
        self.alertasPlazo = [];
        // #311 · el registro sí guarda las alertas, aplanadas a texto: el corte por tiempo se rescata
        // de ahí, que una propuesta rehecha del audit-log sigue siendo la propuesta cortada.
        self.avisoTiempoAgotado = self.avisoTiempoAgotadoDe(resultado.alertas);
      },
      // Extrae el username del planificador conectado desde la sesión que guarda el login.
      getMiUsername() {
        try {
          const s = JSON.parse(window.localStorage.getItem('session') || '{}');
          return s.username || (s.user && (s.user.username || s.user.userName)) || null;
        } catch (e) { return null; }
      },
      // Etiqueta legible de la fase actual — usada en la banda del drawer.
      faseLabel(fase) {
        const t = this.$t.bind(this);
        switch (fase) {
          case 'EN_COLA':      return t('proponerDrawer.faseEnCola');
          case 'CONSTRUYENDO': return t('proponerDrawer.faseConstruyendo');
          case 'RESOLVIENDO':  return t('proponerDrawer.faseResolviendo');
          case 'MAPEANDO':     return t('proponerDrawer.faseMapeando');
          case 'FIN':          return t('proponerDrawer.faseFin');
          case 'ERROR':        return t('proponerDrawer.faseError');
          default:             return t('proponerDrawer.faseDesconocida');
        }
      },
      // C4-REALINEAMIENTO: muta la línea propuesta al shape de una planificación REAL (para que se pinte y
      // sume igual que las de siempre). Campo ya viene como LINEA de movilidad; TPIP se materializa como
      // tarea T0005 (así entra en las badges TPIP€/tiempo existentes). NO persiste hasta Aceptar.
      materializarPropuesta(l) {
        l.esPropuesta = true;
        l.estado = 'PLANIFICADA';
        // (B) esPropuesta + pendienteConfirmar=true → el campo (LINEA) cae en OEB-PPEND (amarillo) y, al
        // aceptar, la plani real nace también pendiente de confirmar. Llega en false del solver; el front la marca.
        l.pendienteConfirmar = true;
        if (l.tipoTrabajo === 'INFORME') {                 // (A) TPIP → tarea T0005 (NO LINEA): suma en TPIP, no en TPC
          l.tipo = 'TAREA';
          if (!l.tipoTarea) { l.tipoTarea = { codigo: 'T0005', nombre: 'TPI' }; }
          l.codigoTarea = l.codigoTarea || 'T0005';
        }
        return l;
      },
      // Nombre visible de la propuesta (misma imagen que un evento real).
      nombrePropuesta(l) {
        if (l.tipo === 'TAREA' && l.nombreTarea) {
          // Continuación multidía (T0004): mismo formato que una tarea real (código tipo - nombre)
          return (l.tipoTarea && l.tipoTarea.codigo ? l.tipoTarea.codigo + ' - ' : '') + l.nombreTarea;
        }
        if (l.tipoTrabajo === 'INFORME') {
          return 'TPI · ' + this.fmtMin(l.tiempoEstimadoCampo);      // "TPI · 1h20" (cantidad de tiempo)
        }
        if (l.servicio) {
          return (l.servicio.materia ? l.servicio.materia.codigo : l.servicio.codigo) + ' - ' + (l.servicio.nombre || '');
        }
        return l.codigoExpediente || 'Propuesta';
      },
      // C4-EXPLICABILIDAD: explicación de una propuesta, unida por lineaId con explicaciones[] de
      // /proponer. SOLO MUESTRA lo que trae la respuesta — no recalcula nada (ENAC): mismos datos →
      // mismo texto. Los bloques partidos/multidía de una visita comparten lineaId → mismo motivo.
      explicacionDe(p) {
        if (!p || !p.lineaId) return null;
        return (this.explicaciones || []).find(function(e) { return e.lineaId === p.lineaId; }) || null;
      },
      // Texto legible del motivo: diccionario ÚNICO compartido con el Informe de Propuesta
      // (src/js/MotivosPlanificacion.js) — un solo sitio para el mapa enum→texto.
      textoMotivo(e) {
        return MotivosPlanificacion.textoMotivo(e);
      },
      // Línea del panel "¿Por qué?": "MAR 08:35 · Rivas — por cercanía (38 km desde la anterior)".
      // Día/hora/lugar salen de la PROPUESTA; el motivo, de su explicación (unidos por lineaId).
      lineaPorQue(ev) {
        const p = ev.planificacion;
        const d = new Date(ev.start);
        const dias = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];
        const hh = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
        const lugar = (p.direccionInspeccion && p.direccionInspeccion.poblacion)
          ? p.direccionInspeccion.poblacion
          : (p.cliente && p.cliente.nombre ? p.cliente.nombre : (p.codigoExpediente || p.lineaId));
        return dias[d.getDay()] + ' ' + hh + ' · ' + lugar + ' — ' + this.textoMotivo(this.explicacionDe(p));
      },
      // Visitas propuestas CON motivo, una por lineaId (el 1er bloque de cada visita: los partidos por
      // comida/multidía comparten lineaId), en orden de agenda. Orden determinista (start, lineaId).
      propuestasConMotivo() {
        const self = this;
        const porLinea = {};
        (self.propuestas || []).forEach(function(ev) {
          const p = ev.planificacion;
          if (!p || !self.explicacionDe(p)) return;
          if (!porLinea[p.lineaId] || ev.start < porLinea[p.lineaId].start) {
            porLinea[p.lineaId] = ev;
          }
        });
        return Object.keys(porLinea).map(function(k) { return porLinea[k]; })
          .sort(function(a, b) {
            return (a.start - b.start)
              || (a.planificacion.lineaId < b.planificacion.lineaId ? -1 : 1);
          });
      },
      limpiarPropuestas() {
        this.propuestas = [];
        this.noPlanificables = [];
        this.olvidarCapturaNegocio();            // #325
        this.desdeDeLaPropuesta = null;
        this.banco = [];
        this.alertasPlazo = [];
        this.avisoTiempoAgotado = null;
        this.explicaciones = [];
        this.runPropuesta = null;
        this.panelPorQueAbierto = false;
        this.getPlanificaciones();
      },
      // C4: cuenta las pendientes de confirmar PERSISTIDAS (aceptadas: PLANIFICADA + pendienteConfirmar=true,
      // NO la capa provisional esPropuesta) del inspector visibles — lo que borra "Limpiar pendientes".
      contarPendientesPersistidas() {
        const self = this;
        if (!self.events || !self.events.length) return 0;
        return self.events.filter(function(e) {
          const p = e.planificacion;
          // #268 · sin las ausencias: los barridos del servidor las apartan desde la #48, y una
          // vacación puesta a mano entra ahora pendiente de confirmar, así que contarla dibujaba
          // «Confirmar pendientes (1)» para un botón que confirma 0.
          return p && p.estado === 'PLANIFICADA' && p.pendienteConfirmar === true && !p.esPropuesta
            && p.tipo !== 'DESPLAZAMIENTO' && !self.esAusenciaDeRh(p) && self.esInspector(p);
        }).length;
      },
      /**
       * #282 ronda 3 · PUNTO ÚNICO del nombre de cada clase de bloque que el barrido borra. De aquí
       * salen la cifra, el nombre, el singular y el orden con que los nombran el aviso, los rótulos
       * de los botones, la segunda confirmación y el mensaje final: así ninguno de los cuatro puede
       * rotular por su cuenta lo que no ha mirado.
       *
       * El reparto era binario —`DESPLAZAMIENTO` o «visita»— y eso rotulaba por supuesto: aceptar
       * una propuesta de informe TPI o de continuación multidía persiste una `TAREA` (T0005 / T0004)
       * con `pendienteConfirmar`, así que el aviso llegaba a decir «3 visitas» cuando lo que iba a
       * borrar eran las tareas T0005/T0004. En una operación irreversible cuyo único cometido es
       * describir lo que destruye, el nombre lo tiene que poner el dato.
       *
       * `otros` está a propósito y NO es un cajón mudo: `tipo` es un enum de nueve valores y la
       * escoba alcanza cualquiera que llegue con `pendienteConfirmar`. Lo que no se sepa nombrar se
       * cuenta aparte y se lee «otros bloques» —dice menos, pero no miente—.
       *
       * El vocabulario es el que la pantalla ya usa: las badges del día llaman «Insp.» a
       * `LINEA`+`SINPEDIDO` y «Tareas» a `TAREA`.
       */
      gruposLimpieza() {
        return [
          { clave: 'visitas', tipos: ['LINEA', 'SINPEDIDO'], uno: 'visita', varios: 'visitas' },
          { clave: 'tareas', tipos: ['TAREA'], uno: 'tarea', varios: 'tareas' },
          { clave: 'otros', tipos: null, uno: 'otro bloque', varios: 'otros bloques' }
        ];
      },
      // Reparto a cero, con TODAS las claves de `gruposLimpieza`: lo que se devuelve cuando no hay
      // respuesta entendible. Un objeto a mano aquí volvería a dejar fuera el grupo que se añada.
      repartoLimpiezaVacio() {
        const r = { desplazamientos: 0, aceptadas: 0, total: 0 };
        this.gruposLimpieza().forEach(function(g) { r[g.clave] = 0; });
        return r;
      },
      /**
       * #282 · Reparte por tipo lo que contesta `/limpiarPendientes`. Desde #282 la respuesta mezcla
       * las propuestas aceptadas pendientes y los bloques `DESPLAZAMIENTO` que el barrido del back se
       * lleva de sus días: el diálogo necesita las cifras por separado —una visita, una tarea y un
       * tramo de ruta no son lo mismo y no se pueden sumar en un número sin nombre— y el total para
       * decir cuánto desaparece en junto. `aceptadas` es lo que borra cada botón sin contar la ruta:
       * es la cifra que decide si ese botón se dibuja, así que NO puede ser la de un solo grupo.
       */
      repartoLimpiezaPorTipo(res) {
        const arr = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
        const lista = Array.isArray(arr) ? arr : null;
        if (!lista) return null;                  // respuesta que no se entiende: el llamador decide
        const grupos = this.gruposLimpieza();
        const reparto = this.repartoLimpiezaVacio();
        reparto.total = lista.length;
        lista.forEach(function(p) {
          const tipo = (p && p.tipo) || null;
          if (tipo === 'DESPLAZAMIENTO') { reparto.desplazamientos += 1; return; }
          const grupo = grupos.filter(function(g) { return g.tipos && g.tipos.indexOf(tipo) > -1; })[0]
            || grupos[grupos.length - 1];          // el último es el cajón nombrado, nunca «visita»
          reparto[grupo.clave] += 1;
          reparto.aceptadas += 1;
        });
        return reparto;
      },
      /**
       * #282 ronda 3 · «20 visitas», «20 visitas y 3 tareas», «20 visitas, 3 tareas y 1 otro bloque».
       * Solo los grupos con cifra: nombrar uno vacío manda a buscar en el calendario algo que no
       * existe. Si no hay nada que nombrar devuelve la cifra en seco, que es lo único cierto.
       */
      fraseGruposLimpieza(reparto) {
        const partes = this.gruposLimpieza()
          .filter(function(g) { return reparto[g.clave] > 0; })
          .map(function(g) {
            return reparto[g.clave] + ' ' + (reparto[g.clave] === 1 ? g.uno : g.varios);
          });
        if (!partes.length) return (reparto.aceptadas || 0) + ' bloques';
        if (partes.length === 1) return partes[0];
        return partes.slice(0, -1).join(', ') + ' y ' + partes[partes.length - 1];
      },
      // #282: preview del barrido en UN rango, contado como lo cuenta el back. No se deduce de la otra
      // llamada ni de los `events` cargados: la cifra del aviso tiene que salir de quien borra.
      previewLimpiezaPendientes(fechaDesde, fechaHasta) {
        const self = this;
        return self.Planificacion.limpiarPendientes({ data: {
          inspector: self.inspectorFiltro, fechaDesde: fechaDesde, fechaHasta: fechaHasta, soloListar: true
        }}).then(function(res) {
          return self.repartoLimpiezaPorTipo(res) || self.repartoLimpiezaVacio();
        });
      },
      /**
       * #282 · Botón destructivo de un diálogo de Framework7, en rojo y separado del primero que haya
       * (que es siempre la salida).
       *
       * El rojo NO se pide con el `color: 'red'` de Framework7: `--f7-dialog-button-text-color` se
       * declara en `:root` como `var(--f7-theme-color)`, así que ya llega resuelto al botón y la clase
       * `color-red` que F7 le pondría no lo cambia. Se pinta con clase propia, en el `<style>` sin
       * scoped —el diálogo se monta colgado de `<body>`—.
       */
      botonDestructivo(botonesYaPuestos, texto, onClick) {
        const primero = botonesYaPuestos.length === 1;     // detrás de «Cancelar» y de nada más
        return {
          text: texto,
          cssClass: 'c4-limpiar-destructivo' + (primero ? ' c4-limpiar-separado' : ''),
          onClick: onClick
        };
      },
      /**
       * #282 · Cómo se llama, en el aviso, el tramo que la persona está viendo. NO es siempre una
       * semana: el selector de vista ofrece Mes, Semana y Día, y en Cordova el valor de partida es
       * Día. `fechaDesdeFiltro`/`fechaHastaFiltro` son el tramo que pinta esa vista y es el rango
       * que el botón manda al back, así que en vista Mes ese botón borra el mes entero. Llamarlo
       * «esta semana» presentaría como semanal un borrado irreversible de un mes, que es el mismo
       * engaño que esta ficha viene a cerrar. Si algún día apareciera una vista nueva, el nombre
       * neutro dice menos pero no miente.
       */
      nombresTramoVisible() {
        if (this.type === 'month') {
          return { este: 'este mes', enElQueVes: 'en el mes que estás viendo',
            loQueVes: 'El mes que estás viendo', titulo: 'Este mes', otros: 'de otros meses' };
        }
        if (this.type === 'day') {
          return { este: 'este día', enElQueVes: 'en el día que estás viendo',
            loQueVes: 'El día que estás viendo', titulo: 'Este día', otros: 'de otros días' };
        }
        if (this.type === 'week') {
          return { este: 'esta semana', enElQueVes: 'en la semana que estás viendo',
            loQueVes: 'La semana que estás viendo', titulo: 'Esta semana', otros: 'de otras semanas' };
        }
        return { este: 'el tramo que estás viendo', enElQueVes: 'en el tramo que estás viendo',
          loQueVes: 'El tramo que estás viendo', titulo: 'Tramo visible', otros: 'de otras fechas' };
      },
      // El cuerpo del diálogo es HTML y el empleado se escribe a mano en el filtro de la cabecera.
      escaparHtml(texto) {
        return String(texto == null ? '' : texto)
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      },
      // C4: botón "Limpiar pendientes de confirmar". SOLO por botón + confirm. El endpoint acepta CUALQUIER
      // rango (inspector + fechaDesde/fechaHasta obligatorios): el "solo la ventana visible" era un límite
      // del FRONT y dejaba residuo ppend invisible acumulándose en otras semanas (caso IAS: semanas de
      // corridas pre-fixes). Ahora: soloListar sobre el HORIZONTE (±90 días) para contar el residuo total,
      // y el diálogo ofrece limpiar la ventana o TODO el horizonte. Nunca REALIZADA ni confirmada.
      //
      // #282 · El aviso enumeraba lo que estaba a salvo («nunca se toca REALIZADA ni agenda confirmada»)
      // y callaba lo único en riesgo: las visitas que el usuario acababa de aceptar. Y la cifra no era la
      // de lo que se destruye —el barrido se lleva además los bloques de desplazamiento de esos días—.
      // Ahora nombra primero lo que borra con su cifra, la pide al back (que desde #282 informa de esos
      // bloques), y los rótulos dicen la consecuencia en vez del ámbito.
      limpiarPendientesConfirmar() {
        const self = this;
        const app = self.$f7;
        if (!self.inspectorFiltro || !self.fechaDesdeFiltro || !self.fechaHastaFiltro) {
          app.dialog.alert('Selecciona inspector y fechas antes de limpiar.');
          return;
        }
        // La ventana de ±90 días se cuenta SIEMPRE desde HOY, no desde el tramo que se está mirando:
        // es el rango que el botón manda al back, así que es el que el diálogo tiene que nombrar.
        const desdeH = moment().subtract(90, 'days').format('YYYY-MM-DD');
        const hastaH = moment().add(90, 'days').format('YYYY-MM-DD');
        const desdeV = self.fechaDesdeFiltro;
        const hastaV = self.fechaHastaFiltro;
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        // Un preview por botón, porque cada botón borra un rango distinto. Deducir la cifra del tramo
        // visible restándola de la del horizonte dejaría fuera sus desplazamientos, y mentiría del todo
        // si ese tramo cae fuera de los ±90 días.
        // #663 · `Promise.all` es nativa: atada, si la sesión cambia en vuelo no se abre el aviso ni
        // el `alert` de la cancelación sobre la cuenta siguiente. La espera la suelta su dueño.
        atarALaSesion(Promise.all([
          self.previewLimpiezaPendientes(desdeH, hastaH),
          self.previewLimpiezaPendientes(desdeV, hastaV)
        ])).then(function(previews) {
          espera.cerrar();
          self.avisarLimpiezaPendientes(previews[1], previews[0], desdeV, hastaV, desdeH, hastaH);
        }).catch(function(e) {
          espera.cerrar();
          app.dialog.alert((e && (e.message || e.error)) || 'No se pudo consultar el residuo pendiente.');
        });
      },
      /**
       * #282 · El aviso. Orden obligado por dirección: PRIMERO lo que se destruye y con su cifra; lo de
       * `REALIZADA` y la agenda confirmada va después y en letra secundaria. Dice también los
       * desplazamientos y las tareas que pueden quedarse huérfanas —lo que el barrido hace de verdad—,
       * y de qué empleado y de qué fechas concretas habla.
       */
      avisarLimpiezaPendientes(ventana, horizonte, desdeV, hastaV, desdeH, hastaH) {
        const self = this;
        const app = self.$f7;
        // `aceptadas` y no la cifra de un grupo: un tramo con solo tareas T0005/T0004 pendientes sí
        // tiene algo que limpiar, y con `visitas` se contestaba «no hay nada» y no se dibujaba botón.
        if (ventana.aceptadas === 0 && horizonte.aceptadas === 0) {
          app.toast.create({ text: 'No hay propuestas pendientes que limpiar (±90 días).', position: 'center', closeTimeout: 3000 }).open();
          return;
        }
        // El tramo visible se nombra por lo que de verdad abarca la vista (mes, semana o día): el
        // botón borra ese rango completo. Ver `nombresTramoVisible`.
        const tramo = self.nombresTramoVisible();
        // Solo se nombran los alcances que de verdad se ofrecen como botón: dar la cifra del tramo
        // visible cuando no hay botón para él es ruido que se lee como una opción que no existe.
        const alcances = [];
        if (ventana.aceptadas > 0) alcances.push({ etiqueta: tramo.este, p: ventana });
        if (horizonte.aceptadas > 0) alcances.push({ etiqueta: 'los ±90 días', p: horizonte });
        // La resta «las de fuera» SOLO vale si el tramo visible está dentro del horizonte: el
        // calendario navega sin límite de fecha, así que puede caer fuera, o a medias. Cuando no está
        // contenido, sus pendientes no son un subconjunto de las del horizonte y restar daría una cifra
        // inventada —20 en una semana futura y 70 en el horizonte anunciaban «más 50 de otras semanas»
        // cuando el otro botón iba a borrar 70 distintas—. Entonces no se relacionan las dos cifras:
        // cada botón dice la suya, que es la que su propio rango destruye.
        const ventanaDentroDelHorizonte = moment(desdeV).isSameOrAfter(moment(desdeH), 'day')
          && moment(hastaV).isSameOrBefore(moment(hastaH), 'day');
        const fuera = ventanaDentroDelHorizonte ? Math.max(0, horizonte.aceptadas - ventana.aceptadas) : 0;
        const porAlcance = function(valorDe, union) {
          return alcances.map(valorDe).join(union);
        };
        // A qué fechas corresponde la cifra que se acaba de dar: la resta solo se nombra cuando vale,
        // y si el tramo cae fuera del horizonte lo único cierto es acotarla al propio tramo.
        let alcanceDeLaCifra = '';
        if (!ventanaDentroDelHorizonte) alcanceDeLaCifra = ' ' + tramo.enElQueVes;
        else if (fuera > 0) alcanceDeLaCifra = ', más <b>' + fuera + '</b> ' + tramo.otros;
        // Cada cifra con el nombre que le corresponde a su tipo —ver `gruposLimpieza`—: «20 visitas»
        // si son líneas de campo, «20 visitas y 3 tareas» si entre lo aceptado hay un informe TPI o
        // una continuación multidía. Nunca «3 visitas» para tres tareas T0005/T0004.
        const destruye = ventana.aceptadas > 0
          ? 'Se van a borrar <b>' + self.fraseGruposLimpieza(ventana)
            + ' que has aceptado y que todavía no has confirmado</b>'
            + alcanceDeLaCifra + '. No se pueden recuperar.'
          : 'Se van a borrar <b>' + self.fraseGruposLimpieza(horizonte)
            + ' que has aceptado y que todavía no has confirmado</b>,'
            + ' todas ' + tramo.otros + ': ' + tramo.enElQueVes + ' no hay ninguna. No se pueden recuperar.';
        // Con el tramo visible fuera del horizonte y los dos botones en pantalla hay que decir por qué
        // las dos cifras no cuadran entre sí, o se leen como si una incluyera a la otra.
        const avisoFuera = (ventanaDentroDelHorizonte || alcances.length < 2) ? ''
          : '<p>' + tramo.loQueVes + ' cae fuera —del todo o en parte— de los ±90 días contados desde'
            + ' hoy, así que estas dos cifras no se suman ni se restan: cada botón borra lo de su rango.</p>';
        // El barrido de fichas de tarea solo se dispara por las planificaciones de tipo `TAREA` que
        // se borran: sin ninguna, prometer que «puede borrar fichas de tarea» manda a vigilar una
        // lista en la que no va a pasar nada. Y se dice «ficha de tarea» y no «tarea» porque la
        // cifra de arriba ya puede estar nombrando tareas: son dos cosas y en dos listas distintas.
        const hayTareas = alcances.some(function(a) { return a.p.tareas > 0; });
        const texto = '<p class="c4-limpiar-destruye">' + destruye + '</p>'
          + avisoFuera
          + '<p>Con ellas se borran los <b>bloques de desplazamiento</b> de esos días ('
          + porAlcance(function(a) { return a.p.desplazamientos + ' en ' + a.etiqueta; }, ' y ')
          + '), incluida la ruta de visitas que sí están confirmadas de esos mismos días —esa se vuelve a'
          + ' calcular sola—.'
          + (hayTareas ? ' Y puede borrar las <b>fichas de tarea</b> que se queden sin ninguna'
            + ' planificación que las use, que viven en otra lista.' : '')
          + '</p>'
          + '<p>En total desaparecen '
          + porAlcance(function(a) { return '<b>' + a.p.total + '</b> bloques del calendario si eliges ' + a.etiqueta; }, ', y ')
          + '.</p>'
          + '<p class="c4-limpiar-preserva">No se toca ninguna visita <b>REALIZADA</b> ni la agenda ya'
          + ' confirmada.<br>Empleado <b>' + self.escaparHtml(self.inspectorFiltro) + '</b>'
          + '<br>' + tramo.titulo + ': ' + self.fmtDiaCorto(desdeV) + ' – ' + self.fmtDiaCorto(hastaV)
          + '<br>Los ±90 días, contados desde hoy: ' + self.fmtDiaCorto(desdeH) + ' – ' + self.fmtDiaCorto(hastaH) + '</p>';
        // Cancelar PRIMERO, destacado y por defecto (Enter). Los destructivos debajo, en rojo y
        // separados: hasta ahora «Todo el horizonte» era el que iba en bold y el que más pesaba.
        const botones = [{ text: self.$t('limpiarPendientes.cancelar'), bold: true, keyCodes: [13, 27] }];
        // La cifra de los rótulos es `aceptadas` —todo lo que el botón borra sin contar la ruta— y
        // el rótulo no nombra el tipo («N aceptadas sin confirmar»), así que vale para cualquier
        // mezcla de visitas y tareas: el desglose por nombre lo da el cuerpo del aviso.
        if (ventana.aceptadas > 0) {
          botones.push(self.botonDestructivo(botones,
            self.$t('limpiarPendientes.borrarVentana', { n: ventana.aceptadas }),
            function() { self.ejecutarLimpiezaPendientes(desdeV, hastaV, ventana); }));
        }
        if (horizonte.aceptadas > 0) {
          botones.push(self.botonDestructivo(botones,
            self.$t('limpiarPendientes.borrarHorizonte', { n: horizonte.aceptadas }),
            function() { self.confirmarLimpiezaHorizonte(horizonte, desdeH, hastaH, ventana.aceptadas > 0); }));
        }
        app.dialog.create({
          title: self.$t('limpiarPendientes.titulo'),
          text: texto,
          cssClass: 'c4-limpiar-dialogo',
          buttons: botones,
          verticalButtons: true
        }).open();
      },
      /**
       * #282 punto 5 · «Todo el horizonte» son seis meses de trabajo aceptado de ese empleado a un clic.
       * El botón se queda —es la vía para el residuo de otras semanas, que es para lo que se amplió el
       * rango— pero exige una segunda confirmación explícita, también con la salida como opción por
       * defecto. La cura de fondo es #281 (B1); esto es contención.
       */
      confirmarLimpiezaHorizonte(horizonte, desdeH, hastaH, hayBotonDelTramo) {
        const self = this;
        const app = self.$f7;
        const tramo = self.nombresTramoVisible();
        // La salida solo puede remitir al otro botón si ese botón existe: cuando el tramo visible no
        // tiene pendientes no se dibuja, y mandar a buscarlo es la misma clase de aviso que engaña.
        const salida = hayBotonDelTramo
          ? 'Si solo querías limpiar ' + tramo.este + ', sal de aquí y usa el otro botón.'
          : 'En ' + tramo.este + ' no hay nada pendiente que limpiar: este botón es el rango completo.';
        app.dialog.create({
          title: self.$t('limpiarPendientes.segundaTitulo'),
          // El mismo desglose por nombre que el primer aviso (`fraseGruposLimpieza`): el segundo no
          // puede resumir en «N visitas aceptadas» lo que el primero acaba de repartir en visitas y
          // tareas — sería el mismo engaño, y justo en el clic que ya no se deshace.
          text: '<p class="c4-limpiar-destruye">Vas a borrar <b>' + self.fraseGruposLimpieza(horizonte)
            + ' aceptadas</b> de <b>'
            + self.escaparHtml(self.inspectorFiltro) + '</b> y <b>' + horizonte.desplazamientos
            + '</b> bloques de desplazamiento, en todo el rango ' + self.fmtDiaCorto(desdeH) + ' – '
            + self.fmtDiaCorto(hastaH) + '. Son ' + horizonte.total + ' bloques del calendario y no se'
            + ' pueden recuperar.</p>'
            + '<p class="c4-limpiar-preserva">' + salida + '</p>',
          cssClass: 'c4-limpiar-dialogo',
          buttons: [
            { text: self.$t('limpiarPendientes.segundaNo'), bold: true, keyCodes: [13, 27] },
            self.botonDestructivo([{}], self.$t('limpiarPendientes.segundaSi', { n: horizonte.aceptadas }),
              function() { self.ejecutarLimpiezaPendientes(desdeH, hastaH, horizonte); })
          ],
          verticalButtons: true
        }).open();
      },
      // Fecha 'YYYY-MM-DD' (o Date) en la forma en que la lee una persona. Las del diálogo de limpiar
      // son el rango REAL que se manda al back, así que no se reformatean por otro sitio.
      fmtDiaCorto(d) {
        return d ? moment(d).format('DD/MM/YYYY') : '—';
      },
      // INTEGRIDAD PR-2: CONFIRMAR las pendientes de la ventana. Preview con soloListar (el conteo real
      // del backend, no el visual) + diálogo explícito: confirmar crea EXPEDIENTES (segundas incluidas)
      // y en producción notifica a SAP — es el paso irreversible-por-diseño, de ahí el aviso claro.
      // SPEC-REGISTRO-PROPUESTAS: panel del audit-log — carga los registros del inspector (solo lectura).
      abrirRegistroPropuestas() {
        const self = this;
        const app = self.$f7;
        self.registroAbierto = !self.registroAbierto;
        if (!self.registroAbierto) return;
        cerrojoDeLaSesion(self, 'cargandoRegistros');
        self.registros = [];
        self.registroExpandido = null;
        self.Planificacion.registroPropuestas({ data: { inspector: self.inspectorFiltro, limite: 30 } })
          .then(function(res) {
            const data = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
            self.registros = Array.isArray(data) ? data : [];
          }).catch(function(e) {
            if (typeof e == 'string') e = { error: e };
            app.dialog.alert(e.message || e.error || 'No se pudo cargar el registro de propuestas.');
          }).finally(function() {
            self.cargandoRegistros = false;
          });
      },
      // SPEC-INFORME-PROPUESTA: navegar al informe completo de una corrida del panel de registro.
      verInforme(reg) {
        this.$f7.views.current.router.navigate('/dashboard/informe-propuesta/' + reg.id + '/');
      },
      // #460 · Las cifras de una corrida en el panel «¿Por qué?», por el MISMO módulo que las del
      // informe completo al que enlaza ese panel: `RecuentoPropuesta` LEE el plan de unidades que
      // derivó la API y las altas que acreditó, así que las dos pantallas no cuentan, leen lo mismo.
      // Una corrida sin plan no tiene denominador y se dice con un «?» en vez de rellenarlo con
      // bloques, que es otra unidad.
      propuestasDeCorrida(reg) {
        const c = RecuentoPropuesta.recuento(reg);
        return c.conDenominador ? c.propuestos : '?';
      },
      aceptadasDeCorrida(reg) {
        return RecuentoPropuesta.recuento(reg).aceptados;
      },
      // #460 · Lo que alguien descartó a mano, para que el cociente de arriba no se lea como si
      // faltara trabajo por atender. Cadena vacía cuando no hay descartes, que es lo normal: el
      // aviso solo aparece cuando hay algo que avisar.
      //
      // Y CON SU MOTIVO, que está guardado en cada descarte: es el mismo olvido que dejaba muda la
      // píldora gris del informe (prueba de dirección del 16/10/2026) — el dato existe y no se
      // pintaba, así que había que ir al registro para saber qué pasó con ese trabajo.
      descartadasDeCorrida(reg) {
        const n = RecuentoPropuesta.recuento(reg).descartados || 0;
        if (n <= 0) return '';
        const motivos = RecuentoPropuesta.motivosDescartados(reg);
        return ' · ' + n + ' descartada(s) a mano'
          + (motivos.length ? ' (' + motivos.join('; ') + ')' : '');
      },
      fmtFecha(d) {
        return d ? new Date(d).toLocaleDateString('es-ES') : '—';
      },
      fmtFechaHora(d) {
        if (!d) return '—';
        const f = new Date(d);
        return f.toLocaleDateString('es-ES') + ' ' + f.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      },
      // Solo los parámetros informados (los null son defaults del solver): legible en una línea.
      resumenParametros(p) {
        if (!p) return 'defaults del solver';
        const partes = [];
        if (p.alcance) partes.push(p.alcance);
        if (p.modo) partes.push(p.modo);
        if (p.proponerInformes != null) partes.push('informes: ' + (p.proponerInformes ? 'sí' : 'no'));
        if (p.planificarConComida != null) partes.push('comida: ' + (p.planificarConComida ? 'sí' : 'no'));
        if (p.planificarConPernocta != null) partes.push('pernocta: ' + (p.planificarConPernocta ? 'sí' : 'no'));
        if (p.comidaPreferente) partes.push('comida pref ' + p.comidaPreferente);
        if (p.comidaInicioMin || p.comidaInicioMax) partes.push('ventana comida ' + (p.comidaInicioMin || '13:00') + '-' + (p.comidaInicioMax || '15:30'));
        if (p.comidaDuracionMin) partes.push(p.comidaDuracionMin + "' de comida");
        if (p.jornadaInicioPreferente) partes.push('jornada ' + p.jornadaInicioPreferente);
        if (p.jornadaInicioMin) partes.push('madrugón hasta ' + p.jornadaInicioMin);
        if (p.mesesAntiguedadMax) partes.push('antigüedad máx ' + p.mesesAntiguedadMax + 'm');
        if (p.diasAReplanificar && p.diasAReplanificar.length) partes.push(p.diasAReplanificar.length + ' días a replanificar');
        return partes.length ? partes.join(' · ') : 'defaults del solver';
      },
      resumenRestricciones(r) {
        if (!r) return '—';
        const partes = [];
        if (r.baseDireccion) partes.push('base ' + r.baseDireccion);
        if (r.radioMaxKm) partes.push('radio ' + r.radioMaxKm + ' km');
        if (r.pernoctaPermitida != null) partes.push('pernocta ' + (r.pernoctaPermitida ? 'sí' : 'no'));
        if (r.zonasCubre && r.zonasCubre.length) partes.push('cubre ' + r.zonasCubre.join('/'));
        if (r.zonasVetadas && r.zonasVetadas.length) partes.push('vetadas ' + r.zonasVetadas.join('/'));
        if (r.topeHorasDiaOverride) partes.push('tope día ' + r.topeHorasDiaOverride + ' h');
        if (r.diaPreferidoInformes) partes.push('informes ' + r.diaPreferidoInformes);
        return partes.length ? partes.join(' · ') : '—';
      },
      confirmarPendientesReal() {
        const self = this;
        const app = self.$f7;
        if (!self.inspectorFiltro || !self.fechaDesdeFiltro || !self.fechaHastaFiltro) {
          app.dialog.alert('Selecciona inspector y semana antes de confirmar.');
          return;
        }
        const ventana = {
          inspector: self.inspectorFiltro,
          fechaDesde: self.fechaDesdeFiltro,
          fechaHasta: self.fechaHastaFiltro
        };
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        self.Planificacion.confirmarPendientes({ data: Object.assign({ soloListar: true }, ventana) })
          .then(function(res) {
            espera.cerrar();
            const arr = (res && res.dto) ? res.dto : ((res && res.data) ? res.data : res);
            const n = Array.isArray(arr) ? arr.length : 0;
            if (n === 0) {
              app.toast.create({ text: 'No hay propuestas pendientes que confirmar en esta ventana.', position: 'center', closeTimeout: 3000 }).open();
              return;
            }
            app.dialog.confirm(
              'Vas a CONFIRMAR ' + n + ' propuestas pendientes: se crearán los expedientes '
              + '(segundas incluidas) y se notificará el pedido. Este paso las hace REALES. ¿Seguro?',
              'Confirmar pendientes',
              function() {
                const esperaConfirmar = preloaderDeLaSesion(self);
                esperaConfirmar.mostrar();
                self.Planificacion.confirmarPendientes({ data: ventana }).then(function(res2) {
                  const arr2 = (res2 && res2.dto) ? res2.dto : ((res2 && res2.data) ? res2.data : res2);
                  const num = Array.isArray(arr2) ? arr2.length : n;
                  // Recarga: las confirmadas dejan de ser amarillas y el cabecero pasa de OEB-PPEND a OEB.
                  self.getPlanificaciones().then(function() { self.$forceUpdate(); }).catch(function() {});
                  app.toast.create({ text: 'Confirmadas ' + num + ' propuestas (expedientes creados).', position: 'center', closeTimeout: 3500 }).open();
                }).catch(function(e) {
                  // Incremental por diseño: si una línea falla, las anteriores quedan confirmadas y
                  // reintentar continúa con las restantes. Recargar para ver el estado real.
                  self.getPlanificaciones().then(function() { self.$forceUpdate(); }).catch(function() {});
                  app.dialog.alert(((e && (e.message || e.error)) || 'Error al confirmar.')
                    + ' La confirmación es incremental: reintenta para continuar con las restantes.');
                }).finally(function() {
                  esperaConfirmar.cerrar();
                });
              });
          }).catch(function(e) {
            espera.cerrar();
            app.dialog.alert((e && (e.message || e.error)) || 'No se pudo consultar las pendientes a confirmar.');
          });
      },
      // Borrado real acotado al rango elegido en el diálogo (ventana u horizonte completo) + recarga.
      // #282: `previsto` es el reparto que se le anunció a la persona (ver `repartoLimpiezaPorTipo`),
      // y sirve de respaldo si la respuesta no llega entendible. El mensaje final reparte igual que el
      // aviso: si el diálogo dijo «20 visitas y 3 desplazamientos», el resultado no puede contestar «23
      // propuestas pendientes» y dejar a quien lo lee creyendo que se borró más de lo que pidió. Y por
      // eso nombra los grupos con `fraseGruposLimpieza`, igual que el aviso: una tarea T0005 borrada no
      // puede salir aquí contada como visita después de que el aviso la haya nombrado tarea.
      ejecutarLimpiezaPendientes(fechaDesde, fechaHasta, previsto) {
        const self = this;
        const app = self.$f7;
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        self.Planificacion.limpiarPendientes({ data: {
          inspector: self.inspectorFiltro,
          fechaDesde: fechaDesde,
          fechaHasta: fechaHasta
        }}).then(function(res) {
          const borrado = self.repartoLimpiezaPorTipo(res) || previsto || self.repartoLimpiezaVacio();
          // Recarga: reconstruye events + recalcula el cabecero ACOTADO a la ventana. Refresca la vista.
          self.getPlanificaciones().then(function() { self.$forceUpdate(); }).catch(function() {});
          app.toast.create({ text: 'Se limpiaron ' + self.fraseGruposLimpieza(borrado)
            + ' pendientes de confirmar'
            + (borrado.desplazamientos > 0 ? ', y ' + borrado.desplazamientos + ' bloques de desplazamiento' : '')
            + '.', position: 'center', closeTimeout: 3000 }).open();
        }).catch(function(e) {
          app.dialog.alert((e && (e.message || e.error)) || 'No se pudieron limpiar las pendientes.');
        }).finally(function() {
          espera.cerrar();
        });
      },
      // C4-B2 ============================================================================
      // Fin del horizonte según el toggle (1/2 semanas): desde + N*7 días. El backend aguanta el rango (B1).
      horizonteHasta() {
        if (!this.fechaDesdeFiltro) return this.fechaHastaFiltro;
        return moment(this.fechaDesdeFiltro).add(this.semanasHorizonte * 7 - 1, 'days').format('YYYY-MM-DD');
      },
      setSemanasHorizonte(n) { this.semanasHorizonte = n; },
      // Banco del inspector propuesto (la petición es de 1 inspector → banco[0]).
      bancoInspector() { return (this.banco || [])[0] || null; },
      bancoSemanas() { const b = this.bancoInspector(); return (b && b.semanas) ? b.semanas : []; },
      // C4-REALINEAMIENTO v2: retirados semanaBancoDe / propuestasDia / repartoDedup / repartoCampoDia /
      // tpipEuroDia / repartoDia / tpipMinDia / tpipNumDia / objetivoCampoDia — alimentaban las badges/franja
      // B2/B3 inventadas ya retiradas. Los indicadores REALES (totalImporteDia, totalTiempoPorTipo,
      // importePorTipo) suman las propuestas materializadas sin cálculo paralelo.
      // Formato "Xh YY" para minutos (TPIP tiempo).
      fmtMin(min) {
        min = Math.round(Number(min) || 0);
        const h = Math.floor(min / 60); const m = min % 60;
        return (h > 0 ? h + 'h' : '') + (m > 0 || h === 0 ? (h > 0 ? ' ' : '') + m + "'" : '');
      },
      /**
       * #311 · mensaje de la alerta TIEMPO_AGOTADO, o null. Llega de dos formas: como objeto en la
       * respuesta de Proponer y, en la propuesta rehecha del audit-log, como la línea de texto
       * «SEVERIDAD TIPO: mensaje (lineaId)» que compone `RegistroPropuestasService.volcarAlertas`.
       */
      avisoTiempoAgotadoDe(alertas) {
        const lista = Array.isArray(alertas) ? alertas : [];
        for (let i = 0; i < lista.length; i++) {
          const a = lista[i];
          if (a && typeof a === 'object' && a.tipo === 'TIEMPO_AGOTADO') {
            return a.mensaje || 'el solver agotó su tiempo y la propuesta puede mejorarse.';
          }
          if (typeof a === 'string') {
            const m = a.match(/(?:^|\s)TIEMPO_AGOTADO: (.*?)(?: \([^()]*\))?$/);
            if (m) return m[1] || 'el solver agotó su tiempo y la propuesta puede mejorarse.';
          }
        }
        return null;
      },
      fmtH(h) { return (Math.round((Number(h) || 0) * 10) / 10).toString().replace('.', ',') + ' h'; },
      // C4: € es-ES (miles con punto, sin decimales) "1.240 €" para el importe de reparto por bloque.
      fmtEur(n) {
        return new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0)) + ' €';
      },
      // C4: un informe es «P1» (plazo legal) si su línea está en las alertas de plazo del /proponer.
      esPlazoP1(l) {
        if (!l || l.tipoTrabajo !== 'INFORME') return false;
        return (this.alertasPlazo || []).some(function(a) { return (a.lineaId || a.linea_id) === l.lineaId; });
      },
      // Saldo del banco ACUMULADO hasta el final de la semana `s` (saldo inicial + Σ saldo_semana hasta ella).
      // El motor lo expone; el responsable decide compensar (no auto-compensa).
      saldoAcumHasta(s) {
        const b = this.bancoInspector(); if (!b) return 0;
        let acc = Number(b.saldoBancoInicial || 0);
        const sems = this.bancoSemanas();
        for (let i = 0; i < sems.length; i++) {
          acc += Number(sems[i].saldo_semana || 0);
          if (sems[i].anio === s.anio && sems[i].semana === s.semana) break;
        }
        return acc;
      },
      // C4-REALINEAMIENTO v2: retirados propuestasSemana / repartoCampoSemana / tpipEuroSemana / tpipMinSemana
      // (alimentaban la fila PRODUCCIÓN de la franja, ya retirada).
      // Nº de días 'YYYY-MM-DD' desde `desde` a vaciar/rehacer en Modo B (1..4, o 5 = semana laboral L-V).
      diasReplanList() {
        if (this.modoPropuesta !== 'REPLANIFICAR_DIAS' || !this.fechaDesdeFiltro) return [];
        const n = Number(this.diasReplan) || 1;
        const out = [];
        for (let i = 0; i < n; i++) {
          out.push(moment(this.fechaDesdeFiltro).add(i, 'days').format('YYYY-MM-DD'));
        }
        return out;
      },
      // ================================================================================
      // Aceptar UNA propuesta (Modo A, por evento) — ALTA POR TIPO por el flujo de planificación de siempre.
      // NO se manda el plani entero como línea: eso caía al bucle común y para TAREA sin idTarea petaba con
      // "id must not be null" (tareaRepository.findById(null)). Campo = alta por pedido+línea; TPIP = tarea
      // T0005 genérica. La propuesta solo se retira de la capa provisional si el guardado confirma OK.
      //
      // Una visita de campo que el solver ha partido alrededor de la comida se acepta ENTERA, con la misma
      // regla que el aceptar-todo (dedupePropuestas): la API crea UN alta de campo por (pedido, línea), así
      // que aceptar un tramo suelto creaba la visita con los minutos de ESE tramo y dejaba el otro
      // provisional para siempre —al pulsarlo, «la línea ya está planificada»—. Y después de arreglar el
      // aceptar-todo, las dos vías de la misma pantalla habrían hecho cosas distintas con los mismos
      // datos: 60 minutos por una y 44 por la otra. Se pregunta antes, porque lo que se crea no es el
      // bloque que se ha pulsado.
      aceptarPropuesta(plani) {
        const self = this;
        const app = self.$f7;
        self.cerrarDetalleDelDia();
        const tramos = self.tramosDeLaMismaVisita(plani);
        const dd = self.dedupePropuestas(tramos);
        const alta = dd.unicas[0] || plani;
        const crear = function() {
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          // #460 · el alta va sola: el denominador de «aceptadas» son las unidades que la API
          // derivó de la propuesta de la corrida, así que aceptar una visita suelta no tiene que
          // declarar nada. Lo que se CREA no cambia: sigue siendo el alta del de-dupe de esta visita.
          self.Planificacion.save({ data: self.altaDesdePropuesta(alta), itemId: null })
            .then(function() {
              self.propuestas = self.propuestas.filter(function(p) { return tramos.indexOf(p.planificacion) === -1; });
            })
            .catch(function(e) {
              app.dialog.alert(self.msgErrorProp(e) + ' La propuesta sigue como provisional.');
            })
            .finally(function() { espera.cerrar(); self.getPlanificaciones(); });
        };
        // Lo que se pregunta sale del RESULTADO del de-dupe, no del número de tramos (review CODEX
        // ronda 2): dos propuestas idénticas —mismo pedido, línea, día y HORA— también son dos
        // tramos aquí, pero el de-dupe las omite sin sumar sus minutos, así que anunciar «con los
        // minutos de todos los tramos» prometía un total que el alta no lleva. `consolidadas` son
        // los tramos que SÍ aportan minutos; `omitidas`, las que se retiran sin aportar nada.
        const sumados = dd.consolidadas.length;
        const repetidas = dd.omitidas.length;
        if (!sumados && !repetidas) { crear(); return; }
        let texto = self.refDePropuesta(plani) + ': se creará UN bloque de '
          + (alta.tiempoEstimadoCampo || 0) + ' min'
          + (alta.horaInicio ? ' que empieza a las ' + moment(alta.horaInicio).format('HH:mm') : '')
          + ' (la API crea un alta de campo por línea).';
        if (sumados) {
          texto += ' La visita viene partida en ' + (sumados + 1)
            + ' tramos y el bloque lleva los minutos de todos.';
        }
        // Mismo texto que el confirm del aceptar-todo: las dos vías de la pantalla no pueden
        // contar lo mismo con palabras distintas.
        if (repetidas) { texto += ' Además ' + self.resumenOmitidas(dd.omitidas) + ', sin sumar minutos.'; }
        app.dialog.confirm(texto + ' ¿Continuar?',
          sumados ? 'Aceptar la visita completa' : 'Aceptar la visita', crear);
      },
      // Los tramos de campo de la MISMA visita (pedido + línea + día) que siguen en la capa provisional, en
      // el orden en que llegaron —el de-dupe no depende de él, ver dedupePropuestas—. Para una continuación
      // multidía o un informe la visita es ella sola: su clave de de-dupe ya coincide con lo que la API
      // admite, y agruparlos sería meterse en las ramas que esta tarea no toca.
      tramosDeLaMismaVisita(plani) {
        const self = this;
        if (!plani || !self.esVisitaDeCampo(plani)) return [plani];
        const ref = self.refLineaDia(plani);
        const tramos = (self.propuestas || []).map(function(p) { return p.planificacion; })
          .filter(function(pl) {
            return pl && self.esVisitaDeCampo(pl) && self.refLineaDia(pl) === ref;
          });
        // Sin respaldo la lista podría salir vacía si la propuesta ya no está en la capa provisional, y el
        // aceptar se quedaría sin hacer nada en silencio.
        return tramos.length ? tramos : [plani];
      },
      // #460 · criterio ÚNICO de «esto es una continuación multidía», en `UnidadAceptable`: es el que
      // decide la identidad de la unidad, así que no puede haber otra versión suya por aquí.
      esContinuacionMultidia(pl) {
        return UnidadAceptable.esContinuacion(pl);
      },
      // #460 · «esto es una visita de campo», por el MISMO criterio que la identidad de la unidad. Lo
      // que había repartido por la pantalla era `esContinuacionMultidia(pl) || pl.tipoTrabajo ===
      // 'INFORME'`, que es la clasificación escrita otra vez a mano: una propuesta reconstruida del
      // registro trae el tipo guardado y ese `tipoTrabajo` es solo una aproximación suya.
      esVisitaDeCampo(pl) {
        return UnidadAceptable.tipo(pl) === UnidadAceptable.TIPO_CAMPO;
      },
      refLineaDia(pl) {
        return this.refLineaDeCampo(pl) + '@' + this.diaDePropuesta(pl);
      },
      // La (pedido, línea) de una visita de campo: lo ÚNICO que la API mira para decidir si ya está
      // planificada, sin día ni hora. De ahí que sea la clave con la que el de-dupe agrupa los tramos.
      refLineaDeCampo(pl) {
        return 'CAMPO:' + String(pl.numeroPedido || pl.codigoPedido) + '#' + pl.numLinea;
      },
      // Construye el alta (CreatePlanificacionDTO) POR TIPO desde una propuesta materializada:
      //  · Campo (LINEA)  → { numeroOCodigoPedido, numeroLinea, fechaVisita, inspectores }: camino real que
      //    valida "ya planificada" y resuelve dirección/servicio/item/importe reales desde el pedido/línea.
      //  · TPIP (INFORME) → tarea T0005 genérica { tarea:{tipo T0005, tiempoEstimado}, fechaVisita, inspectores }:
      //    el solver da el TPIP AGREGADO por día (sin expediente concreto) → se crea una tarea T0005 con ese
      //    tiempo (decisión JJCS 05/08). El € sigue siendo proyección TPIP€ (tiempo × precioMinuto).
      // #460: y además manda `lineaId`, la identidad que el solver dio al bloque. Los tres caminos de
      // arriba mandan una REFERENCIA (pedido+línea, o una tarea nueva) y el backend reconstruye el
      // bloque leyéndolo de Mongo, así que sin este campo la identidad del solver no llega al registro
      // de la corrida y la medición de desviación no sabe qué propuesta era cada aceptada. Se nota
      // sobre todo en el TPIP, que se propone sin pedido ni línea: sin `lineaId` no hay NADA que lo
      // identifique. Ver `PlanificacionServiceImpl.estamparLineaIdDePropuesta`.
      // #460 (opción A) · y además manda `unidadId`: la identidad de la UNIDAD ACEPTABLE que este alta
      // materializa, la misma con la que el de-dupe la agrupó y con la que va declarada en el plan de
      // la corrida. Es lo que permite al backend acreditar el alta creada contra la unidad declarada
      // en vez de volver a deducir la regla por su cuenta. No es `lineaId`: un alta de campo consolida
      // varios bloques, cada uno con su lineaId, y una multidía parte un lineaId en una unidad por día.
      /**
       * #286 · El VÍNCULO CON LA LÍNEA DE PEDIDO que se le pone a la tarea que el alta crea, en un
       * solo sitio para los tres caminos que crean una (continuación T0004, informe T0005 y la
       * restauración del snapshot).
       *
       * Por qué hace falta: un bloque de `planificaciones` sin pedido ni línea no se cruza con nada
       * —el censo del 06/10/2026 contó 6.373 así, 918 de ellos pendientes de confirmar—, y la
       * aceptación que lo creó se anotaba sin identificador. No hay identificador nuevo que
       * inventar: la tarea del ERP se vincula a la línea de pedido con `numeroPedido` +
       * `numeroLineaPedido`, el backend completa desde ahí el código e id de pedido y el expediente
       * (`TareaServiceImpl.rellenarDatosFacturaPedidoClienteOferta`), y el bloque copia de la tarea
       * lo que la tarea sabe (`PlanificacionServiceImpl.copiarVinculoDeLineaDePedido`).
       *
       * Se mandan los DOS o NINGUNO, nunca medio: con el pedido y sin la línea el backend resuelve
       * pedido, cliente y oferta pero el bloque se queda sin `numLinea`, o sea con pinta de tener
       * clave sin ser localizable por (pedido, línea), que es justo lo que esta ficha viene a
       * cerrar. Y no se deduce nada: si la propuesta no trae la línea, aquí no se elige una.
       *
       * Y si no trae los dos números pero sí su EXPEDIENTE, se manda el expediente: el backend
       * saca de él el pedido y la línea (`TareaServiceImpl.rellenarDatosExpedienteYLinea`), así que
       * es vínculo de verdad y no una pista. Pasa cuando el reparto del solver trae
       * `lineaResumen` —de donde salen la línea y el expediente— pero no `pedidoResumen`, que es de
       * donde sale el número de pedido (`SolverResponseMapper`): callarse el expediente ahí era
       * tirar la única clave que el bloque podía tener. No se manda con los dos números puestos
       * porque entonces sobra: el backend reescribe el expediente desde la línea que resuelve.
       */
      vinculoLineaDeLaPropuesta(plani) {
        if (!plani) return {};
        if (plani.numeroPedido != null && plani.numLinea != null) {
          return { numeroPedido: plani.numeroPedido, numeroLineaPedido: plani.numLinea };
        }
        if (plani.idExpediente != null || plani.codigoExpediente != null) {
          return { idExpediente: plani.idExpediente, codigoExpediente: plani.codigoExpediente };
        }
        return {};
      },
      altaDesdePropuesta(plani, insp) {
        const inspector = insp || (plani.inspectores && plani.inspectores[0] && plani.inspectores[0].username) || this.inspectorFiltro;
        const inspectores = [{ username: inspector, rol: 'INSPECTOR' }];
        const fechaVisita = plani.horaInicio;
        const lineaId = plani.lineaId || null;
        const unidadId = UnidadAceptable.id(plani);
        // MULTIDÍA (SPEC-MULTIDIA-CONTINUACION-TAREA): los días 2..N vienen del mapper como TAREA T0004
        // vinculada a la línea. Alta por el flujo de tareas de siempre (mismo patrón que el TPIP T0005):
        // el backend crea la tarea (rellenando pedido/cliente/expediente desde numeroPedido+numeroLineaPedido)
        // y su planificación. Nunca un alta de LINEA (eso duplicaría la línea del día 1).
        if (plani.tipo === 'TAREA' && plani.tipoTarea && plani.tipoTarea.codigo === 'T0004') {
          return {
            inspectores: inspectores,
            fechaVisita: fechaVisita,
            pendienteConfirmar: true,          // (B) nace pendiente de confirmar → OEB-PPEND
            runId: this.runPropuesta,          // SPEC-REGISTRO-PROPUESTAS: vínculo al audit-log de la corrida
            lineaId: lineaId,                  // #460: identidad del bloque propuesto
            unidadId: unidadId,                // #460: identidad de la unidad aceptable que crea
            // #286: el vínculo con la línea va por `vinculoLineaDeLaPropuesta`, el mismo sitio que
            // el informe y la restauración. Antes se copiaba aquí a pelo, y con media clave (pedido
            // sin línea) el bloque nacía no localizable; ahora van los dos o ninguno, y sin los dos
            // la API rechaza la continuación diciendo lo que falta.
            tarea: Object.assign({
              tipo: { codigo: 'T0004' },
              tiempoEstimado: plani.tiempoEstimadoCampo,
              horaInicio: fechaVisita,
              descripcion: plani.nombreTarea || 'Continuación producción campo',
              comentarios: plani.comentariosTarea || ''
            }, this.vinculoLineaDeLaPropuesta(plani))
          };
        }
        if (plani.tipoTrabajo === 'INFORME') {
          return {
            inspectores: inspectores,
            fechaVisita: fechaVisita,
            pendienteConfirmar: true,          // (B) nace pendiente de confirmar → OEB-PPEND
            runId: this.runPropuesta,          // SPEC-REGISTRO-PROPUESTAS: vínculo al audit-log de la corrida
            lineaId: lineaId,                  // #460: identidad del bloque propuesto
            unidadId: unidadId,                // #460: identidad de la unidad aceptable que crea
            // #286: y su vínculo con la línea de pedido, si la propuesta lo trae. Hoy no lo trae
            // casi nunca y no es un olvido: el solver propone el TPIP AGREGADO por día —cuánto
            // tiempo de informe cabe, no el informe de una línea— y esa agregación
            // (`_agregar_tpip`) se queda sin la línea de cada candidato. Cuando la propuesta sí
            // identifique el informe, el alta lo lleva sin tocar nada más; mientras no, el bloque
            // se identifica por su código de tarea y la API lo deja dicho en el log. Aquí no se
            // elige una línea del día: sería inventarla.
            tarea: Object.assign({ tipo: { codigo: 'T0005' }, tiempoEstimado: plani.tiempoEstimadoCampo, horaInicio: fechaVisita, descripcion: 'TPI (planificador C4)' },
              this.vinculoLineaDeLaPropuesta(plani))
          };
        }
        return {
          inspectores: inspectores,
          fechaVisita: fechaVisita,
          pendienteConfirmar: true,            // (B) nace pendiente de confirmar → OEB-PPEND
          runId: this.runPropuesta,            // SPEC-REGISTRO-PROPUESTAS: vínculo al audit-log de la corrida
          lineaId: lineaId,                    // #460: identidad del bloque propuesto
          unidadId: unidadId,                  // #460: identidad de la unidad aceptable que crea
          // FIX doble conteo multidía: la propuesta LINEA trae los minutos del TRAMO de ese día (el
          // mapper reparte por día; los días 2+ van como T0004 con los suyos). La plani nace con ellos
          // y el cabecero no duplica. En una línea normal coincide con el TCPE → sin cambio efectivo.
          tiempoPlanificadoDia: plani.tiempoEstimadoCampo || null,
          // numeroPedido = pedido LIMPIO (2408969). OJO: codigoPedido en la propuesta de campo es el code
          // de LÍNEA del reparto ("2408969-20.1"), NO el pedido → el backend no lo encuentra. numeroPedido
          // SIEMPRE primero; codigoPedido solo como último fallback.
          numeroOCodigoPedido: String(plani.numeroPedido || plani.codigoPedido || ''),
          numeroLinea: plani.numLinea
        };
      },
      /**
       * Los bloques de la pantalla que son de la MISMA UNIDAD que uno dado: lo que la API trata como
       * un solo trabajo. No es lo mismo que `tramosDeLaMismaVisita`, y la diferencia importa: ésa
       * agrupa los tramos del mismo DÍA, que es lo que un alta de campo lleva encima, y ésta agrupa
       * la unidad entera —campo por (pedido, línea) sin mirar el día—, que es lo que el registro de
       * la corrida marca cuando se descarta. Un informe de oficina es su `lineaId` aunque salga en
       * dos días, y una continuación multidía es una por línea y día.
       */
      bloquesDeLaMismaUnidad(plani) {
        const self = this;
        if (!UnidadAceptable.identificable(plani)) return [plani];
        const ref = UnidadAceptable.id(plani);
        const iguales = (self.propuestas || []).map(function(p) { return p.planificacion; })
          .filter(function(pl) {
            return pl && UnidadAceptable.identificable(pl) && UnidadAceptable.id(pl) === ref;
          });
        // Sin respaldo la lista saldría vacía si la propuesta ya no está en la capa provisional, y el
        // descarte se quedaría sin hacer nada en silencio (mismo motivo que en el aceptar).
        return iguales.length ? iguales : [plani];
      },
      /**
       * Descartar una propuesta se lleva el TRABAJO ENTERO, no el bloque pulsado, porque es lo que
       * anota el registro: la unidad la deriva la API del bloque que se le manda. Retirando de la
       * pantalla solo el bloque pulsado, los demás de esa misma unidad seguían visibles y se podían
       * aceptar después —la API creaba entonces el alta con los minutos que quedaban, 16 de una
       * visita de 60, sobre una unidad que ya tenía anotado su descarte (P2 de Codex, ronda 1 del
       * 16/10/2026)—. Es el mismo motivo por el que `aceptarPropuesta` consolida: lo que se decide
       * no es el bloque que se ha pulsado.
       *
       * Se pregunta solo cuando hay más de un bloque, que es cuando lo que va a pasar no es lo que
       * se ve; con un bloque suelto el descarte sigue siendo inmediato, como siempre.
       */
      descartarPropuesta(plani) {
        const self = this;
        const app = self.$f7;
        const bloques = self.bloquesDeLaMismaUnidad(plani);
        const quitar = function() {
          self.propuestas = self.propuestas.filter(function(p) { return bloques.indexOf(p.planificacion) === -1; });
          // #460 · Descartado no es inexistente: el bloque se va de la pantalla pero la corrida lo
          // propuso, así que se anota en el registro y el informe puede decir qué fue de él — y la
          // corrida deja de contar esa unidad como pendiente. Se manda AQUÍ y no al aceptar: si se
          // descarta lo último que quedaba, el Aceptar ya no vuelve a pasar por ningún sitio.
          self.anotarDescarteDeLaCorrida(bloques);
          // El detalle del día se cierra por su único sitio y no con `selectedOpen = false`: de
          // develop, que lo cambió aquí mismo mientras esta rama estaba abierta.
          self.cerrarDetalleDelDia();
          self.getPlanificaciones();
        };
        if (bloques.length < 2) { quitar(); return; }
        app.dialog.confirm(self.refDePropuesta(plani) + ': en la pantalla son ' + bloques.length
          + ' bloques del mismo trabajo y el descarte se lleva todos (la API decide por línea, no por'
          + ' bloque). ¿Continuar?', 'Descartar el trabajo completo', quitar);
      },
      /**
       * #460 (opción A) · «Quitar propuestas»: el descarte a mano de TODO lo que queda en pantalla.
       *
       * Es el mismo gesto que descartar un bloque suelto, con todos a la vez, así que se anota
       * igual y por el mismo motivo: si se acepta una visita y después se quitan las que quedaban,
       * sin anotarlo la corrida se queda como aceptación parcial para siempre aunque la persona la
       * haya resuelto entera. Es el P2 de Codex de la ronda 4 del 15/10/2026 por el botón de al
       * lado — la misma forma del fallo, otra vía de salida de la pantalla.
       *
       * No se confunde con el {@code limpiarPropuestas()} que corre DESPUÉS de aceptar: allí la
       * pantalla se vacía porque el trabajo ya está creado, o porque el lote se revirtió entero, y
       * nadie ha descartado nada. Anotar un descarte ahí sería escribir «descartada a mano» sobre
       * algo que nadie descartó.
       */
      quitarPropuestas() {
        const self = this;
        self.anotarDescarteDeLaCorrida((self.propuestas || []).map(function(p) { return p.planificacion; }));
        self.limpiarPropuestas();
      },
      // C4-REALINEAMIENTO v2: Aceptar TODA la propuesta con semántica TODO-O-NADA + informe de fallos.
      // De-dupe previo (ver dedupePropuestas) para no chocar con el guardián de doble-planificación de la
      // API, que admite UN alta de campo por (pedido, línea): los tramos de una visita partida no se
      // mandan dos veces, se consolidan en un alta con la suma de sus minutos.
      // CUBRIR_HUECOS: crea en secuencia; si algún fallo → rollback por id de lo creado
      // (nada queda). REPLANIFICAR_DIAS: CREA primero; solo si TODO OK, borra lo viejo (PLANIFICADA de esos
      // días, nunca REALIZADA); si algún fallo → rollback y NO borra nada → lo viejo queda intacto.
      // Inspector OBJETIVO del Aceptar = el de las propuestas (todas del mismo inspector), NO self.inspectorFiltro
      // (que al ver el calendario de otro inspector puede haber derivado al usuario logado → borrado buscaría 0
      // mientras las altas van al inspector correcto → apilamiento). Fallback a inspectorFiltro si no hubiera.
      inspectorObjetivo() {
        const p = (this.propuestas || [])[0];
        const insp = p && p.planificacion && p.planificacion.inspectores && p.planificacion.inspectores[0];
        return (insp && insp.username) || this.inspectorFiltro;
      },
      aceptarPlanificacion() {
        const self = this;
        const app = self.$f7;
        if (!self.propuestas || !self.propuestas.length) return;
        const inspObj = self.inspectorObjetivo();
        const dd = self.dedupePropuestas(self.propuestas.map(function(p) { return p.planificacion; }));
        const planis = dd.unicas;
        // Lo que el de-dupe ha cambiado respecto a lo que el usuario está viendo, para el confirm previo
        // y para el aviso del resultado: los dos tienen que decir lo mismo.
        const ajustes = [self.resumenConsolidadas(dd.consolidadas), self.resumenOmitidas(dd.omitidas)]
          .filter(function(t) { return !!t; }).join(' · ');
        const detalleAjustes = function() { return self.textoConsolidadas(dd.consolidadas) + self.textoOmitidas(dd.omitidas); };
        const fin = function(espera) { espera.cerrar(); self.limpiarPropuestas(); };

        if (self.modoPropuesta === 'REPLANIFICAR_DIAS') {
          const dias = self.diasReplanList();
          if (!dias.length) { app.dialog.alert('Elige los días a replanificar.'); return; }
          const espera = preloaderDeLaSesion(self);
          espera.mostrar();
          // (a) SNAPSHOT: lista completa de las PLANIFICADA de esos días (nunca REALIZADA), para poder restaurar.
          // SIEMPRE con el inspector OBJETIVO (el de las propuestas), no inspectorFiltro.
          self.Planificacion.borrarProvisionalDias({ data: { inspector: inspObj, dias: dias, soloListar: true } })
            .then(function(res) {
              espera.cerrar();
              const snapshot = self.listaBorrado(res);
              // El confirm previo lleva el nº REAL de altas (dd.unicas) y los ajustes, igual que el
              // de CUBRIR_HUECOS: aquí el borrado es destructivo, así que es justo donde menos puede
              // el usuario enterarse después (review CODEX ronda 2).
              const aviso = self.resumenBorrado(snapshot, dias, planis.length, ajustes);
              app.dialog.confirm(aviso, 'Replanificar días', function() {
                const esperaReplan = preloaderDeLaSesion(self);
                esperaReplan.mostrar();
                const diasRecalc = dias.concat(self.diasDelLote(planis));
                // (b) BORRAR de verdad: borrarProvisionalDias(soloListar=false) borra TODAS las PLANIFICADA de esos
                // días del inspector objetivo y revierte las líneas de campo a CREADO_PEDIDO (fix backend A).
                self.Planificacion.borrarProvisionalDias({ data: { inspector: inspObj, dias: dias, soloListar: false } })
                  .then(function() { return self.guardarLote(planis, inspObj); })   // (c) CREAR las nuevas (ya sin colisión)
                  .then(function(r) {
                    // (d) FALLO → rollback de las nuevas + RESTAURAR el snapshot (nunca perder lo viejo) + recalc.
                    if (r.fallos.length) { return self.revertirReplanificacion(r, snapshot, diasRecalc, inspObj); }
                    // OK: todo creado. (El borrado por borrarInspector ya revirtió/limpió lo viejo.)
                    app.dialog.alert('Replanificado: ' + r.creadas.length + ' creadas (pendientes de confirmar) · '
                      + snapshot.length + ' borradas.' + detalleAjustes());
                  })
                  .catch(function(e) { app.dialog.alert(self.msgErrorProp(e)); })
                  .finally(function() { fin(esperaReplan); });
              });
            })
            .catch(function(e) { espera.cerrar(); app.dialog.alert(self.msgErrorProp(e) + ' No se pudo listar el borrado.'); });
          return;
        }
        // CUBRIR_HUECOS
        app.dialog.confirm('Se crearán ' + planis.length + ' planificaciones (pendientes de confirmar)'
          + (ajustes ? ' · ' + ajustes : '') + '. ¿Continuar?', 'Aceptar planificación', function() {
          const esperaLote = preloaderDeLaSesion(self);
          esperaLote.mostrar();
          self.guardarLote(planis, inspObj).then(function(r) {
            if (r.fallos.length) {                              // TODO-O-NADA → rollback total de lo creado
              return self.rollbackCreadas(r.creadas, inspObj)
                .then(function() { return self.recalcularRutaDias(self.diasDelLote(planis), inspObj); })
                .then(function() {
                  app.dialog.alert(self.informeFallos(r.fallos, 'No se creó ninguna (todo-o-nada).'));
                });
            }
            app.dialog.alert('Creadas ' + r.creadas.length + ' (pendientes de confirmar).' + detalleAjustes());
          }).catch(function(e) { app.dialog.alert(self.msgErrorProp(e)); }).finally(function() { fin(esperaLote); });
        });
      },
      // Paso (d) de REPLANIFICAR_DIAS cuando alguna alta falla: rollback de lo creado, RESTAURAR el
      // snapshot de lo borrado (nunca perder lo viejo) y recalcular la ruta. Vive aquí fuera y no dentro
      // del `then` del lote porque allí quedaba a cinco niveles de función anidada (Sonar S2004) justo en
      // el camino que menos se puede leer deprisa: el que decide si lo que se borró vuelve o no.
      revertirReplanificacion(r, snapshot, diasRecalc, insp) {
        const self = this;
        const app = self.$f7;
        return self.rollbackCreadas(r.creadas, insp)
          .then(function() { return self.restaurarSnapshot(snapshot, insp); })
          .then(function(noRest) {
            return self.recalcularRutaDias(diasRecalc, insp)
              .then(function() { app.dialog.alert(self.informeReversion(r, noRest)); });
          });
      },
      // El aviso de esa reversión. INNEGOCIABLE: si algo NO se pudo restaurar, se dice de forma
      // PROMINENTE y nunca en silencio.
      informeReversion(r, noRest) {
        if (!noRest.length) {
          return this.informeFallos(r.fallos, 'No se replanificó nada; lo existente se restauró intacto.');
        }
        return '⚠️ ATENCIÓN: ' + noRest.length + ' planificaciones NO se pudieron RESTAURAR:<br>'
          + noRest.slice(0, 15).join('<br>') + (noRest.length > 15 ? '<br>… y ' + (noRest.length - 15) + ' más.' : '')
          + '<br><br>Revisa el calendario del inspector. Fallo(s) de creación: '
          + r.fallos.map(function(f) { return f.ref + ' — ' + f.motivo; }).join(' · ');
      },
      // Día / momento de una propuesta, para las claves de de-dupe y las referencias. Con horaInicio
      // ausente devuelve '?' en lugar de dejar que moment(undefined) resuelva a «ahora»: así dos
      // propuestas sin hora caen siempre en la misma clave, y no en una u otra según el reloj.
      // #460 · el mismo día que entra en la identidad de la unidad (`UnidadAceptable.claveDia`): las
      // claves del de-dupe y el plan que se guarda no pueden fechar distinto el mismo bloque.
      diaDePropuesta(pl) {
        return UnidadAceptable.claveDia(pl);
      },
      // Al minuto, que es la granularidad con la que el solver emite los inicios: dos tramos de la
      // misma visita separados por la pausa de comida distan horas, y un duplicado de verdad repite
      // el mismo inicio. Con segundos, un duplicado que diferiera en el redondeo dejaría de verse.
      momentoDePropuesta(pl) {
        return (pl && pl.horaInicio) ? moment(pl.horaInicio).format('YYYY-MM-DD HH:mm') : '?';
      },
      // Un día de clave ('YYYY-MM-DD', o '?' cuando la propuesta no traía hora) tal como se le enseña al
      // usuario en los avisos.
      diaLegible(dia) {
        return (dia && dia !== '?') ? moment(dia, 'YYYY-MM-DD').format('DD/MM') : '?';
      },
      // El día en el que se creará la visita de campo de cada (pedido, línea): el PRIMERO del calendario
      // entre sus tramos, no el primero de la lista (review CODEX ronda 3). La API admite un alta de campo
      // por (pedido, línea) sin mirar el día, así que cuando llegan tramos de días distintos solo uno se
      // crea, y cuál no puede depender del orden en que el solver los emita: ni `data.propuestas` ni
      // `propuestasResumen` los ordenan. Los días son 'YYYY-MM-DD', que ordena como el calendario; el '?'
      // de una propuesta sin hora cae después de cualquier fecha, así que si hay un tramo fechado se crea
      // ese y no el que no se sabe cuándo es.
      diasDeCreacionDeCampo(planis) {
        const self = this;
        const dias = {};
        (planis || []).forEach(function(pl) {
          if (!pl || !self.esVisitaDeCampo(pl)) return;
          const ref = self.refLineaDeCampo(pl);
          const dia = self.diaDePropuesta(pl);
          if (dias[ref] === undefined || dia < dias[ref]) dias[ref] = dia;
        });
        return dias;
      },
      // De-dupe de propuestas. Devuelve {unicas, omitidas:[{plani, motivo}], consolidadas:[{plani, destino}],
      // plan:{unidades, omitidos}}.
      // El motivo viaja con la omisión porque es lo que después se le dice al usuario, y antes el aviso
      // llamaba «duplicado» a todo.
      //
      // #460 (opción A, 16/10/2026) · esta función decide QUÉ ALTAS manda el Aceptar, y eso no cambia
      // con esta tarea: ni las claves con las que agrupa, ni los minutos que suma, ni el día en el que
      // crea. Lo que YA NO hace es declarar un plan de unidades para que alguien lo cuente: el plan de
      // la corrida lo deriva la API de la propuesta que tiene guardada, y el informe, el panel y el
      // estado de la corrida cuentan ESO (ver `src/js/RecuentoPropuesta.js`). Las claves siguen saliendo
      // de `src/js/UnidadAceptable.js`, que es la misma forma de identidad que usa la API: el alta manda
      // la suya en `unidadId` y el registro avisa en el log si las dos se separan.
      //
      // Las continuaciones multidía (T0004, clave pedido+línea+DÍA) y los informes (lineaId) son las de
      // siempre. Lo que cambia es el CAMPO, y no es un simple «añadir la hora a la clave» (review CODEX
      // ronda 1): la API admite UN alta de campo por (pedido, línea) y punto —sin mirar día ni hora—. Lo
      // valida dos veces, en la rama numeroOCodigoPedido de PlanificacionServiceImpl.create
      // (findByCodigoPedidoAndNumLineaAndTipo) y en validarLineasSinDuplicados, que además de la petición
      // consulta las planis ya persistidas. Dejar pasar los dos tramos haría que el segundo save fallara
      // con «la línea ya está planificada» y, por el todo-o-nada de guardarLote, el rollback se llevaría
      // también el primero: de perder 16 minutos se pasaba a perder los 60.
      //
      // Así que los tramos de una misma visita no se dejan pasar sueltos ni se descartan: se CONSOLIDAN
      // en el alta que ya va, sumándole sus minutos (tiempoPlanificadoDia → tiempoEstimadoCampo de la
      // plani). Tres casos, y el orden importa:
      //   · mismo pedido+línea+día+HORA  → duplicado de verdad: se omite (no se suma, o doblaría minutos).
      //   · mismo pedido+línea+día, otra hora → tramo de la visita partida: se suma y se dice.
      //   · mismo pedido+línea, otro día → la API no admite la segunda: se omite diciendo qué día se crea.
      //
      // Nada de lo que decide la rama de campo depende del ORDEN en que lleguen los tramos (review CODEX
      // ronda 3): el día que se crea es el más temprano (diasDeCreacionDeCampo) y el bloque arranca en el
      // tramo más temprano de ese día, no en el primero de la lista. Si el solver emitiera
      // [15:00/16 min, 12:16/44 min] —y ni `data.propuestas` ni `propuestasResumen` ordenan nada—, un
      // bloque de 60 minutos a las 15:00 se comería la tarde del inspector y dejaría 44 minutos de
      // trabajo fuera de su hueco.
      dedupePropuestas(planis) {
        const self = this;
        const vistas = {}; const unicas = []; const omitidas = []; const consolidadas = [];
        const fuera = function(pl, motivo) {
          omitidas.push({ plani: pl, motivo: motivo });
        };
        // Alta de campo que YA va por cada (pedido, línea): es a la que se le suman sus otros tramos.
        const campoPorLinea = {};
        const diasDeCampo = self.diasDeCreacionDeCampo(planis);
        (planis || []).forEach(function(pl) {
          if (UnidadAceptable.esContinuacion(pl)) {
            // Continuación multidía: dedup por pedido+línea+DÍA — cada día 2..N es SU tarea; si se
            // dedupeara solo por pedido+línea se comería las continuaciones.
            const keyT = UnidadAceptable.id(pl);
            if (vistas[keyT]) { fuera(pl, 'otra continuación del mismo pedido y línea el mismo día'); }
            else { vistas[keyT] = true; unicas.push(pl); }
            return;
          }
          if (UnidadAceptable.esInforme(pl)) {
            const keyI = UnidadAceptable.id(pl);
            if (vistas[keyI]) { fuera(pl, 'otro informe de la misma línea'); }
            else { vistas[keyI] = true; unicas.push(pl); }
            return;
          }
          const refLinea = self.refLineaDeCampo(pl);
          const keyExacta = refLinea + '@' + self.momentoDePropuesta(pl);
          if (vistas[keyExacta]) {
            fuera(pl, 'otra visita del mismo pedido y línea a la misma hora');
            return;
          }
          vistas[keyExacta] = true;
          const diaDeCreacion = diasDeCampo[refLinea];
          if (self.diaDePropuesta(pl) !== diaDeCreacion) {
            fuera(pl, 'la API crea un alta de campo por línea y esa visita ya se crea el '
              + self.diaLegible(diaDeCreacion));
            return;
          }
          const yaVa = campoPorLinea[refLinea];
          if (!yaVa) {
            // Copia: consolidar escribe el total de minutos en el alta, y la propuesta original se sigue
            // dibujando en la capa provisional hasta que el usuario confirma (y puede cancelar el
            // diálogo). Mutarla dejaría la pantalla diciendo 60 en un tramo y 16 en el otro.
            campoPorLinea[refLinea] = self.copiaDePropuesta(pl);
            unicas.push(campoPorLinea[refLinea]);
            return;
          }
          yaVa.tiempoEstimadoCampo = (yaVa.tiempoEstimadoCampo || 0) + (pl.tiempoEstimadoCampo || 0);
          // El bloque arranca en el tramo MÁS TEMPRANO de la visita: es el hueco que el solver le
          // reservó, y los minutos de los demás tramos se le suman a partir de ahí. Con el inicio del
          // primero de la LISTA, una propuesta emitida al revés crearía el bloque entero en el hueco de
          // la tarde, encima de lo que venga después.
          if (self.momentoDePropuesta(pl) < self.momentoDePropuesta(yaVa)) { yaVa.horaInicio = pl.horaInicio; }
          consolidadas.push({ plani: pl, destino: yaVa });
        });
        return { unicas: unicas, omitidas: omitidas, consolidadas: consolidadas };
      },
      /**
       * #460 (opción A, 16/10/2026) · le dice al registro de la corrida que una persona ha
       * DESCARTADO a mano propuestas, para que esas unidades dejen de figurar como pendientes.
       *
       * PUNTO ÚNICO de las dos salidas por las que una propuesta se va de la pantalla sin llegar a
       * ser alta: el descarte de un bloque suelto y «Quitar propuestas». Tenerlo en un sitio es lo
       * que evita que la siguiente salida que se añada se olvide de anotarlo, que es como esto llegó
       * a la ronda 4.
       *
       * Tres cosas que no son casualidad:
       *
       *  · **Solo viaja la REFERENCIA del bloque**, no una identidad de unidad ni un plan. El
       *    denominador de la corrida lo deriva la API de la propuesta que tiene guardada, y la unidad
       *    del bloque descartado también: así un descarte solo puede señalar trabajo que la corrida
       *    propuso de verdad, y no puede fijar ni mover ningún número.
       *  · **Se manda al descartar, no al aceptar.** Si se guardara para el Aceptar, descartar la
       *    última propuesta pendiente no llegaría nunca —no queda nada que aceptar— y la corrida se
       *    quedaría como aceptación parcial para siempre aunque la persona la hubiera resuelto entera
       *    (P2 de Codex, ronda 4 del 15/10/2026).
       *  · **Es best-effort**: si no se puede anotar, la pantalla sigue igual y esa unidad se queda
       *    como pendiente, que es la lectura conservadora. Nunca rechaza.
       */
      anotarDescarteDeLaCorrida(planis) {
        const self = this;
        // Todo dentro del try, también lo síncrono: anotar el descarte no puede costarle a nadie el
        // descarte en sí, que es lo que la persona ha pedido.
        try {
          const bloques = (planis || []).filter(function(pl) { return !!pl; })
            .map(function(pl) { return UnidadAceptable.refBloque(pl); });
          // Sin bloques no se manda nada: la API rechazaría la petición vacía y el viaje no diría
          // nada que no se sepa aquí.
          if (!bloques.length) return Promise.resolve(null);
          return self.Planificacion.descarteDeCorrida({
            data: {
              runId: self.runPropuesta,
              inspector: self.inspectorObjetivo(),
              motivo: 'descartada a mano antes de aceptar',
              bloques: bloques
            }
          }).catch(function() { return null; });
        } catch (e) {
          return Promise.resolve(null);
        }
      },
      // Copia superficial de una propuesta para construir el alta. Superficial basta: de lo que
      // `altaDesdePropuesta` lee, lo único que se reescribe al consolidar es `tiempoEstimadoCampo`, que
      // es un número; `inspectores` y `tipoTarea` se comparten sin tocarse.
      copiaDePropuesta(pl) {
        return Object.assign({}, pl);
      },
      // Referencia legible de una propuesta para el informe de fallos y el aviso de omitidas. El campo
      // lleva día y hora porque desde que la clave de de-dupe las mira, «Pedido 123 línea 1» ya no
      // identifica un tramo: una visita partida son dos, y hay que poder decir cuál.
      refDePropuesta(pl) {
        if (!pl) return '?';
        if (this.esContinuacionMultidia(pl)) {
          return 'Continuación pedido ' + (pl.numeroPedido || pl.codigoPedido || '?') + ' línea ' + pl.numLinea
            + ' (' + (pl.horaInicio ? moment(pl.horaInicio).format('DD/MM') : '?') + ')';
        }
        if (UnidadAceptable.esInforme(pl)) return 'TPIP ' + (pl.lineaId || '');
        return 'Pedido ' + (pl.numeroPedido || pl.codigoPedido || '?') + ' línea ' + pl.numLinea
          + (pl.horaInicio ? ' (' + moment(pl.horaInicio).format('DD/MM HH:mm') + ')' : '');
      },
      // Crea el lote en secuencia. Registra creadas[{id}] y fallos[{ref, motivo}]; NUNCA rechaza (para poder
      // decidir rollback con el balance completo).
      guardarLote(planis, insp) {
        const self = this;
        const creadas = []; const fallos = [];
        return (planis || []).reduce(function(chain, pl) {
          return chain.then(function() {
            return self.Planificacion.save({ data: self.altaDesdePropuesta(pl, insp), itemId: null })
              .then(function(res) {
                const lst = (res && (res.list || (res.dto ? [res.dto] : []))) || [];
                lst.forEach(function(c) {
                  if (c && c.id) creadas.push({ id: c.id, tipo: c.tipo, idPedido: c.idPedido, numLinea: c.numLinea });
                });
              })
              .catch(function(e) { fallos.push({ ref: self.refDePropuesta(pl), motivo: self.msgErrorProp(e) }); });
          });
        }, Promise.resolve()).then(function() { return { creadas: creadas, fallos: fallos }; });
      },
      // Rollback targeted: SOLO las creadas en este lote (nunca borrado amplio). El campo (LINEA) se revierte
      // con borrarInspector (por idPlani) para limpiar también los legs de desplazamiento que el alta genera
      // y desmarcar la línea; el resto (TPIP/TAREA) por delete(id). Best-effort (no bloquea el informe).
      rollbackCreadas(creadas, insp) {
        const self = this;
        const inspector = insp || self.inspectorFiltro;
        return (creadas || []).reduce(function(chain, c) {
          return chain.then(function() {
            if (c.tipo === 'LINEA' && c.idPedido != null) {
              return self.Planificacion.borrarInspector({ data: { inspector: inspector, idPlani: c.id,
                idPedido: c.idPedido, numeroLinea: c.numLinea, esQuedada: false } }).catch(function() {});
            }
            return self.Planificacion.delete({ itemId: c.id }).catch(function() {});
          });
        }, Promise.resolve());
      },
      // Modo B (d) — RESTAURA el snapshot recreando cada plani vieja por su shape. Devuelve la lista de refs que
      // NO se pudieron recrear (para el aviso prominente). NUNCA silencioso: si algo falla, se reporta.
      restaurarSnapshot(items, insp) {
        const self = this;
        const noRest = [];
        return (items || []).reduce(function(chain, p) {
          return chain.then(function() {
            const alta = self.altaDesdeSnapshot(p, insp);
            if (!alta) { noRest.push(self.refDeSnapshot(p) + ' (tipo no restaurable)'); return; }
            return self.Planificacion.save({ data: alta, itemId: null })
              .catch(function(e) { noRest.push(self.refDeSnapshot(p) + ' (' + self.msgErrorProp(e) + ')'); });
          });
        }, Promise.resolve()).then(function() { return noRest; });
      },
      // Alta para RECREAR una plani del snapshot: campo = pedido+línea; TPIP = tarea T0005 (mismo tiempo).
      // Otros tipos → null (no restaurable automáticamente → se reporta).
      //
      // #286: el bloque del snapshot es uno GUARDADO, así que aquí el pedido y la línea sí suelen
      // venir —un TPI planificado desde «Planificar pedido» los lleva— y la restauración los
      // perdía: el bloque restaurado nacía sin clave aunque el que sustituye la tuviera. Es la
      // misma forma del fallo que en `altaDesdePropuesta`, en el otro camino que crea una tarea,
      // así que se cierra con el mismo sitio único.
      altaDesdeSnapshot(p, insp) {
        const inspector = insp || (p.inspectores && p.inspectores[0] && p.inspectores[0].username) || this.inspectorFiltro;
        const inspectores = [{ username: inspector, rol: 'INSPECTOR' }];
        const fechaVisita = p.horaInicio;
        const cod = p.tipoTarea && p.tipoTarea.codigo;
        if (p.tipo === 'TAREA' && cod === 'T0005') {
          return { inspectores: inspectores, fechaVisita: fechaVisita, pendienteConfirmar: p.pendienteConfirmar,
            tarea: Object.assign({ tipo: { codigo: 'T0005' }, tiempoEstimado: p.tiempoEstimadoCampo, horaInicio: fechaVisita, descripcion: 'TPI (restaurada C4)' },
              this.vinculoLineaDeLaPropuesta(p)) };
        }
        if (p.tipo === 'LINEA' && (p.numeroPedido != null || p.codigoPedido != null) && p.numLinea != null) {
          return { inspectores: inspectores, fechaVisita: fechaVisita, pendienteConfirmar: p.pendienteConfirmar,
            numeroOCodigoPedido: String(p.numeroPedido || p.codigoPedido || ''), numeroLinea: p.numLinea };
        }
        return null;
      },
      refDeSnapshot(p) {
        if (p.tipo === 'TAREA') {
          return 'Tarea ' + ((p.tipoTarea && p.tipoTarea.codigo) || '') + ' ' + (p.horaInicio ? String(p.horaInicio).slice(0, 10) : '');
        }
        return 'Pedido ' + (p.numeroPedido || p.codigoPedido || '?') + ' línea ' + p.numLinea;
      },
      // Días 'YYYY-MM-DD' distintos que toca el lote (para recalcular su ruta tras un rollback).
      diasDelLote(planis) {
        const set = {};
        (planis || []).forEach(function(pl) {
          const d = (pl.horaInicio && pl.horaInicio.split) ? pl.horaInicio.split('T')[0] : null;
          if (d) set[d] = true;
        });
        return Object.keys(set);
      },
      // Tras un rollback, calcularRuta (persist) del inspector en cada día afectado: borra las DESPLAZAMIENTO
      // del día y regenera desde las visitas que queden (0 tras el rollback → 0 legs). Evita DESPLAZAMIENTO
      // fantasma que inflarían TD/Km. Best-effort y acotado a los días del lote. (calcularRuta no toca días
      // con legs moviloc reales: retorna sin borrar.)
      recalcularRutaDias(dias, insp) {
        const self = this;
        const inspector = insp || self.inspectorFiltro;
        return (dias || []).reduce(function(chain, dia) {
          return chain.then(function() {
            return self.Planificacion.calcularRuta({ data: { dia: dia, inspector: inspector } }).catch(function() {});
          });
        }, Promise.resolve());
      },
      // Diálogo de fallos: por cada uno, referencia (pedido/línea o tarea) + motivo del backend.
      informeFallos(fallos, cabecera) {
        let html = (cabecera || '') + '<br><br><b>Fallos (' + fallos.length + '):</b><br>';
        html += fallos.slice(0, 15).map(function(f) { return '• ' + f.ref + ' — ' + f.motivo; }).join('<br>');
        if (fallos.length > 15) { html += '<br>… y ' + (fallos.length - 15) + ' más.'; }
        return html;
      },
      // Agrupa las omitidas por motivo: {motivo, refs[]} en el orden en que aparecieron. Lo usan el
      // aviso del resultado y el del confirm previo, que tienen que decir lo mismo.
      gruposOmitidas(omitidas) {
        const self = this;
        const grupos = [];
        (omitidas || []).forEach(function(o) {
          const motivo = (o && o.motivo) || 'omitida sin motivo registrado';
          let grupo = grupos.filter(function(g) { return g.motivo === motivo; })[0];
          if (!grupo) { grupo = { motivo: motivo, refs: [] }; grupos.push(grupo); }
          grupo.refs.push(self.refDePropuesta((o && o.plani) || o));
        });
        return grupos;
      },
      // Aviso de omitidas: cada grupo con SU número y SU frase, nunca un «N duplicadas» que los junte
      // ni una cola de «0 omitidas» cuando la pasada fue limpia (mismo criterio que el javadoc de
      // FactCobroAsignacionRegla en movilidad). No dice «duplicada»: lo que se omite es una propuesta
      // que repite la clave de otra, y el motivo dice en qué la repite.
      textoOmitidas(omitidas) {
        if (!omitidas || !omitidas.length) return '';
        let html = '<br>Se omitieron ' + omitidas.length
          + (omitidas.length === 1 ? ' propuesta repetida:' : ' propuestas repetidas:');
        this.gruposOmitidas(omitidas).forEach(function(g) {
          html += '<br>• ' + g.refs.length + ' por ' + g.motivo + ': ' + g.refs.slice(0, 8).join(', ')
            + (g.refs.length > 8 ? ' … y ' + (g.refs.length - 8) + ' más' : '');
        });
        return html;
      },
      // Visitas cuyos tramos se han consolidado en un solo alta, una entrada por visita y con el
      // reparto de los tramos: el usuario vio dos bloques en la propuesta y va a ver uno, así que se le
      // dice —y se le dice que los minutos van completos, que es lo que importa—. Mismo criterio que
      // textoOmitidas: sin cola de «0 consolidadas» cuando la pasada fue limpia.
      textoConsolidadas(consolidadas) {
        const self = this;
        if (!consolidadas || !consolidadas.length) return '';
        const visitas = [];
        consolidadas.forEach(function(c) {
          const destino = c && c.destino;
          if (!destino) return;
          let v = visitas.filter(function(x) { return x.destino === destino; })[0];
          if (!v) { v = { destino: destino, tramos: 1 }; visitas.push(v); }
          v.tramos += 1;
        });
        let html = '<br>' + visitas.length + (visitas.length === 1
          ? ' visita partida se crea como UN bloque, con todos sus minutos:'
          : ' visitas partidas se crean como UN bloque cada una, con todos sus minutos:');
        visitas.forEach(function(v) {
          html += '<br>• ' + self.refDePropuesta(v.destino) + ' — ' + v.tramos + ' tramos, '
            + (v.destino.tiempoEstimadoCampo || 0) + ' min en total (la API crea un alta de campo por línea).';
        });
        return html;
      },
      // Los motivos distintos, para el confirm previo (donde no cabe el detalle). Antes decía «N
      // duplicadas se omiten» en bloque, que es la misma afirmación sin comprobar que textoOmitidas.
      resumenOmitidas(omitidas) {
        if (!omitidas || !omitidas.length) return '';
        const n = omitidas.length;
        const motivos = this.gruposOmitidas(omitidas).map(function(g) { return g.motivo; }).join(' · ');
        return n + (n === 1 ? ' se omite' : ' se omiten') + ' (' + motivos + ')';
      },
      // Lo mismo para el confirm previo, pero de las consolidadas: cuántas visitas y que no pierden
      // minutos. Sin detalle, que ahí no cabe; el detalle lo da textoConsolidadas en el resultado.
      resumenConsolidadas(consolidadas) {
        if (!consolidadas || !consolidadas.length) return '';
        const visitas = [];
        consolidadas.forEach(function(c) {
          if (c && c.destino && visitas.indexOf(c.destino) === -1) visitas.push(c.destino);
        });
        const n = visitas.length;
        return n + (n === 1 ? ' visita partida se crea' : ' visitas partidas se crean')
          + ' como un solo bloque, con todos sus minutos';
      },
      // Normaliza la lista de PLANIFICADA a borrar que devuelve el endpoint acotado (ResponseDto<List>).
      listaBorrado(res) {
        let lista = res ? (res.dto || res.list || res.data) : null;
        return Array.isArray(lista) ? lista : [];
      },
      // Texto del diálogo de confirmación del borrado (Modo B): qué se borra, nunca REALIZADA, y qué
      // se crea. `nAltas` es el nº de altas que se van a mandar (dd.unicas), NO el de propuestas
      // dibujadas: desde que los tramos de una visita partida se consolidan, las dos cifras no
      // coinciden y la de la pantalla prometía más bloques de los que se crean. `ajustes` es el
      // mismo resumen de consolidadas y omitidas que ve el confirm de CUBRIR_HUECOS: lo que el
      // de-dupe ha cambiado se dice ANTES del borrado, no en el aviso del final.
      resumenBorrado(lista, dias, nAltas, ajustes) {
        const creadas = 'Se crearán ' + nAltas + ' planificaciones (pendientes de confirmar)'
          + (ajustes ? ' · ' + ajustes : '') + '.';
        if (!lista.length) {
          return 'No hay planificaciones PLANIFICADA que borrar en ' + dias.join(', ') + '. ' + creadas;
        }
        let html = 'Se BORRARÁN ' + lista.length + ' planificaciones PLANIFICADA en ' + dias.join(', ')
          + ' (nunca las REALIZADA). ' + creadas + '<br><br>';
        html += lista.slice(0, 15).map(function(p) {
          const dia = p.horaInicio ? (p.horaInicio.split ? p.horaInicio.split('T')[0] : p.horaInicio) : '';
          const ref = p.codigoExpediente || (p.tipoTarea && p.tipoTarea.codigo) || p.tipo || '';
          return '• ' + dia + ' — ' + ref;
        }).join('<br>');
        if (lista.length > 15) { html += '<br>… y ' + (lista.length - 15) + ' más.'; }
        return html;
      },
      // Extrae el motivo legible del backend. El error de negocio llega anidado como { error: { message } }
      // (ResponseDto); también soporta string / { message } / { error: "..." }.
      msgErrorProp(e) {
        if (!e) return 'Error al procesar la propuesta.';
        if (typeof e == 'string') { try { e = JSON.parse(e); } catch (_) { return e; } }
        if (e.error && typeof e.error == 'object' && e.error.message) return e.error.message;
        return e.message || (typeof e.error == 'string' ? e.error : null) || e.error_description || 'Error al procesar la propuesta.';
      },
      /**
       * #59 · De qué va lo que hay AHORA en la rejilla: de este empleado y de esta semana.
       *
       * Es la clave que llevan las cuatro cargas del calendario (agenda, pedidos del cabecero,
       * diarios y mapa TPC). Todas piden por los mismos tres datos, así que todas se caducan a la
       * vez y por el mismo sitio: cuando se cambia de empleado o de semana, lo que venga de la
       * combinación anterior se descarta en el carril y no llega a escribirse.
       *
       * El empleado se normaliza con `comoUsername` —la ERP guarda «JJCS» y el login «jjcs»—
       * porque `getPlanificaciones` lleva `inspectorFiltro` a esa misma forma: sin normalizar
       * aquí, la clave de la carga y la de la pantalla podrían no coincidir solo por la caja y se
       * descartaría una respuesta buena.
       *
       * **Y de qué sesión.** Las tres primeras no distinguen de quién son los datos: cerrar sesión
       * y entrar con otra cuenta en la misma pestaña deja el mismo empleado y la misma semana en la
       * clave, así que la respuesta de la cuenta anterior seguía siendo «de lo que se mira» y se
       * pintaba. Es el mismo tercer dato que ya llevan «Mis vacaciones», la bandeja y el badge del
       * menú (ver `identidadSesion.js`), y aquí cierra las cuatro cargas de golpe.
       */
      claveDelCalendario() {
        return [
          identidadSesion(),
          this.comoUsername(this.inspectorFiltro),
          this.fechaDesdeFiltro,
          this.fechaHastaFiltro
        ];
      },
      getPlanificaciones() {
        const self = this;
        const app = self.$f7;
        self.readOnlyPlanif = true;
        self.Planificacion.clearCache();
        self.inspectorFiltro = self.comoUsername(self.inspectorFiltro);
        // Y la comparación con el empleado de la ruta, también por `username` normalizado: con el
        // login en minúsculas, «JJCS» != «jjcs» mandaba a navegar al calendario propio recién
        // abierto en vez de reconocerlo como el mismo.
        if(self.inspectorFiltro != null && self.inspectorFiltro != '' && !self.mismoUsuario(self.inspectorFiltro, self.username) && self.target != 'cordova') {
          self.open("/calendario/" + self.inspectorFiltro + "/");
          self.inspectorFiltro = self.comoUsername(self.username);
          return;
        }

        if (self.inspectorFiltro == null || self.inspectorFiltro == '' || self.inspectorFiltro == undefined || self.inspectorFiltro == 'undefined') {
          if (self.username == undefined || self.username == 'undefined')  {
            self.inspectorFiltro = self.comoUsername(Utils.getUser().username);
            if (self.target != 'cordova') {
              self.open("/calendario/" + self.inspectorFiltro + "/");
              return;
            }
          } else {
            self.inspectorFiltro = self.comoUsername(location.href.split('/')[location.href.split('/').length-2]);
          }
        }

        // #59 · la clave de esta pasada: las cuatro cargas que vienen a continuación son de este
        // empleado y de esta semana, y se descartan solas si para cuando contesten se está
        // mirando otra cosa.
        const claveDeEstaCarga = self.claveDelCalendario();
        // #59 · Si se ha pasado a mirar OTRA combinación, lo de la anterior se va ya: los datos,
        // las cifras del cabecero —`totalesDia` incluido, que antes se vaciaba aparte y en TODAS
        // las recargas, también en las de la misma persona— y el detalle del día abierto.
        if (!mismaClave(self.clavePintada, claveDeEstaCarga)) {
          self.vaciarLoPintado();
        }
        self.clavePintada = claveDeEstaCarga;
        // #59 · Y las CUATRO cargas salen de aquí, incluida la de los diarios.
        //
        // Los diarios colgaban de `getEvents`, que solo se dispara al mover el rango del
        // calendario. Cambiar de empleado llama a `getPlanificaciones` —desde el selector y desde
        // otros veinticinco sitios— y no los relanzaba.
        self.getDiarios(claveDeEstaCarga);
        // En esta búsqueda vamos a proyectar los campos fechaContratacion y totalSinIVASinTasasConDescuento para obtener todos los pedidos y poder acumular por día y total
        self.carrilPedidos.lanzar(self.Pedido.getList({
          projection: "codigo,numero,fechaContratacion,totalSinIVASinTasasConDescuento",
          filter: {
            withoutAggregations: true,
            onlyAggregations: false,
            activo: true,
            empleadoContratacion: self.inspectorFiltro,
            fechaContratacionDesde: self.fechaDesdeFiltro,
            fechaContratacionHasta: self.fechaHastaFiltro,
            estados: ['CREADO', 'EN_EJECUCION', 'PLANIFICADO', 'EJECUTADO', 'FACTURADO', 'CERRADO']
          }
        }), {
          clave: claveDeEstaCarga,
          deAhora: self.claveDelCalendario,
          // Los totales se acumulan en una lista propia y se publican de una vez al final: así lo
          // que se pinta nunca es una suma a medias de esta carga.
          exito: function(res) {
            // aquí vamos a calcular los OEA díarios y total y lo guardamos en self.totalesDia
            const totales = [];
            let oea = 0;
            let pedidosTotal = [];
            let dia;
            let totalDia;
            res.list.forEach(p=>{
              dia=p.fechaContratacion.split("T")[0];
              oea+= p.totalSinIVASinTasasConDescuento;
              totalDia = totales.find(t => t.dia == dia);
              pedidosTotal.push({id: p.id, numero:p.numero, codigo: p.codigo});
              if (totalDia) {
                totalDia.oea += p.totalSinIVASinTasasConDescuento;
                totalDia.pedidos?totalDia.pedidos.push({id: p.id, numero:p.numero, codigo: p.codigo}):totalDia.pedidos=[{id: p.id, numero:p.numero, codigo: p.codigo}];
              } else {
                totales.push({dia: dia, oea: p.totalSinIVASinTasasConDescuento,pedidos: [{id: p.id, numero:p.numero, codigo: p.codigo}]});
              }
            });
            // añadimos a la lista de totales el total general con valor dia == "total"
            totales.push({dia: "total", oea: oea, pedidos: pedidosTotal});
            self.totalesDia = totales;
          },
          limpiar: function() { self.totalesDia = []; },
          fallo: function(e) {
            if (typeof e == "string") e = { error: e };
            let error = e.message || e.error || e.error_description;
            app.dialog.alert(error);
          }
        });

        return new Promise(function(resolve, reject) {
          if (!self.inspectorFiltro) {
            app.dialog.alert("Debe introducir un inspector.");
            // #59 · Y se cierra: sin empleado no sale ninguna petición, así que no hay nada que
            // esperar. Quedándose pendiente, quien la esperase —la recarga que arranca al resolver
            // unas vacaciones, que mantiene su espera hasta que esto conteste— se quedaba con el
            // indicador puesto para siempre sobre la aplicación entera. Se cumple y no se rechaza
            // porque el aviso ya está dado y la mayoría de los veinticinco llamantes no atienden
            // el rechazo: lo convertirían en un error sin dueño en la consola.
            resolve();
          } else {
            document.title = self.inspectorFiltro.toUpperCase();
            // #58 · De quién va a ser la agenda que traiga ESTA petición. Se guarda junto a los
            // eventos cuando llegan, porque `inspectorFiltro` ya puede ser otro para entonces.
            const inspectorDeEstaCarga = self.inspectorFiltro;
            // Y se guarda la promesa: hasta que esta carga no contesta no se sabe de quién es la
            // rejilla, y hay decisiones que no se pueden tomar sin saberlo (`conDuenioDeLaAgenda`).
            self.promesaAgenda = self.carrilAgenda.lanzar(self.Planificacion
              .getList({
                filter: {
                  inspector: inspectorDeEstaCarga,
                  fechaDesde: self.fechaDesdeFiltro,
                  fechaHasta: self.fechaHastaFiltro,
                }
              }), {
              clave: claveDeEstaCarga,
              deAhora: self.claveDelCalendario,
              exito: function(res) {
                self.events = [];
                self.duenioEventos = inspectorDeEstaCarga;
                let fechaFiltro = moment().subtract(1, 'day').format('YYYY-MM-DD');
                // self.fechaHastaFiltro es una fecha en formato GMT, si es mayor al dia actual se setea el dia actual en fechaFiltro en el formato GMT tambien
                
                if (self.fechaHastaFiltro && self.fechaHastaFiltro < fechaFiltro) {
                  fechaFiltro = self.fechaHastaFiltro;
                }

                self.totalImporteInformesPendientes = self.getDiario(fechaFiltro)?.importeInformesPendientes;
                self.fechaPrimerInformePdte = DateUtils.dateFormat(self.getDiario(fechaFiltro)?.fechaPrimerInforme, 'DD/MM/YYYY');
                if (res && res.list && res.list.length) {
                    // #460 · un bloque por el que se tropiece la pantalla NO puede vaciar el día. El
                    // armado de cada bloque vive ahora en `eventoDePlanificacion`, que nunca lanza
                    // y que descarta el registro que no trae planificación (ronda 12): un hueco de
                    // la lista no se puede pintar y tampoco se inventa, así que no llega a `events`.
                    self.planificacionesPintables(res.list, 'la agenda del inspector').forEach(l => {
                      const evento = self.eventoDePlanificacion(l);
                      if (evento) self.events.push(evento);
                    });
                    if (self.filterData && Object.keys(self.filterData).length > 0) {
                      self.events = self.events.filter(e => {
                        // #460 · el filtro decide leyendo la planificación del bloque. Un evento sin
                        // ella ya no se publica, pero si llegara por otro camino no se puede decidir
                        // nada sobre él: fuera, en vez de reventar la recarga entera aquí.
                        const plani = e && e.planificacion;
                        if (!plani) return false;
                        let include = true;
                        for (let key in self.filterData) {
                          if (key == 'tipoTarea') {
                            if (self.filterData[key] == 'OTRAS') {
                              if (plani[key] && plani[key].codigo && ['T0005', 'T0040'].includes(plani[key].codigo)) {
                                include = false;
                              }
                            } else if (self.filterData[key] && plani[key] && !self.filterData[key].includes(plani[key].codigo)) {
                              include = false;
                            }
                          } else if (self.filterData[key] && !self.filterData[key].includes(plani[key])) {
                            include = false;
                          }
                        }
                        return include;
                      });
                    }
                }
                // C4 FIX (arrastre OEB-PPEND a semanas siguientes): la capa PROVISIONAL de propuestas y el
                // cálculo de TODOS los totales del cabecero corren SIEMPRE, haya o no agenda confirmada esta
                // semana. Antes la rama "sin agenda confirmada" (semana vacía) NO recalculaba totalPPend, así
                // que el OEB-PPEND de la semana propuesta (S33) se arrastraba a S34/S35. Los total* van
                // acotados a [fechaDesdeFiltro, fechaHastaFiltro] (totalImporte / totalTiempoPorTipo /
                // importePorTipo), de modo que una semana vacía da 0 (badge oculto) y la semana propuesta
                // vuelve a mostrar su importe. La capa provisional sobrevive recargas (NO se toca self.propuestas).
                if (self.propuestas && self.propuestas.length) {
                  // #460 (ronda 12) · este es el ÚNICO punto por el que la capa provisional entra en
                  // `events`, así que es donde se cierra el contrato por ese lado: se publica el
                  // evento que trae planificación. `self.propuestas` no se toca (sobrevive recargas).
                  self.events.push.apply(self.events, self.propuestas.filter(
                    p => p && self.esPlanificacionPintable(p.planificacion)));
                }
                self.recalcularTotales();
                // OEB CALENDARIO TPC=SI: cargar mapa y recalcular los totales que dependen de él
                self.cargarMapaTpcFechas(claveDeEstaCarga).then(function() {
                  self.totalTotal = self.totalImporte(undefined, false);
                  self.totalRealizado = self.totalImporte('REALIZADA');
                  self.totalPlanif = self.totalImporte('PLANIFICADA');
                  self.totalPPend = self.totalImporte('PLANIFICADA', true);
                  // Forzar re-render para que las cabeceras de los días se recalculen con el mapa
                  self.$forceUpdate();
                });
                resolve();
              },
              // #59 · Si la agenda no se puede leer, la rejilla se queda SIN DUEÑO: vacía.
              //
              // Dejar los eventos del empleado anterior bajo el nombre del recién elegido es el
              // mismo fallo que destapó la revisión de las respuestas caducadas, por el otro
              // camino: allí lo pintaba una respuesta vieja, aquí lo deja puesto una que no llega
              // nunca —y en Cordova, donde cambiar de persona no navega, se queda así hasta que
              // alguien vuelva a cargar algo—. Con `duenioEventos` a null, `esMiCalendario` y
              // `apruebaA(duenioEventos)` contestan que no, que es el lado seguro: ni se abre el
              // detalle de un día ajeno como propio ni `conDuenioDeLaAgenda` decide un destino
              // con el dueño de antes. Y es lo que ya daba por hecho su comentario: «ahí la
              // rejilla está vacía».
              limpiar: function() {
                self.vaciarLoPintado();
              },
              fallo: function(e) {
                // #59 · No queda ninguna carga en camino que vaya a decir de quién es la rejilla.
                // Dejar aquí la promesa de la carga fallida convertía el reintento de
                // `conDuenioDeLaAgenda` en una espera por algo que ya había terminado sin traer
                // nada: a null, la siguiente decisión que necesite el dueño vuelve a pedir la
                // agenda.
                //
                // Y antes del diálogo, no después: lo que cierra esta carga para quien la espera
                // no puede quedar colgando de que el aviso al usuario salga bien.
                self.promesaAgenda = null;
                reject(e);
                if (typeof e == "string") e = { error: e };
                // #460 · el aviso dice lo que de verdad ha quedado en pantalla, y eso se MIRA, no se
                // deduce de por dónde falló la carga.
                //
                // Antes se intentaba distinguir «sigue la agenda de antes» de «esta carga a medias»
                // según si la petición había llegado a contestar, y las dos frases eran imposibles:
                // cuando este `fallo` habla, el `limpiar` de esta misma carga ya ha corrido —el
                // carril llama siempre a `limpiar` y DESPUÉS a `fallo`, está escrito así en
                // `carrilPeticiones.caida`— y `vaciarLoPintado()` ha dejado la rejilla vacía. O sea
                // que mandar a recargar diciendo «lo que ves sigue siendo la carga anterior» era
                // describir una pantalla que no existe, en los dos casos. Lo acreditan los bloques 9
                // y 10 de `scripts/prueba-calendario-no-se-vacia.js`, que es donde se vio: nunca
                // habían llegado a correr.
                //
                // Se queda la pregunta por el estado REAL, que es verdad diga lo que diga el camino:
                // vacío se explica —para que nadie lea «no hay trabajo»— y lo que quede en pie se
                // declara incompleto. Y con un fallo sin `message` ni `error` —una excepción de
                // pintado— se alertaba `undefined` y el diálogo salía en blanco.
                let error = e.message || e.error || e.error_description;
                const queSeVe = (self.events && self.events.length)
                  ? 'lo que ves puede estar incompleto: faltan bloques o cifras de esta carga.'
                  : 'lo que ves ahora está vacío por el error, no porque no haya nada.';
                app.dialog.alert((error || 'Fallo inesperado al cargar el calendario.')
                  + ' No se ha podido cargar la agenda: ' + queSeVe
                  + ' Vuelve a cargar la pantalla.');
              }
            })
            // Si la respuesta se descarta por caducada no se llama ni a `exito` ni a `fallo`, así
            // que el promise que espera el llamante lo cierra el carril: quien hiciera
            // `getPlanificaciones().then(...)` no se queda esperando una carga que ya no interesa.
            //
            // Y si lo que se rompe es `exito` —la respuesta llega bien y es al transformarla, un
            // DESPLAZAMIENTO antiguo sin `desplazamiento.distance`—, esa excepción sale por
            // `limpiar` y `fallo`, que son los que vacían la rejilla y rechazan este promise
            // (`carrilPeticiones`, «la promesa que devuelve `lanzar` se cumple SIEMPRE»). Antes
            // quedaba rechazada la promesa del carril y este `then`, que solo atendía el
            // cumplimiento, no cerraba ni este promise ni la espera de `conDuenioDeLaAgenda`: la
            // pantalla se quedaba sin saber de quién era la rejilla, para siempre y sin decirlo
            // (revisión CODEX del PR #1735, 07/10/2026).
            .then(function() { resolve(); });
          }
        })
      },

      /**
       * #59 · Publica los totales del cabecero a partir de lo que haya en `events`.
       *
       * Estaba escrito dentro del `exito` de la agenda, que era el único sitio que cambiaba la
       * rejilla. Ahora también la vacía el `limpiar` de esa misma carga, y los totales tienen que
       * irse con ella: diecisiete campos puestos a mano en dos sitios se desincronizan en cuanto
       * alguien añada el dieciochoavo.
       *
       * Con `events` vacío todos dan cero o vacío, que es exactamente lo que tiene que enseñar un
       * cabecero sin agenda detrás.
       */
      recalcularTotales() {
        const self = this;
        self.totalTotal = self.totalImporte(undefined, false);
        self.tiempoTotal = self.totalTiempoPorTipo(null, null, ['particular'], [false]);
        self.totalRealizado = self.totalImporte('REALIZADA');
        self.totalPlanif = self.totalImporte('PLANIFICADA');
        self.totalPPend = self.totalImporte('PLANIFICADA', true);
        self.totalTotalKm = self.totalKm();
        self.totalTotalKmParticular = self.totalKm(true);
        self.totalTotalConsumo = self.totalConsumo();
        self.totalTotalConsumoParticular = self.totalConsumo(true);
        self.totalTiempoDesplazamiento = self.totalTiempoPorTipo('DESPLAZAMIENTO', null, "particular", false);
        self.totalTiempoDesplazamientoParticular = self.totalTiempoPorTipo('DESPLAZAMIENTO', null, "particular", true);
        self.totalTiempoTPIR = self.totalTiempoPorTipo('TAREA', null, ['tipoTarea.codigo', 'estado'], ['T0005', 'REALIZADA']);
        self.totalTiempoTPIP = self.totalTiempoPorTipo('TAREA', null, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA']);
        self.totalImporteTPIR = self.totalImporteFirma('REALIZADA');
        self.totalImporteTPIP = self.getFormatImporte(self.importePorTipo('TAREA', null, ['tipoTarea.codigo', 'estado'], ['T0005', 'PLANIFICADA'], true));
        self.totalTiempoTPC = self.totalTiempoPorTipo(['LINEA', 'SINPEDIDO']);
      },

      getInformesPendientes(dia) {
        const self = this;
        let diario = self.getDiario(dia);
        if (diario) {
          return diario.informesPendientes;
        } else {
          return 0;
        }
      },

      /**
       * #563 · los avisos que el cálculo de la ruta dejó en el diario del día. Van en el diario, y no
       * en los desplazamientos, porque los días que los necesitan son los que se quedan sin alguno.
       */
      avisosRutaDia(dia) {
        const diario = this.getDiario(dia);
        return diario && Array.isArray(diario.avisosRuta)
          ? diario.avisosRuta.filter(a => a && a.texto)
          : [];
      },
      /** Naranja si algo no se pudo calcular o decidir; gris si solo explica un día que está bien. */
      colorAvisosRutaDia(dia) {
        return this.avisosRutaDia(dia).some(a => a.nivel === 'AVISO') ? 'orange' : 'gray';
      },
      textoAvisosRutaDia(dia) {
        return this.avisosRutaDia(dia).some(a => a.nivel === 'AVISO') ? '⚠ Ruta' : 'Ruta';
      },
      tooltipAvisosRutaDia(dia) {
        // El tooltip pinta HTML y los textos traen direcciones tal cual: se escapan.
        const escapar = t => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return this.avisosRutaDia(dia).map(a => escapar(a.texto)).join('<br/>');
      },

      getDiario(dia) {
        const self = this;
        let desde = moment(dia).startOf("day");
        let hasta = moment(dia).endOf("day");
        return self.diarios.filter(d => moment(d.dia).isBetween(desde,hasta))[0];
      },

      /**
       * #59 · Todo lo que la pantalla enseña de un empleado y una semana, fuera: los datos de la
       * rejilla, las cifras del cabecero y **el detalle del día que estuviera abierto**.
       *
       * Es el sitio único por el que pasa «esto ya no es de lo que se mira», y lo usan los dos
       * caminos por los que eso ocurre:
       *
       * - **se cambia de empleado o de semana** (`getPlanificaciones`): las cuatro cargas se
       *   relanzan, y hasta que contesten no hay nada que enseñar. Que se quedara lo anterior es
       *   justo el fallo que se arrastra toda la revisión —el nombre de una persona con los días
       *   de otra—, y relanzar no basta: entre el cambio y la respuesta hay un hueco.
       * - **la agenda falla** (su `limpiar`): la rejilla se queda sin dueño.
       *
       * Van todos juntos a propósito. Tenerlo repartido es lo que ha ido dejando sitios a
       * medias ronda tras ronda: primero los eventos, después los totales del cabecero, luego los
       * diarios, y al final lo que no era un dato sino **el detalle del día abierto**. Lo que se
       * añada mañana se añade **aquí**, y queda cubierto por los dos caminos.
       *
       * **Y lo primero que hace es soltar las cargas en vuelo.** Vaciar sin soltarlas deja el
       * hueco por el otro lado: cuando lo que cambia no es el empleado ni la semana —la agenda
       * vigente ha fallado— la clave sigue siendo la misma, así que las otras tres cargas pasaban
       * su `deAhora` y volvían a publicar diarios, informes pendientes y totales del cabecero
       * sobre una rejilla ya vacía (revisión CODEX del PR #1735, ronda 10). El carril descarta por
       * clave y por orden; esto es lo que dice «y además, ya no me vale ninguna».
       */
      vaciarLoPintado() {
        const self = this;
        self.carrilAgenda.invalidar();
        self.carrilPedidos.invalidar();
        self.carrilDiarios.invalidar();
        self.carrilTpc.invalidar();
        // Las etiquetas de festivo son del domicilio de la persona que se miraba, así que se van
        // con sus días: dejarlas puestas marcaba como fiesta un día que para el nuevo empleado
        // —o para la cuenta que acaba de entrar— es laborable, y al revés. Son la quinta carga
        // por persona y tramo de esta pantalla, y la única que no se iba por aquí.
        self.carrilFestivos.invalidar();
        self.festivosPorDia = {};
        self.events = [];
        self.duenioEventos = null;
        self.mapaTpcFechas = {};
        self.clavesEnEvents = {};
        self.diarios = [];
        self.totalesDia = [];
        self.publicarInformesPendientes();
        // Los totales del cabecero salen todos de `events`, así que se recalculan en bloque en
        // vez de ponerse a cero uno a uno: así no hay una lista de campos que alguien tenga que
        // acordarse de ampliar aquí al añadir un total nuevo.
        self.recalcularTotales();
        // Y el detalle del día, que es lo único de la pantalla que no colgaba de aquí: el menú de
        // un día con sus botones de aprobar no puede sobrevivir a la rejilla que lo contenía.
        self.cerrarDetalleDelDia();
      },

      /**
       * #59 · Los dos datos del cabecero que salen de los diarios: el importe de informes
       * pendientes y la fecha del primero.
       *
       * Estaban escritos dentro del `exito` de la AGENDA, que es otra carga. Como las dos van en
       * paralelo, si los diarios contestaban después se quedaban los del empleado anterior —o
       * nada— con el nombre del nuevo delante; y si la agenda fallaba, se borraban unas cifras
       * que seguían siendo buenas. Ahora los publica quien los trae, que es el único que sabe
       * cuándo valen.
       */
      publicarInformesPendientes() {
        const self = this;
        let fechaFiltro = moment().subtract(1, 'day').format('YYYY-MM-DD');
        // self.fechaHastaFiltro es una fecha en formato GMT, si es mayor al dia actual se setea el dia actual en fechaFiltro en el formato GMT tambien
        if (self.fechaHastaFiltro && self.fechaHastaFiltro < fechaFiltro) {
          fechaFiltro = self.fechaHastaFiltro;
        }
        const diario = self.getDiario(fechaFiltro);
        self.totalImporteInformesPendientes = diario?.importeInformesPendientes;
        self.fechaPrimerInformePdte = DateUtils.dateFormat(diario?.fechaPrimerInforme, 'DD/MM/YYYY');
      },

      /**
       * #59 · Los diarios del empleado y la semana que se están mirando.
       *
       * No se llama desde fuera salvo por `getPlanificaciones`: es una de las cuatro cargas del
       * calendario y todas se relanzan juntas desde allí. La `clave` llega de quien las lanza
       * para que las cuatro lleven exactamente la misma y se caduquen a la vez.
       */
      getDiarios(clave) {
        const self = this;
        self.inspectorFiltro = self.comoUsername(self.inspectorFiltro);
        if (!self.inspectorFiltro) {
          return;
        }
        // #59 · los diarios son del mismo empleado y del mismo periodo que la agenda, y de
        // ellos sale el importe de informes pendientes del cabecero: una respuesta caducada
        // mezclaría las cifras de una persona con los días de otra.
        self.carrilDiarios.lanzar(self.Planificacion
          .getDiarios({
            data: {
              inspector: self.inspectorFiltro,
              fechaDesde: self.fechaDesdeFiltro,
              fechaHasta: self.fechaHastaFiltro,
            }
          }), {
            clave: clave || self.claveDelCalendario(),
            deAhora: self.claveDelCalendario,
            exito: function(res) {
              self.diarios = res && res.list ? res.list : [];
              self.publicarInformesPendientes();
            },
            limpiar: function() {
              self.diarios = [];
              self.publicarInformesPendientes();
            }
          });
      },

      /**
       * #240 · El RELLENO de un bloque del calendario. Dice el TIPO de trabajo y NUNCA el estado:
       * el estado lo dice el borde (la regla entera está arriba, junto a `RELLENO_TIPO`).
       *
       * Dos mitades. Los tipos que una persona tiene que reconocer de un vistazo —las ausencias, los
       * desplazamientos, el fichaje, la inspección sin pedido— llevan relleno DECLARADO y una
       * entrada propia en la leyenda. El resto conserva lo de siempre, «un tono propio por tipo de
       * trabajo», que es lo que permite ver que dos bloques son del mismo servicio sin leerlos: lo
       * que cambia es que del hash sale solo el TONO, y de un arco que no toca ningún color
       * RESERVADO —ni los cuatro de estado ni los siete rellenos declarados—, en vez de un color
       * cualquiera de los 16 millones.
       */
      /**
       * #460 (ronda 12) · ¿Esto es una planificación que se pueda pintar? Un `null`, un hueco de
       * array o un escalar suelto no lo son. Es la única pregunta del contrato de entrada de los
       * eventos del calendario, en un solo sitio para que los tres caminos que fabrican bloques
       * —la agenda confirmada, la propuesta del solver y la propuesta reconstruida del registro—
       * respondan lo mismo.
       */
      esPlanificacionPintable (l) {
        return !!l && typeof l === 'object';
      },
      /**
       * #460 (ronda 12) · Las entradas de una lista de la API que SÍ se pueden pintar, con los
       * descartes dichos en la consola (que es lo que permite enterarse de que la API está
       * devolviendo huecos, en vez de que desaparezcan sin más).
       *
       * No rellena lo que falta: devolver una planificación inventada para que el bloque pase
       * pintaría en la agenda algo que no existe, y eso es peor que no pintarlo.
       */
      planificacionesPintables (lista, origen) {
        const self = this;
        const pintables = (lista || []).filter(l => self.esPlanificacionPintable(l));
        const descartadas = (lista || []).length - pintables.length;
        if (descartadas > 0) {
          console.warn('[CALENDARIO] ' + descartadas + ' registro(s) sin planificación descartado(s) de '
            + origen + '; el resto del día se pinta igual');
        }
        return pintables;
      },
      /**
       * #460 · UN bloque del calendario, armado a prueba de un dato que falte.
       *
       * Antes esto era un bucle escrito en línea dentro del `.then` de la carga, y la PRIMERA
       * línea de ese `.then` es `self.events = []`. Así que cualquier dato ausente en UN bloque
       * rompía el bucle entero y el calendario se quedaba literalmente vacío: ni el bloque malo,
       * ni los buenos, ni la capa de propuestas. Es lo que vio el probador al aceptar el
       * 15/10/2026 («desapareció todo»), y por eso el aceptar parecía borrar: lo guardado estaba
       * en la base de datos y lo que fallaba era la recarga de después.
       *
       * Un bloque que la pantalla no sabe nombrar se pinta igual, con su tipo por nombre. Lo que
       * no puede pasar es que se lleve por delante el resto del día.
       *
       * #460 (ronda 12) · CONTRATO DE ENTRADA: sin planificación no hay evento, y devuelve `null`.
       * Es la otra mitad de la misma garantía. Un bloque al que le falta un DATO se pinta; un
       * registro que NO ES una planificación no es un bloque: no se le puede inventar una —sería
       * pintar un hueco en la agenda— y publicarlo con `planificacion: null` reaparece dos pasos
       * más allá, porque el filtro de la recarga lee `planificacion[key]`, la plantilla del bloque
       * desreferencia `event.planificacion.direccionInspeccion` sin guarda y las cabeceras de día
       * hacen lo mismo (`totalImporteDia` y `totalImporteDiaFirma` leen `plani.idExpediente`
       * directo, `horasFichajeDia` lee `e.planificacion.tipo`). Descartarlo aquí es lo que deja
       * esos consumos en pie sin ir a poner una guarda en cada uno.
       */
      eventoDePlanificacion (l) {
        const self = this;
        if (!self.esPlanificacionPintable(l)) {
          console.warn('[CALENDARIO] registro sin planificación: no se pinta como bloque');
          return null;
        }
        let nombre;
        try {
          nombre = self.nombreDePlanificacion(l);
        } catch (e) {
          console.warn('[CALENDARIO] bloque sin nombre legible (id=' + (l && l.id) + '): ' + (e && e.message));
          nombre = (l && l.tipo) || 'BLOQUE';
        }
        let color;
        try {
          color = self.getColorEvento(l);
        } catch (e) {
          color = RELLENO_TIPO.DESPLAZAMIENTO_EMPRESA;
        }
        const inicio = (l && l.horaInicio) ? new Date(l.horaInicio).getTime() : 0;
        return {
          name: nombre + (l && l.tipo == 'FICHAJE' ? (' ' + l.tipoFichaje + ' ' + DateUtils.dateFormat(l.horaInicio, 'HH:mm')) : ''),
          color: color,
          colorLetras: self.getColorLetrasEvento(color),
          start: inicio,
          end: inicio + (l && l.tiempoEstimadoCampo ? l.tiempoEstimadoCampo * 60000 : 0),
          timed: true,
          planificacion: l
        };
      },
      /** El rótulo de un bloque por su tipo. Mismo texto que siempre; ver `eventoDePlanificacion`. */
      nombreDePlanificacion (l) {
        if (!l) return 'BLOQUE';
        if (l.tipo == 'TAREA') {
          return (l.codigoTarea + ' - ' + l.nombreTarea);
        }
        if (l.servicio && l.servicio.codigo) {
          return l.servicio.materia
            ? (l.servicio.materia.codigo + ' - ' + l.servicio.nombre)
            : (l.servicio.codigo + ' - ' + l.servicio.nombre);
        }
        if (l.formato) {
          return (l.formato.materia ? l.formato.materia.codigo : l.formato.codigo) + " - "
            + (l.formato.nombre ? l.formato.nombre : (l.formato.materia ? l.formato.materia.nombre : ""));
        }
        if (l.tipo == 'SINPEDIDO') {
          return 'INSPECCIÓN SIN PEDIDO';
        }
        if (l.tipo == 'DESPLAZAMIENTO') {
          return l.moviloc ? this.nombreDesplazamientoMoviloc(l) : this.nombreDesplazamientoRuta(l);
        }
        return l.tipo;
      },
      /**
       * #460 · Los metros de un bloque DESPLAZAMIENTO, de Moviloc o de Google, y 0 si el tramo no
       * los trae. Mismo barrido que `nombreDesplazamientoRuta`: los dos contadores de km leían
       * `desplazamiento.distance.inMeters` sin guarda, así que un tramo sin distancia —el mismo que
       * la medición de la #460 da por posible— dejaba a medias el cálculo de los totales del
       * cabecero y abortaba el resto de la recarga.
       */
      metrosDeDesplazamiento (plani) {
        if (!plani) return 0;
        if (plani.moviloc) {
          const km = parseInt(plani.moviloc.distancia);
          return isNaN(km) ? 0 : km;
        }
        const d = plani.desplazamiento;
        return (d && d.distance && d.distance.inMeters) ? d.distance.inMeters : 0;
      },
      nombreDesplazamientoMoviloc (l) {
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: false
        });
        let nombre = formatter.format(parseInt(l.moviloc.distancia ? l.moviloc.distancia : 0) / 1000).toString()
          + ' Km - ' + (l.tiempoEstimadoCampo ? this.getMinutesHumanize(l.tiempoEstimadoCampo) : l.moviloc.duracion);
        if (l.moviloc.matricula) {
          nombre = nombre + " - " + l.moviloc.matricula;
        }
        return nombre;
      },
      /**
       * #460 · El rótulo del tramo que calculó Google. Se leía `desplazamiento.distance.humanReadable`
       * con tres puntos y sin una sola guarda, y que un tramo persistido venga sin `distance` o sin
       * `duration` no es una hipótesis: es el caso que la propia medición de esta tarea da por
       * posible y aparta (`PlanificacionServiceImpl.tramosEnOrdenDeRuta` invalida el día cuando lo
       * encuentra). Un tramo así dice lo que le falta en vez de dejar el calendario en blanco.
       */
      nombreDesplazamientoRuta (l) {
        const d = l.desplazamiento || {};
        const km = d.distance && d.distance.humanReadable;
        const min = d.duration && d.duration.humanReadable;
        if (km && min) return km + ' - ' + min;
        if (km || min) return km || min;
        return 'DESPLAZAMIENTO (sin datos de ruta)';
      },

      getColorEvento (l) {
        if (!l) {
          return RELLENO_TIPO.DESPLAZAMIENTO_EMPRESA;
        }
        const declarado = this.rellenoDeclarado(l);
        if (declarado) {
          return declarado;
        }
        const str = l.tipo == 'TAREA' ? ((l.tipoTarea && l.tipoTarea.codigo ? l.tipoTarea.codigo : '') + (l.tipoTarea && l.tipoTarea.nombre ? l.tipoTarea.nombre : '')) : ((l.servicio && l.servicio.codigo) ?  l.servicio.codigo : (l.formato ? (l.formato.codigo ? l.formato.codigo : (l.formato.materia ? l.formato.materia.codigo : 'SIN MATERIA')) : l.tipo == 'SINPEDIDO' ? 'INSPECCIÓN SIN PEDIDO' : ( l.tipo ? l.tipo : 'SIN TIPO')));

        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return rellenoDeTono(tonoLibre(hash));
      },
      /**
       * #240 · ¿Tiene este bloque un relleno DECLARADO —uno de los que la leyenda enseña uno por
       * uno— o le toca el tono por tipo de trabajo? Devuelve el hex, o null si no es ninguno.
       *
       * El orden de las comprobaciones es el mismo que tenían los bordes que antes decían el tipo
       * (`borde-rojo`/`borde-negro` del desplazamiento por delante del `borde-naranja` del «sin
       * pedido»), para que ningún bloque cambie de familia al mover la señal del borde al relleno.
       */
      rellenoDeclarado(l) {
        if (l.tipo == 'FICHAJE') {
          return RELLENO_TIPO.FICHAJE;
        }
        if (l.tipo == 'DESPLAZAMIENTO') {
          return l.particular ? RELLENO_TIPO.DESPLAZAMIENTO_PARTICULAR : RELLENO_TIPO.DESPLAZAMIENTO_EMPRESA;
        }
        const codigoTipo = l.tipoTarea && l.tipoTarea.codigo;
        if (codigoTipo && RELLENO_AUSENCIA[codigoTipo]) {
          return RELLENO_AUSENCIA[codigoTipo];
        }
        // Misma condición que el viejo `borde-naranja`: un bloque que no es tarea ni fichaje y no
        // tiene pedido detrás. Es la inspección sin pedido.
        //
        // Las PROPUESTAS quedan fuera, y no es una excepción nueva: el `borde-provisional` se
        // declara al final de la hoja de estilos, así que ganaba siempre y el naranja no se llegaba
        // a ver nunca en una propuesta. Su relleno era —y sigue siendo— el tono de su tipo de
        // trabajo, que es lo que dice la leyenda de la capa de propuestas.
        if (l.tipo != 'TAREA' && !l.idPedido && !l.esPropuesta) {
          return RELLENO_TIPO.SIN_PEDIDO;
        }
        return null;
      },
      /**
       * #240 · Color del badge «horas imputadas» de la cabecera del día. No sale de la paleta de
       * rellenos aunque hable de fichajes: `rBadge` compone una clase de Framework7
       * (`color-<valor>`), así que necesita un NOMBRE de color y un hex lo dejaría sin pintar.
       */
      colorBadgeFichaje () {
        return 'lime';
      },

      getColorLetrasEvento (hexcolor) {

        // If a leading # is provided, remove it
        if (hexcolor.slice(0, 1) === '#') {
          hexcolor = hexcolor.slice(1);
        }

        // Convert to RGB value
        var r = parseInt(hexcolor.substr(0,2),16);
        var g = parseInt(hexcolor.substr(2,2),16);
        var b = parseInt(hexcolor.substr(4,2),16);

        // Get YIQ ratio
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

        // Check contrast
        return (yiq >= 128) ? 'black' : 'white';

      },

      log(str) {
        console.log(str);
      },

      startDrag ({ event, timed }) {
        var self = this;
        console.log("startdrag");
        if(event && timed) {
          self.clickedEvent = event;
        }
        // #49 · sin arrastre en las vacaciones ni en los festivos generados. Se corta aquí y no en
        // mouseMove porque sin dragEvent no hay nada que mover: el resto del arrastre cuelga de él.
        if (event && self.esEventoBloqueado(event.planificacion)) {
          return;
        }
        if (event && timed && ((event.planificacion && (event.planificacion.tipo == 'TAREA' || (event.planificacion.tipo == 'FICHAJE' && Utils.getUser() && (Utils.getUser().username == 'NOID' || (event.planificacion.inspectores[0] && Utils.getUser().username == event.planificacion.inspectores[0].username))))) || !(event.planificacion && event.planificacion.estado && event.planificacion.estado == 'REALIZADA'))) {
          self.dragEvent = event;
          // #49 · aquí NO se anota la planificación: coger el evento es el `mousedown`, que también
          // es la primera mitad de un clic de consulta. Anotarlo aquí hacía que el interruptor, al
          // llegar encendido, tomara por modificada una vacación que solo se había mirado, y saliera
          // el aviso, se cerrara el detalle y se recargara el calendario sin que nadie hubiera
          // tocado nada (review CODEX ronda 8). Se anota en `mouseMove`, que es donde de verdad se
          // muta `horaInicio`/`tiempoEstimadoCampo`.
          self.previousDragEvent = null;
          self.nextDragEvent = null;
          if (self.dragEvent && self.dragEvent.planificacion && self.dragEvent.planificacion.tipo && self.dragEvent.planificacion.tipo == 'FICHAJE') {
            let fichajes = self.events.filter(e => e.planificacion && e.planificacion.tipo == 'FICHAJE');
            // Obtener en previousDragEvent el anterior fichaje de dragEvent por el campo start que es un timemillis
            self.previousDragEvent = fichajes.filter(e => e.start < self.dragEvent.start).sort((a, b) => b.start - a.start)[0];
            // Obtener en nextDragEvent el siguiente fichaje de dragEvent por el campo start que es un timemillis
            self.nextDragEvent = fichajes.filter(e => e.start > self.dragEvent.start).sort((a, b) => a.start - b.start)[0]; 
          }
          
          self.initialDragEvent = JSON.parse(JSON.stringify(event));
          self.dragTime = null;
          self.extendOriginal = null;
        }
      },
      startTime (tms) {
        var self = this;
        const mouse = self.toTime(tms)

        if (self.dragEvent && self.dragTime === null) {
          const start = self.dragEvent.start

          self.dragTime = mouse - start
        } else {
          if (self.selectedOpen) {
            // Pulsar la rejilla con el detalle abierto lo cierra, y cerrarlo es cerrarlo del todo:
            // si no, la solicitud del día que acabó de leerse se quedaba guardada bajo un detalle
            // que ya no se ve.
            self.cerrarDetalleDelDia();
          }
          else {
            self.createStart = self.roundTime(mouse);
            if (!self.gestoSobreEventoSinArrastre()) {
              // #268 · el alta es de la persona cuyo calendario se ha pulsado, no de la que esté en
              // el selector cuando se guarde (ver `borradorDelAlta`).
              self.inspectorDelAlta = self.inspectorFiltro;
              self.popupCrearOpened = true;
            }
          }
        }
      },
      extendBottom (event) {
        var self = this;
        self.createEvent = event
        self.createStart = event.start
        self.extendOriginal = event.end
      },
      mouseMove (tms) {
        var self = this;
        const mouse = self.toTime(tms);
        
        
        if (self.dragEvent && self.dragTime !== null) {
          console.log("mouseMove");
          const start = self.dragEvent.start
          const end = self.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - self.dragTime
          const newStart = self.roundTime(newStartTime)
          const newEnd = newStart + duration

          if (self.dragEvent.planificacion && self.dragEvent.planificacion.tipo == 'FICHAJE') {
            // si newStart es en un dia diferente hacemos return
            if (newStart < new Date(self.initialDragEvent.start).setHours(0, 0, 0, 0)) {
              return;
            }
            // comprobamos tambien si lo intentamos mover al dia siguiente
            if (newStart > new Date(self.initialDragEvent.start).setHours(0, 0, 0, 0) + 86400000) {
              return;
            }
            // Tambien hay que comprobar que no sea posterior a la hora actual
            if (newStart > new Date().getTime()) {
              return;
            }

          }

          if (!self.previousDragEvent || newStart > self.previousDragEvent.start) {
            if (!self.nextDragEvent || newEnd < self.nextDragEvent.start) {
              self.dragEvent.start = newStart
              self.dragEvent.end = newEnd
              if (self.dragEvent.planificacion) {
                self.dragEvent.planificacion.horaInicio = new Date (newStart);
                self.dragEvent.planificacion.tiempoEstimadoCampo = (newEnd - newStart)/60000;
              }
            }
          }

          // self.dragEvent.start = newStart
          // self.dragEvent.end = newEnd

          // if (self.dragEvent.planificacion) {
          //   self.dragEvent.planificacion.horaInicio = new Date (newStart);
          //   self.dragEvent.planificacion.tiempoEstimadoCampo = (newEnd - newStart)/60000;
          // }
        } else if (self.createEvent && self.createStart !== null) {
          const mouseRounded = self.roundTime(mouse, false)
          const min = Math.min(mouseRounded, self.createStart)
          const max = Math.max(mouseRounded, self.createStart)

          self.createEvent.start = min
          self.createEvent.end = max
          if (self.createEvent.planificacion) {
            self.createEvent.planificacion.horaInicio = new Date (self.createEvent.start);
            self.createEvent.planificacion.tiempoEstimadoCampo = (self.createEvent.end - self.createEvent.start)/60000;
          }
        }
      },
      endDrag () {
        var self = this;
        var lineaPlan = null;
        let enviar = true;
        if (self.dragEvent) {
          if (self.initialDragEvent && self.dragEvent.start == self.initialDragEvent.start && self.dragEvent.end == self.initialDragEvent.end) {
            enviar = false;
          }
          lineaPlan = self.dragEvent;
        } else if (self.createEvent) {
          lineaPlan = self.createEvent;
        }

        self.selectedEvent = lineaPlan;

        // #49 · el cuarto camino por el que el calendario escribe. `startDrag` no coge los eventos
        // bloqueados, así que esto no debería llegar a saltar nunca; se queda como cierre del camino,
        // igual que en `guardarCambios`, para que lo que decide sea el tipo de la tarea y no por qué
        // manejador se entró. Se relee para que el evento vuelva a su sitio.
        if (lineaPlan && self.esEventoBloqueado(lineaPlan.planificacion)) {
          enviar = false;
          self.$f7.dialog.alert(MENSAJE_BLOQUEO_VACACIONES);
          self.getPlanificaciones();
        }

        if (lineaPlan && lineaPlan.planificacion && lineaPlan.planificacion.id && enviar) {

          var data = {lineas: [lineaPlan.planificacion]};

          Planificacion.save({
            data: data,
            itemId: null
          }).then(function(res) {

          }).catch(function(e) {
            if (typeof e == "string") {
              e = {
                message: e
              };
            }
            app.dialog.alert(e.message);
            self.errors = e.errors || {};
          }).finally(function(res) {
              self.getPlanificaciones();
          });
        }
        self.dragTime = null
        self.dragEvent = null
        self.createEvent = null
        self.createStart = null
        self.extendOriginal = null
        self.clickedEvent = null
      },
      cancelDrag () {
        var self = this;
        if (self.createEvent) {
          if (self.extendOriginal) {
            self.createEvent.end = self.extendOriginal
            if (self.createEvent.planificacion) {
              self.createEvent.planificacion.tiempoEstimadoCampo = (self.extendOriginal - self.createEvent.start)/60000;
            }
          } else {
            const i = self.events.indexOf(self.createEvent)
            if (i !== -1) {
              self.events.splice(i, 1)
            }
          }
        }

        self.createEvent = null
        self.createStart = null
        self.dragTime = null
        self.dragEvent = null
        self.clickedEvent = null
      },
      roundTime (time, down = true) {
        const roundTo = 5 // minutes
        const roundDownTime = roundTo * 60 * 1000

        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      },
      toTime (tms) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      },
      getEventColor (event) {
        return event ? event.color : '#fff';
      },
      getEvents ({ start, end }) {

        const self = this;

        if (self.inspectorFiltro == null || self.inspectorFiltro == undefined  || self.inspectorFiltro == 'undefined') {

          if (self.username == undefined || self.username == 'undefined') {
            self.inspectorFiltro = self.comoUsername(Utils.getUser().username);
            self.open("/calendario/" + self.inspectorFiltro + "/");
            return;
          } else {
            self.inspectorFiltro = self.comoUsername(location.href.split('/')[location.href.split('/').length-2]);
          }
        }
        self.fechaDesdeFiltro = start.date;
        self.fechaHastaFiltro = end.date;

        // #59 · `getDiarios` ya no se llama aquí: lo hace `getPlanificaciones`, que es el único
        // sitio desde el que se relanzan las cuatro cargas. Llamarlo también desde aquí pediría
        // los diarios dos veces al mover el rango.
        self.getPlanificaciones();
        self.getFestivos();
      },
      /**
       * Cambio del campo «Empleado». En web no hace falta nada más que `getPlanificaciones`,
       * porque navega a otra instancia de la página y allí se carga todo desde cero; en Cordova
       * esa función NO navega, así que el tramo visible no cambia, `getEvents` no se vuelve a
       * disparar y los festivos se quedan siendo los del inspector anterior pintados encima del
       * calendario del nuevo (revisión CODEX del PR #1956).
       */
      cambiarEmpleado() {
        const self = this;
        self.getPlanificaciones();
        if (self.target == 'cordova') {
          self.getFestivos();
        }
      },
      /**
       * Los festivos de esta persona en el tramo visible. No bloquea nada: si falla, el
       * calendario se pinta igual y lo único que falta es la etiqueta del día.
       *
       * #59 · Va con la clave del calendario, como las otras cuatro cargas: estos festivos son
       * **de una persona y de un tramo** —los autonómicos y los locales salen de su domicilio—,
       * así que una respuesta que llegue cuando ya se mira a otra persona, otro tramo u otra
       * sesión pintaría las etiquetas de un calendario ajeno sobre el que hay delante. El
       * contador del carril no basta: la pantalla puede pasar a mirar otra cosa sin relanzar
       * esta carga (ver `carrilPeticiones`).
       */
      getFestivos() {
        const self = this;
        if (!self.inspectorFiltro || !self.fechaDesdeFiltro || !self.fechaHastaFiltro) return;
        self.carrilFestivos.lanzar(
          Festivo.calendario(self.inspectorFiltro, self.fechaDesdeFiltro, self.fechaHastaFiltro), {
            clave: self.claveDelCalendario(),
            deAhora: self.claveDelCalendario,
            exito: function(lista) {
              const porDia = {};
              (lista || []).forEach(function(f) { if (f && f.fecha) porDia[f.fecha] = f; });
              self.festivosPorDia = porDia;
            },
            limpiar: function() { self.festivosPorDia = {}; }
          });
      },
      /** El festivo de ese día, si lo hay. `date` llega ya como 'yyyy-MM-dd' del v-calendar. */
      festivoDelDia(date) {
        return this.festivosPorDia[date] || null;
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      rndElement (arr) {
        var self = this;
        return arr[self.rnd(0, arr.length - 1)]
      },
      esInspector(plani) {
        const self = this;
        return !!plani.inspectores.filter(i => i.username == self.inspectorFiltro && self.rolesInspectorSuma.includes(i.rol)).length;
      },
      /**
       * #49 · ¿Es este evento una vacación (T0006) o un festivo GENERADO por el módulo (T0083 con
       * grupo FEST-)? Solo dice de qué TIPO es; no mira el interruptor.
       *
       * El grupo viaja en la planificación (`grupoTarea`, denormalizado por la API) para no tener que
       * pedir la tarea de cada evento. Sin grupo, una T0083 es una FIESTA creada a mano y sigue
       * editándose como siempre: es la diferencia que pidió la incidencia.
       */
      esEventoDeVacaciones(plani) {
        if (!plani || plani.tipo != 'TAREA') return false;
        return this.esTipoReservado(plani.tipoTarea && plani.tipoTarea.codigo, plani.grupoTarea);
      },
      /**
       * #49 · La regla de qué es intocable, sobre el par (código de tipo de tarea, grupo). Es la
       * misma que aplica el servidor en `RhBloqueoGenericoService.esProtegida`, y vive aparte porque
       * el front la necesita sobre dos formas distintas del mismo dato: la planificación de un
       * evento del calendario (`tipoTarea` + `grupoTarea`, denormalizados) y la tarea que se trae de
       * `/tarea/search` (`tipo` + `grupo`). Escrita dos veces se habría quedado coja en una.
       */
      esTipoReservado(codigoTipoTarea, grupo) {
        if (!codigoTipoTarea) return false;
        if (codigoTipoTarea == 'T0006') return true;
        return codigoTipoTarea == 'T0083' && !!grupo && String(grupo).indexOf('FEST-') === 0;
      },
      /**
       * #49 · ¿Es intocable la tarea YA EXISTENTE cuyo código se ha escrito en el panel «Tarea» del
       * popup «Crear planificación»? Devuelve una promesa porque hay que preguntárselo al servidor:
       * ese panel es un campo de texto libre y la tarea no tiene por qué estar en el calendario
       * —una T0006 en PENDIENTE no está planificada y no se ha pintado nunca—.
       *
       * Se consulta por `andList` y no por el filtro `codigo` de `TareaFilterDTO`, que está tipado
       * como `Integer` mientras el código real de una tarea es `JJCS/00123/26`.
       *
       * `EQUALS_IGNORE_CASE` y no `EQUALS`: el campo es texto libre y no pasa el valor a mayúsculas,
       * así que un `jjcs/00123/26` no encontraba la tarea, esta comprobación resolvía `false` y quien
       * lo escribió se llevaba el error del servidor en vez del mensaje que dice a dónde ir (review
       * CODEX ronda 8). Normalizar el campo a mayúsculas no serviría: el código lleva dentro el
       * username del inspector y darlo por hecho en mayúsculas rompería la búsqueda del que no lo
       * esté —y encima con el interruptor apagado, que es el estado que se entrega—.
       *
       * Ante cualquier fallo, false: se manda y manda el servidor, que es quien de verdad bloquea.
       * Y con el interruptor apagado no se pregunta nada, que es el estado que se entrega.
       */
      tareaExistenteBloqueada(codigoTarea) {
        const self = this;
        const codigo = codigoTarea == null ? '' : String(codigoTarea).trim();
        if (!self.bloqueoVacaciones || !codigo) return Promise.resolve(false);
        return Tarea.getList({
          projection: 'codigo,tipo,grupo',
          filter: { andList: [{ nombre: 'codigo', valor: self.escaparRegex(codigo), operacion: 'EQUALS_IGNORE_CASE' }] }
        }, true).then(function(res) {
          // Todas las devueltas y no la primera: buscando sin distinguir mayúsculas puede volver más
          // de una, y basta que UNA sea de las reservadas para que la petición genérica no valga.
          const tareas = (res && res.list) || [];
          return tareas.some(function(tarea) {
            return self.esTipoReservado(tarea.tipo && tarea.tipo.codigo, tarea.grupo);
          });
        }).catch(function() {
          return false;
        });
      },
      /**
       * #49 · Escapa los metacaracteres de una expresión regular. `EQUALS_IGNORE_CASE` se traduce en
       * el servidor a un `^<valor>$` con la marca `i` (`SearchRepositoryImpl`) y mete el valor tal
       * cual, así que un paréntesis suelto tecleado en «Código de tarea» daría una regex inválida.
       * No es un agujero —el `catch` de arriba resuelve `false` y el servidor sigue bloqueando—, pero
       * se ahorra un error del que nadie se va a acordar viendo el log.
       */
      escaparRegex(texto) {
        return String(texto).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      },
      /**
       * #49 · ¿Hay que quitarle a este evento el lápiz, la papelera, el arrastre y «Marcar como
       * realizada»?
       *
       * Dos reglas, y este es el único sitio donde viven, porque de él cuelgan los nueve caminos
       * —los cuatro botones que se dibujan, el tirador de redimensionado, el arrastre y los tres
       * cierres de las escrituras—. Separarlas en dos predicados dejaba la puerta abierta a que un
       * camino nuevo preguntase por el que no toca.
       *
       * - **Un día de vacaciones (T0006): siempre, con el interruptor en el estado que sea.** Lo
       *   pide el punto 6 de la #58 —«estos días no se editan ni se borran desde ahí»— y lo volvió
       *   a pedir dirección tras probar preview-2 el 16/10/2026, donde el detalle de un día de una
       *   solicitud pendiente salía con lápiz, papelera y «Marcar como realizada». Tocarlo desde
       *   aquí se salta el circuito de solicitud y aprobación y descuadra el saldo, y «Marcar como
       *   realizada» daría por disfrutadas unas vacaciones que nadie ha aprobado: REALIZADA la pone
       *   solo el cierre nocturno (D-UX). Si la acción no es posible, su punto de entrada no se
       *   dibuja (§9 del `CLAUDE.md` del orquestador).
       * - **El resto de lo reservado —los festivos generados `FEST-`— sigue colgando del
       *   interruptor**, que es la regla que escribió la #49 y que esta incidencia no cambia: una
       *   FIESTA generada se gestiona desde su módulo solo a partir de la puesta en marcha.
       *
       * Consecuencia dicha y asumida: con el interruptor apagado, un T0006 cargado a mano por los
       * caminos genéricos (D-PROC) ya no se edita, se mueve ni se borra desde el calendario. Darlo
       * de alta sigue siendo posible —el desplegable de «Crear tarea» lo filtra por interruptor, no
       * por esto—, y gestionarlo es del módulo de Vacaciones.
       */
      esEventoBloqueado(plani) {
        if (this.esDiaDeVacaciones(plani)) return true;
        return this.bloqueoVacaciones && this.esEventoDeVacaciones(plani);
      },
      /**
       * #49 · ¿Se corta esta escritura del calendario? Si se corta, lo DICE, cierra el detalle y
       * relee las planificaciones: es el mismo desenlace en los caminos que escriben, porque lo que
       * haya en pantalla después de un corte son valores tecleados que no se han guardado.
       */
      avisarSiBloqueado(plani) {
        const self = this;
        if (!self.esEventoBloqueado(plani)) return false;
        self.$f7.dialog.alert(MENSAJE_BLOQUEO_VACACIONES);
        self.onCerrarDetalle();
        self.getPlanificaciones();
        return true;
      },
      /**
       * #49 · ¿El gesto ha empezado sobre un evento que no se arrastra? Entonces no es un clic en un
       * hueco libre y no abre «Crear planificación».
       *
       * El mousedown pasa por los DOS manejadores: `@mousedown:event` (startDrag) y, a continuación,
       * `@mousedown:time` (startTime). Cuando startDrag no se queda con el evento, startTime ve
       * `dragEvent` a null y lo toma por un hueco. Esto es lo que lo distingue, y son dos casos:
       *
       * - el REALIZADA que ya estaba —de ahí sale esta comprobación, que antes vivía suelta en
       *   startTime—;
       * - y el evento bloqueado de esta incidencia, que sin esto abría el popup de crear encima del
       *   detalle con solo consultar una vacación (review CODEX ronda 1).
       *
       * `clickedEvent` no se queda viejo: endDrag y cancelDrag lo limpian en el mouseup.
       */
      gestoSobreEventoSinArrastre() {
        const plani = this.clickedEvent && this.clickedEvent.planificacion;
        if (!plani) return false;
        return plani.estado == 'REALIZADA' || this.esEventoBloqueado(plani);
      },
      /**
       * #49 · Filtro del desplegable «Tipo de tarea» del popup «Crear tarea»: con el bloqueo
       * encendido, T0006 no se ofrece. Una vacación creada por ahí nace sin solicitud ni aprobador, y
       * además el servidor rechazaría el alta, así que ofrecerla solo sería un callejón sin salida.
       *
       * T0083 SÍ se sigue ofreciendo: la FIESTA que alguien crea a mano es legítima y no se puede
       * convertir en un festivo generado desde este popup (el grupo FEST- lo pone el módulo).
       */
      esTipoTareaSeleccionable(item) {
        // #271 · y tampoco con el camino manual apagado: ahí el servidor rechaza toda vacación
        // puesta a mano, y ofrecerla sería un botón que lleva a un 403 (§9).
        return !((this.bloqueoVacaciones || this.caminoManualApagado) && item && item.codigo == 'T0006');
      },
      /**
       * #271 · Qué se le dice a quien llega a guardar un T0006 que el desplegable ya no ofrece. Si lo
       * cierra el bloqueo de la #49, su texto de siempre; si lo cierra el camino manual, el suyo, que
       * dice dónde se piden ahora y quién lo reabre.
       */
      mensajeTipoNoSeleccionable() {
        return this.bloqueoVacaciones ? MENSAJE_BLOQUEO_VACACIONES : this.textoCaminoManualCerrado();
      },
      /**
       * #271 · Por qué no se pueden poner vacaciones a mano, dónde se piden ahora y quién lo reabre.
       * «Dónde» depende de si esta persona llega a «Mis vacaciones», como el aviso de la #268: no se
       * le señala un sitio al que no puede entrar.
       */
      textoCaminoManualCerrado() {
        const partes = [this.$t('caminoManual.cerrado'),
          this.$t(this.puedeAbrirVacaciones ? 'vacacionAMano.dondeOficial' : 'vacacionAMano.dondeOficialSinAcceso')];
        if (this.puedeAbrirVacaciones && PermisosVacaciones.registrarEnNombreDe()) {
          partes.push(this.$t('vacacionAMano.enNombreDeOtro'));
        }
        partes.push(this.$t('caminoManual.reabrir'));
        return partes.join(' ');
      },
      /**
       * Obtiene la clave de acto de un codigoExpediente.
       * Formato: {prefijo}/{visita}/{[version/...]}/{año}
       * Ejemplo: 28/REBT-V/06/20040/01/26 → clave "28/REBT-V/06/20040/01/26" (prefijo + visita + año)
       * Ejemplo: 28/REBT-V/06/20040/01/01/26 → clave "28/REBT-V/06/20040/01/26" (misma clave, versión 01)
       * Dos planificaciones con la misma clave de acto representan el mismo acto.
       */
      claveActo(codigoExpediente) {
        if (!codigoExpediente) return null;
        const partes = codigoExpediente.split('/');
        if (partes.length < 6) return null;
        // Las primeras 4 partes son el prefijo, la 5ª es la visita, la última es el año
        // Las partes intermedias (entre visita y año) son la versión
        const prefijo = partes.slice(0, 4).join('/');
        const visita = partes[4];
        const anio = partes[partes.length - 1];
        return prefijo + '/' + visita + '/' + anio;
      },
      /**
       * Determina si una planificación tiene una versión superior en self.events.
       * Si existe otra planificación del mismo acto con código mayor, esta se excluye de la suma.
       */
      esVersion(plani) {
        const self = this;
        if (plani.tipo != 'LINEA' || !plani.codigoExpediente) return false;
        const clave = self.claveActo(plani.codigoExpediente);
        if (!clave) return false;
        // Buscar en los eventos si hay otra planificación del mismo acto con código mayor
        return self.events.some(e => {
          const p = e.planificacion;
          return p && p.tipo == 'LINEA' && p.codigoExpediente
            && p.codigoExpediente !== plani.codigoExpediente
            && self.claveActo(p.codigoExpediente) === clave
            && p.codigoExpediente > plani.codigoExpediente;
        });
      },
      horasFichajeDia: function(fecha) {
        var self = this;
        var total = 0;
        // vamos a filtrar todas las planificaciones tipo FICHAJE, sumando las horas de inicio entre ENTRADA y SALIDA consecutivas
        if (self.events && self.events.length > 0) {
          // filtramos los eventos de FICHAJE del día y los ordenamos por hora de inicio
          var eventosFichaje = self.events.filter(e => e.planificacion.tipo == 'FICHAJE' && (!fecha || moment(e.planificacion.horaInicio).isSame(fecha, 'day')))
                                          .sort((a, b) => moment(a.planificacion.horaInicio).isBefore(moment(b.planificacion.horaInicio)) ? -1 : 1);
           // si la lista de eventos de fichaje empieza por una salida, es que la entrada es del día anterior, así que meteremos al principio un evento de entrada falso con hora de inicio 00:00
          if (eventosFichaje.length > 0 && eventosFichaje[0].tipoFichaje == 'SALIDA') {
            eventosFichaje.unshift({planificacion: {horaInicio: moment(fecha).startOf('day').format('YYYY-MM-DDTHH:mm:ss')}});
          }
          // vamos sumando en total diferencias de horas de inicio entre eventos consecutivos SALIDA - ENTRADA (en horas y minutos) y si no hay salida, detenemos el proceso
          for (var i = 0; i < eventosFichaje.length; i++) {
            if (eventosFichaje[i].planificacion.tipoFichaje == 'ENTRADA') {
              if (i < eventosFichaje.length - 1 && eventosFichaje[i + 1].planificacion.tipoFichaje == 'SALIDA') {
                total += moment(eventosFichaje[i + 1].planificacion.horaInicio).diff(moment(eventosFichaje[i].planificacion.horaInicio), 'seconds');
              } else {
                break;
              }
            }
          }
        }
        // generamos un string con el total de horas y minutos en lugar de solo minutos, pondremos Xh Ym
        var horas = Math.floor(total / 3600);
        var minutos = Math.round((total % 3600) / 60);
        return horas + 'h ' + minutos + 'm';
      },
      // ===== TPC=SI: alinear OEB con fecha de reparto de ejecución =====
      // Devuelve la fecha que se usa para sumar el OEB en el calendario.
      // Si la planificación tiene TPC=SI (está en mapaTpcFechas), usa la fecha de ejecución.
      // En otro caso, usa horaInicio (lógica original). Fallback siempre seguro.
      fechaCalendarioPlani: function(plani) {
        var self = this;
        if (!plani) return null;
        if (plani.numeroPedido != null && plani.numLinea != null && self.mapaTpcFechas) {
          var clave = plani.numeroPedido + '-' + plani.numLinea;
          var info = self.mapaTpcFechas[clave];
          if (info && info.fecha) return info.fecha;
        }
        return plani.horaInicio;
      },
      // Carga el mapa TPC=SI desde el backend después de cargar planificaciones.
      // Si falla, queda vacío y el cálculo usa horaInicio (fallback).
      //
      // #59 · `claveDeLaCarga` es la de la agenda que lo ha pedido (ver `claveDelCalendario`): el
      // mapa se pide por empleado y periodo, así que si para cuando contesta se está mirando otra
      // semana no se escribe. El promise se cierra igual, descartada o no —y también si lo que se
      // rompe es su `exito`, que el carril cuenta como carga fallida—, porque quien lo espera solo
      // recalcula totales a partir de `events`, que ya son los buenos. El `try` de aquí abajo no
      // alcanzaba a eso: lo que se rompe dentro del manejador se rompe ya en otra vuelta del bucle
      // de eventos.
      cargarMapaTpcFechas: function(claveDeLaCarga) {
        var self = this;
        return new Promise(function(resolve) {
          try {
            self.mapaTpcFechas = {};
            self.clavesEnEvents = {};
            if (!self.inspectorFiltro || !self.events || self.events.length === 0) { resolve(); return; }
            for (var i = 0; i < self.events.length; i++) {
              var p = self.events[i].planificacion;
              if (p && p.numeroPedido != null && p.numLinea != null) {
                self.clavesEnEvents[p.numeroPedido + '-' + p.numLinea] = true;
              }
            }
            var claves = Object.keys(self.clavesEnEvents);
            var fmtFecha = function(d) {
              var dd = new Date(d);
              return dd.getFullYear() + '-' + String(dd.getMonth() + 1).padStart(2,'0') + '-' + String(dd.getDate()).padStart(2,'0');
            };
            self.carrilTpc.lanzar(Oeb.tpcFechas({
              claves: claves,
              username: self.inspectorFiltro,
              fechaDesde: self.fechaDesdeFiltro ? fmtFecha(self.fechaDesdeFiltro) : null,
              fechaHasta: self.fechaHastaFiltro ? fmtFecha(self.fechaHastaFiltro) : null
            }), {
              clave: claveDeLaCarga || self.claveDelCalendario(),
              deAhora: self.claveDelCalendario,
              exito: function(res) {
                if (res && res.dto) self.mapaTpcFechas = res.dto;
              }
            }).then(function() { resolve(); });
          } catch (e) { resolve(); }
        });
      },
      totalImporteDia: function(dia, estado, pendiente) {
        var self = this;
        var total = 0;
        var desde = moment(dia).startOf("day");
        var hasta = moment(dia).endOf("day");
        // Set local de claves que REALMENTE sumaron al total en este día (no todas las del events)
        var clavesSumadas = {};
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            var plani = self.events[j].planificacion;
            if ((!plani.idExpediente || plani.sumarImporte) && self.esInspector(plani) && !self.esVersion(plani)) {
              if (plani && plani.totalSinIVASinTasasConDescuento && plani.horaInicio &&
                (plani.tipo != 'TAREA' || !plani.tipoTarea || (plani.tipoTarea.codigo != 'T0005' && plani.tipoTarea.codigo != 'T0040'))
              ) {
                var horaPlani = moment(self.fechaCalendarioPlani(plani));
                if (horaPlani.isBetween(desde,hasta)) {
                  var sumadoEstaIter = false;
                  // si no le pasamos estado ni pendiente, sumamos todos los importes
                  if (!estado && !pendiente && !plani.pendienteConfirmar) {
                    total+= plani.totalSinIVASinTasasConDescuento;
                    sumadoEstaIter = true;
                  } else if (estado && estado == plani.estado && !pendiente && !plani.pendienteConfirmar) {
                    total+= plani.totalSinIVASinTasasConDescuento;
                    sumadoEstaIter = true;
                  } else if (estado && estado == plani.estado && pendiente && pendiente == plani.pendienteConfirmar) {
                    total+= plani.totalSinIVASinTasasConDescuento;
                    sumadoEstaIter = true;
                  }
                  if (sumadoEstaIter && plani.numeroPedido != null && plani.numLinea != null) {
                    clavesSumadas[plani.numeroPedido + '-' + plani.numLinea] = true;
                  }
                }
              }
            }
          }
        }
        // Segundo bucle: planificaciones del mapa TPC=SI cuya plani NO sumó en el primer bucle
        // (descubrimos planificaciones de otros meses cuya ejecución cae en este día)
        if (self.mapaTpcFechas) {
          for (var clave in self.mapaTpcFechas) {
            if (clavesSumadas[clave]) continue;
            var info = self.mapaTpcFechas[clave];
            if (!info || !info.fecha || !info.importe) continue;
            var fechaTpc = moment(info.fecha);
            if (fechaTpc.isBetween(desde, hasta, null, '[]')) {
              if (!estado && !pendiente) {
                total += info.importe;
              } else if (estado === 'REALIZADA' && !pendiente) {
                total += info.importe;
              }
            }
          }
        }
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: false
        });
        return !total ? total : (formatter.format(total).toString().replace('.',',') + ' €');
      },
      totalImporteDiaFirma (dia, estado) {
        var self = this;
        var total = 0;
        var desde = moment(dia).startOf("day");
        var hasta = moment(dia).endOf("day");
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            var plani = self.events[j].planificacion;
            if ((!plani.idExpediente || plani.sumarImporte) && self.esInspector(plani) && !self.esVersion(plani)) {
              if (plani && plani.totalSinIVASinTasasConDescuento && plani.horaInicio &&
                (plani.tipo == 'TAREA' && plani.tipoTarea && plani.tipoTarea.codigo == 'T0040') &&
                (!estado || estado == plani.estado) &&
                (typeof plani.sumarImporte == 'undefined' || plani.sumarImporte)
              ) {
                var horaPlani = moment(plani.horaInicio);
                if (horaPlani.isBetween(desde,hasta)) {
                  total+= plani.totalSinIVASinTasasConDescuento;
                }
              }
            }
          }
        }
        return self.formatoImporte(total);
      },
      formatoImporte(importe) {
        const self = this;
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: false
        });
        return !importe ? importe : formatter.format(importe).toString().replace('.',',') + ' €';
      },
      getTotalOeaDia(dia) {
        const self = this;
        let totalDia = self.totalesDia.find(t => t.dia == dia);
        if (totalDia) {
          return self.formatoImporte(totalDia.oea);
          // return !totalDia.oea ? totalDia.oea : formatter.format(totalDia.oea).toString().replace('.',',') + ' €';
        } else {
          return null;
        }
      },
      mostrarPedidos(dia) {
        const self = this;
        let pedidos = self.getPedidosDia(dia);
        // mostraremos un modal con los pedidos del día
        if (pedidos) {
          let str = '';
          pedidos.forEach(p => {
            const url = self.getUrl('pedidos/view/' + p.id + '/');
            // generamos un html con enlace a cada pedido en una pestaña nueva
            str += `<a class="external" href="${url}" target="_blank" rel="noopener noreferrer">${p.numero} - ${p.codigo}</a><br/>`;
          });
          app.dialog.alert(str, "Listado de pedidos");
        } else {
          app.dialog.alert("No hay pedidos asociados");
        }
      },
      getPedidosDiaHtml(dia) {
        const self = this;
        let pedidos = self.getPedidosDia(dia);
        if (pedidos) {
          let str = '';
          pedidos.forEach(p => {
            str += p.numero + ' - ' + p.codigo + '<br/>';
          });
          return str;
        } else {
          return null;
        }
      },
      getPedidosDia(dia) {
        const self = this;
        let totalDia = self.totalesDia.find(t => t.dia == dia);
        if (totalDia) {
          return totalDia.pedidos;
        } else {
          return null;
        }
      },
      totalKmDia (dia, particular) {
        var self = this;
        var total = 0;
        var desde = moment(dia).startOf("day");
        var hasta = moment(dia).endOf("day");
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion && self.events[j].planificacion.tipo == 'DESPLAZAMIENTO' 
              && ((particular && self.events[j].planificacion.particular) || (!particular && !self.events[j].planificacion.particular))
            ) {
              var plani = self.events[j].planificacion;
              if (plani.horaInicio) {
                var horaPlani = moment(plani.horaInicio);
                if (horaPlani.isBetween(desde,hasta)) {
                  total += self.metrosDeDesplazamiento(plani);
                }
              }
            }
          }
        }
        total = total / 1000;
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,      
          maximumFractionDigits: 0,
          useGrouping: false
        });
        if (!total) {
          return total;
        }
        return formatter.format(total).toString() + ' Km';
      },
      totalConsumoDia (dia, particular) {
        var self = this;
        var total = 0;
        var desde = moment(dia).startOf("day");
        var hasta = moment(dia).endOf("day");
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion && self.events[j].planificacion.tipo == 'DESPLAZAMIENTO' 
              && ((particular && self.events[j].planificacion.particular) || (!particular && !self.events[j].planificacion.particular))
            ) {
              var plani = self.events[j].planificacion;
              if (plani.horaInicio) {
                var horaPlani = moment(plani.horaInicio);
                if (horaPlani.isBetween(desde,hasta)) {
                  if (plani.moviloc && plani.moviloc.consumo) {
                    total += parseFloat(plani.moviloc.consumo);
                  }
                }
              }
            }
          }
        }
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 1,      
          maximumFractionDigits: 1,
          useGrouping: false
        });
        if (!total) {
          return total;
        }
        return formatter.format(total).toString();
      },
      numEventosDia (dia, tipo) {
        var self = this;
        var total = 0;
        var desde = moment(dia).startOf("day");
        var hasta = moment(dia).endOf("day");
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion) {
              var plani = self.events[j].planificacion;
              if (plani.horaInicio) {
                var horaPlani = moment(plani.horaInicio);
                if (horaPlani.isBetween(desde,hasta)) {
                  if (tipo == undefined || tipo == null || tipo == plani.tipo) {
                    total+=1;
                  }
                }
              }
            }
          }
        }
        return total;
      },
      getFormatImporte(importe) {
        const self = this;
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: false
        });
        return !importe ? importe : formatter.format(importe).toString().replace('.',',') + ' €';
      },
      totalImporte (estado,pendiente) {
        const self = this;
        var totalTotal = 0;
        // Para coherencia con totalImporteDia, solo sumamos planificaciones cuya fecha calendarizada
        // (horaInicio normalmente, fechaEjecucion si TPC=SI) cae dentro del rango filtrado.
        var rangoDesde = self.fechaDesdeFiltro ? moment(self.fechaDesdeFiltro).startOf('day') : null;
        var rangoHasta = self.fechaHastaFiltro ? moment(self.fechaHastaFiltro).endOf('day') : null;
        // Set local de claves que REALMENTE sumaron (no todas las del events)
        var clavesSumadas = {};
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion && self.events[j].planificacion.totalSinIVASinTasasConDescuento) {
              if ((self.events[j].planificacion.tipo != 'TAREA' || !self.events[j].planificacion.tipoTarea || (self.events[j].planificacion.tipoTarea.codigo != 'T0005' && self.events[j].planificacion.tipoTarea.codigo != 'T0040'))
                  && (!estado || estado == self.events[j].planificacion.estado)) {
                if ((!self.events[j].planificacion.idExpediente || self.events[j].planificacion.sumarImporte) && self.esInspector(self.events[j].planificacion) && !self.esVersion(self.events[j].planificacion)) {
                  // Filtro por fecha calendarizada (alineado con totalImporteDia)
                  var fechaCal = self.fechaCalendarioPlani(self.events[j].planificacion);
                  if (rangoDesde && rangoHasta && fechaCal && !moment(fechaCal).isBetween(rangoDesde, rangoHasta, null, '[]')) {
                    continue;
                  }
                  var sumadoEstaIter = false;
                  // si pendiente es undefined, acumulamos sin más comprobación
                  if((pendiente == undefined || pendiente == false) && !self.events[j].planificacion.pendienteConfirmar) {
                    totalTotal+= self.events[j].planificacion.totalSinIVASinTasasConDescuento;
                    sumadoEstaIter = true;
                  } else
                  // si planificacion.pendienteConfirmar es igual que pendiente, acumulamos
                  if (pendiente && pendiente == self.events[j].planificacion.pendienteConfirmar) {
                    totalTotal+= self.events[j].planificacion.totalSinIVASinTasasConDescuento;
                    sumadoEstaIter = true;
                  }
                  if (sumadoEstaIter && self.events[j].planificacion.numeroPedido != null && self.events[j].planificacion.numLinea != null) {
                    clavesSumadas[self.events[j].planificacion.numeroPedido + '-' + self.events[j].planificacion.numLinea] = true;
                  }
                }
              }
            }
          }
        }
        // Segundo bucle: planificaciones del mapa TPC=SI cuya plani NO sumó en el primer bucle
        // (descubrimos planificaciones de otros meses cuya ejecución cae en este rango)
        if (self.mapaTpcFechas && rangoDesde && rangoHasta) {
          for (var clave in self.mapaTpcFechas) {
            if (clavesSumadas[clave]) continue;
            var info = self.mapaTpcFechas[clave];
            if (!info || !info.fecha || !info.importe) continue;
            var fechaTpc = moment(info.fecha);
            if (!fechaTpc.isBetween(rangoDesde, rangoHasta, null, '[]')) continue;
            if ((!estado && (pendiente == undefined || pendiente == false)) || (estado === 'REALIZADA' && (pendiente == undefined || pendiente == false))) {
              totalTotal += info.importe;
            }
          }
        }
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: false
        });
        return !totalTotal ? totalTotal : formatter.format(totalTotal).toString().replace('.',',') + ' €';
      },
      totalImporteFirma (estado) {
        const self = this;
        var totalTotal = 0;
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion && self.events[j].planificacion.totalSinIVASinTasasConDescuento) {
              if ((self.events[j].planificacion.tipo == 'TAREA' && self.events[j].planificacion.tipoTarea && self.events[j].planificacion.tipoTarea.codigo == 'T0040') 
                && (!estado || estado == self.events[j].planificacion.estado) && ((typeof self.events[j].planificacion.sumarImporte == 'undefined' || self.events[j].planificacion.sumarImporte))) {
                if ((!self.events[j].planificacion.idExpediente || self.events[j].planificacion.sumarImporte) && self.esInspector(self.events[j].planificacion) && !self.esVersion(self.events[j].planificacion)) {
                  console.log(self.events[j].planificacion.idExpediente);
                  console.log(self.events[j].planificacion.totalSinIVASinTasasConDescuento);
                  totalTotal+= self.events[j].planificacion.totalSinIVASinTasasConDescuento;
                }
              }
            }
          }
        }
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,      
          maximumFractionDigits: 2,
          useGrouping: false
        });
        return !totalTotal ? totalTotal : formatter.format(totalTotal).toString().replace('.',',') + ' €';
      },
      fieldCondition(field, valField, plani) {
        const self = this;
        if (!field) {
          return true;
        }
        if (!Array.isArray(field)) {
          field = [field];
        }
        if (!Array.isArray(valField)) {
          valField = [valField];
        }
          
        let res = true;
        field.forEach((f, idx) => {
          const esFalse = f.startsWith('!');
          if (esFalse) {
            f = f.substr(1);
          }
          if (valField[idx] == true || valField[idx] == false) {
            if (valField[idx] == true && (esFalse ? self.getValue(f, plani) : !self.getValue(f, plani))) {
              res = false;
              return;
            } else if (valField[idx] == false && (esFalse ? !self.getValue(f, plani) : self.getValue(f, plani))) {
              res = false;
              return;
            }
          } else if (esFalse ? self.getValue(f, plani) == valField[idx] : self.getValue(f, plani) != valField[idx]) {
            res = false;
            return;
          }
        })
        return res;
      },
      totalTiempoPorTipo (tipo = null, dia = null, field = null, valField = null, returnMinutes = null) {
        const self = this;
        let totalTotal = 0;
        // Ventana de suma: el día si se pasa `dia`; si no, la SEMANA visible [fechaDesde,fechaHasta]
        // (coherente con totalImporteDia / totalImporte). Antes, sin `dia`, no acotaba y arrastraba las
        // propuestas provisionales de la semana propuesta (S33) al cabecero de S34/S35 (TD / TPIP tiempo).
        const desde = dia ? moment(dia).startOf("day") : (self.fechaDesdeFiltro ? moment(self.fechaDesdeFiltro).startOf("day") : null);
        const hasta = dia ? moment(dia).endOf("day") : (self.fechaHastaFiltro ? moment(self.fechaHastaFiltro).endOf("day") : null);
        const hoy = moment().startOf("day");
        if (typeof tipo == 'string') {
          tipo = [tipo];
        }
        // tenemos que excluir los eventos de tipo FICHAJE
        const eventos = self.events?self.events.filter(e => e.planificacion && e.planificacion.tipo != 'FICHAJE'):null;
        if (eventos && eventos.length > 0) {

          for (var j = 0; j < eventos.length; j++) {
            let plani = eventos[j].planificacion;
            if (!self.esVersion(plani) && plani && plani.tiempoEstimadoCampo && self.fieldCondition(field, valField, plani)) {
              if (!tipo || tipo.includes(plani.tipo)) {
                if (!desde || !hasta || (plani.horaInicio && moment(plani.horaInicio).isBetween(desde, hasta))) {
                  // Si no viene tipo hay que ignorar los anteriores a hoy si son TPI planificado
                  // #460 · `!plani.tipoTarea` como en las otras cinco lecturas de este código
                  // (`esTipoReservado`, `totalKm`, `totalConsumo`): una TAREA sin `tipoTarea` no es
                  // un TPI planificado, así que entra en la suma. Sin la guarda reventaba aquí y,
                  // como estas sumas corren dentro de la recarga, se llevaba el día entero.
                  if (tipo || plani.tipo != 'TAREA' || !plani.tipoTarea || (plani.tipoTarea.codigo != 'T0005' && plani.tipoTarea.codigo != 'T0040') || plani.estado != 'PLANIFICADA' || moment(plani.horaInicio).isAfter(hoy)) {
                    totalTotal+= plani.tiempoEstimadoCampo;
                  }
                }
              }
            }
          }
        }
        if (!totalTotal || returnMinutes) {
          return totalTotal;
        }
        return self.getMinutesHumanize(totalTotal, false);
      },
      importePorTipo (tipo = null, dia = null, field = null, valField = null, returnMinutes = null) {
        const self = this;
        let totalTotal = 0;
        // Ventana de suma: el día si se pasa `dia`; si no, la SEMANA visible [fechaDesde,fechaHasta]
        // (coherente con totalImporteDia). Antes, sin `dia`, no acotaba y arrastraba las propuestas
        // provisionales de la semana propuesta (S33) al TPIP€ del cabecero de S34/S35.
        const desde = dia ? moment(dia).startOf("day") : (self.fechaDesdeFiltro ? moment(self.fechaDesdeFiltro).startOf("day") : null);
        const hasta = dia ? moment(dia).endOf("day") : (self.fechaHastaFiltro ? moment(self.fechaHastaFiltro).endOf("day") : null);
        const hoy = moment().startOf("day");
        if (typeof tipo == 'string') {
          tipo = [tipo];
        }
        // tenemos que excluir los eventos de tipo FICHAJE
        const eventos = self.events?self.events.filter(e => e.planificacion && e.planificacion.tipo != 'FICHAJE'):null;
        if (eventos && eventos.length > 0) {

          for (var j = 0; j < eventos.length; j++) {
            let plani = eventos[j].planificacion;
            if (!self.esVersion(plani) && plani && plani.tiempoEstimadoCampo && self.fieldCondition(field, valField, plani)) {
              if (!tipo || tipo.includes(plani.tipo)) {
                if (!desde || !hasta || (plani.horaInicio && moment(plani.horaInicio).isBetween(desde, hasta))) {
                  // Si no viene tipo hay que ignorar los anteriores a hoy si son TPI planificado
                  // #460 · `!plani.tipoTarea` como en las otras cinco lecturas de este código
                  // (`esTipoReservado`, `totalKm`, `totalConsumo`): una TAREA sin `tipoTarea` no es
                  // un TPI planificado, así que entra en la suma. Sin la guarda reventaba aquí y,
                  // como estas sumas corren dentro de la recarga, se llevaba el día entero.
                  if (tipo || plani.tipo != 'TAREA' || !plani.tipoTarea || (plani.tipoTarea.codigo != 'T0005' && plani.tipoTarea.codigo != 'T0040') || plani.estado != 'PLANIFICADA' || moment(plani.horaInicio).isAfter(hoy)) {
                    totalTotal+= (plani.tiempoEstimadoCampo * self.precioMinuto(plani.horaInicio));
                  }
                }
              }
            }
          }
        }
        if (!totalTotal || returnMinutes) {
          return totalTotal;
        }
        return self.getMinutesHumanize(totalTotal, false);
      },
      getValue: function(name, obj) {
        var namespaces = name.split(".");
        var context = obj;
        for (var i = 0; i < namespaces.length; i++) {
          // #460 · `== null` y no `typeof == "undefined"`: un tramo NULO por el camino —`tipoTarea:
          // null` en una TAREA, que es lo que llega de la API— reventaba al leer el siguiente nivel.
          // Lo usa `fieldCondition`, y `fieldCondition` lo llaman los totales del cabecero DENTRO
          // de la recarga del calendario: un solo bloque a medias vaciaba el día. El valor FINAL
          // nulo sigue devolviéndose tal cual (el bucle ya ha terminado), así que las comparaciones
          // de `fieldCondition` no cambian.
          if (context == null) {
            return "";
          }
          context = context[namespaces[i]];
        }
        return context;
      },
      totalKm(particular) {
        var self = this;
        var totalTotal = 0;
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion && self.events[j].planificacion.tipo && self.events[j].planificacion.tipo == 'DESPLAZAMIENTO'
              && ((particular && self.events[j].planificacion.particular) || (!particular && !self.events[j].planificacion.particular))
            ) {
              totalTotal += self.metrosDeDesplazamiento(self.events[j].planificacion);
            }
          }
        }
        totalTotal = totalTotal / 1000;
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 0,      
          maximumFractionDigits: 0,
          useGrouping: false
        });
        return formatter.format(totalTotal).toString() + ' Km';
      },
      totalConsumo(particular) {
        var self = this;
        var totalTotal = 0;
        if (self.events && self.events.length > 0) {
          for (var j = 0; j < self.events.length; j++) {
            if (self.events[j].planificacion && self.events[j].planificacion.tipo && self.events[j].planificacion.tipo == 'DESPLAZAMIENTO'
              && ((particular && self.events[j].planificacion.particular) || (!particular && !self.events[j].planificacion.particular))
            ) {
              if (self.events[j].planificacion.moviloc && self.events[j].planificacion.moviloc.consumo) {
                totalTotal += parseFloat(self.events[j].planificacion.moviloc.consumo);
              }
            }
          }
        }
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 1,      
          maximumFractionDigits: 1,
          useGrouping: false
        });
        return totalTotal == 0 ? totalTotal : formatter.format(totalTotal).toString();
      },
      onOpenCalcularRuta() {
        const self = this;
        const app = self.$f7;
        self.Planificacion
          .getDiario({
            data: {
              dia: self.diaSelected,
              inspector: self.inspectorFiltro
            }
          })
          .then(function(res) {
            if (res) {
              let data = self.$refs.rformCalucarRuta.formData;
              data.direccionInicio = res.origen;
              data.direccionFin = res.destino;
              if (res.calculadoMoviloc) {
                app.dialog.alert("Ya se ha realizado la importación de los datos de Moviloc, no se puede modificar la ruta.");
                if (self.$refs.popupCalcularRuta) {
                  self.$refs.popupCalcularRuta.close();
                }
              }
              // data.horaInicio = res.horaInicio;
            }
          })
          .catch(function(e) {
            app.preloader.hide();
            if (typeof e == "string") e = { error: e };
            let error = e.message || e.error || e.error_description;
            app.dialog.alert(error);
            self.getPlanificaciones();
          });
        
      },
      onSaveCalcularRuta() {
        const self = this;
        var data = self.$refs.rformCalucarRuta.formData;

        // var dateInicio = new Date (data.dia);
        // var horaInicio = new Date (data.horaInicio);
        
        // dateInicio.setHours(horaInicio.getHours());
        // dateInicio.setMinutes(horaInicio.getMinutes());
        // dateInicio.setSeconds(horaInicio.getSeconds());
        // dateInicio.setMilliseconds(horaInicio.getMilliseconds());

        // data.horaInicio = dateInicio;

        self.calcularRuta(data);
      },
      calcularRuta(data) {
        const self = this;
        const app = self.$f7;
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        self.Planificacion
          .calcularRuta({
            data: data
          })
          .then(function(res) {
            if (self.$refs.popupCalcularRuta) {
              self.$refs.popupCalcularRuta.close();
            }
            espera.cerrar();
            self.getPlanificaciones();
          })
          .catch(function(e) {
            espera.cerrar();
            if (typeof e == "string") e = { error: e };
            let error = e.message || e.error || e.error_description;
            app.dialog.alert(error);
            self.getPlanificaciones();
          });
      },
      getComentariosDireccion: function (item) {
        const self = this;
        let text = "";
        if (item.titular) {
          text = item.titular;
        }
        if (item.nifTitular) {
          text = text + ' NIF: ' + item.nifTitular;
        }
        if (item.direccionInspeccion) {
          text = text + " (" + self.getDireccionStr(item.direccionInspeccion) + ")";
        }
        return text;
      },
      getDireccionStr(direccion) {
        if (direccion) {
          if (direccion.direccionStr) {
            return direccion.direccionStr;
          }
          return (direccion.direccion || '') + ' ' + (direccion.cp || '') + ' ' + (direccion.poblacion || '') + ' (' + (direccion.pais || '') + ')';
        } else {
          return '';
        }
      },
      getLineasTexto: function (comentarios) {
        if (!comentarios) {
          return [];
        }
        return comentarios.split("##").map(c => c.trim());
      },
      // loadInformesPdtes() {
      //   const self = this;
      //   self.LineaPedido.getList({
      //     filter: {
      //       withoutAggregations: false,
      //       onlyAggregations: true,
      //       activo: true,
      //       tpcLinea: "S",
      //       tpiLinea: "N",
      //       usuEjecucionLinea: self.inspectorFiltro,
      //       tipoLinea: 'LINEA',
      //       fechaContratacionDesde: '2021-01-01T00:00:00Z',
      //       estados: ['CREADO', 'EN_EJECUCION', 'PLANIFICADO', 'EJECUTADO', 'FACTURADO', 'CERRADO']
      //     }
      //   }).then(function(res) {
      //     self.infPdtes = res.totalCount;
      //   }).catch(function(e) {
      //     if (typeof e == "string") e = { error: e };
      //     let error = e.message || e.error || e.error_description;
      //     app.dialog.alert(error);
      //   });
      // }
    }
  }
</script>
<style>
.month-container {
  margin-top: 20px;
}
.calendar .calendar-header table th:hover {
    color: black;
}
.v-application {
  max-height:95% !important;
}
.v-application--wrap {
  min-height:0 !important;
}
.v-application .v-menu__content {
  position: fixed !important;
}
.expand-header-calendar .v-expansion-panel-header__icon {
  float: right;
}
.expand-header-calendar {
  width: 97%;
  margin-bottom: 0;
}
.borde-verde {
  border: 3px solid #5bc929;
  height: 100%;
  border-radius: 3px;
}
.borde-azul {
  border: 3px solid #2196f3;
  height: 100%;
  border-radius: 3px;
}
/* #240 · aquí vivían `.borde-naranja` (sin pedido), `.borde-negro` (desplazamiento de empresa) y
   `.borde-rojo` (desplazamiento particular). Decían el TIPO, no el estado, y además se declaraban
   DEBAJO del verde y del azul, así que ganaban y esos bloques no enseñaban su estado. Esa señal
   está ahora en el relleno (`rellenoDeclarado`), con las mismas condiciones y el mismo orden. */
.borde-amarillo {
  border: 3px solid yellow;
  height: 100%;
  border-radius: 3px;
}
/* C4: propuesta PROVISIONAL del solver (no persistida; se acepta o descarta) */
.borde-provisional {
  border: 3px dashed #9c27b0;
  height: 100%;
  border-radius: 3px;
}
/* #482 · el BOTÓN de no planificables, en el mismo rincón donde estaba el panel y con el mismo
   `position: fixed`: lo que crece crece hacia arriba, así que no empuja ni tapa nada del
   calendario (§9 del CLAUDE.md del orquestador). Ocupa una línea en vez de media pantalla.

   `right: 94px` y no 8: en ese rincón vive la burbuja del chat (`agent-chat-widget`, 62 px a 20 px
   del borde y por encima de todo), y en la prueba del 30/10 tapaba «Ver detalle». 20 + 62 y 12 de
   aire. Sin `width`: la caja mide lo que el botón —o la nota, que no pasa de 420 px—, así que no
   queda franja vacía que se quede los clics de la rejilla, y el `max-width` solo frena en pantallas
   estrechas. */
.boton-no-planificables {
  position: fixed;
  right: 94px;
  bottom: 8px;
  max-width: calc(100vw - 110px);
  z-index: 6;
  text-align: right;
  /* La caja puede ser más ancha que el botón cuando lleva la nota, y esa franja quedaría por
     delante de la rejilla. Se le quitan los eventos de puntero y los recuperan el botón y la nota,
     que es lo único que se ve: el mismo remedio que `.c4d-fase-flotante` más abajo. */
  pointer-events: none;
}
/* `<button>` nativo vestido de pastilla: el foco, el teclado y la pulsación táctil vienen de serie
   y solo hay que quitarle la cara de botón de formulario.

   Con DOS clases a propósito. Hay dos reglas globales para todo `<button>` que ganaban a una sola:
   la de Framework7 (`button { width: 100% }`) estiraba la pastilla a toda la caja, y la de
   `vuetify.css` (`[type=button] { color: inherit }`, que se importa DESPUÉS en el bloque scoped y
   empata en especificidad) le quitaba el blanco al texto. En la prueba del 30/10 se leía gris oscuro
   sobre azul marino. Lo mismo vale para los botones de la ventana, más abajo. */
.boton-no-planificables .btn-np {
  display: inline-flex;
  align-items: center;
  width: auto;
  /* El tope es lo que frena la pastilla en el móvil: el `max-width` de la caja solo limita la caja,
     y un `inline-flex` con `nowrap` se sale por la izquierda con el resumen cortado. */
  max-width: 100%;
  white-space: nowrap;
  border: 0;
  appearance: none;
  -webkit-appearance: none;
  font-family: inherit;
  text-align: left;
  background: #23355b;
  color: #fff;
  border-radius: 22px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  /* El contenedor suelta los clics; se los queda solo lo que de verdad se ve. Va también en el
     estado gris: el botón deshabilitado no se pulsa, pero su `title` es donde dice por qué (§9) y
     sin eventos de puntero no aparecería. */
  pointer-events: auto;
}
.btn-np-icono {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  border-radius: 50%;
  background: #ffb300;
  color: #3a2a00;
  font-weight: 900;
  font-size: 13px;
  flex: none;
}
/* Lo único que cede cuando no cabe es el resumen: parte en renglones dentro de la pastilla en vez
   de salirse de la pantalla. Con sitio de sobra —el escritorio— la pastilla sigue midiendo su texto
   en una línea, porque solo se encoge lo que no cabe. El `min-width: 0` es lo que le deja bajar del
   ancho de su frase; sin él un hijo de flex no se encoge y el `nowrap` de la pastilla manda. */
.btn-np-rotulo {
  min-width: 0;
  white-space: normal;
  overflow-wrap: break-word;
}
.btn-np-ver {
  flex: none;
  margin-left: 10px;
  padding-left: 10px;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  font-size: 11.5px;
  opacity: 0.85;
  white-space: nowrap;
}
/* Sin bloqueadas: gris, sin cursor de mano y sin ventana. El porqué va en el `title`, junto al
   propio control, no en un aviso al principio de la pantalla. Tres clases: tiene que ganarle a la
   regla de la pastilla, que ya lleva dos. */
.boton-no-planificables .btn-np.btn-np-sin-lineas {
  background: #77778a;
  box-shadow: none;
  cursor: default;
}
.btn-np-sin-lineas .btn-np-icono {
  background: #cfcfd8;
  color: #4a4a57;
}
/* La nota vive JUNTO al botón: habla de la cifra que el botón acaba de decir. El tope de ancho es
   lo que la hace romper en pocos renglones ahora que la caja ya no tiene ancho fijo. */
.btn-np-nota {
  max-width: 420px;
  margin-left: auto;
  margin-top: 4px;
  font-size: 11.5px;
  line-height: 1.3;
  color: #5c4a00;
  background: #fff8e1;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 4px 8px;
  text-align: left;
  pointer-events: auto;
}
/* ---- #482 · la ventana ---- */
.ventana-np-titulo {
  font-size: 16px;
}
/* El subtítulo cede antes que la ✕: en una ventana estrecha se recorta él (y queda entero en su
   `title`), y no empuja el botón de cerrar fuera de la barra. */
.ventana-np-sub {
  margin-left: 12px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  opacity: 0.85;
}
/* Los botones de la ventana, por lo mismo que la pastilla: Framework7 da `width: 100%` a todo
   `<button>`. Eso partía «Negocio (4)» en dos renglones —los tres del filtro se repartían el ancho
   a tercios—, echaba el Excel a otra línea y, en el pie, dejaba la leyenda en una columna de
   catorce renglones con «Cerrar» saliéndose por la derecha. Una sola regla para todos, y no una por
   botón, para que el siguiente que se añada no vuelva a caer. Los iconos de Vuetify (la ✕) traen
   su ancho con más especificidad y no se tocan. */
.ventana-np button {
  width: auto;
}
/* Con la especificidad de Vuetify a propósito. `.v-dialog > .v-card > .v-card__text` (tres clases)
   le gana a una sola y deja el cuerpo con `padding-top: 0`: los tres recuadros arrancaban pegados a
   la barra y su sombra les tapaba el borde de arriba (prueba del 31/10). Lo mismo le pasaba al pie
   con `.v-card__actions`. */
.v-dialog > .v-card.ventana-np > .v-card__text.ventana-np-cuerpo {
  padding: 14px 16px 12px;
  color: #1f2933;
}
.np-kpis {
  display: flex;
  flex-wrap: wrap;
}
.np-kpi {
  flex: 1 1 220px;
  border: 1px solid #e3e3ea;
  border-radius: 6px;
  padding: 8px 12px;
  margin: 0 12px 10px 0;
}
.np-kpi:last-child {
  margin-right: 0;
}
.np-kpi-total { border-left: 4px solid #c62828; }
.np-kpi-solver { border-left: 4px solid #23355b; }
.np-kpi-negocio { border-left: 4px solid #b26a00; }
.np-kpi-l {
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b6b7b;
}
.np-kpi-v {
  font-size: 20px;
  font-weight: 600;
}
.np-kpi-v small {
  font-size: 13px;
  font-weight: 400;
  color: #6b6b7b;
}
.np-aviso {
  font-size: 12.5px;
  color: #5c4a00;
  background: #fff8e1;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 5px 8px;
  margin-bottom: 8px;
}
.np-herramientas {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e3e3ea;
}
.np-buscador {
  border: 1px solid #c9c9d3;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 13px;
  width: 280px;
  max-width: 100%;
  margin-right: 10px;
}
.np-filtro {
  display: flex;
  border: 1px solid #c9c9d3;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 10px;
}
.np-filtro button {
  flex: none;
  white-space: nowrap;
  border: 0;
  appearance: none;
  -webkit-appearance: none;
  font-family: inherit;
  background: #fff;
  color: #23355b;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
}
.np-filtro button.on {
  background: #23355b;
  color: #fff;
}
.np-orden {
  font-size: 13px;
  color: #444;
  margin-right: auto;
}
/* Dos clases por el `color: inherit` de `vuetify.css` (ver `.btn-np`). */
.np-herramientas .np-excel {
  flex: none;
  border: 1px solid #23355b;
  appearance: none;
  -webkit-appearance: none;
  font-family: inherit;
  background: #fff;
  color: #23355b;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
/* La tabla CABE en la ventana, sin barra de desplazamiento lateral (prueba del 31/10). Hasta
   entonces línea, oferta, entidad · fecha y «Qué hacer» iban en un solo renglón (`nowrap`); con
   datos reales sumaban más que la ventana, salía la barra lateral, «Qué hacer» quedaba cortada y al
   desplazar se escondía «Origen · causa». Ahora cada columna mide lo que su contenido mientras hay
   sitio y, cuando no lo hay, el texto largo pasa a varios renglones —entre palabras, y dentro de
   una palabra solo si ella sola no cabe (`anywhere`, que a diferencia de `break-word` sí cuenta al
   medir la columna)—. Solo el importe sigue en una pieza: es corto y partido no se lee. */
.np-tabla {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.np-tabla th {
  text-align: left;
  font-size: 10.5px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b6b7b;
  font-weight: 600;
  padding: 6px 8px;
  border-bottom: 1px solid #e3e3ea;
  background: #fafafc;
}
.np-tabla td {
  padding: 5px 8px;
  border-bottom: 1px solid #f0f0f4;
  vertical-align: top;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.np-tabla .np-der {
  text-align: right;
  white-space: nowrap;
}
.np-tabla tr.np-grupo td {
  font-weight: 600;
  padding-top: 9px;
}
.np-tabla tr.np-grupo-negocio td { background: #fff4dc; }
.np-tabla tr.np-grupo-solver td { background: #ecebf7; }
.np-chip {
  display: inline-block;
  border-radius: 3px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  margin-right: 6px;
}
.np-chip-negocio { background: #b26a00; }
.np-chip-solver { background: #3f3d72; }
.np-accion {
  color: #9c27b0;
  font-weight: 500;
}
.np-vacio {
  padding: 16px 8px;
  color: #6b6b7b;
  font-style: italic;
  text-align: center;
}
/* El pie en una línea, como el mockup: la leyenda ocupa lo que haya y «Cerrar» se queda con su
   ancho a la derecha (el `width: 100%` de Framework7 lo quita `.ventana-np button`). */
.v-dialog > .v-card.ventana-np > .v-card__actions.np-pie {
  border-top: 1px solid #e3e3ea;
  padding: 10px 16px;
}
.np-leyenda {
  flex: 1 1 auto;
  min-width: 0;
  margin-right: 16px;
  font-size: 12px;
  color: #6b6b7b;
}
.ventana-np .np-cerrar {
  flex: none;
}
/* C4-EXPLICABILIDAD: panel "¿Por qué esta propuesta?" (informativo; solo muestra lo del solver) */
.panel-por-que {
  position: fixed;
  left: 8px;
  bottom: 8px;
  width: 430px;
  max-width: 90vw;
  z-index: 6;
}
.panel-por-que-body {
  max-height: 45vh;
  overflow-y: auto;
  padding-top: 8px;
}
.panel-por-que-body .linea-pq {
  padding: 4px 0;
  border-bottom: 1px dashed #e2e7ec;
  font-size: 12.5px;
  color: #1f2933;
}
.pq-alt {
  color: #6b7885;
  font-size: 11.5px;
}
.aviso-geo {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 8px;
  font-weight: bold;
}
.sumar-importe {
  position: relative;
}
.sumar-importe::after {
  content: '';
  position: absolute;
  top: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  background: #4CAF50;
  border: 1px solid black;
  border-radius: 50%;
  z-index: 2;
}
.presente {
  color: #1976d2;
}
.importeTotal label {
  font-size: 20px;
}
.importeTotal .badge {
  font-size: 15px;
  height: 25px;
}
.kmTotal {
  margin-left: 5px;
}

@media only screen and (max-width: 1360px) {
  .importeTotal label {
    font-size: 12px;
  }
  .importeTotal .badge {
    font-size: 13px;
    height: 15px;
  }
  .selectoresCalendario {
    display: flex;
    max-width: 200px;
  }
}
.letrasNegras {
  color: black !important;
}
.selectoresCalendario {
  display: flex;
  max-width: 400px;
}
/* #1133 · El botón de ACEL PLANIFICACIÓN entra en la barra sin quitarle sitio a nadie. Los 400 px
   de arriba son un tope, y «Empleado» y «Tipo» se quedan con lo que dejan los botones: con uno más
   y el mismo tope, el nombre del empleado salía cortado («E… JJC», dirección en preview-2,
   30/10/2026). Se suma el ancho de un botón de icono dentro de una toolbar —48 px, no los 36 de
   fuera: lo fija `vuetify.css`, que esta pantalla importa— y solo cuando se pinta, así que esos dos
   campos miden lo mismo que antes, tenga o no el botón.
   Va fuera del `@media` a propósito: ahí el tope de 200 px lo pisa la regla de arriba, que viene
   después, y la barra mide 400 en todas las anchuras; ponerlo dentro cambiaría eso. */
.selectoresCalendario.con-acel-planificacion {
  max-width: 448px;
}

/* SPEC-PARAMETRIZACION-PROPONER: drawer de parametrización del Proponer (estilo de la maqueta) */
.c4d-overlay {
  position: fixed; top: 0; right: 0; bottom: 0; left: 0;
  background: rgba(18, 18, 26, .28); z-index: 10990;
}
.c4d-drawer {
  position: fixed; top: 0; right: 0; bottom: 0; width: 456px; max-width: 96vw;
  background: #fff; z-index: 10991; display: flex; flex-direction: column;
  box-shadow: -8px 0 40px rgba(30, 20, 70, .18); text-align: left;
}
.c4d-head { background: linear-gradient(135deg, #3d2f96, #6d5ce0); color: #fff; padding: 18px 22px; flex-shrink: 0; }
.c4d-head-row { display: flex; justify-content: space-between; align-items: center; }
.c4d-head h1 { margin: 0; font-size: 19px; font-weight: 750; letter-spacing: -.01em; color: #fff; }
.c4d-x { background: rgba(255,255,255,.16); border: none; color: #fff; width: 30px; height: 30px; border-radius: 8px; font-size: 16px; cursor: pointer; }
.c4d-sub { opacity: .9; font-size: 12.5px; margin-top: 3px; }
.c4d-body { flex: 1; overflow-y: auto; padding: 18px 22px 12px; }
.c4d-grp { margin-bottom: 20px; }
.c4d-grp-t {
  font-size: 11.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .05em;
  color: #4a3aa7; margin: 0 0 12px; display: flex; align-items: center; gap: 8px;
}
.c4d-grp-t::after { content: ""; flex: 1; height: 1px; background: #f0f0f7; }
.c4d-fld { margin-bottom: 13px; }
.c4d-fld > label { display: block; font-size: 11.5px; color: #54545f; font-weight: 600; margin-bottom: 5px; }
.c4d-insp {
  display: flex; align-items: center; gap: 12px; background: #efedfb; border: 1px solid #ddd7f6;
  border-radius: 12px; padding: 11px 14px;
}
.c4d-av {
  width: 38px; height: 38px; border-radius: 50%; background: linear-gradient(135deg, #4a3aa7, #6d5ce0);
  color: #fff; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 13px; flex-shrink: 0;
}
.c4d-nm { font-weight: 700; font-size: 15px; color: #12121a; }
.c4d-mt { font-size: 11.5px; color: #54545f; }
.c4d-sel, .c4d-inp {
  width: 100%; border: 1px solid #e9e9f2; border-radius: 9px; padding: 9px 11px;
  font-size: 13.5px; font-weight: 600; color: #12121a; background: #fbfbfe; font-family: inherit;
}
.c4d-row2 { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.c4d-row3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; }
.c4d-seg { display: flex; background: #fbfbfe; border: 1px solid #e9e9f2; border-radius: 9px; padding: 3px; gap: 3px; }
.c4d-seg button {
  flex: 1; border: none; background: none; padding: 7px 4px; font-size: 12px; font-weight: 600;
  color: #54545f; border-radius: 6px; cursor: pointer;
}
.c4d-seg button.on { background: #4a3aa7; color: #fff; }
.c4d-mini { font-size: 11px; color: #8a8a97; margin-top: 4px; }
.c4d-toggle { display: flex; align-items: center; justify-content: space-between; padding: 10px 0; border-top: 1px solid #f0f0f7; cursor: pointer; }
.c4d-tl { font-size: 13.5px; font-weight: 600; color: #12121a; }
.c4d-tl-s { font-size: 12px; font-weight: 600; color: #12121a; }
.c4d-td { font-size: 11.5px; color: #8a8a97; }
.c4d-toggle-inline { display: flex; align-items: center; gap: 8px; cursor: pointer; }
.c4d-sw {
  width: 42px; height: 24px; border-radius: 999px; background: #cfcfda; position: relative;
  cursor: pointer; transition: .15s; flex-shrink: 0; display: inline-block;
}
.c4d-sw.on { background: #0ca30c; }
.c4d-sw::after {
  content: ""; position: absolute; top: 2px; left: 2px; width: 20px; height: 20px; border-radius: 50%;
  background: #fff; transition: .15s; box-shadow: 0 1px 3px rgba(0,0,0,.2);
}
.c4d-sw.on::after { left: 20px; }
.c4d-preview { background: linear-gradient(160deg, #fff, #efedfb); border: 1px solid #ddd7f6; border-radius: 14px; padding: 16px; }
.c4d-pv-t {
  font-size: 12px; font-weight: 700; color: #4a3aa7; text-transform: uppercase; letter-spacing: .04em;
  margin-bottom: 10px; display: flex; align-items: center; gap: 7px;
}
.c4d-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px; }
.c4d-chip { font-size: 11.5px; background: #fff; border: 1px solid #e2e0f0; border-radius: 999px; padding: 3px 10px; font-weight: 600; color: #54545f; }
.c4d-chip b { color: #12121a; }
.c4d-cand { display: flex; align-items: baseline; gap: 8px; margin-bottom: 8px; }
.c4d-n { font-size: 30px; font-weight: 800; letter-spacing: -.02em; color: #12121a; }
.c4d-l { font-size: 12.5px; color: #54545f; font-weight: 600; }
.c4d-stack { display: flex; height: 12px; border-radius: 6px; overflow: hidden; background: #e6e4f2; gap: 2px; margin-bottom: 8px; }
.c4d-stack > i { display: block; height: 100%; }
.c4d-leg { display: flex; flex-wrap: wrap; gap: 10px; font-size: 11px; color: #54545f; }
.c4d-leg span { display: inline-flex; align-items: center; gap: 5px; }
.c4d-d { width: 9px; height: 9px; border-radius: 3px; display: inline-block; }
/* #760 · medida de la puerta del bloque vivo, bajo la leyenda de candidatas */
.c4d-puerta { margin-top: 12px; padding-top: 10px; border-top: 1px dashed #ddd7f6; display: flex; flex-direction: column; gap: 6px; }
.c4d-puerta-l { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; font-size: 12px; font-weight: 600; color: #12121a; }
/* Botón y no enlace (ronda 1 de Codex): un <a> sin href no entra en el orden de tabulación ni responde
   a Intro, y quien navega con teclado se quedaba sin poder abrir las listas. Se le quita el aspecto de
   botón para que siga pareciendo el enlace de antes. Y el `width: auto` no es decoración (ronda 2):
   Framework7 le da `width: 100%` a todo <button>, y sin él «Ver la lista» se comía la fila entera y
   empujaba la frase de la cifra. El ancho es el de su texto y no encoge; lo que parte línea es la frase. */
.c4d-puerta-ver { flex: 0 0 auto; width: auto; min-width: 0; margin: 0; padding: 0; border: 0; background: none; font: inherit; font-size: 11.5px; color: #4a3aa7; cursor: pointer; text-decoration: underline; white-space: nowrap; text-align: right; }
.c4d-puerta-l > span { flex: 1 1 auto; min-width: 0; }
.c4d-puerta-ver:focus-visible { outline: 2px solid #4a3aa7; outline-offset: 2px; border-radius: 2px; }
.c4d-puerta-lista { max-height: 220px; overflow: auto; background: #fff; border: 1px solid #e2e0f0; border-radius: 8px; }
.c4d-puerta-t { width: 100%; border-collapse: collapse; font-size: 11px; color: #54545f; }
.c4d-puerta-t th { position: sticky; top: 0; background: #f6f5fc; text-align: left; font-weight: 700; padding: 5px 6px; white-space: nowrap; }
.c4d-puerta-t td { padding: 4px 6px; border-top: 1px solid #f0f0f7; vertical-align: top; }
.c4d-puerta-num { text-align: right; white-space: nowrap; }
.c4d-avisos { margin-top: 12px; display: flex; flex-direction: column; gap: 6px; }
.c4d-aviso { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 600; padding: 7px 10px; border-radius: 8px; }
.c4d-aviso.ok { background: #e9f7ea; color: #1c7a2b; border: 1px solid #c7ecc9; }
.c4d-aviso.wn { background: #fff5e6; color: #a5670a; border: 1px solid #f7e2bf; }
.c4d-foot {
  padding: 14px 22px 18px; border-top: 1px solid #f0f0f7; background: #fff;
  display: grid; grid-template-columns: auto 1fr; gap: 10px; align-items: stretch; flex-shrink: 0;
}
.c4d-btn-prop {
  background: linear-gradient(135deg, #4a3aa7, #7b6bec); color: #fff; border: none; border-radius: 12px;
  padding: 15px; font-size: 16px; font-weight: 750; cursor: pointer; box-shadow: 0 6px 18px rgba(74, 58, 167, .32);
  width: 100%; min-width: 0; white-space: nowrap; margin: 0; position: static;
}
/* #296 · el aviso del pie ocupa la fila completa del grid de 2 columnas, encima de los botones:
   así queda pegado al control sin reorganizar el footer ni empujar nada de sitio. */
.c4d-aviso-pie { grid-column: 1 / -1; align-items: flex-start; line-height: 1.35; }
.c4d-btn-prop:disabled { opacity: .55; cursor: default; box-shadow: none; }
.c4d-btn-cancel {
  background: none; border: 1px solid #e9e9f2; border-radius: 12px; padding: 15px 18px;
  font-size: 14px; font-weight: 600; color: #54545f; cursor: pointer;
  width: auto; margin: 0; position: static; white-space: nowrap;
}

/* ENCARGO-021c · banda de fase del /proponer/async. Se pinta entre el body del drawer y el
   footer. Colores por fase, con el mismo lenguaje visual que el resto del drawer (chips
   redondeados, tipografía compacta). No bloquea al usuario: es informativa, no modal. */
.c4d-fase {
  margin: 0 22px 12px; padding: 12px 14px; border-radius: 10px;
  display: flex; flex-direction: column; gap: 6px; font-size: 13px; font-weight: 600;
  border: 1px solid transparent;
}
.c4d-fase-lbl { font-size: 13px; font-weight: 750; }
.c4d-fase-msg { font-size: 12px; font-weight: 500; opacity: .9; word-break: break-word; }
.c4d-fase-acc { display: flex; align-items: center; gap: 10px; margin-top: 4px; flex-wrap: wrap; }
.c4d-fase-cnt { font-size: 12px; font-weight: 600; opacity: .85; }
/* #460 · el coste de abrir el informe, en la misma fila que su botón. `flex-basis: 100%` para que
   caiga debajo cuando la fila ya va llena: es una frase, no un chip, y partida a media palabra no
   se lee. */
.c4d-fase-nota { font-size: 11px; font-weight: 500; opacity: .9; flex-basis: 100%; line-height: 1.35; }
.c4d-fase-btn {
  background: rgba(255, 255, 255, 0.55); border: 1px solid rgba(0, 0, 0, 0.08); border-radius: 8px;
  padding: 6px 12px; font-size: 12px; font-weight: 700; cursor: pointer; color: inherit;
}
.c4d-fase-btn:hover { background: rgba(255, 255, 255, 0.85); }
.c4d-fase-btn-alt { background: transparent; }
/* #283 · el ✕ de cerrar, en la esquina del propio bloque. Posicionado y no un hijo más de la
   columna: así los cinco bloques lo llevan igual sin reordenar el contenido de ninguno —hay dos
   que no tienen título y el ✕ se les quedaría en una fila suelta—. El `padding-right` del bloque
   es lo que impide que el texto largo pase por debajo. */
.c4d-fase-x {
  position: absolute; top: 8px; right: 8px;
  width: 24px; height: 24px; padding: 0; line-height: 22px; text-align: center;
  background: rgba(255, 255, 255, 0.55); border: 1px solid rgba(0, 0, 0, 0.08); border-radius: 8px;
  font-size: 13px; font-weight: 700; color: inherit; cursor: pointer;
}
.c4d-fase-x:hover { background: rgba(255, 255, 255, 0.9); }
.c4d-fase.fase-en_cola     { background: #fff5e6; color: #a5670a; border-color: #f7e2bf; }
.c4d-fase.fase-construyendo { background: #eef4fd; color: #2857b0; border-color: #cfe0f7; }
.c4d-fase.fase-resolviendo  { background: #eef4fd; color: #2857b0; border-color: #cfe0f7; }
.c4d-fase.fase-mapeando     { background: #eef4fd; color: #2857b0; border-color: #cfe0f7; }
.c4d-fase.fase-fin          { background: #e9f7ea; color: #1c7a2b; border-color: #c7ecc9; }
.c4d-fase.fase-error        { background: #fdecec; color: #a2211f; border-color: #f4c9c9; }

/* ENCARGO-025 · contenedor flotante de la banda de fase FUERA del drawer. Se dibuja
   arriba y centrado en la ventana, por encima del appbar (z-index alto). Sin fondo
   propio — cada .c4d-fase interno mantiene su color. Sombra suave para separarlo del
   calendario. `pointer-events: none` en el wrapper para no interceptar clicks fuera de
   las propias bandas; cada banda vuelve a activar `pointer-events: auto`. */
.c4d-fase-flotante {
  position: fixed;
  /* #283 · suelo. El valor de verdad lo pone `recolocarBandaFaseAsync()` en el `style` en línea,
     midiendo dónde acaba la barra de indicadores: a 12px la banda caía justo encima de ella. */
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20000;
  width: min(94vw, 480px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}
.c4d-fase-flotante > .c4d-fase {
  margin: 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  pointer-events: auto;
  /* #283 · referencia del ✕ y hueco para que no se le monte encima el texto. */
  position: relative;
  padding-right: 38px;
}
/* #282 · Diálogo de «Limpiar pendientes». Va en el bloque SIN scoped a propósito: el diálogo de
   Framework7 se monta colgado de <body>, fuera del componente, y una regla scoped no lo alcanza.
   Lo que se busca con esto es lo que pidió dirección: que lo que se destruye se lea primero y que
   el botón destructivo no tenga el mismo peso visual que la salida. */
.c4-limpiar-dialogo .dialog-text {
  text-align: left;
  font-size: 14px;
  line-height: 1.45;
}
.c4-limpiar-dialogo .dialog-text p {
  margin: 0 0 8px;
}
.c4-limpiar-dialogo .dialog-text p:last-child {
  margin-bottom: 0;
}
.c4-limpiar-destruye {
  color: #8e1d14;
}
/* La letra secundaria del punto 1: lo que se preserva se dice, pero no compite con lo que se pierde. */
.c4-limpiar-preserva {
  color: #6b7885;
  font-size: 12px;
}
/* El rojo va aquí y no por el `color: 'red'` de Framework7: --f7-dialog-button-text-color se declara
   en :root, ya llega resuelto al botón, y la clase color-red que F7 le pondría no lo cambia. */
.c4-limpiar-dialogo .c4-limpiar-destructivo {
  color: #c0392b;
}
/* Separa el primer destructivo de la salida: en vertical y pegados se pulsa el de al lado sin querer. */
.c4-limpiar-dialogo .c4-limpiar-separado {
  margin-top: 10px;
  border-top: 1px solid #e2e7ec;
}
</style>
<style scoped>
@import '../../css/vuetify.css';

/* #174 · aviso de la cabecera cuando el interruptor de vacaciones no se ha podido comprobar.
   Discreto a propósito: el ámbar lo hace visible sin competir con las métricas de al lado, y el
   texto se esconde en pantallas estrechas para que nunca empuje al título ni a los botones de
   semana —ahí queda el icono, que con el tooltip sigue diciendo lo mismo—. */
.aviso-bloqueo-vacaciones { display: inline-flex; align-items: center; gap: 4px; margin-left: 10px; padding: 2px 8px; border: 1px solid #f0d7a8; border-radius: 20px; background: #fffbe9; color: #8a6a1f; font-size: 11.5px; font-weight: 600; white-space: nowrap; cursor: help; }
@media (max-width: 1100px) { .aviso-bloqueo-vacaciones .texto { display: none; } }

/* ===== C4-B2: franja banco de horas + producción por semana ===== */
.banco-franja { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; padding: 10px 12px 0; }
.banco-franja.one { grid-template-columns: 1fr; max-width: 620px; }
.banco-franja .wk-card { background: #fff; border: 1px solid #e2e7ec; border-radius: 10px; padding: 11px 14px; box-shadow: 0 1px 2px rgba(20,40,70,.05); }
.banco-franja .wk-hd { display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 7px; }
.banco-franja .wk-t { font-weight: 700; font-size: 14px; color: #1f2933; }
.banco-franja .wk-r { color: #6b7885; font-size: 12px; }
.banco-franja .wk-row { display: flex; gap: 16px; flex-wrap: wrap; align-items: center; padding: 6px 0; }
.banco-franja .wk-row + .wk-row { border-top: 1px dashed #e2e7ec; }
.banco-franja .wk-tag { font-size: 10px; font-weight: 700; letter-spacing: .5px; color: #6b7885; width: 74px; flex-shrink: 0; }
.banco-franja .wk-m .k { color: #6b7885; font-size: 10px; text-transform: uppercase; letter-spacing: .3px; }
.banco-franja .wk-m .val { font-size: 15px; font-weight: 700; line-height: 1.15; color: #1f2933; }
.banco-franja .wk-m .val small { font-size: 11px; color: #6b7885; font-weight: 600; }
.banco-franja .wk-right { margin-left: auto; text-align: right; }
.banco-franja .pill { display: inline-block; padding: 2px 9px; border-radius: 20px; font-weight: 700; font-size: 12px; }
.banco-franja .pill.pos { color: #c77700; background: #fbeeda; }
.banco-franja .pill.neg { color: #2a6fb0; background: #e7f0f8; }
.banco-franja .pill.cap-ok { color: #2e9e5b; background: #e7f5ec; }
.banco-franja .pill.over { color: #c0392b; background: #fbe6e3; }
.banco-note { color: #6b7885; font-size: 12px; margin: 10px 14px 2px; }
.banco-note b { color: #455; }
.banco-callout { background: #fffbe9; border: 1px solid #f0e2a8; border-radius: 8px; padding: 8px 12px; margin: 8px 14px 2px; color: #7a6a2a; font-size: 12.5px; }
.banco-callout .al-roja { color: #c0392b; font-weight: 700; }
.banco-callout .al-ambar { color: #c77700; font-weight: 700; }
.banco-callout .al-count { color: #6b7885; }
/* C4-REALINEAMIENTO v2: etiqueta ARRIBA y el toggle en su propia línea a lo ancho del card. Antes iban en
   flex space-between dentro de 300px: el v-btn-toggle (overflow:hidden en Vuetify) quedaba estrujado y
   recortaba los botones no seleccionados (se veía solo el activo). En columna caben y son clicables. */
.c4-horizonte { display: flex; flex-direction: column; align-items: flex-start; gap: 4px; font-size: 13px; margin-bottom: 6px; }
/* INTEGRIDAD PR-2: leyenda de los tres caminos (Aceptar/Confirmar/Limpiar) del panel Proponer */
.c4-caminos { color: #6b7885; font-size: 11px; line-height: 1.5; margin-top: 8px; padding-top: 6px; border-top: 1px dashed #e2e7ec; }
.c4-caminos b { color: #455; }
/* #460 · por qué no hay Aceptar y dónde se pulsa cuando lo haya. Mismo registro visual que
   `.c4-caminos` (es el otro texto explicativo del menú) y en el sitio del botón que falta, no al
   principio del menú: quien busca el botón mira donde debería estar. */
.c4-sin-propuesta {
  color: #6b7885; font-size: 11px; line-height: 1.5; margin-top: 8px; padding: 6px 8px;
  background: #f7f9fb; border-left: 3px solid #2e9e5b; border-radius: 3px;
}
.c4-sin-propuesta b { color: #455; }
/* SPEC-REGISTRO-PROPUESTAS: panel del audit-log */
.reg-item { border-bottom: 1px solid #eceff1; padding: 4px 0; }
.reg-cab { cursor: pointer; font-size: 12px; }
.reg-cab:hover { background: #f5f7f8; }
.reg-flecha { float: right; color: #90a4ae; }
.reg-informe { float: right; color: #5b21b6; font-weight: 700; font-size: 11px; margin-right: 10px; text-decoration: none; }
.reg-informe:hover { text-decoration: underline; }
/* #460 · aviso de que el enlace al informe se lleva la propuesta provisional. Ámbar, no rojo: no es
   un error, es el precio de pulsar. */
.reg-aviso-provisional {
  font-size: 11px; line-height: 1.4; color: #7a5600; background: #fff8e1;
  border-left: 3px solid #f0ad4e; border-radius: 3px; padding: 5px 8px; margin-bottom: 8px;
}
.reg-detalle { font-size: 11px; color: #546e7a; padding: 4px 0 4px 10px; border-left: 2px solid #cfd8dc; margin: 4px 0; }
.reg-detalle > div { margin-bottom: 3px; }
.reg-estado { font-weight: 600; }
.reg-propuesta { color: #9c27b0; }
.reg-aceptada, .reg-aceptada_parcial { color: #f9a825; }
.reg-confirmada { color: #2e7d32; }
.reg-descartada { color: #c0392b; }
/* SPEC-PARAMETROS-COMIDA-JORNADA: fila compacta de inputs de hora/número del panel Proponer */
.c4-params-fila { display: flex; gap: 6px; align-items: center; width: 100%; }
.c4-params-fila .c4-time { max-width: 86px; }
.c4-params-fila .c4-num { max-width: 62px; }
.c4-params-fila .v-text-field input { font-size: 12.5px; padding: 4px 0; }
.c4-horizonte .lbl { color: #666; }
.c4-horizonte .v-btn-toggle { flex-wrap: wrap; max-width: 100%; }
/* C4-REALINEAMIENTO v2: resaltar el botón seleccionado del toggle (Horizonte/Alcance/Modo). */
.c4-horizonte .v-btn-toggle .v-btn.v-btn--active { background-color: #9c27b0 !important; color: #fff !important; }
/* importe de reparto por etiqueta (verde, como el mockup) */
.imp-reparto { color: #0f7a52; font-weight: 800; }
.imp-reparto .tag-inf { font-size: 9px; font-weight: 700; padding: 0 4px; border: 1px solid #7e57c2; color: #7e57c2; border-radius: 8px; margin-left: 3px; }
.imp-reparto .tag-p1 { font-size: 9px; font-weight: 700; padding: 0 4px; border: 1px solid #c0392b; color: #c0392b; border-radius: 8px; margin-left: 3px; }
/* etiqueta "2ª" (2ª visita) en campo propuesto */
.vac-a-mano.borde-amarillo { border-color: #e69500; border-style: dashed; }
.tag-a-mano { font-size: 9px; font-weight: 700; padding: 0 4px; border: 1px dashed #8a6d00; color: #8a6d00; border-radius: 8px; margin-left: 4px; }
.aviso-vacacion-a-mano { margin: 6px 16px 10px; padding: 8px 10px; border-left: 3px solid #d98324; background: #fff6e8; color: #5a3d00; font-size: 13px; }
.vac-sin-papelera { color: #5a3d00; }
/* #271 · lo mismo que el aviso de la #268, en neutro: no avisa de un riesgo, explica por qué falta
   una opción. */
.aviso-camino-manual-cerrado { margin: 6px 16px 10px; padding: 8px 10px; border-left: 3px solid #64748b; background: #f1f5f9; color: #334155; font-size: 13px; }
.tag-2a { font-size: 9px; font-weight: 700; padding: 0 4px; border: 1px solid #c0392b; color: #c0392b; border-radius: 8px; margin-left: 4px; }
/* #54: etiqueta de ámbito del festivo, encima del día. Va la primera de las badges de la
   cabecera porque es lo que explica por qué ese día no tiene trabajo. */
.badge-festivo { font-weight: 700; }
/* C4-REALINEAMIENTO v2: leyenda de la capa propuesta (provisional) */
.banco-leyenda { display: flex; gap: 16px; flex-wrap: wrap; margin: 8px 14px 4px; color: #6b7885; font-size: 11.5px; align-items: center; }
.banco-leyenda span { display: inline-flex; align-items: center; gap: 6px; }
.banco-leyenda .sw { width: 14px; height: 12px; border-radius: 3px; display: inline-block; border: 1px solid #e2e7ec; }
/* #240 · misma forma que las muestras de estado de `.calendario-leyenda`: lo que se pinta de una
   propuesta es el BORDE morado discontinuo de `.borde-provisional`, no un relleno, así que la
   muestra lleva interior claro y los mismos 3 px. El relleno de una propuesta es el de su tipo de
   trabajo, igual que en una planificación real. */
.banco-leyenda .sw-prop { width: 20px; height: 15px; background: #fff; border: 3px dashed #9c27b0; }
.banco-leyenda .tag-p1 { font-size: 9px; font-weight: 700; padding: 0 4px; border: 1px solid #c0392b; color: #c0392b; border-radius: 8px; }
.banco-leyenda .tag-inf { font-size: 9px; font-weight: 700; padding: 0 4px; border: 1px solid #7e57c2; color: #7e57c2; border-radius: 8px; }

/* #49 · leyenda de estados del calendario. Misma tipografía y medidas que .banco-leyenda; las
   muestras llevan EXACTAMENTE los colores de .borde-amarillo, .borde-azul y .borde-verde, que son
   los que se pintan en los eventos — si alguien cambia uno, hay que cambiar el otro.
   #240 · y ahora dos FORMAS de muestra, porque son dos cosas distintas y antes se enseñaban igual:
   - `.sw-borde` — caja con interior claro y 3 px de borde vivo: es un borde de estado, y a ese
     tamaño se ve que lo que lleva color es el contorno (la muestra de 14x12 con 3 px de borde que
     había antes dejaba 8x6 de interior y se leía como un bloque de color macizo);
   - `.sw-relleno` — bloque macizo en el tono pálido del tipo, sin borde de estado.
   Los hex de los rellenos son los de `RELLENO_TIPO`/`RELLENO_AUSENCIA` del bloque JS, y la prueba
   `scripts/prueba-colores-leyenda-calendario.js` falla si se separan. */
.calendario-leyenda { display: flex; gap: 16px; flex-wrap: wrap; margin: 8px 14px 4px; color: #6b7885; font-size: 11.5px; align-items: center; }
.calendario-leyenda span { display: inline-flex; align-items: center; gap: 6px; }
.calendario-leyenda .leyenda-grupo { font-weight: 700; color: #4a5560; }
.calendario-leyenda .sw { width: 14px; height: 12px; border-radius: 3px; display: inline-block; }
.calendario-leyenda .sw-borde { width: 20px; height: 15px; background: #fff; border-style: solid; border-width: 3px; }
.calendario-leyenda .sw-relleno { width: 20px; height: 15px; border: 1px solid #cfd6dd; }
.calendario-leyenda .sw-pdte { border-color: yellow; }
/* #268 · vacaciones puestas a mano: pendientes de confirmar, pero en naranja y discontinuo, para
   que no se confundan con las de una solicitud que todavía no se ha aprobado. El color es el de
   `.vac-a-mano.borde-amarillo`: si cambia uno, hay que cambiar el otro. */
.calendario-leyenda .sw-a-mano { border-color: #e69500; border-style: dashed; }
.calendario-leyenda .sw-confirmada { border-color: #2196f3; }
.calendario-leyenda .sw-realizada { border-color: #5bc929; }
.calendario-leyenda .sw-vacaciones { background: #d6c4ee; }
.calendario-leyenda .sw-festivo { background: #c4eeea; }
.calendario-leyenda .sw-baja { background: #eec4dc; }
.calendario-leyenda .sw-compensacion { background: #c4c5ee; }
.calendario-leyenda .sw-despl-empresa { background: #dedede; }
.calendario-leyenda .sw-despl-particular { background: #eeccc4; }
.calendario-leyenda .sw-fichaje { background: #c4eec7; }
.calendario-leyenda .sw-sin-pedido { background: #eeddc4; }
/* El «resto» no es un color, son los 74 tonos de los arcos libres: la muestra enseña tres de ellos
   para que se lea «varios tonos del mismo registro pálido» y no se confunda con una entrada más.
   Las paradas van duplicadas (y no con la sintaxis de dos posiciones) porque el browserslist de
   este repo llega a Chrome 49.
   Los tres son tonos que la pantalla puede pintar de verdad —la prueba lo comprueba barriendo el
   hash— y están a 25° o más de cualquier relleno declarado, para que la propia muestra del «resto»
   no se lea como una de las muestras de al lado. Las dos primeras paradas de antes (#eed2c4 y
   #cbc4ee) ya no se pueden pintar: caían en los tonos que ahora quedan reservados. */
.calendario-leyenda .sw-resto {
  background: linear-gradient(90deg, #e0eec4, #e0eec4 33%, #c4eed9 33%, #c4eed9 66%, #eec4cb 66%);
}

#popupSelectDate {
  width: 1179px;
}

.v-application .v-btn.btn-calendar {
  min-width: 10px;
  width: 10px;
}

.v-event-draggable {
  padding-left: 6px;
  height: 100%;
}

.v-event-summary {
  height: 100%;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}
.v-event-drag-bottom::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
}

.v-event-drag-bottom:hover::after {
    display: block;
}

.linea-texto {
  border: 2px solid gray;
  background-color: rgba(131, 131, 240, 0.438);
  padding-left: 10px;
}

.linea-comentario-cerrada {
  border: 2px solid rgb(102, 71, 26);
  background-color: rgba(128, 128, 128, 0.452);
}

.linea-comentario-direccion {
  border: 2px solid rgb(245, 191, 111);
  background-color: white;
}

/* #58 · detalle del día de vacaciones. El botón de la barra no lleva estilo propio: es un icono
   más de la toolbar, igual que el Proponer y el de informes pendientes. */
.detalle-vacaciones .vac-jornada {
  font-weight: bold;
  color: #1a2744;
  margin-bottom: 4px;
}
.detalle-vacaciones .vac-linea { font-size: 13px; }
.detalle-vacaciones .vac-estado {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  border: 1px solid #cfd4da;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
}
.detalle-vacaciones .vac-sin-solicitud { color: #8e8e93; font-style: italic; }
/* #59 · Lo que explica los dos botones apagados, junto a ellos y no arriba (§9). */
.detalle-vacaciones .vac-resolviendo { color: #8a6d00; margin-top: 4px; }
.detalle-vacaciones .vac-comentario { color: #64748b; font-style: italic; }
</style>

